/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StaffImport } from './routes/_staff'
import { Route as IndividualImport } from './routes/_individual'
import { Route as IndexImport } from './routes/index'
import { Route as StaffIdManagementsImport } from './routes/_staff/id-managements'
import { Route as StaffAppsImport } from './routes/_staff/apps'
import { Route as AuthSignInIndexImport } from './routes/auth/sign-in/index'
import { Route as StaffSettingsIndexImport } from './routes/_staff/settings/index'
import { Route as StaffOrganizationIndexImport } from './routes/_staff/organization/index'
import { Route as StaffItOperationCoreIndexImport } from './routes/_staff/it-operation-core/index'
import { Route as StaffCockpitIndexImport } from './routes/_staff/cockpit/index'
import { Route as IndividualIndividualIndexImport } from './routes/_individual/individual/index'
import { Route as StaffTimeAndAttendanceLayoutImport } from './routes/_staff/time-and-attendance/_layout'
import { Route as StaffStorageFilesListImport } from './routes/_staff/storage-files/_list'
import { Route as StaffStarlinksLayoutImport } from './routes/_staff/starlinks/_layout'
import { Route as StaffSoftwareLayoutImport } from './routes/_staff/software/_layout'
import { Route as StaffPublicIdsListImport } from './routes/_staff/public-ids/_list'
import { Route as StaffPublicIdsIdImport } from './routes/_staff/public-ids/$id'
import { Route as StaffPlacesLayoutImport } from './routes/_staff/places/_layout'
import { Route as StaffPeopleListImport } from './routes/_staff/people/_list'
import { Route as StaffOrganizationListImport } from './routes/_staff/organization/_list'
import { Route as StaffNetworksLayoutImport } from './routes/_staff/networks/_layout'
import { Route as StaffMarketplaceStoreImport } from './routes/_staff/marketplace/_store'
import { Route as StaffLicensesListImport } from './routes/_staff/licenses/_list'
import { Route as StaffLaborCorePersonTargetsImport } from './routes/_staff/labor-core/person-targets'
import { Route as StaffLaborCoreAnchorDateImport } from './routes/_staff/labor-core/anchor-date'
import { Route as StaffLaborCorePackagesImport } from './routes/_staff/labor-core/_packages'
import { Route as StaffItOperationCoreRootImport } from './routes/_staff/it-operation-core/_root'
import { Route as StaffItOperationCoreDetailImport } from './routes/_staff/it-operation-core/_detail'
import { Route as StaffIdsLayoutImport } from './routes/_staff/ids/_layout'
import { Route as StaffIdManagementsSplatImport } from './routes/_staff/id-managements/$'
import { Route as StaffGaOperationCorePackagesImport } from './routes/_staff/ga-operation-core/_packages'
import { Route as StaffFleetsLayoutImport } from './routes/_staff/fleets/_layout'
import { Route as StaffEquipmentLayoutImport } from './routes/_staff/equipment/_layout'
import { Route as StaffDevicesListImport } from './routes/_staff/devices/_list'
import { Route as StaffContractorCorePackagesImport } from './routes/_staff/contractor-core/_packages'
import { Route as StaffContractListImport } from './routes/_staff/contract/_list'
import { Route as StaffCertificationListImport } from './routes/_staff/certification/_list'
import { Route as StaffBusinessPartnerListImport } from './routes/_staff/business-partner/_list'
import { Route as StaffBusinessOperationEventsListImport } from './routes/_staff/business-operation-events/_list'
import { Route as StaffAppsListImport } from './routes/_staff/apps/_list'
import { Route as StaffAppsSplatImport } from './routes/_staff/apps/$'
import { Route as StaffAccessesLayoutImport } from './routes/_staff/accesses/_layout'
import { Route as StaffPlacesImportCsvRouteImport } from './routes/_staff/places/import-csv/route'
import { Route as StaffItOperationCoreDeviceInventoryRouteImport } from './routes/_staff/it-operation-core/device-inventory/route'
import { Route as AuthInvitationInvitationCodeIndexImport } from './routes/auth/invitation/$invitationCode/index'
import { Route as StaffTimeAndAttendanceLayoutIndexImport } from './routes/_staff/time-and-attendance/_layout/index'
import { Route as StaffStarlinksLayoutIndexImport } from './routes/_staff/starlinks/_layout/index'
import { Route as StaffSoftwareAddIndexImport } from './routes/_staff/software/add/index'
import { Route as StaffSettingsPersonsIndexImport } from './routes/_staff/settings/persons/index'
import { Route as StaffSettingsPermissionAndRolesIndexImport } from './routes/_staff/settings/permission-and-roles/index'
import { Route as StaffSettingsContractingCorporationProfileIndexImport } from './routes/_staff/settings/contracting-corporation-profile/index'
import { Route as StaffPublicIdsAddIndexImport } from './routes/_staff/public-ids/add/index'
import { Route as StaffPublicIdsListIndexImport } from './routes/_staff/public-ids/_list/index'
import { Route as StaffPublicIdsIdIndexImport } from './routes/_staff/public-ids/$id/index'
import { Route as StaffPlacesAddIndexImport } from './routes/_staff/places/add/index'
import { Route as StaffPlacesAddSelectIndexImport } from './routes/_staff/places/add-select/index'
import { Route as StaffPlacesLayoutIndexImport } from './routes/_staff/places/_layout/index'
import { Route as StaffPersonExternalHrSaasIndexImport } from './routes/_staff/person/external-hr-saas/index'
import { Route as StaffPersonAddIndexImport } from './routes/_staff/person/add/index'
import { Route as StaffPersonAddPersonCertificationIndexImport } from './routes/_staff/person/add-person-certification/index'
import { Route as StaffOrganizationPlanIndexImport } from './routes/_staff/organization/plan/index'
import { Route as StaffNetworksAddIndexImport } from './routes/_staff/networks/add/index'
import { Route as StaffNetworksLayoutIndexImport } from './routes/_staff/networks/_layout/index'
import { Route as StaffMarketplaceUnavailableIndexImport } from './routes/_staff/marketplace/unavailable/index'
import { Route as StaffMarketplaceCartIndexImport } from './routes/_staff/marketplace/cart/index'
import { Route as StaffLicensesAddIndexImport } from './routes/_staff/licenses/add/index'
import { Route as StaffLaborCorePackagesIndexImport } from './routes/_staff/labor-core/_packages/index'
import { Route as StaffIdsLayoutIndexImport } from './routes/_staff/ids/_layout/index'
import { Route as StaffGaOperationCorePackagesIndexImport } from './routes/_staff/ga-operation-core/_packages/index'
import { Route as StaffFleetsAddIndexImport } from './routes/_staff/fleets/add/index'
import { Route as StaffFleetsAddSelectIndexImport } from './routes/_staff/fleets/add-select/index'
import { Route as StaffEquipmentImportCsvIndexImport } from './routes/_staff/equipment/import-csv/index'
import { Route as StaffEquipmentAddIndexImport } from './routes/_staff/equipment/add/index'
import { Route as StaffEquipmentAddSelectIndexImport } from './routes/_staff/equipment/add-select/index'
import { Route as StaffEquipmentLayoutIndexImport } from './routes/_staff/equipment/_layout/index'
import { Route as StaffDevicesExternalItSaasIndexImport } from './routes/_staff/devices/external-it-saas/index'
import { Route as StaffDevicesAddIndexImport } from './routes/_staff/devices/add/index'
import { Route as StaffDeviceCatalogAddIndexImport } from './routes/_staff/device-catalog/add/index'
import { Route as StaffContractorCorePackagesIndexImport } from './routes/_staff/contractor-core/_packages/index'
import { Route as StaffContractAddIndexImport } from './routes/_staff/contract/add/index'
import { Route as StaffContractListIndexImport } from './routes/_staff/contract/_list/index'
import { Route as StaffCockpitIdIndexImport } from './routes/_staff/cockpit/$id/index'
import { Route as StaffCertificationAddIndexImport } from './routes/_staff/certification/add/index'
import { Route as StaffCertificationListIndexImport } from './routes/_staff/certification/_list/index'
import { Route as StaffBusinessPartnerAddIndexImport } from './routes/_staff/business-partner/add/index'
import { Route as StaffBusinessPartnerListIndexImport } from './routes/_staff/business-partner/_list/index'
import { Route as StaffBusinessOperationEventsListIndexImport } from './routes/_staff/business-operation-events/_list/index'
import { Route as StaffBusinessOperationEventsEventInstanceIdIndexImport } from './routes/_staff/business-operation-events/$eventInstanceId/index'
import { Route as StaffAccessesLayoutIndexImport } from './routes/_staff/accesses/_layout/index'
import { Route as StaffStarlinksIdLayoutImport } from './routes/_staff/starlinks/$id/_layout'
import { Route as StaffSoftwareLayoutIntegrationsImport } from './routes/_staff/software/_layout/integrations'
import { Route as StaffSoftwareIdIdImport } from './routes/_staff/software/$id/_$id'
import { Route as StaffSettingsPersonsListImport } from './routes/_staff/settings/persons/_list'
import { Route as StaffSettingsPermissionAndRolesListImport } from './routes/_staff/settings/permission-and-roles/_list'
import { Route as StaffSettingsPermissionAndRolesFormImport } from './routes/_staff/settings/permission-and-roles/_form'
import { Route as StaffSettingsPermissionAndRolesDetailImport } from './routes/_staff/settings/permission-and-roles/_detail'
import { Route as StaffSettingsContractingCorporationProfileLayoutImport } from './routes/_staff/settings/contracting-corporation-profile/_layout'
import { Route as StaffPlacesIdLayoutImport } from './routes/_staff/places/$id/_layout'
import { Route as StaffPersonIdProfileImport } from './routes/_staff/person/$id/_profile'
import { Route as StaffPeopleListSalaryAndPaymentImport } from './routes/_staff/people/_list/salary-and-payment'
import { Route as StaffPeopleListRuleAndPolicyImport } from './routes/_staff/people/_list/rule-and-policy'
import { Route as StaffPeopleListPeopleGraphImport } from './routes/_staff/people/_list/people-graph'
import { Route as StaffPeopleListOperationActivityImport } from './routes/_staff/people/_list/operation-activity'
import { Route as StaffPeopleListCommunityImport } from './routes/_staff/people/_list/community'
import { Route as StaffPeopleListAlertsImport } from './routes/_staff/people/_list/alerts'
import { Route as StaffOrganizationIdLayoutImport } from './routes/_staff/organization/$id/_layout'
import { Route as StaffNetworksIdLayoutImport } from './routes/_staff/networks/$id/_layout'
import { Route as StaffLicensesIdProfileImport } from './routes/_staff/licenses/$id/_profile'
import { Route as StaffLaborCoreSettingsEgovCallbackImport } from './routes/_staff/labor-core/settings/egov-callback'
import { Route as StaffLaborCorePackagesSettingsImport } from './routes/_staff/labor-core/_packages/settings'
import { Route as StaffItOperationCoreDeviceInventoryDetailImport } from './routes/_staff/it-operation-core/device-inventory/detail'
import { Route as StaffItOperationCoreDeviceInventoryDataImport } from './routes/_staff/it-operation-core/device-inventory/data'
import { Route as StaffFleetsLayoutSettingsImport } from './routes/_staff/fleets/_layout/settings'
import { Route as StaffFleetsLayoutRuleAndPolicyImport } from './routes/_staff/fleets/_layout/rule-and-policy'
import { Route as StaffFleetsLayoutOverviewImport } from './routes/_staff/fleets/_layout/overview'
import { Route as StaffFleetsLayoutAlertsImport } from './routes/_staff/fleets/_layout/alerts'
import { Route as StaffFleetsIdLayoutImport } from './routes/_staff/fleets/$id/_layout'
import { Route as StaffEquipmentIdLayoutImport } from './routes/_staff/equipment/$id/_layout'
import { Route as StaffDevicesListRuleAndPolicyImport } from './routes/_staff/devices/_list/rule-and-policy'
import { Route as StaffDevicesListOperationActivityImport } from './routes/_staff/devices/_list/operation-activity'
import { Route as StaffDevicesListContractAndCostImport } from './routes/_staff/devices/_list/contract-and-cost'
import { Route as StaffDevicesListAlertsImport } from './routes/_staff/devices/_list/alerts'
import { Route as StaffContractIdLayoutImport } from './routes/_staff/contract/$id/_layout'
import { Route as StaffCertificationIdLayoutImport } from './routes/_staff/certification/$id/_layout'
import { Route as StaffBusinessPartnerIdLayoutImport } from './routes/_staff/business-partner/$id/_layout'
import { Route as StaffBusinessOperationEventsListSettingsImport } from './routes/_staff/business-operation-events/_list/settings'
import { Route as StaffBusinessOperationEventsListRuleAndPolicyImport } from './routes/_staff/business-operation-events/_list/rule-and-policy'
import { Route as StaffBusinessOperationEventsListOverviewImport } from './routes/_staff/business-operation-events/_list/overview'
import { Route as StaffBusinessOperationEventsListOperationActivityImport } from './routes/_staff/business-operation-events/_list/operation-activity'
import { Route as StaffBusinessOperationEventsListConfigImport } from './routes/_staff/business-operation-events/_list/config'
import { Route as StaffBusinessOperationEventsListArchiveImport } from './routes/_staff/business-operation-events/_list/archive'
import { Route as StaffAppsListRuleAndPolicyImport } from './routes/_staff/apps/_list/rule-and-policy'
import { Route as StaffAppsListOperationActivityImport } from './routes/_staff/apps/_list/operation-activity'
import { Route as StaffAppsListContractAndCostImport } from './routes/_staff/apps/_list/contract-and-cost'
import { Route as StaffAppIntegrationsIdIdImport } from './routes/_staff/app-integrations/$id/_$id'
import { Route as StaffSoftwareLayoutPeopleRouteImport } from './routes/_staff/software/_layout/people/route'
import { Route as StaffSoftwareIdImportCsvRouteImport } from './routes/_staff/software/$id/import-csv/route'
import { Route as StaffPublicIdsImportCsvPublicIdTypeRouteImport } from './routes/_staff/public-ids/import-csv/$publicIdType/route'
import { Route as StaffPlacesLayoutSettingsRouteImport } from './routes/_staff/places/_layout/settings/route'
import { Route as StaffPersonImportCsvWorkerTypeRouteImport } from './routes/_staff/person/import-csv/$workerType/route'
import { Route as StaffItOperationCoreRootPackagesRouteImport } from './routes/_staff/it-operation-core/_root/packages/route'
import { Route as StaffDevicesImportCsvDeviceTypeRouteImport } from './routes/_staff/devices/import-csv/$deviceType/route'
import { Route as StaffAppIntegrationsImportCsvIdRouteImport } from './routes/_staff/app-integrations/import-csv/$id/route'
import { Route as StaffLicensesListIndexRouteImport } from './routes/_staff/licenses/_list/index/route'
import { Route as StaffTimeAndAttendanceLayoutAttendanceLinksIndexImport } from './routes/_staff/time-and-attendance/_layout/attendance-links/index'
import { Route as StaffStorageFilesListFoldersIndexImport } from './routes/_staff/storage-files/_list/folders/index'
import { Route as StaffStorageFilesListFilesIndexImport } from './routes/_staff/storage-files/_list/files/index'
import { Route as StaffStarlinksLayoutUserTerminalsIndexImport } from './routes/_staff/starlinks/_layout/user-terminals/index'
import { Route as StaffStarlinksLayoutAlertsIndexImport } from './routes/_staff/starlinks/_layout/alerts/index'
import { Route as StaffSoftwareAddTypeIndexImport } from './routes/_staff/software/add/$type/index'
import { Route as StaffSoftwareLayoutSettingsIndexImport } from './routes/_staff/software/_layout/settings/index'
import { Route as StaffSoftwareLayoutRuleAndPolicyIndexImport } from './routes/_staff/software/_layout/rule-and-policy/index'
import { Route as StaffSoftwareLayoutRegistryIndexImport } from './routes/_staff/software/_layout/registry/index'
import { Route as StaffSoftwareLayoutPeopleIndexImport } from './routes/_staff/software/_layout/people/index'
import { Route as StaffSoftwareLayoutOperationActivityIndexImport } from './routes/_staff/software/_layout/operation-activity/index'
import { Route as StaffSoftwareLayoutMarketplaceIndexImport } from './routes/_staff/software/_layout/marketplace/index'
import { Route as StaffSoftwareLayoutContractAndCostIndexImport } from './routes/_staff/software/_layout/contract-and-cost/index'
import { Route as StaffSoftwareIdIdIndexImport } from './routes/_staff/software/$id/_$id/index'
import { Route as StaffPublicIdsListSettingsIndexImport } from './routes/_staff/public-ids/_list/settings/index'
import { Route as StaffPublicIdsListRulesAndPoliciesIndexImport } from './routes/_staff/public-ids/_list/rules-and-policies/index'
import { Route as StaffPublicIdsListRegistryIndexImport } from './routes/_staff/public-ids/_list/registry/index'
import { Route as StaffPublicIdsListOperationActivityIndexImport } from './routes/_staff/public-ids/_list/operation-activity/index'
import { Route as StaffPublicIdsListMembersIndexImport } from './routes/_staff/public-ids/_list/members/index'
import { Route as StaffPublicIdsListAlertsIndexImport } from './routes/_staff/public-ids/_list/alerts/index'
import { Route as StaffPublicIdsIdFilesIndexImport } from './routes/_staff/public-ids/$id/files/index'
import { Route as StaffPublicIdsIdDetailsIndexImport } from './routes/_staff/public-ids/$id/details/index'
import { Route as StaffPlacesLayoutSettingsIndexImport } from './routes/_staff/places/_layout/settings/index'
import { Route as StaffPersonAddWorkerTypeIndexImport } from './routes/_staff/person/add/$workerType/index'
import { Route as StaffPersonAddPersonCertificationCertificationKindIndexImport } from './routes/_staff/person/add-person-certification/$certificationKind/index'
import { Route as StaffPeopleListWorkforceIndexImport } from './routes/_staff/people/_list/workforce/index'
import { Route as StaffPeopleListSettingsIndexImport } from './routes/_staff/people/_list/settings/index'
import { Route as StaffPeopleListAlumniIndexImport } from './routes/_staff/people/_list/alumni/index'
import { Route as StaffOrganizationPlanCreateIndexImport } from './routes/_staff/organization/plan/create/index'
import { Route as StaffOrganizationPlanIdIndexImport } from './routes/_staff/organization/plan/$id/index'
import { Route as StaffOrganizationListSettingsIndexImport } from './routes/_staff/organization/_list/settings/index'
import { Route as StaffOrganizationListRulePolicyIndexImport } from './routes/_staff/organization/_list/rule-policy/index'
import { Route as StaffOrganizationListHistoryIndexImport } from './routes/_staff/organization/_list/history/index'
import { Route as StaffOrganizationListCostIndexImport } from './routes/_staff/organization/_list/cost/index'
import { Route as StaffOrganizationListChartIndexImport } from './routes/_staff/organization/_list/chart/index'
import { Route as StaffOrganizationListAlertIndexImport } from './routes/_staff/organization/_list/alert/index'
import { Route as StaffOrganizationIdLayoutIndexImport } from './routes/_staff/organization/$id/_layout/index'
import { Route as StaffMarketplaceSalesOrdersOrderIdIndexImport } from './routes/_staff/marketplace/sales-orders/$orderId/index'
import { Route as StaffLicensesAddAllocationTypeIndexImport } from './routes/_staff/licenses/add/$allocationType/index'
import { Route as StaffLicensesListSettingsIndexImport } from './routes/_staff/licenses/_list/settings/index'
import { Route as StaffLicensesListRuleAndPolicyIndexImport } from './routes/_staff/licenses/_list/rule-and-policy/index'
import { Route as StaffLicensesListPeopleIndexImport } from './routes/_staff/licenses/_list/people/index'
import { Route as StaffLicensesListOperationActivityIndexImport } from './routes/_staff/licenses/_list/operation-activity/index'
import { Route as StaffLicensesListInventoryIndexImport } from './routes/_staff/licenses/_list/inventory/index'
import { Route as StaffLicensesListContractAndCostIndexImport } from './routes/_staff/licenses/_list/contract-and-cost/index'
import { Route as StaffLicensesListAlertsIndexImport } from './routes/_staff/licenses/_list/alerts/index'
import { Route as StaffLaborCoreConfigPatternIdIndexImport } from './routes/_staff/labor-core/config/$patternId/index'
import { Route as StaffLaborCorePackagesSettingsIndexImport } from './routes/_staff/labor-core/_packages/settings/index'
import { Route as StaffLaborCorePackagesConfigsIndexImport } from './routes/_staff/labor-core/_packages/configs/index'
import { Route as StaffLaborCorePackagesArchivesIndexImport } from './routes/_staff/labor-core/_packages/archives/index'
import { Route as StaffItOperationCoreConfigPatternIdIndexImport } from './routes/_staff/it-operation-core/config/$patternId/index'
import { Route as StaffItOperationCoreRootPackagesIndexImport } from './routes/_staff/it-operation-core/_root/packages/index'
import { Route as StaffItOperationCoreRootConfigIndexImport } from './routes/_staff/it-operation-core/_root/config/index'
import { Route as StaffItOperationCoreRootArchivesIndexImport } from './routes/_staff/it-operation-core/_root/archives/index'
import { Route as StaffIdsGroupIdAddIndexImport } from './routes/_staff/ids/group-id/add/index'
import { Route as StaffIdsLayoutPeopleIndexImport } from './routes/_staff/ids/_layout/people/index'
import { Route as StaffGaOperationCoreConfigPatternIdIndexImport } from './routes/_staff/ga-operation-core/config/$patternId/index'
import { Route as StaffGaOperationCorePackagesConfigsIndexImport } from './routes/_staff/ga-operation-core/_packages/configs/index'
import { Route as StaffGaOperationCorePackagesArchivesIndexImport } from './routes/_staff/ga-operation-core/_packages/archives/index'
import { Route as StaffFleetsLayoutListIndexImport } from './routes/_staff/fleets/_layout/_list/index'
import { Route as StaffEquipmentLayoutSettingsIndexImport } from './routes/_staff/equipment/_layout/settings/index'
import { Route as StaffDevicesAddDeviceTypeIndexImport } from './routes/_staff/devices/add/$deviceType/index'
import { Route as StaffDevicesListSettingsIndexImport } from './routes/_staff/devices/_list/settings/index'
import { Route as StaffDevicesListPeopleIndexImport } from './routes/_staff/devices/_list/people/index'
import { Route as StaffDevicesListInventoryIndexImport } from './routes/_staff/devices/_list/inventory/index'
import { Route as StaffDevicesListCatalogIndexImport } from './routes/_staff/devices/_list/catalog/index'
import { Route as StaffDeviceCatalogAddDeviceTypeIndexImport } from './routes/_staff/device-catalog/add/$deviceType/index'
import { Route as StaffContractorCoreConfigPatternIdIndexImport } from './routes/_staff/contractor-core/config/$patternId/index'
import { Route as StaffContractorCorePackagesConfigsIndexImport } from './routes/_staff/contractor-core/_packages/configs/index'
import { Route as StaffContractorCorePackagesArchivesIndexImport } from './routes/_staff/contractor-core/_packages/archives/index'
import { Route as StaffContractImportCsvContractTypeIndexImport } from './routes/_staff/contract/import-csv/$contractType/index'
import { Route as StaffCertificationAddCertificationKindIndexImport } from './routes/_staff/certification/add/$certificationKind/index'
import { Route as StaffCertificationListSettingsIndexImport } from './routes/_staff/certification/_list/settings/index'
import { Route as StaffBusinessPartnerAddBusinessPartnerTypeIndexImport } from './routes/_staff/business-partner/add/$businessPartnerType/index'
import { Route as StaffBusinessPartnerListTerminatedIndexImport } from './routes/_staff/business-partner/_list/terminated/index'
import { Route as StaffAppsCustomAppAddIndexImport } from './routes/_staff/apps/custom-app/add/index'
import { Route as StaffAppsListSettingsIndexImport } from './routes/_staff/apps/_list/settings/index'
import { Route as StaffAppsListPeopleIndexImport } from './routes/_staff/apps/_list/people/index'
import { Route as StaffAppsListMarketplaceIndexImport } from './routes/_staff/apps/_list/marketplace/index'
import { Route as StaffAppsListIntegrationsIndexImport } from './routes/_staff/apps/_list/integrations/index'
import { Route as StaffAppIntegrationsIdIdIndexImport } from './routes/_staff/app-integrations/$id/_$id/index'
import { Route as StaffAccessesLayoutListIndexImport } from './routes/_staff/accesses/_layout/list/index'
import { Route as StaffAccessesLayoutAlertsIndexImport } from './routes/_staff/accesses/_layout/alerts/index'
import { Route as IndividualIndividualTaskIdIndexImport } from './routes/_individual/individual/task/$id/index'
import { Route as IndividualIndividualOperationPackageIdIndexImport } from './routes/_individual/individual/operation-package/$id/index'
import { Route as StaffTimeAndAttendanceLayoutPlaceholdersClockingImport } from './routes/_staff/time-and-attendance/_layout/_placeholders/clocking'
import { Route as StaffTimeAndAttendanceLayoutPlaceholdersAttendancesImport } from './routes/_staff/time-and-attendance/_layout/_placeholders/attendances'
import { Route as StaffStarlinksLayoutPlaceholdersOperationActivityImport } from './routes/_staff/starlinks/_layout/_placeholders/operation-activity'
import { Route as StaffStarlinksLayoutPlaceholdersMarketplaceImport } from './routes/_staff/starlinks/_layout/_placeholders/marketplace'
import { Route as StaffStarlinksLayoutPlaceholdersBillingAndCostImport } from './routes/_staff/starlinks/_layout/_placeholders/billing-and-cost'
import { Route as StaffSoftwareLayoutAlertsAlertsImport } from './routes/_staff/software/_layout/alerts/_alerts'
import { Route as StaffSettingsPersonsListAccountImport } from './routes/_staff/settings/persons/_list/_account'
import { Route as StaffProfileDeviceIdProfileImport } from './routes/_staff/profile/device/$id/_profile'
import { Route as StaffPlacesLayoutPlaceholdersStoreImport } from './routes/_staff/places/_layout/_placeholders/store'
import { Route as StaffPlacesLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/places/_layout/_placeholders/rule-and-policy'
import { Route as StaffPlacesLayoutPlaceholdersPeopleImport } from './routes/_staff/places/_layout/_placeholders/people'
import { Route as StaffPlacesLayoutPlaceholdersOverviewImport } from './routes/_staff/places/_layout/_placeholders/overview'
import { Route as StaffPlacesLayoutPlaceholdersOperationActivityImport } from './routes/_staff/places/_layout/_placeholders/operation-activity'
import { Route as StaffPlacesLayoutPlaceholdersContractAndCostImport } from './routes/_staff/places/_layout/_placeholders/contract-and-cost'
import { Route as StaffPlacesLayoutPlaceholdersAlertsImport } from './routes/_staff/places/_layout/_placeholders/alerts'
import { Route as StaffPersonAlumniIdProfileImport } from './routes/_staff/person/alumni/$id/_profile'
import { Route as StaffPersonAddWorkerTypeCompletedImport } from './routes/_staff/person/add/$workerType/completed'
import { Route as StaffPersonAddPersonCertificationCertificationKindCompletedImport } from './routes/_staff/person/add-person-certification/$certificationKind/completed'
import { Route as StaffNetworksLayoutPlaceholdersSettingsImport } from './routes/_staff/networks/_layout/_placeholders/settings'
import { Route as StaffNetworksLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/networks/_layout/_placeholders/rule-and-policy'
import { Route as StaffNetworksLayoutPlaceholdersOverviewImport } from './routes/_staff/networks/_layout/_placeholders/overview'
import { Route as StaffNetworksLayoutPlaceholdersOperationActivityImport } from './routes/_staff/networks/_layout/_placeholders/operation-activity'
import { Route as StaffNetworksLayoutPlaceholdersContractAndCostImport } from './routes/_staff/networks/_layout/_placeholders/contract-and-cost'
import { Route as StaffNetworksLayoutPlaceholdersAlertsImport } from './routes/_staff/networks/_layout/_placeholders/alerts'
import { Route as StaffMarketplaceSentOrdersOrderIdLayoutImport } from './routes/_staff/marketplace/sent-orders/$orderId/_layout'
import { Route as StaffLicensesAddAllocationTypeCompletedImport } from './routes/_staff/licenses/add/$allocationType/completed'
import { Route as StaffLaborCoreSettingsProfileProfileIdImport } from './routes/_staff/labor-core/settings/profile.$profileId'
import { Route as StaffItOperationCoreRootPackagesPackageIdImport } from './routes/_staff/it-operation-core/_root/packages/$packageId'
import { Route as StaffIdsGroupIdIdIdImport } from './routes/_staff/ids/group-id/$id/_$id'
import { Route as StaffIdsLayoutPlaceholdersSettingsImport } from './routes/_staff/ids/_layout/_placeholders/settings'
import { Route as StaffIdsLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/ids/_layout/_placeholders/rule-and-policy'
import { Route as StaffIdsLayoutPlaceholdersOverviewImport } from './routes/_staff/ids/_layout/_placeholders/overview'
import { Route as StaffIdsLayoutPlaceholdersOperationActivityImport } from './routes/_staff/ids/_layout/_placeholders/operation-activity'
import { Route as StaffIdsLayoutPlaceholdersGroupIdImport } from './routes/_staff/ids/_layout/_placeholders/group-id'
import { Route as StaffIdsLayoutPlaceholdersAlertsImport } from './routes/_staff/ids/_layout/_placeholders/alerts'
import { Route as StaffEquipmentLayoutPlaceholdersSettingsImport } from './routes/_staff/equipment/_layout/_placeholders/settings'
import { Route as StaffEquipmentLayoutPlaceholdersRuleAndPolicyImport } from './routes/_staff/equipment/_layout/_placeholders/rule-and-policy'
import { Route as StaffEquipmentLayoutPlaceholdersOverviewImport } from './routes/_staff/equipment/_layout/_placeholders/overview'
import { Route as StaffEquipmentLayoutPlaceholdersAlertsImport } from './routes/_staff/equipment/_layout/_placeholders/alerts'
import { Route as StaffDevicesAddDeviceTypeCompletedImport } from './routes/_staff/devices/add/$deviceType/completed'
import { Route as StaffDevicesListSettingsCatalogImport } from './routes/_staff/devices/_list/settings/catalog'
import { Route as StaffDeviceCatalogDraftIdLayoutImport } from './routes/_staff/device-catalog/draft/$id/_layout'
import { Route as StaffDeviceCatalogAddDeviceTypeCompletedImport } from './routes/_staff/device-catalog/add/$deviceType/completed'
import { Route as StaffDeviceCatalogActiveIdLayoutImport } from './routes/_staff/device-catalog/active/$id/_layout'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutImport } from './routes/_staff/certification/specialty-certification/$id/_layout'
import { Route as StaffCertificationHandlingCertificationIdLayoutImport } from './routes/_staff/certification/handling-certification/$id/_layout'
import { Route as StaffCertificationAddCertificationKindCompletedImport } from './routes/_staff/certification/add/$certificationKind/completed'
import { Route as StaffBusinessPartnerAddBusinessPartnerTypeCompletedImport } from './routes/_staff/business-partner/add/$businessPartnerType/completed'
import { Route as StaffAppsListAlertsAlertsImport } from './routes/_staff/apps/_list/alerts/_alerts'
import { Route as StaffAppIntegrationsIdIdGroupsImport } from './routes/_staff/app-integrations/$id/_$id/groups'
import { Route as StaffAccessesLayoutPlaceholdersSoftwareImport } from './routes/_staff/accesses/_layout/_placeholders/software'
import { Route as StaffAccessesLayoutPlaceholdersSettingsImport } from './routes/_staff/accesses/_layout/_placeholders/settings'
import { Route as StaffAccessesLayoutPlaceholdersOverviewImport } from './routes/_staff/accesses/_layout/_placeholders/overview'
import { Route as StaffAccessesLayoutPlaceholdersContractAndCostImport } from './routes/_staff/accesses/_layout/_placeholders/contract-and-cost'
import { Route as IndividualIndividualTaskIdApprovalDialogImport } from './routes/_individual/individual/task/$id/approval-dialog'
import { Route as StaffSoftwareLayoutMarketplaceIdRouteImport } from './routes/_staff/software/_layout/marketplace/$id/route'
import { Route as StaffContractListPlaceholdersPeopleRouteImport } from './routes/_staff/contract/_list/_placeholders/people/route'
import { Route as StaffContractListPlaceholdersOverviewRouteImport } from './routes/_staff/contract/_list/_placeholders/overview/route'
import { Route as StaffContractListPlaceholdersOperationActivityRouteImport } from './routes/_staff/contract/_list/_placeholders/operation-activity/route'
import { Route as StaffContractListPlaceholdersContractAndCostRouteImport } from './routes/_staff/contract/_list/_placeholders/contract-and-cost/route'
import { Route as StaffContractListPlaceholdersAlertsRouteImport } from './routes/_staff/contract/_list/_placeholders/alerts/route'
import { Route as StaffCertificationListPlaceholdersRuleAndPolicyRouteImport } from './routes/_staff/certification/_list/_placeholders/rule-and-policy/route'
import { Route as StaffCertificationListPlaceholdersOverviewRouteImport } from './routes/_staff/certification/_list/_placeholders/overview/route'
import { Route as StaffCertificationListPlaceholdersOperationActivityRouteImport } from './routes/_staff/certification/_list/_placeholders/operation-activity/route'
import { Route as StaffCertificationListPlaceholdersAlertsRouteImport } from './routes/_staff/certification/_list/_placeholders/alerts/route'
import { Route as StaffBusinessPartnerListPlaceholdersSettingsRouteImport } from './routes/_staff/business-partner/_list/_placeholders/settings/route'
import { Route as StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteImport } from './routes/_staff/business-partner/_list/_placeholders/rule-and-policy/route'
import { Route as StaffBusinessPartnerListPlaceholdersOperationActivityRouteImport } from './routes/_staff/business-partner/_list/_placeholders/operation-activity/route'
import { Route as StaffBusinessPartnerListPlaceholdersContractAndCostRouteImport } from './routes/_staff/business-partner/_list/_placeholders/contract-and-cost/route'
import { Route as StaffBusinessPartnerListPlaceholdersAlertsRouteImport } from './routes/_staff/business-partner/_list/_placeholders/alerts/route'
import { Route as StaffAppsListMarketplaceIdRouteImport } from './routes/_staff/apps/_list/marketplace/$id/route'
import { Route as StaffPersonIdProfileIndexRouteImport } from './routes/_staff/person/$id/_profile/index/route'
import { Route as StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexImport } from './routes/_staff/time-and-attendance/_layout/attendance-links/$placeId/index'
import { Route as StaffTimeAndAttendanceLayoutListSummaryIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/index'
import { Route as StaffSoftwareCustomSaasAddCustomSaasTypeIndexImport } from './routes/_staff/software/custom-saas/add/$customSaasType/index'
import { Route as StaffSoftwareLayoutAlertsAlertsIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/index'
import { Route as StaffSoftwareIdIdUsersIndexImport } from './routes/_staff/software/$id/_$id/users/index'
import { Route as StaffSoftwareIdIdSettingsIndexImport } from './routes/_staff/software/$id/_$id/settings/index'
import { Route as StaffSoftwareIdIdRuleAndPolicyIndexImport } from './routes/_staff/software/$id/_$id/rule-and-policy/index'
import { Route as StaffSoftwareIdIdDetailIndexImport } from './routes/_staff/software/$id/_$id/detail/index'
import { Route as StaffSoftwareIdIdContractsCostIndexImport } from './routes/_staff/software/$id/_$id/contracts-cost/index'
import { Route as StaffSoftwareIdIdArchitectureIndexImport } from './routes/_staff/software/$id/_$id/architecture/index'
import { Route as StaffSoftwareIdIdActivityMonitoringIndexImport } from './routes/_staff/software/$id/_$id/activity-monitoring/index'
import { Route as StaffSettingsPersonsListSettingsIndexImport } from './routes/_staff/settings/persons/_list/settings/index'
import { Route as StaffSettingsPermissionAndRolesListRolesIndexImport } from './routes/_staff/settings/permission-and-roles/_list/roles/index'
import { Route as StaffSettingsPermissionAndRolesListProductPermissionsIndexImport } from './routes/_staff/settings/permission-and-roles/_list/product-permissions/index'
import { Route as StaffSettingsPermissionAndRolesListPeopleGroupsIndexImport } from './routes/_staff/settings/permission-and-roles/_list/people-groups/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutShareholdersIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/shareholders/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutRegistrationIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/registration/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutHistoryIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/history/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/group-companies/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutContactPointsIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/contact-points/index'
import { Route as StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexImport } from './routes/_staff/settings/contracting-corporation-profile/_layout/board-member/index'
import { Route as StaffPlacesLayoutSettingsPlaceSubCodesIndexImport } from './routes/_staff/places/_layout/settings/place-sub-codes/index'
import { Route as StaffPlacesIdLayoutLaborCoreIndexImport } from './routes/_staff/places/$id/_layout/labor-core/index'
import { Route as StaffPlacesIdLayoutAdministratorsIndexImport } from './routes/_staff/places/$id/_layout/administrators/index'
import { Route as StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexImport } from './routes/_staff/person/external-hr-saas/$appIntegrationId/preview/index'
import { Route as StaffPersonIdProfilePublicIdIndexImport } from './routes/_staff/person/$id/_profile/public-id/index'
import { Route as StaffPersonIdProfilePersonalInformationIndexImport } from './routes/_staff/person/$id/_profile/personal-information/index'
import { Route as StaffPersonIdProfileHistoryIndexImport } from './routes/_staff/person/$id/_profile/history/index'
import { Route as StaffPersonIdProfileEquipmentIndexImport } from './routes/_staff/person/$id/_profile/equipment/index'
import { Route as StaffPersonIdProfileEmployeeInformationIndexImport } from './routes/_staff/person/$id/_profile/employee-information/index'
import { Route as StaffPersonIdProfileEducationAndQualificationIndexImport } from './routes/_staff/person/$id/_profile/education-and-qualification/index'
import { Route as StaffPersonIdProfileDevicesIndexImport } from './routes/_staff/person/$id/_profile/devices/index'
import { Route as StaffPersonIdProfileAppsIndexImport } from './routes/_staff/person/$id/_profile/apps/index'
import { Route as StaffPersonIdProfileActivityIndexImport } from './routes/_staff/person/$id/_profile/activity/index'
import { Route as StaffPeopleListSettingsWorkModeIndexImport } from './routes/_staff/people/_list/settings/work-mode/index'
import { Route as StaffPeopleListSettingsRetirementReasonsIndexImport } from './routes/_staff/people/_list/settings/retirement-reasons/index'
import { Route as StaffPeopleListSettingsPositionsIndexImport } from './routes/_staff/people/_list/settings/positions/index'
import { Route as StaffPeopleListSettingsPlaceSocialInsurancesIndexImport } from './routes/_staff/people/_list/settings/place-social-insurances/index'
import { Route as StaffPeopleListSettingsJobTypesIndexImport } from './routes/_staff/people/_list/settings/job-types/index'
import { Route as StaffPeopleListSettingsJobTitlesIndexImport } from './routes/_staff/people/_list/settings/job-titles/index'
import { Route as StaffPeopleListSettingsJobLevelsIndexImport } from './routes/_staff/people/_list/settings/job-levels/index'
import { Route as StaffPeopleListSettingsJobGradesIndexImport } from './routes/_staff/people/_list/settings/job-grades/index'
import { Route as StaffPeopleListSettingsJobFunctionsIndexImport } from './routes/_staff/people/_list/settings/job-functions/index'
import { Route as StaffPeopleListSettingsJobCompetenciesIndexImport } from './routes/_staff/people/_list/settings/job-competencies/index'
import { Route as StaffPeopleListSettingsHealthInsuranceAssociationsIndexImport } from './routes/_staff/people/_list/settings/health-insurance-associations/index'
import { Route as StaffPeopleListSettingsGradesIndexImport } from './routes/_staff/people/_list/settings/grades/index'
import { Route as StaffPeopleListSettingsEmploymentTypesIndexImport } from './routes/_staff/people/_list/settings/employment-types/index'
import { Route as StaffPeopleListSettingsEmployeeSubIdNamesIndexImport } from './routes/_staff/people/_list/settings/employee-sub-id-names/index'
import { Route as StaffPeopleListSettingsContractorTypesIndexImport } from './routes/_staff/people/_list/settings/contractor-types/index'
import { Route as StaffPeopleListSettingsContractEndReasonsIndexImport } from './routes/_staff/people/_list/settings/contract-end-reasons/index'
import { Route as StaffPeopleListSettingsCollaboratorTypesIndexImport } from './routes/_staff/people/_list/settings/collaborator-types/index'
import { Route as StaffPeopleListSettingsBoardMemberTypesIndexImport } from './routes/_staff/people/_list/settings/board-member-types/index'
import { Route as StaffOrganizationPlanIdAddIndexImport } from './routes/_staff/organization/plan/$id/add/index'
import { Route as StaffOrganizationIdLayoutHistoryIndexImport } from './routes/_staff/organization/$id/_layout/history/index'
import { Route as StaffMarketplaceSentOrdersOrderIdLayoutIndexImport } from './routes/_staff/marketplace/sent-orders/$orderId/_layout/index'
import { Route as StaffMarketplaceStoreStoreStarlinksIndexImport } from './routes/_staff/marketplace/_store/store/starlinks/index'
import { Route as StaffMarketplaceStoreStoreSentOrdersIndexImport } from './routes/_staff/marketplace/_store/store/sent-orders/index'
import { Route as StaffMarketplaceStoreStoreSalesOrdersIndexImport } from './routes/_staff/marketplace/_store/store/sales-orders/index'
import { Route as StaffMarketplaceStoreStoreDevicesIndexImport } from './routes/_staff/marketplace/_store/store/devices/index'
import { Route as StaffLicensesIdProfileServicePlansIndexImport } from './routes/_staff/licenses/$id/_profile/service-plans/index'
import { Route as StaffLicensesIdProfilePeopleIndexImport } from './routes/_staff/licenses/$id/_profile/people/index'
import { Route as StaffLicensesIdProfileAssignmentsIndexImport } from './routes/_staff/licenses/$id/_profile/assignments/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/index'
import { Route as StaffIdsGroupIdIdIdIndexImport } from './routes/_staff/ids/group-id/$id/_$id/index'
import { Route as StaffEquipmentLayoutSettingsEquipmentTypesIndexImport } from './routes/_staff/equipment/_layout/settings/equipment-types/index'
import { Route as StaffEquipmentLayoutSettingsEquipmentItemsIndexImport } from './routes/_staff/equipment/_layout/settings/equipment-items/index'
import { Route as StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexImport } from './routes/_staff/devices/external-it-saas/$appIntegrationId/preview/index'
import { Route as StaffCertificationListSettingsSpecialtyCategoryIndexImport } from './routes/_staff/certification/_list/settings/specialty-category/index'
import { Route as StaffCertificationListSettingsSpecialtyCategoryLevelIndexImport } from './routes/_staff/certification/_list/settings/specialty-category-level/index'
import { Route as StaffCertificationListSettingsIssuingOrganizationIndexImport } from './routes/_staff/certification/_list/settings/issuing-organization/index'
import { Route as StaffCertificationIdLayoutSpecialtyCertificationsIndexImport } from './routes/_staff/certification/$id/_layout/specialty-certifications/index'
import { Route as StaffCertificationIdLayoutHandlingCertificationsIndexImport } from './routes/_staff/certification/$id/_layout/handling-certifications/index'
import { Route as StaffCertificationIdLayoutCertificationHoldersIndexImport } from './routes/_staff/certification/$id/_layout/certification-holders/index'
import { Route as StaffCertificationIdLayoutIndexIndexImport } from './routes/_staff/certification/$id/_layout/_index/index'
import { Route as StaffBusinessPartnerIdLayoutAddressAndContactIndexImport } from './routes/_staff/business-partner/$id/_layout/address-and-contact/index'
import { Route as StaffBusinessPartnerIdLayoutIndexIndexImport } from './routes/_staff/business-partner/$id/_layout/_index/index'
import { Route as StaffAppsCustomAppAddCustomAppTypeIndexImport } from './routes/_staff/apps/custom-app/add/$customAppType/index'
import { Route as StaffAppsListAlertsAlertsIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/index'
import { Route as StaffAppIntegrationsIdIdUsersIndexImport } from './routes/_staff/app-integrations/$id/_$id/users/index'
import { Route as StaffAppIntegrationsIdIdSettingsIndexImport } from './routes/_staff/app-integrations/$id/_$id/settings/index'
import { Route as StaffAppIntegrationsIdIdRuleAndPolicyIndexImport } from './routes/_staff/app-integrations/$id/_$id/rule-and-policy/index'
import { Route as StaffAppIntegrationsIdIdDetailIndexImport } from './routes/_staff/app-integrations/$id/_$id/detail/index'
import { Route as StaffAppIntegrationsIdIdArchitectureIndexImport } from './routes/_staff/app-integrations/$id/_$id/architecture/index'
import { Route as IndividualIndividualTaskIdApprovalIndexImport } from './routes/_individual/individual/task/$id/approval/index'
import { Route as StaffProfileDeviceIdProfileMonitoringImport } from './routes/_staff/profile/device/$id/_profile/monitoring'
import { Route as StaffProfileDeviceIdProfileConfigurationImport } from './routes/_staff/profile/device/$id/_profile/configuration'
import { Route as StaffMarketplaceSentOrdersOrderIdLayoutActivitiesImport } from './routes/_staff/marketplace/sent-orders/$orderId/_layout/activities'
import { Route as StaffLicensesIdServicePlansLicenseServiceIdDetailImport } from './routes/_staff/licenses/$id/service-plans/$licenseServiceId/_detail'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout'
import { Route as StaffProfileDeviceIdProfileFilesRouteImport } from './routes/_staff/profile/device/$id/_profile/files/route'
import { Route as StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/rule-and-policy/route'
import { Route as StaffContractIdLayoutPlaceholdersRiskProvisionsRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/risk-provisions/route'
import { Route as StaffContractIdLayoutPlaceholdersOperationActivityRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/operation-activity/route'
import { Route as StaffContractIdLayoutPlaceholdersHistoryRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/history/route'
import { Route as StaffContractIdLayoutPlaceholdersApprovalInfoRouteImport } from './routes/_staff/contract/$id/_layout/_placeholders/approval-info/route'
import { Route as StaffPersonAlumniIdProfileIndexRouteImport } from './routes/_staff/person/alumni/$id/_profile/index/route'
import { Route as StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-place/index'
import { Route as StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-person/index'
import { Route as StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexImport } from './routes/_staff/time-and-attendance/_layout/_list/summary/daily-place/index'
import { Route as StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/violated-role/index'
import { Route as StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/violated-assignment/index'
import { Route as StaffSoftwareLayoutAlertsAlertsNoWorkerIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/no-worker/index'
import { Route as StaffSoftwareLayoutAlertsAlertsNoUserIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/no-user/index'
import { Route as StaffSoftwareLayoutAlertsAlertsInactiveUserIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/inactive-user/index'
import { Route as StaffSoftwareLayoutAlertsAlertsAlumniIndexImport } from './routes/_staff/software/_layout/alerts/_alerts/alumni/index'
import { Route as StaffSettingsPersonsListAccountStaffIndexImport } from './routes/_staff/settings/persons/_list/_account/staff/index'
import { Route as StaffSettingsPersonsListAccountIndividualIndexImport } from './routes/_staff/settings/persons/_list/_account/individual/index'
import { Route as StaffSettingsPermissionAndRolesFormRolesNewIndexImport } from './routes/_staff/settings/permission-and-roles/_form/roles/new/index'
import { Route as StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexImport } from './routes/_staff/settings/permission-and-roles/_form/product-permissions/new/index'
import { Route as StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexImport } from './routes/_staff/settings/permission-and-roles/_form/people-groups/new/index'
import { Route as StaffSettingsPermissionAndRolesDetailRolesIdIndexImport } from './routes/_staff/settings/permission-and-roles/_detail/roles/$id/index'
import { Route as StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexImport } from './routes/_staff/settings/permission-and-roles/_detail/product-permissions/$id/index'
import { Route as StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexImport } from './routes/_staff/settings/permission-and-roles/_detail/people-groups/$id/index'
import { Route as StaffProfileDeviceIdProfileLifecycleIndexImport } from './routes/_staff/profile/device/$id/_profile/lifecycle/index'
import { Route as StaffProfileDeviceIdProfileHistoryIndexImport } from './routes/_staff/profile/device/$id/_profile/history/index'
import { Route as StaffPersonAlumniIdProfilePublicIdIndexImport } from './routes/_staff/person/alumni/$id/_profile/public-id/index'
import { Route as StaffPersonAlumniIdProfilePersonalInformationIndexImport } from './routes/_staff/person/alumni/$id/_profile/personal-information/index'
import { Route as StaffPersonAlumniIdProfileHistoryIndexImport } from './routes/_staff/person/alumni/$id/_profile/history/index'
import { Route as StaffPersonAlumniIdProfileEquipmentIndexImport } from './routes/_staff/person/alumni/$id/_profile/equipment/index'
import { Route as StaffPersonAlumniIdProfileEmployeeInformationIndexImport } from './routes/_staff/person/alumni/$id/_profile/employee-information/index'
import { Route as StaffPersonAlumniIdProfileEducationAndQualificationIndexImport } from './routes/_staff/person/alumni/$id/_profile/education-and-qualification/index'
import { Route as StaffPersonAlumniIdProfileDevicesIndexImport } from './routes/_staff/person/alumni/$id/_profile/devices/index'
import { Route as StaffPersonAlumniIdProfileAppsIndexImport } from './routes/_staff/person/alumni/$id/_profile/apps/index'
import { Route as StaffPersonAlumniIdProfileActivityIndexImport } from './routes/_staff/person/alumni/$id/_profile/activity/index'
import { Route as StaffPersonIdProfileFamilyFamilyPersonIdIndexImport } from './routes/_staff/person/$id/_profile/family/$familyPersonId/index'
import { Route as StaffOrganizationPlanIdEditUnitIdIndexImport } from './routes/_staff/organization/plan/$id/edit/$unitId/index'
import { Route as StaffMarketplaceStoreStoreStarlinksProductIdIndexImport } from './routes/_staff/marketplace/_store/store/starlinks/$productId/index'
import { Route as StaffMarketplaceStoreStoreDevicesProductIdIndexImport } from './routes/_staff/marketplace/_store/store/devices/$productId/index'
import { Route as StaffIdsGroupIdIdIdSettingsIndexImport } from './routes/_staff/ids/group-id/$id/_$id/settings/index'
import { Route as StaffIdsGroupIdIdIdRuleAndPolicyIndexImport } from './routes/_staff/ids/group-id/$id/_$id/rule-and-policy/index'
import { Route as StaffIdsGroupIdIdIdMembersIndexImport } from './routes/_staff/ids/group-id/$id/_$id/members/index'
import { Route as StaffDeviceCatalogDraftIdLayoutProfileIndexImport } from './routes/_staff/device-catalog/draft/$id/_layout/profile/index'
import { Route as StaffDeviceCatalogActiveIdLayoutProfileIndexImport } from './routes/_staff/device-catalog/active/$id/_layout/profile/index'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexImport } from './routes/_staff/certification/specialty-certification/$id/_layout/handling-certifications/index'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexImport } from './routes/_staff/certification/specialty-certification/$id/_layout/certification-holders/index'
import { Route as StaffCertificationSpecialtyCertificationIdLayoutIndexIndexImport } from './routes/_staff/certification/specialty-certification/$id/_layout/_index/index'
import { Route as StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexImport } from './routes/_staff/certification/handling-certification/$id/_layout/certification-holders/index'
import { Route as StaffCertificationHandlingCertificationIdLayoutIndexIndexImport } from './routes/_staff/certification/handling-certification/$id/_layout/_index/index'
import { Route as StaffAppsListAlertsAlertsViolatedRoleIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/violated-role/index'
import { Route as StaffAppsListAlertsAlertsViolatedAssignmentIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/violated-assignment/index'
import { Route as StaffAppsListAlertsAlertsNoWorkerIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/no-worker/index'
import { Route as StaffAppsListAlertsAlertsNoUserIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/no-user/index'
import { Route as StaffAppsListAlertsAlertsInactiveUserIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/inactive-user/index'
import { Route as StaffAccessesLayoutAlertsDetailShadowItAppIdIndexImport } from './routes/_staff/accesses/_layout/alerts/detail/$shadowItAppId/index'
import { Route as IndividualIndividualOperationPackageIdPatternPatternIdIndexImport } from './routes/_individual/individual/operation-package/$id/pattern/$patternId/index'
import { Route as StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport } from './routes/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout'
import { Route as StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport } from './routes/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout'
import { Route as StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport } from './routes/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout'
import { Route as StaffAppsListAlertsAlertsShadowItShadowItImport } from './routes/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it'
import { Route as StaffSoftwareLayoutMarketplaceIdInstallFinishIndexImport } from './routes/_staff/software/_layout/marketplace/$id/install.finish/index'
import { Route as StaffSettingsPermissionAndRolesFormRolesIdEditIndexImport } from './routes/_staff/settings/permission-and-roles/_form/roles/$id/edit/index'
import { Route as StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexImport } from './routes/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/index'
import { Route as StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexImport } from './routes/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/index'
import { Route as StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexImport } from './routes/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/index'
import { Route as StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexImport } from './routes/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/index'
import { Route as StaffAppsListMarketplaceIdInstallFinishIndexImport } from './routes/_staff/apps/_list/marketplace/$id/install.finish/index'
import { Route as StaffAppsListAlertsAlertsShadowItShadowItIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/index'
import { Route as StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexImport } from './routes/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/index'
import { Route as StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexImport } from './routes/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/index'
import { Route as StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexImport } from './routes/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/index'
import { Route as StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/index'
import { Route as StaffAppsListAlertsAlertsShadowItShadowItAppsIndexImport } from './routes/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/index'
import { Route as IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexImport } from './routes/_individual/individual/task/$id/_operation-package/_common/form/$formId/index'
import { Route as StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport } from './routes/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
import { Route as StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport } from './routes/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
import { Route as StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport } from './routes/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
import { Route as StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport } from './routes/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index'
import { Route as StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport } from './routes/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index'
import { Route as StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport } from './routes/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index'
import { Route as StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport } from './routes/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index'
import { Route as StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport } from './routes/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index'
import { Route as StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport } from './routes/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index'

// Create Virtual Routes

const StaffTimeAndAttendanceImport = createFileRoute(
  '/_staff/time-and-attendance',
)()
const StaffStorageFilesImport = createFileRoute('/_staff/storage-files')()
const StaffStarlinksImport = createFileRoute('/_staff/starlinks')()
const StaffSoftwareImport = createFileRoute('/_staff/software')()
const StaffPublicIdsImport = createFileRoute('/_staff/public-ids')()
const StaffPlacesImport = createFileRoute('/_staff/places')()
const StaffPeopleImport = createFileRoute('/_staff/people')()
const StaffOrganizationImport = createFileRoute('/_staff/organization')()
const StaffNetworksImport = createFileRoute('/_staff/networks')()
const StaffMarketplaceImport = createFileRoute('/_staff/marketplace')()
const StaffLicensesImport = createFileRoute('/_staff/licenses')()
const StaffLaborCoreImport = createFileRoute('/_staff/labor-core')()
const StaffItOperationCoreImport = createFileRoute(
  '/_staff/it-operation-core',
)()
const StaffIdsImport = createFileRoute('/_staff/ids')()
const StaffGaOperationCoreImport = createFileRoute(
  '/_staff/ga-operation-core',
)()
const StaffFleetsImport = createFileRoute('/_staff/fleets')()
const StaffEquipmentImport = createFileRoute('/_staff/equipment')()
const StaffDevicesImport = createFileRoute('/_staff/devices')()
const StaffContractorCoreImport = createFileRoute('/_staff/contractor-core')()
const StaffContractImport = createFileRoute('/_staff/contract')()
const StaffCertificationImport = createFileRoute('/_staff/certification')()
const StaffBusinessPartnerImport = createFileRoute('/_staff/business-partner')()
const StaffBusinessOperationEventsImport = createFileRoute(
  '/_staff/business-operation-events',
)()
const StaffAccessesImport = createFileRoute('/_staff/accesses')()
const StaffStarlinksIdImport = createFileRoute('/_staff/starlinks/$id')()
const StaffSoftwareIdImport = createFileRoute('/_staff/software/$id')()
const StaffSettingsPersonsImport = createFileRoute('/_staff/settings/persons')()
const StaffSettingsPermissionAndRolesImport = createFileRoute(
  '/_staff/settings/permission-and-roles',
)()
const StaffSettingsContractingCorporationProfileImport = createFileRoute(
  '/_staff/settings/contracting-corporation-profile',
)()
const StaffPlacesIdImport = createFileRoute('/_staff/places/$id')()
const StaffPersonIdImport = createFileRoute('/_staff/person/$id')()
const StaffOrganizationIdImport = createFileRoute('/_staff/organization/$id')()
const StaffNetworksIdImport = createFileRoute('/_staff/networks/$id')()
const StaffLicensesIdImport = createFileRoute('/_staff/licenses/$id')()
const StaffFleetsIdImport = createFileRoute('/_staff/fleets/$id')()
const StaffEquipmentIdImport = createFileRoute('/_staff/equipment/$id')()
const StaffContractIdImport = createFileRoute('/_staff/contract/$id')()
const StaffCertificationIdImport = createFileRoute(
  '/_staff/certification/$id',
)()
const StaffBusinessPartnerIdImport = createFileRoute(
  '/_staff/business-partner/$id',
)()
const StaffAppIntegrationsIdImport = createFileRoute(
  '/_staff/app-integrations/$id',
)()
const AuthPasswordResetIndexLazyImport = createFileRoute(
  '/auth/password-reset/',
)()
const StaffSoftwareLayoutAlertsImport = createFileRoute(
  '/_staff/software/_layout/alerts',
)()
const StaffProfileDeviceIdImport = createFileRoute(
  '/_staff/profile/device/$id',
)()
const StaffPersonAlumniIdImport = createFileRoute('/_staff/person/alumni/$id')()
const StaffMarketplaceSentOrdersOrderIdImport = createFileRoute(
  '/_staff/marketplace/sent-orders/$orderId',
)()
const StaffIdsGroupIdIdImport = createFileRoute('/_staff/ids/group-id/$id')()
const StaffDeviceCatalogDraftIdImport = createFileRoute(
  '/_staff/device-catalog/draft/$id',
)()
const StaffDeviceCatalogActiveIdImport = createFileRoute(
  '/_staff/device-catalog/active/$id',
)()
const StaffCertificationSpecialtyCertificationIdImport = createFileRoute(
  '/_staff/certification/specialty-certification/$id',
)()
const StaffCertificationHandlingCertificationIdImport = createFileRoute(
  '/_staff/certification/handling-certification/$id',
)()
const StaffAppsListAlertsImport = createFileRoute('/_staff/apps/_list/alerts')()
const StaffPeopleListSettingsRouteLazyImport = createFileRoute(
  '/_staff/people/_list/settings',
)()
const StaffEquipmentLayoutSettingsRouteLazyImport = createFileRoute(
  '/_staff/equipment/_layout/settings',
)()
const StaffCertificationListSettingsRouteLazyImport = createFileRoute(
  '/_staff/certification/_list/settings',
)()
const StaffSoftwareLayoutIndexRouteLazyImport = createFileRoute(
  '/_staff/software/_layout/',
)()
const StaffPeopleListIndexRouteLazyImport = createFileRoute(
  '/_staff/people/_list/',
)()
const StaffDevicesListIndexRouteLazyImport = createFileRoute(
  '/_staff/devices/_list/',
)()
const StaffAppsListIndexRouteLazyImport = createFileRoute(
  '/_staff/apps/_list/',
)()
const StaffLicensesIdServicePlansLicenseServiceIdImport = createFileRoute(
  '/_staff/licenses/$id/service-plans/$licenseServiceId',
)()
const StaffItOperationCoreDetailOperationInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId',
  )()
const StaffLicensesIdProfileIndexLazyImport = createFileRoute(
  '/_staff/licenses/$id/_profile/',
)()
const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdImport =
  createFileRoute(
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId',
  )()
const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdImport =
  createFileRoute(
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId',
  )()
const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdImport =
  createFileRoute(
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId',
  )()
const StaffAppsListAlertsAlertsShadowItImport = createFileRoute(
  '/_staff/apps/_list/alerts/_alerts/shadow-it',
)()
const StaffStarlinksIdLayoutDetailIndexLazyImport = createFileRoute(
  '/_staff/starlinks/$id/_layout/detail/',
)()
const StaffStarlinksIdLayoutOverviewIndexLazyImport = createFileRoute(
  '/_staff/starlinks/$id/_layout/_overview/',
)()
const StaffPlacesIdLayoutProfileIndexLazyImport = createFileRoute(
  '/_staff/places/$id/_layout/_profile/',
)()
const StaffNetworksIdLayoutProfileIndexLazyImport = createFileRoute(
  '/_staff/networks/$id/_layout/_profile/',
)()
const StaffFleetsIdLayoutProfileIndexLazyImport = createFileRoute(
  '/_staff/fleets/$id/_layout/_profile/',
)()
const StaffEquipmentIdLayoutProfileIndexLazyImport = createFileRoute(
  '/_staff/equipment/$id/_layout/_profile/',
)()
const StaffContractIdLayoutStructureIndexLazyImport = createFileRoute(
  '/_staff/contract/$id/_layout/structure/',
)()
const StaffContractIdLayoutIndexIndexLazyImport = createFileRoute(
  '/_staff/contract/$id/_layout/_index/',
)()
const StaffProfileDeviceIdProfileStatusRouteLazyImport = createFileRoute(
  '/_staff/profile/device/$id/_profile/status',
)()
const StaffProfileDeviceIdProfileMdmRouteLazyImport = createFileRoute(
  '/_staff/profile/device/$id/_profile/mdm',
)()
const StaffProfileDeviceIdProfileControlRouteLazyImport = createFileRoute(
  '/_staff/profile/device/$id/_profile/control',
)()
const StaffProfileDeviceIdProfileIndexRouteLazyImport = createFileRoute(
  '/_staff/profile/device/$id/_profile/',
)()
const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId',
  )()
const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId',
  )()
const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport =
  createFileRoute(
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId',
  )()

// Create/Update Routes

const StaffRoute = StaffImport.update({
  id: '/_staff',
  getParentRoute: () => rootRoute,
} as any)

const IndividualRoute = IndividualImport.update({
  id: '/_individual',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const StaffTimeAndAttendanceRoute = StaffTimeAndAttendanceImport.update({
  id: '/time-and-attendance',
  path: '/time-and-attendance',
  getParentRoute: () => StaffRoute,
} as any)

const StaffStorageFilesRoute = StaffStorageFilesImport.update({
  id: '/storage-files',
  path: '/storage-files',
  getParentRoute: () => StaffRoute,
} as any)

const StaffStarlinksRoute = StaffStarlinksImport.update({
  id: '/starlinks',
  path: '/starlinks',
  getParentRoute: () => StaffRoute,
} as any)

const StaffSoftwareRoute = StaffSoftwareImport.update({
  id: '/software',
  path: '/software',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPublicIdsRoute = StaffPublicIdsImport.update({
  id: '/public-ids',
  path: '/public-ids',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPlacesRoute = StaffPlacesImport.update({
  id: '/places',
  path: '/places',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPeopleRoute = StaffPeopleImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => StaffRoute,
} as any)

const StaffOrganizationRoute = StaffOrganizationImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => StaffRoute,
} as any)

const StaffNetworksRoute = StaffNetworksImport.update({
  id: '/networks',
  path: '/networks',
  getParentRoute: () => StaffRoute,
} as any)

const StaffMarketplaceRoute = StaffMarketplaceImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => StaffRoute,
} as any)

const StaffLicensesRoute = StaffLicensesImport.update({
  id: '/licenses',
  path: '/licenses',
  getParentRoute: () => StaffRoute,
} as any)

const StaffLaborCoreRoute = StaffLaborCoreImport.update({
  id: '/labor-core',
  path: '/labor-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffItOperationCoreRoute = StaffItOperationCoreImport.update({
  id: '/it-operation-core',
  path: '/it-operation-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffIdsRoute = StaffIdsImport.update({
  id: '/ids',
  path: '/ids',
  getParentRoute: () => StaffRoute,
} as any)

const StaffGaOperationCoreRoute = StaffGaOperationCoreImport.update({
  id: '/ga-operation-core',
  path: '/ga-operation-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffFleetsRoute = StaffFleetsImport.update({
  id: '/fleets',
  path: '/fleets',
  getParentRoute: () => StaffRoute,
} as any)

const StaffEquipmentRoute = StaffEquipmentImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => StaffRoute,
} as any)

const StaffDevicesRoute = StaffDevicesImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => StaffRoute,
} as any)

const StaffContractorCoreRoute = StaffContractorCoreImport.update({
  id: '/contractor-core',
  path: '/contractor-core',
  getParentRoute: () => StaffRoute,
} as any)

const StaffContractRoute = StaffContractImport.update({
  id: '/contract',
  path: '/contract',
  getParentRoute: () => StaffRoute,
} as any)

const StaffCertificationRoute = StaffCertificationImport.update({
  id: '/certification',
  path: '/certification',
  getParentRoute: () => StaffRoute,
} as any)

const StaffBusinessPartnerRoute = StaffBusinessPartnerImport.update({
  id: '/business-partner',
  path: '/business-partner',
  getParentRoute: () => StaffRoute,
} as any)

const StaffBusinessOperationEventsRoute =
  StaffBusinessOperationEventsImport.update({
    id: '/business-operation-events',
    path: '/business-operation-events',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffAccessesRoute = StaffAccessesImport.update({
  id: '/accesses',
  path: '/accesses',
  getParentRoute: () => StaffRoute,
} as any)

const StaffIdManagementsRoute = StaffIdManagementsImport.update({
  id: '/id-managements',
  path: '/id-managements',
  getParentRoute: () => StaffRoute,
} as any)

const StaffAppsRoute = StaffAppsImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => StaffRoute,
} as any)

const StaffStarlinksIdRoute = StaffStarlinksIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffStarlinksRoute,
} as any)

const StaffSoftwareIdRoute = StaffSoftwareIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffSettingsPersonsRoute = StaffSettingsPersonsImport.update({
  id: '/settings/persons',
  path: '/settings/persons',
  getParentRoute: () => StaffRoute,
} as any)

const StaffSettingsPermissionAndRolesRoute =
  StaffSettingsPermissionAndRolesImport.update({
    id: '/settings/permission-and-roles',
    path: '/settings/permission-and-roles',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffSettingsContractingCorporationProfileRoute =
  StaffSettingsContractingCorporationProfileImport.update({
    id: '/settings/contracting-corporation-profile',
    path: '/settings/contracting-corporation-profile',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPlacesIdRoute = StaffPlacesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPersonIdRoute = StaffPersonIdImport.update({
  id: '/person/$id',
  path: '/person/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffOrganizationIdRoute = StaffOrganizationIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffOrganizationRoute,
} as any)

const StaffNetworksIdRoute = StaffNetworksIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffNetworksRoute,
} as any)

const StaffLicensesIdRoute = StaffLicensesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffLicensesRoute,
} as any)

const StaffFleetsIdRoute = StaffFleetsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffEquipmentIdRoute = StaffEquipmentIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffEquipmentRoute,
} as any)

const StaffContractIdRoute = StaffContractIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffContractRoute,
} as any)

const StaffCertificationIdRoute = StaffCertificationIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffCertificationRoute,
} as any)

const StaffBusinessPartnerIdRoute = StaffBusinessPartnerIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => StaffBusinessPartnerRoute,
} as any)

const StaffAppIntegrationsIdRoute = StaffAppIntegrationsIdImport.update({
  id: '/app-integrations/$id',
  path: '/app-integrations/$id',
  getParentRoute: () => StaffRoute,
} as any)

const AuthPasswordResetIndexLazyRoute = AuthPasswordResetIndexLazyImport.update(
  {
    id: '/auth/password-reset/',
    path: '/auth/password-reset/',
    getParentRoute: () => rootRoute,
  } as any,
).lazy(() =>
  import('./routes/auth/password-reset/index.lazy').then((d) => d.Route),
)

const AuthSignInIndexRoute = AuthSignInIndexImport.update({
  id: '/auth/sign-in/',
  path: '/auth/sign-in/',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/auth/sign-in/index.lazy').then((d) => d.Route),
)

const StaffSettingsIndexRoute = StaffSettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => StaffRoute,
} as any)

const StaffOrganizationIndexRoute = StaffOrganizationIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffOrganizationRoute,
} as any)

const StaffItOperationCoreIndexRoute = StaffItOperationCoreIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffItOperationCoreRoute,
} as any)

const StaffCockpitIndexRoute = StaffCockpitIndexImport.update({
  id: '/cockpit/',
  path: '/cockpit/',
  getParentRoute: () => StaffRoute,
} as any)

const IndividualIndividualIndexRoute = IndividualIndividualIndexImport.update({
  id: '/individual/',
  path: '/individual/',
  getParentRoute: () => IndividualRoute,
} as any)

const StaffTimeAndAttendanceLayoutRoute =
  StaffTimeAndAttendanceLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffTimeAndAttendanceRoute,
  } as any)

const StaffStorageFilesListRoute = StaffStorageFilesListImport.update({
  id: '/_list',
  getParentRoute: () => StaffStorageFilesRoute,
} as any)

const StaffStarlinksLayoutRoute = StaffStarlinksLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffStarlinksRoute,
} as any)

const StaffSoftwareLayoutRoute = StaffSoftwareLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffPublicIdsListRoute = StaffPublicIdsListImport.update({
  id: '/_list',
  getParentRoute: () => StaffPublicIdsRoute,
} as any)

const StaffPublicIdsIdRoute = StaffPublicIdsIdImport.update({
  id: '/public-ids/$id',
  path: '/public-ids/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPlacesLayoutRoute = StaffPlacesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPeopleListRoute = StaffPeopleListImport.update({
  id: '/_list',
  getParentRoute: () => StaffPeopleRoute,
} as any)

const StaffOrganizationListRoute = StaffOrganizationListImport.update({
  id: '/_list',
  getParentRoute: () => StaffOrganizationRoute,
} as any)

const StaffNetworksLayoutRoute = StaffNetworksLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffNetworksRoute,
} as any)

const StaffMarketplaceStoreRoute = StaffMarketplaceStoreImport.update({
  id: '/_store',
  getParentRoute: () => StaffMarketplaceRoute,
} as any)

const StaffLicensesListRoute = StaffLicensesListImport.update({
  id: '/_list',
  getParentRoute: () => StaffLicensesRoute,
} as any)

const StaffLaborCorePersonTargetsRoute =
  StaffLaborCorePersonTargetsImport.update({
    id: '/person-targets',
    path: '/person-targets',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any).lazy(() =>
    import('./routes/_staff/labor-core/person-targets.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffLaborCoreAnchorDateRoute = StaffLaborCoreAnchorDateImport.update({
  id: '/anchor-date',
  path: '/anchor-date',
  getParentRoute: () => StaffLaborCoreRoute,
} as any).lazy(() =>
  import('./routes/_staff/labor-core/anchor-date.lazy').then((d) => d.Route),
)

const StaffLaborCorePackagesRoute = StaffLaborCorePackagesImport.update({
  id: '/_packages',
  getParentRoute: () => StaffLaborCoreRoute,
} as any)

const StaffItOperationCoreRootRoute = StaffItOperationCoreRootImport.update({
  id: '/_root',
  getParentRoute: () => StaffItOperationCoreRoute,
} as any)

const StaffItOperationCoreDetailRoute = StaffItOperationCoreDetailImport.update(
  {
    id: '/_detail',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any,
)

const StaffIdsLayoutRoute = StaffIdsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffIdsRoute,
} as any)

const StaffIdManagementsSplatRoute = StaffIdManagementsSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => StaffIdManagementsRoute,
} as any)

const StaffGaOperationCorePackagesRoute =
  StaffGaOperationCorePackagesImport.update({
    id: '/_packages',
    getParentRoute: () => StaffGaOperationCoreRoute,
  } as any)

const StaffFleetsLayoutRoute = StaffFleetsLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffEquipmentLayoutRoute = StaffEquipmentLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffEquipmentRoute,
} as any)

const StaffDevicesListRoute = StaffDevicesListImport.update({
  id: '/_list',
  getParentRoute: () => StaffDevicesRoute,
} as any)

const StaffContractorCorePackagesRoute =
  StaffContractorCorePackagesImport.update({
    id: '/_packages',
    getParentRoute: () => StaffContractorCoreRoute,
  } as any)

const StaffContractListRoute = StaffContractListImport.update({
  id: '/_list',
  getParentRoute: () => StaffContractRoute,
} as any)

const StaffCertificationListRoute = StaffCertificationListImport.update({
  id: '/_list',
  getParentRoute: () => StaffCertificationRoute,
} as any)

const StaffBusinessPartnerListRoute = StaffBusinessPartnerListImport.update({
  id: '/_list',
  getParentRoute: () => StaffBusinessPartnerRoute,
} as any)

const StaffBusinessOperationEventsListRoute =
  StaffBusinessOperationEventsListImport.update({
    id: '/_list',
    getParentRoute: () => StaffBusinessOperationEventsRoute,
  } as any)

const StaffAppsListRoute = StaffAppsListImport.update({
  id: '/_list',
  getParentRoute: () => StaffAppsRoute,
} as any)

const StaffAppsSplatRoute = StaffAppsSplatImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => StaffAppsRoute,
} as any)

const StaffAccessesLayoutRoute = StaffAccessesLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffAccessesRoute,
} as any)

const StaffPlacesImportCsvRouteRoute = StaffPlacesImportCsvRouteImport.update({
  id: '/places/import-csv',
  path: '/places/import-csv',
  getParentRoute: () => StaffRoute,
} as any)

const StaffItOperationCoreDeviceInventoryRouteRoute =
  StaffItOperationCoreDeviceInventoryRouteImport.update({
    id: '/it-operation-core/device-inventory',
    path: '/it-operation-core/device-inventory',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffSoftwareLayoutAlertsRoute = StaffSoftwareLayoutAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffSoftwareLayoutRoute,
} as any)

const StaffProfileDeviceIdRoute = StaffProfileDeviceIdImport.update({
  id: '/profile/device/$id',
  path: '/profile/device/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPersonAlumniIdRoute = StaffPersonAlumniIdImport.update({
  id: '/person/alumni/$id',
  path: '/person/alumni/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffMarketplaceSentOrdersOrderIdRoute =
  StaffMarketplaceSentOrdersOrderIdImport.update({
    id: '/sent-orders/$orderId',
    path: '/sent-orders/$orderId',
    getParentRoute: () => StaffMarketplaceRoute,
  } as any)

const StaffIdsGroupIdIdRoute = StaffIdsGroupIdIdImport.update({
  id: '/group-id/$id',
  path: '/group-id/$id',
  getParentRoute: () => StaffIdsRoute,
} as any)

const StaffDeviceCatalogDraftIdRoute = StaffDeviceCatalogDraftIdImport.update({
  id: '/device-catalog/draft/$id',
  path: '/device-catalog/draft/$id',
  getParentRoute: () => StaffRoute,
} as any)

const StaffDeviceCatalogActiveIdRoute = StaffDeviceCatalogActiveIdImport.update(
  {
    id: '/device-catalog/active/$id',
    path: '/device-catalog/active/$id',
    getParentRoute: () => StaffRoute,
  } as any,
)

const StaffCertificationSpecialtyCertificationIdRoute =
  StaffCertificationSpecialtyCertificationIdImport.update({
    id: '/specialty-certification/$id',
    path: '/specialty-certification/$id',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const StaffCertificationHandlingCertificationIdRoute =
  StaffCertificationHandlingCertificationIdImport.update({
    id: '/handling-certification/$id',
    path: '/handling-certification/$id',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const StaffAppsListAlertsRoute = StaffAppsListAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffAppsListRoute,
} as any)

const AuthInvitationInvitationCodeIndexRoute =
  AuthInvitationInvitationCodeIndexImport.update({
    id: '/auth/invitation/$invitationCode/',
    path: '/auth/invitation/$invitationCode/',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/auth/invitation/$invitationCode/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffTimeAndAttendanceLayoutIndexRoute =
  StaffTimeAndAttendanceLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffStarlinksLayoutIndexRoute = StaffStarlinksLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffStarlinksLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/starlinks/_layout/index.lazy').then((d) => d.Route),
)

const StaffSoftwareAddIndexRoute = StaffSoftwareAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffSettingsPersonsIndexRoute = StaffSettingsPersonsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffSettingsPersonsRoute,
} as any)

const StaffSettingsPermissionAndRolesIndexRoute =
  StaffSettingsPermissionAndRolesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsContractingCorporationProfileIndexRoute =
  StaffSettingsContractingCorporationProfileIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSettingsContractingCorporationProfileRoute,
  } as any)

const StaffPublicIdsAddIndexRoute = StaffPublicIdsAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffPublicIdsRoute,
} as any)

const StaffPublicIdsListIndexRoute = StaffPublicIdsListIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffPublicIdsListRoute,
} as any)

const StaffPublicIdsIdIndexRoute = StaffPublicIdsIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffPublicIdsIdRoute,
} as any)

const StaffPlacesAddIndexRoute = StaffPlacesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPlacesAddSelectIndexRoute = StaffPlacesAddSelectIndexImport.update({
  id: '/add-select/',
  path: '/add-select/',
  getParentRoute: () => StaffPlacesRoute,
} as any)

const StaffPlacesLayoutIndexRoute = StaffPlacesLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffPlacesLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/places/_layout/index.lazy').then((d) => d.Route),
)

const StaffPersonExternalHrSaasIndexRoute =
  StaffPersonExternalHrSaasIndexImport.update({
    id: '/person/external-hr-saas/',
    path: '/person/external-hr-saas/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonAddIndexRoute = StaffPersonAddIndexImport.update({
  id: '/person/add/',
  path: '/person/add/',
  getParentRoute: () => StaffRoute,
} as any)

const StaffPersonAddPersonCertificationIndexRoute =
  StaffPersonAddPersonCertificationIndexImport.update({
    id: '/person/add-person-certification/',
    path: '/person/add-person-certification/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffOrganizationPlanIndexRoute = StaffOrganizationPlanIndexImport.update(
  {
    id: '/plan/',
    path: '/plan/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any,
)

const StaffNetworksAddIndexRoute = StaffNetworksAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffNetworksRoute,
} as any)

const StaffNetworksLayoutIndexRoute = StaffNetworksLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffNetworksLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/networks/_layout/index.lazy').then((d) => d.Route),
)

const StaffMarketplaceUnavailableIndexRoute =
  StaffMarketplaceUnavailableIndexImport.update({
    id: '/unavailable/',
    path: '/unavailable/',
    getParentRoute: () => StaffMarketplaceRoute,
  } as any)

const StaffMarketplaceCartIndexRoute = StaffMarketplaceCartIndexImport.update({
  id: '/cart/',
  path: '/cart/',
  getParentRoute: () => StaffMarketplaceRoute,
} as any)

const StaffLicensesAddIndexRoute = StaffLicensesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffLicensesRoute,
} as any)

const StaffLaborCorePackagesIndexRoute =
  StaffLaborCorePackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any).lazy(() =>
    import('./routes/_staff/labor-core/_packages/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffIdsLayoutIndexRoute = StaffIdsLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffIdsLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/ids/_layout/index.lazy').then((d) => d.Route),
)

const StaffGaOperationCorePackagesIndexRoute =
  StaffGaOperationCorePackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffGaOperationCorePackagesRoute,
  } as any).lazy(() =>
    import('./routes/_staff/ga-operation-core/_packages/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffFleetsAddIndexRoute = StaffFleetsAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffFleetsAddSelectIndexRoute = StaffFleetsAddSelectIndexImport.update({
  id: '/add-select/',
  path: '/add-select/',
  getParentRoute: () => StaffFleetsRoute,
} as any)

const StaffEquipmentImportCsvIndexRoute =
  StaffEquipmentImportCsvIndexImport.update({
    id: '/import-csv/',
    path: '/import-csv/',
    getParentRoute: () => StaffEquipmentRoute,
  } as any)

const StaffEquipmentAddIndexRoute = StaffEquipmentAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffEquipmentRoute,
} as any)

const StaffEquipmentAddSelectIndexRoute =
  StaffEquipmentAddSelectIndexImport.update({
    id: '/add-select/',
    path: '/add-select/',
    getParentRoute: () => StaffEquipmentRoute,
  } as any)

const StaffEquipmentLayoutIndexRoute = StaffEquipmentLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffEquipmentLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/equipment/_layout/index.lazy').then((d) => d.Route),
)

const StaffDevicesExternalItSaasIndexRoute =
  StaffDevicesExternalItSaasIndexImport.update({
    id: '/external-it-saas/',
    path: '/external-it-saas/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesAddIndexRoute = StaffDevicesAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffDevicesRoute,
} as any)

const StaffDeviceCatalogAddIndexRoute = StaffDeviceCatalogAddIndexImport.update(
  {
    id: '/device-catalog/add/',
    path: '/device-catalog/add/',
    getParentRoute: () => StaffRoute,
  } as any,
)

const StaffContractorCorePackagesIndexRoute =
  StaffContractorCorePackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffContractorCorePackagesRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contractor-core/_packages/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractAddIndexRoute = StaffContractAddIndexImport.update({
  id: '/add/',
  path: '/add/',
  getParentRoute: () => StaffContractRoute,
} as any)

const StaffContractListIndexRoute = StaffContractListIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffContractListRoute,
} as any).lazy(() =>
  import('./routes/_staff/contract/_list/index.lazy').then((d) => d.Route),
)

const StaffCockpitIdIndexRoute = StaffCockpitIdIndexImport.update({
  id: '/cockpit/$id/',
  path: '/cockpit/$id/',
  getParentRoute: () => StaffRoute,
} as any)

const StaffCertificationAddIndexRoute = StaffCertificationAddIndexImport.update(
  {
    id: '/add/',
    path: '/add/',
    getParentRoute: () => StaffCertificationRoute,
  } as any,
)

const StaffCertificationListIndexRoute =
  StaffCertificationListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffCertificationListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/certification/_list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffBusinessPartnerAddIndexRoute =
  StaffBusinessPartnerAddIndexImport.update({
    id: '/add/',
    path: '/add/',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffBusinessPartnerListIndexRoute =
  StaffBusinessPartnerListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/business-partner/_list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffBusinessOperationEventsListIndexRoute =
  StaffBusinessOperationEventsListIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/business-operation-events/_list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffBusinessOperationEventsEventInstanceIdIndexRoute =
  StaffBusinessOperationEventsEventInstanceIdIndexImport.update({
    id: '/$eventInstanceId/',
    path: '/$eventInstanceId/',
    getParentRoute: () => StaffBusinessOperationEventsRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-operation-events/$eventInstanceId/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAccessesLayoutIndexRoute = StaffAccessesLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffAccessesLayoutRoute,
} as any)

const StaffPeopleListSettingsRouteLazyRoute =
  StaffPeopleListSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffPeopleListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffEquipmentLayoutSettingsRouteLazyRoute =
  StaffEquipmentLayoutSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/_layout/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffCertificationListSettingsRouteLazyRoute =
  StaffCertificationListSettingsRouteLazyImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffCertificationListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/certification/_list/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareLayoutIndexRouteLazyRoute =
  StaffSoftwareLayoutIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListIndexRouteLazyRoute =
  StaffPeopleListIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPeopleListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesListIndexRouteLazyRoute =
  StaffDevicesListIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAppsListIndexRouteLazyRoute =
  StaffAppsListIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAppsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/apps/_list/index/route.lazy').then((d) => d.Route),
  )

const StaffStarlinksIdLayoutRoute = StaffStarlinksIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffStarlinksIdRoute,
} as any)

const StaffSoftwareLayoutIntegrationsRoute =
  StaffSoftwareLayoutIntegrationsImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareIdIdRoute = StaffSoftwareIdIdImport.update({
  id: '/_$id',
  getParentRoute: () => StaffSoftwareIdRoute,
} as any)

const StaffSettingsPersonsListRoute = StaffSettingsPersonsListImport.update({
  id: '/_list',
  getParentRoute: () => StaffSettingsPersonsRoute,
} as any)

const StaffSettingsPermissionAndRolesListRoute =
  StaffSettingsPermissionAndRolesListImport.update({
    id: '/_list',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormRoute =
  StaffSettingsPermissionAndRolesFormImport.update({
    id: '/_form',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailRoute =
  StaffSettingsPermissionAndRolesDetailImport.update({
    id: '/_detail',
    getParentRoute: () => StaffSettingsPermissionAndRolesRoute,
  } as any)

const StaffSettingsContractingCorporationProfileLayoutRoute =
  StaffSettingsContractingCorporationProfileLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffSettingsContractingCorporationProfileRoute,
  } as any)

const StaffPlacesIdLayoutRoute = StaffPlacesIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffPlacesIdRoute,
} as any)

const StaffPersonIdProfileRoute = StaffPersonIdProfileImport.update({
  id: '/_profile',
  getParentRoute: () => StaffPersonIdRoute,
} as any)

const StaffPeopleListSalaryAndPaymentRoute =
  StaffPeopleListSalaryAndPaymentImport.update({
    id: '/salary-and-payment',
    path: '/salary-and-payment',
    getParentRoute: () => StaffPeopleListRoute,
  } as any)

const StaffPeopleListRuleAndPolicyRoute =
  StaffPeopleListRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffPeopleListRoute,
  } as any)

const StaffPeopleListPeopleGraphRoute = StaffPeopleListPeopleGraphImport.update(
  {
    id: '/people-graph',
    path: '/people-graph',
    getParentRoute: () => StaffPeopleListRoute,
  } as any,
)

const StaffPeopleListOperationActivityRoute =
  StaffPeopleListOperationActivityImport.update({
    id: '/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffPeopleListRoute,
  } as any)

const StaffPeopleListCommunityRoute = StaffPeopleListCommunityImport.update({
  id: '/community',
  path: '/community',
  getParentRoute: () => StaffPeopleListRoute,
} as any)

const StaffPeopleListAlertsRoute = StaffPeopleListAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffPeopleListRoute,
} as any)

const StaffOrganizationIdLayoutRoute = StaffOrganizationIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffOrganizationIdRoute,
} as any)

const StaffNetworksIdLayoutRoute = StaffNetworksIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffNetworksIdRoute,
} as any)

const StaffLicensesIdProfileRoute = StaffLicensesIdProfileImport.update({
  id: '/_profile',
  getParentRoute: () => StaffLicensesIdRoute,
} as any)

const StaffLaborCoreSettingsEgovCallbackRoute =
  StaffLaborCoreSettingsEgovCallbackImport.update({
    id: '/settings/egov-callback',
    path: '/settings/egov-callback',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any)

const StaffLaborCorePackagesSettingsRoute =
  StaffLaborCorePackagesSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any)

const StaffItOperationCoreDeviceInventoryDetailRoute =
  StaffItOperationCoreDeviceInventoryDetailImport.update({
    id: '/detail',
    path: '/detail',
    getParentRoute: () => StaffItOperationCoreDeviceInventoryRouteRoute,
  } as any)

const StaffItOperationCoreDeviceInventoryDataRoute =
  StaffItOperationCoreDeviceInventoryDataImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => StaffItOperationCoreDeviceInventoryRouteRoute,
  } as any)

const StaffFleetsLayoutSettingsRoute = StaffFleetsLayoutSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StaffFleetsLayoutRoute,
} as any)

const StaffFleetsLayoutRuleAndPolicyRoute =
  StaffFleetsLayoutRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffFleetsLayoutRoute,
  } as any)

const StaffFleetsLayoutOverviewRoute = StaffFleetsLayoutOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => StaffFleetsLayoutRoute,
} as any)

const StaffFleetsLayoutAlertsRoute = StaffFleetsLayoutAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffFleetsLayoutRoute,
} as any)

const StaffFleetsIdLayoutRoute = StaffFleetsIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffFleetsIdRoute,
} as any)

const StaffEquipmentIdLayoutRoute = StaffEquipmentIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffEquipmentIdRoute,
} as any)

const StaffDevicesListRuleAndPolicyRoute =
  StaffDevicesListRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDevicesListOperationActivityRoute =
  StaffDevicesListOperationActivityImport.update({
    id: '/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDevicesListContractAndCostRoute =
  StaffDevicesListContractAndCostImport.update({
    id: '/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDevicesListAlertsRoute = StaffDevicesListAlertsImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => StaffDevicesListRoute,
} as any)

const StaffContractIdLayoutRoute = StaffContractIdLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => StaffContractIdRoute,
} as any)

const StaffCertificationIdLayoutRoute = StaffCertificationIdLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => StaffCertificationIdRoute,
  } as any,
)

const StaffBusinessPartnerIdLayoutRoute =
  StaffBusinessPartnerIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffBusinessPartnerIdRoute,
  } as any)

const StaffBusinessOperationEventsListSettingsRoute =
  StaffBusinessOperationEventsListSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListRuleAndPolicyRoute =
  StaffBusinessOperationEventsListRuleAndPolicyImport.update({
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListOverviewRoute =
  StaffBusinessOperationEventsListOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListOperationActivityRoute =
  StaffBusinessOperationEventsListOperationActivityImport.update({
    id: '/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListConfigRoute =
  StaffBusinessOperationEventsListConfigImport.update({
    id: '/config',
    path: '/config',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffBusinessOperationEventsListArchiveRoute =
  StaffBusinessOperationEventsListArchiveImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => StaffBusinessOperationEventsListRoute,
  } as any)

const StaffAppsListRuleAndPolicyRoute = StaffAppsListRuleAndPolicyImport.update(
  {
    id: '/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffAppsListRoute,
  } as any,
)

const StaffAppsListOperationActivityRoute =
  StaffAppsListOperationActivityImport.update({
    id: '/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffAppsListRoute,
  } as any)

const StaffAppsListContractAndCostRoute =
  StaffAppsListContractAndCostImport.update({
    id: '/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffAppsListRoute,
  } as any)

const StaffAppIntegrationsIdIdRoute = StaffAppIntegrationsIdIdImport.update({
  id: '/_$id',
  getParentRoute: () => StaffAppIntegrationsIdRoute,
} as any)

const StaffSoftwareLayoutPeopleRouteRoute =
  StaffSoftwareLayoutPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareIdImportCsvRouteRoute =
  StaffSoftwareIdImportCsvRouteImport.update({
    id: '/$id/import-csv',
    path: '/$id/import-csv',
    getParentRoute: () => StaffSoftwareRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/import-csv/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPublicIdsImportCsvPublicIdTypeRouteRoute =
  StaffPublicIdsImportCsvPublicIdTypeRouteImport.update({
    id: '/import-csv/$publicIdType',
    path: '/import-csv/$publicIdType',
    getParentRoute: () => StaffPublicIdsRoute,
  } as any)

const StaffPlacesLayoutSettingsRouteRoute =
  StaffPlacesLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/_layout/settings/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonImportCsvWorkerTypeRouteRoute =
  StaffPersonImportCsvWorkerTypeRouteImport.update({
    id: '/person/import-csv/$workerType',
    path: '/person/import-csv/$workerType',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffItOperationCoreRootPackagesRouteRoute =
  StaffItOperationCoreRootPackagesRouteImport.update({
    id: '/packages',
    path: '/packages',
    getParentRoute: () => StaffItOperationCoreRootRoute,
  } as any)

const StaffDevicesImportCsvDeviceTypeRouteRoute =
  StaffDevicesImportCsvDeviceTypeRouteImport.update({
    id: '/import-csv/$deviceType',
    path: '/import-csv/$deviceType',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffAppIntegrationsImportCsvIdRouteRoute =
  StaffAppIntegrationsImportCsvIdRouteImport.update({
    id: '/app-integrations/import-csv/$id',
    path: '/app-integrations/import-csv/$id',
    getParentRoute: () => StaffRoute,
  } as any).lazy(() =>
    import('./routes/_staff/app-integrations/import-csv/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffLicensesListIndexRouteRoute =
  StaffLicensesListIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesIdServicePlansLicenseServiceIdRoute =
  StaffLicensesIdServicePlansLicenseServiceIdImport.update({
    id: '/service-plans/$licenseServiceId',
    path: '/service-plans/$licenseServiceId',
    getParentRoute: () => StaffLicensesIdRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdImport.update({
    id: '/operation-instances/$instanceId',
    path: '/operation-instances/$instanceId',
    getParentRoute: () => StaffItOperationCoreDetailRoute,
  } as any)

const StaffLicensesIdProfileIndexLazyRoute =
  StaffLicensesIdProfileIndexLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/licenses/$id/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute =
  StaffTimeAndAttendanceLayoutAttendanceLinksIndexImport.update({
    id: '/attendance-links/',
    path: '/attendance-links/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffStorageFilesListFoldersIndexRoute =
  StaffStorageFilesListFoldersIndexImport.update({
    id: '/folders/',
    path: '/folders/',
    getParentRoute: () => StaffStorageFilesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/storage-files/_list/folders/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStorageFilesListFilesIndexRoute =
  StaffStorageFilesListFilesIndexImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => StaffStorageFilesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/storage-files/_list/files/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStarlinksLayoutUserTerminalsIndexRoute =
  StaffStarlinksLayoutUserTerminalsIndexImport.update({
    id: '/user-terminals/',
    path: '/user-terminals/',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/_layout/user-terminals/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStarlinksLayoutAlertsIndexRoute =
  StaffStarlinksLayoutAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/_layout/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareAddTypeIndexRoute = StaffSoftwareAddTypeIndexImport.update({
  id: '/add/$type/',
  path: '/add/$type/',
  getParentRoute: () => StaffSoftwareRoute,
} as any)

const StaffSoftwareLayoutSettingsIndexRoute =
  StaffSoftwareLayoutSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareLayoutRuleAndPolicyIndexRoute =
  StaffSoftwareLayoutRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareLayoutRegistryIndexRoute =
  StaffSoftwareLayoutRegistryIndexImport.update({
    id: '/registry/',
    path: '/registry/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/registry/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareLayoutPeopleIndexRoute =
  StaffSoftwareLayoutPeopleIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareLayoutPeopleRouteRoute,
  } as any)

const StaffSoftwareLayoutOperationActivityIndexRoute =
  StaffSoftwareLayoutOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareLayoutMarketplaceIndexRoute =
  StaffSoftwareLayoutMarketplaceIndexImport.update({
    id: '/marketplace/',
    path: '/marketplace/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/marketplace/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareLayoutContractAndCostIndexRoute =
  StaffSoftwareLayoutContractAndCostIndexImport.update({
    id: '/contract-and-cost/',
    path: '/contract-and-cost/',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any)

const StaffSoftwareIdIdIndexRoute = StaffSoftwareIdIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffSoftwareIdIdRoute,
} as any)

const StaffPublicIdsListSettingsIndexRoute =
  StaffPublicIdsListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListRulesAndPoliciesIndexRoute =
  StaffPublicIdsListRulesAndPoliciesIndexImport.update({
    id: '/rules-and-policies/',
    path: '/rules-and-policies/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListRegistryIndexRoute =
  StaffPublicIdsListRegistryIndexImport.update({
    id: '/registry/',
    path: '/registry/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListOperationActivityIndexRoute =
  StaffPublicIdsListOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListMembersIndexRoute =
  StaffPublicIdsListMembersIndexImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsListAlertsIndexRoute =
  StaffPublicIdsListAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffPublicIdsListRoute,
  } as any)

const StaffPublicIdsIdFilesIndexRoute = StaffPublicIdsIdFilesIndexImport.update(
  {
    id: '/files/',
    path: '/files/',
    getParentRoute: () => StaffPublicIdsIdRoute,
  } as any,
)

const StaffPublicIdsIdDetailsIndexRoute =
  StaffPublicIdsIdDetailsIndexImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => StaffPublicIdsIdRoute,
  } as any)

const StaffPlacesLayoutSettingsIndexRoute =
  StaffPlacesLayoutSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPlacesLayoutSettingsRouteRoute,
  } as any)

const StaffPersonAddWorkerTypeIndexRoute =
  StaffPersonAddWorkerTypeIndexImport.update({
    id: '/person/add/$workerType/',
    path: '/person/add/$workerType/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonAddPersonCertificationCertificationKindIndexRoute =
  StaffPersonAddPersonCertificationCertificationKindIndexImport.update({
    id: '/person/add-person-certification/$certificationKind/',
    path: '/person/add-person-certification/$certificationKind/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPeopleListWorkforceIndexRoute =
  StaffPeopleListWorkforceIndexImport.update({
    id: '/workforce/',
    path: '/workforce/',
    getParentRoute: () => StaffPeopleListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/workforce/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsIndexRoute =
  StaffPeopleListSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any)

const StaffPeopleListAlumniIndexRoute = StaffPeopleListAlumniIndexImport.update(
  {
    id: '/alumni/',
    path: '/alumni/',
    getParentRoute: () => StaffPeopleListRoute,
  } as any,
).lazy(() =>
  import('./routes/_staff/people/_list/alumni/index.lazy').then((d) => d.Route),
)

const StaffOrganizationPlanCreateIndexRoute =
  StaffOrganizationPlanCreateIndexImport.update({
    id: '/plan/create/',
    path: '/plan/create/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffOrganizationPlanIdIndexRoute =
  StaffOrganizationPlanIdIndexImport.update({
    id: '/plan/$id/',
    path: '/plan/$id/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffOrganizationListSettingsIndexRoute =
  StaffOrganizationListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListRulePolicyIndexRoute =
  StaffOrganizationListRulePolicyIndexImport.update({
    id: '/rule-policy/',
    path: '/rule-policy/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListHistoryIndexRoute =
  StaffOrganizationListHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListCostIndexRoute =
  StaffOrganizationListCostIndexImport.update({
    id: '/cost/',
    path: '/cost/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListChartIndexRoute =
  StaffOrganizationListChartIndexImport.update({
    id: '/chart/',
    path: '/chart/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationListAlertIndexRoute =
  StaffOrganizationListAlertIndexImport.update({
    id: '/alert/',
    path: '/alert/',
    getParentRoute: () => StaffOrganizationListRoute,
  } as any)

const StaffOrganizationIdLayoutIndexRoute =
  StaffOrganizationIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffOrganizationIdLayoutRoute,
  } as any)

const StaffMarketplaceSalesOrdersOrderIdIndexRoute =
  StaffMarketplaceSalesOrdersOrderIdIndexImport.update({
    id: '/sales-orders/$orderId/',
    path: '/sales-orders/$orderId/',
    getParentRoute: () => StaffMarketplaceRoute,
  } as any)

const StaffLicensesAddAllocationTypeIndexRoute =
  StaffLicensesAddAllocationTypeIndexImport.update({
    id: '/add/$allocationType/',
    path: '/add/$allocationType/',
    getParentRoute: () => StaffLicensesRoute,
  } as any)

const StaffLicensesListSettingsIndexRoute =
  StaffLicensesListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListRuleAndPolicyIndexRoute =
  StaffLicensesListRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListPeopleIndexRoute =
  StaffLicensesListPeopleIndexImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListOperationActivityIndexRoute =
  StaffLicensesListOperationActivityIndexImport.update({
    id: '/operation-activity/',
    path: '/operation-activity/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListInventoryIndexRoute =
  StaffLicensesListInventoryIndexImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListContractAndCostIndexRoute =
  StaffLicensesListContractAndCostIndexImport.update({
    id: '/contract-and-cost/',
    path: '/contract-and-cost/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLicensesListAlertsIndexRoute =
  StaffLicensesListAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffLicensesListRoute,
  } as any)

const StaffLaborCoreConfigPatternIdIndexRoute =
  StaffLaborCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any)

const StaffLaborCorePackagesSettingsIndexRoute =
  StaffLaborCorePackagesSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffLaborCorePackagesSettingsRoute,
  } as any)

const StaffLaborCorePackagesConfigsIndexRoute =
  StaffLaborCorePackagesConfigsIndexImport.update({
    id: '/configs/',
    path: '/configs/',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any)

const StaffLaborCorePackagesArchivesIndexRoute =
  StaffLaborCorePackagesArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffLaborCorePackagesRoute,
  } as any)

const StaffItOperationCoreConfigPatternIdIndexRoute =
  StaffItOperationCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffItOperationCoreRoute,
  } as any)

const StaffItOperationCoreRootPackagesIndexRoute =
  StaffItOperationCoreRootPackagesIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffItOperationCoreRootPackagesRouteRoute,
  } as any)

const StaffItOperationCoreRootConfigIndexRoute =
  StaffItOperationCoreRootConfigIndexImport.update({
    id: '/config/',
    path: '/config/',
    getParentRoute: () => StaffItOperationCoreRootRoute,
  } as any)

const StaffItOperationCoreRootArchivesIndexRoute =
  StaffItOperationCoreRootArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffItOperationCoreRootRoute,
  } as any)

const StaffIdsGroupIdAddIndexRoute = StaffIdsGroupIdAddIndexImport.update({
  id: '/group-id/add/',
  path: '/group-id/add/',
  getParentRoute: () => StaffIdsRoute,
} as any).lazy(() =>
  import('./routes/_staff/ids/group-id/add/index.lazy').then((d) => d.Route),
)

const StaffIdsLayoutPeopleIndexRoute = StaffIdsLayoutPeopleIndexImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => StaffIdsLayoutRoute,
} as any).lazy(() =>
  import('./routes/_staff/ids/_layout/people/index.lazy').then((d) => d.Route),
)

const StaffGaOperationCoreConfigPatternIdIndexRoute =
  StaffGaOperationCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffGaOperationCoreRoute,
  } as any)

const StaffGaOperationCorePackagesConfigsIndexRoute =
  StaffGaOperationCorePackagesConfigsIndexImport.update({
    id: '/configs/',
    path: '/configs/',
    getParentRoute: () => StaffGaOperationCorePackagesRoute,
  } as any)

const StaffGaOperationCorePackagesArchivesIndexRoute =
  StaffGaOperationCorePackagesArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffGaOperationCorePackagesRoute,
  } as any)

const StaffFleetsLayoutListIndexRoute = StaffFleetsLayoutListIndexImport.update(
  {
    id: '/_list/',
    path: '/',
    getParentRoute: () => StaffFleetsLayoutRoute,
  } as any,
)

const StaffEquipmentLayoutSettingsIndexRoute =
  StaffEquipmentLayoutSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffEquipmentLayoutSettingsRouteLazyRoute,
  } as any)

const StaffDevicesAddDeviceTypeIndexRoute =
  StaffDevicesAddDeviceTypeIndexImport.update({
    id: '/add/$deviceType/',
    path: '/add/$deviceType/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesListSettingsIndexRoute =
  StaffDevicesListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDevicesListPeopleIndexRoute =
  StaffDevicesListPeopleIndexImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/people/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesListInventoryIndexRoute =
  StaffDevicesListInventoryIndexImport.update({
    id: '/inventory/',
    path: '/inventory/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/inventory/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDevicesListCatalogIndexRoute =
  StaffDevicesListCatalogIndexImport.update({
    id: '/catalog/',
    path: '/catalog/',
    getParentRoute: () => StaffDevicesListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/devices/_list/catalog/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDeviceCatalogAddDeviceTypeIndexRoute =
  StaffDeviceCatalogAddDeviceTypeIndexImport.update({
    id: '/device-catalog/add/$deviceType/',
    path: '/device-catalog/add/$deviceType/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffContractorCoreConfigPatternIdIndexRoute =
  StaffContractorCoreConfigPatternIdIndexImport.update({
    id: '/config/$patternId/',
    path: '/config/$patternId/',
    getParentRoute: () => StaffContractorCoreRoute,
  } as any)

const StaffContractorCorePackagesConfigsIndexRoute =
  StaffContractorCorePackagesConfigsIndexImport.update({
    id: '/configs/',
    path: '/configs/',
    getParentRoute: () => StaffContractorCorePackagesRoute,
  } as any)

const StaffContractorCorePackagesArchivesIndexRoute =
  StaffContractorCorePackagesArchivesIndexImport.update({
    id: '/archives/',
    path: '/archives/',
    getParentRoute: () => StaffContractorCorePackagesRoute,
  } as any)

const StaffContractImportCsvContractTypeIndexRoute =
  StaffContractImportCsvContractTypeIndexImport.update({
    id: '/import-csv/$contractType/',
    path: '/import-csv/$contractType/',
    getParentRoute: () => StaffContractRoute,
  } as any)

const StaffCertificationAddCertificationKindIndexRoute =
  StaffCertificationAddCertificationKindIndexImport.update({
    id: '/add/$certificationKind/',
    path: '/add/$certificationKind/',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const StaffCertificationListSettingsIndexRoute =
  StaffCertificationListSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any)

const StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute =
  StaffBusinessPartnerAddBusinessPartnerTypeIndexImport.update({
    id: '/add/$businessPartnerType/',
    path: '/add/$businessPartnerType/',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffBusinessPartnerListTerminatedIndexRoute =
  StaffBusinessPartnerListTerminatedIndexImport.update({
    id: '/terminated/',
    path: '/terminated/',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/business-partner/_list/terminated/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAppsCustomAppAddIndexRoute = StaffAppsCustomAppAddIndexImport.update(
  {
    id: '/custom-app/add/',
    path: '/custom-app/add/',
    getParentRoute: () => StaffAppsRoute,
  } as any,
)

const StaffAppsListSettingsIndexRoute = StaffAppsListSettingsIndexImport.update(
  {
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffAppsListRoute,
  } as any,
)

const StaffAppsListPeopleIndexRoute = StaffAppsListPeopleIndexImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => StaffAppsListRoute,
} as any).lazy(() =>
  import('./routes/_staff/apps/_list/people/index.lazy').then((d) => d.Route),
)

const StaffAppsListMarketplaceIndexRoute =
  StaffAppsListMarketplaceIndexImport.update({
    id: '/marketplace/',
    path: '/marketplace/',
    getParentRoute: () => StaffAppsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/apps/_list/marketplace/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAppsListIntegrationsIndexRoute =
  StaffAppsListIntegrationsIndexImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => StaffAppsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/apps/_list/integrations/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAppIntegrationsIdIdIndexRoute =
  StaffAppIntegrationsIdIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any)

const StaffAccessesLayoutListIndexRoute =
  StaffAccessesLayoutListIndexImport.update({
    id: '/list/',
    path: '/list/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/accesses/_layout/list/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAccessesLayoutAlertsIndexRoute =
  StaffAccessesLayoutAlertsIndexImport.update({
    id: '/alerts/',
    path: '/alerts/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/accesses/_layout/alerts/index.lazy').then(
      (d) => d.Route,
    ),
  )

const IndividualIndividualTaskIdIndexRoute =
  IndividualIndividualTaskIdIndexImport.update({
    id: '/individual/task/$id/',
    path: '/individual/task/$id/',
    getParentRoute: () => IndividualRoute,
  } as any)

const IndividualIndividualOperationPackageIdIndexRoute =
  IndividualIndividualOperationPackageIdIndexImport.update({
    id: '/individual/operation-package/$id/',
    path: '/individual/operation-package/$id/',
    getParentRoute: () => IndividualRoute,
  } as any)

const StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute =
  StaffTimeAndAttendanceLayoutPlaceholdersClockingImport.update({
    id: '/_placeholders/clocking',
    path: '/clocking',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute =
  StaffTimeAndAttendanceLayoutPlaceholdersAttendancesImport.update({
    id: '/_placeholders/attendances',
    path: '/attendances',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffStarlinksLayoutPlaceholdersOperationActivityRoute =
  StaffStarlinksLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any)

const StaffStarlinksLayoutPlaceholdersMarketplaceRoute =
  StaffStarlinksLayoutPlaceholdersMarketplaceImport.update({
    id: '/_placeholders/marketplace',
    path: '/marketplace',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any)

const StaffStarlinksLayoutPlaceholdersBillingAndCostRoute =
  StaffStarlinksLayoutPlaceholdersBillingAndCostImport.update({
    id: '/_placeholders/billing-and-cost',
    path: '/billing-and-cost',
    getParentRoute: () => StaffStarlinksLayoutRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsRoute =
  StaffSoftwareLayoutAlertsAlertsImport.update({
    id: '/_alerts',
    getParentRoute: () => StaffSoftwareLayoutAlertsRoute,
  } as any)

const StaffSettingsPersonsListAccountRoute =
  StaffSettingsPersonsListAccountImport.update({
    id: '/_account',
    getParentRoute: () => StaffSettingsPersonsListRoute,
  } as any)

const StaffProfileDeviceIdProfileRoute =
  StaffProfileDeviceIdProfileImport.update({
    id: '/_profile',
    getParentRoute: () => StaffProfileDeviceIdRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersStoreRoute =
  StaffPlacesLayoutPlaceholdersStoreImport.update({
    id: '/_placeholders/store',
    path: '/store',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute =
  StaffPlacesLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersPeopleRoute =
  StaffPlacesLayoutPlaceholdersPeopleImport.update({
    id: '/_placeholders/people',
    path: '/people',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersOverviewRoute =
  StaffPlacesLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersOperationActivityRoute =
  StaffPlacesLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersContractAndCostRoute =
  StaffPlacesLayoutPlaceholdersContractAndCostImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPlacesLayoutPlaceholdersAlertsRoute =
  StaffPlacesLayoutPlaceholdersAlertsImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffPlacesLayoutRoute,
  } as any)

const StaffPersonAlumniIdProfileRoute = StaffPersonAlumniIdProfileImport.update(
  {
    id: '/_profile',
    getParentRoute: () => StaffPersonAlumniIdRoute,
  } as any,
)

const StaffPersonAddWorkerTypeCompletedRoute =
  StaffPersonAddWorkerTypeCompletedImport.update({
    id: '/person/add/$workerType/completed',
    path: '/person/add/$workerType/completed',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonAddPersonCertificationCertificationKindCompletedRoute =
  StaffPersonAddPersonCertificationCertificationKindCompletedImport.update({
    id: '/person/add-person-certification/$certificationKind/completed',
    path: '/person/add-person-certification/$certificationKind/completed',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersSettingsRoute =
  StaffNetworksLayoutPlaceholdersSettingsImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute =
  StaffNetworksLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersOverviewRoute =
  StaffNetworksLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersOperationActivityRoute =
  StaffNetworksLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersContractAndCostRoute =
  StaffNetworksLayoutPlaceholdersContractAndCostImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffNetworksLayoutPlaceholdersAlertsRoute =
  StaffNetworksLayoutPlaceholdersAlertsImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffNetworksLayoutRoute,
  } as any)

const StaffMarketplaceSentOrdersOrderIdLayoutRoute =
  StaffMarketplaceSentOrdersOrderIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffMarketplaceSentOrdersOrderIdRoute,
  } as any)

const StaffLicensesAddAllocationTypeCompletedRoute =
  StaffLicensesAddAllocationTypeCompletedImport.update({
    id: '/add/$allocationType/completed',
    path: '/add/$allocationType/completed',
    getParentRoute: () => StaffLicensesRoute,
  } as any)

const StaffLaborCoreSettingsProfileProfileIdRoute =
  StaffLaborCoreSettingsProfileProfileIdImport.update({
    id: '/settings/profile/$profileId',
    path: '/settings/profile/$profileId',
    getParentRoute: () => StaffLaborCoreRoute,
  } as any)

const StaffItOperationCoreRootPackagesPackageIdRoute =
  StaffItOperationCoreRootPackagesPackageIdImport.update({
    id: '/$packageId',
    path: '/$packageId',
    getParentRoute: () => StaffItOperationCoreRootPackagesRouteRoute,
  } as any)

const StaffIdsGroupIdIdIdRoute = StaffIdsGroupIdIdIdImport.update({
  id: '/_$id',
  getParentRoute: () => StaffIdsGroupIdIdRoute,
} as any)

const StaffIdsLayoutPlaceholdersSettingsRoute =
  StaffIdsLayoutPlaceholdersSettingsImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersRuleAndPolicyRoute =
  StaffIdsLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersOverviewRoute =
  StaffIdsLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersOperationActivityRoute =
  StaffIdsLayoutPlaceholdersOperationActivityImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersGroupIdRoute =
  StaffIdsLayoutPlaceholdersGroupIdImport.update({
    id: '/_placeholders/group-id',
    path: '/group-id',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffIdsLayoutPlaceholdersAlertsRoute =
  StaffIdsLayoutPlaceholdersAlertsImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffIdsLayoutRoute,
  } as any)

const StaffEquipmentLayoutPlaceholdersSettingsRoute =
  StaffEquipmentLayoutPlaceholdersSettingsImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any)

const StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute =
  StaffEquipmentLayoutPlaceholdersRuleAndPolicyImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any)

const StaffEquipmentLayoutPlaceholdersOverviewRoute =
  StaffEquipmentLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any)

const StaffEquipmentLayoutPlaceholdersAlertsRoute =
  StaffEquipmentLayoutPlaceholdersAlertsImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffEquipmentLayoutRoute,
  } as any)

const StaffDevicesAddDeviceTypeCompletedRoute =
  StaffDevicesAddDeviceTypeCompletedImport.update({
    id: '/add/$deviceType/completed',
    path: '/add/$deviceType/completed',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffDevicesListSettingsCatalogRoute =
  StaffDevicesListSettingsCatalogImport.update({
    id: '/settings/catalog',
    path: '/settings/catalog',
    getParentRoute: () => StaffDevicesListRoute,
  } as any)

const StaffDeviceCatalogDraftIdLayoutRoute =
  StaffDeviceCatalogDraftIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffDeviceCatalogDraftIdRoute,
  } as any)

const StaffDeviceCatalogAddDeviceTypeCompletedRoute =
  StaffDeviceCatalogAddDeviceTypeCompletedImport.update({
    id: '/device-catalog/add/$deviceType/completed',
    path: '/device-catalog/add/$deviceType/completed',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutRoute =
  StaffDeviceCatalogActiveIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffDeviceCatalogActiveIdRoute,
  } as any)

const StaffCertificationSpecialtyCertificationIdLayoutRoute =
  StaffCertificationSpecialtyCertificationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffCertificationSpecialtyCertificationIdRoute,
  } as any)

const StaffCertificationHandlingCertificationIdLayoutRoute =
  StaffCertificationHandlingCertificationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => StaffCertificationHandlingCertificationIdRoute,
  } as any)

const StaffCertificationAddCertificationKindCompletedRoute =
  StaffCertificationAddCertificationKindCompletedImport.update({
    id: '/add/$certificationKind/completed',
    path: '/add/$certificationKind/completed',
    getParentRoute: () => StaffCertificationRoute,
  } as any)

const StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute =
  StaffBusinessPartnerAddBusinessPartnerTypeCompletedImport.update({
    id: '/add/$businessPartnerType/completed',
    path: '/add/$businessPartnerType/completed',
    getParentRoute: () => StaffBusinessPartnerRoute,
  } as any)

const StaffAppsListAlertsAlertsRoute = StaffAppsListAlertsAlertsImport.update({
  id: '/_alerts',
  getParentRoute: () => StaffAppsListAlertsRoute,
} as any)

const StaffAppIntegrationsIdIdGroupsRoute =
  StaffAppIntegrationsIdIdGroupsImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any)

const StaffAccessesLayoutPlaceholdersSoftwareRoute =
  StaffAccessesLayoutPlaceholdersSoftwareImport.update({
    id: '/_placeholders/software',
    path: '/software',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any)

const StaffAccessesLayoutPlaceholdersSettingsRoute =
  StaffAccessesLayoutPlaceholdersSettingsImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any)

const StaffAccessesLayoutPlaceholdersOverviewRoute =
  StaffAccessesLayoutPlaceholdersOverviewImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any)

const StaffAccessesLayoutPlaceholdersContractAndCostRoute =
  StaffAccessesLayoutPlaceholdersContractAndCostImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any)

const IndividualIndividualTaskIdApprovalDialogRoute =
  IndividualIndividualTaskIdApprovalDialogImport.update({
    id: '/individual/task/$id/approval-dialog',
    path: '/individual/task/$id/approval-dialog',
    getParentRoute: () => IndividualRoute,
  } as any)

const StaffSoftwareLayoutMarketplaceIdRouteRoute =
  StaffSoftwareLayoutMarketplaceIdRouteImport.update({
    id: '/marketplace/$id',
    path: '/marketplace/$id',
    getParentRoute: () => StaffSoftwareLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/_layout/marketplace/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractListPlaceholdersPeopleRouteRoute =
  StaffContractListPlaceholdersPeopleRouteImport.update({
    id: '/_placeholders/people',
    path: '/people',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersOverviewRouteRoute =
  StaffContractListPlaceholdersOverviewRouteImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersOperationActivityRouteRoute =
  StaffContractListPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersContractAndCostRouteRoute =
  StaffContractListPlaceholdersContractAndCostRouteImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffContractListPlaceholdersAlertsRouteRoute =
  StaffContractListPlaceholdersAlertsRouteImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffContractListRoute,
  } as any)

const StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute =
  StaffCertificationListPlaceholdersRuleAndPolicyRouteImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffCertificationListPlaceholdersOverviewRouteRoute =
  StaffCertificationListPlaceholdersOverviewRouteImport.update({
    id: '/_placeholders/overview',
    path: '/overview',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffCertificationListPlaceholdersOperationActivityRouteRoute =
  StaffCertificationListPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffCertificationListPlaceholdersAlertsRouteRoute =
  StaffCertificationListPlaceholdersAlertsRouteImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffCertificationListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersSettingsRouteRoute =
  StaffBusinessPartnerListPlaceholdersSettingsRouteImport.update({
    id: '/_placeholders/settings',
    path: '/settings',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute =
  StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute =
  StaffBusinessPartnerListPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute =
  StaffBusinessPartnerListPlaceholdersContractAndCostRouteImport.update({
    id: '/_placeholders/contract-and-cost',
    path: '/contract-and-cost',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffBusinessPartnerListPlaceholdersAlertsRouteRoute =
  StaffBusinessPartnerListPlaceholdersAlertsRouteImport.update({
    id: '/_placeholders/alerts',
    path: '/alerts',
    getParentRoute: () => StaffBusinessPartnerListRoute,
  } as any)

const StaffAppsListMarketplaceIdRouteRoute =
  StaffAppsListMarketplaceIdRouteImport.update({
    id: '/marketplace/$id',
    path: '/marketplace/$id',
    getParentRoute: () => StaffAppsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/apps/_list/marketplace/$id/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonIdProfileIndexRouteRoute =
  StaffPersonIdProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdImport.update(
    {
      id: '/certifications/specialty-certifications/$personCertificationInformationId',
      path: '/certifications/specialty-certifications/$personCertificationInformationId',
      getParentRoute: () => StaffPersonIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdImport.update(
    {
      id: '/certifications/handling-certifications/$personCertificationInformationId',
      path: '/certifications/handling-certifications/$personCertificationInformationId',
      getParentRoute: () => StaffPersonIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdImport.update(
    {
      id: '/certifications/base-certifications/$personCertificationInformationId',
      path: '/certifications/base-certifications/$personCertificationInformationId',
      getParentRoute: () => StaffPersonIdRoute,
    } as any,
  )

const StaffAppsListAlertsAlertsShadowItRoute =
  StaffAppsListAlertsAlertsShadowItImport.update({
    id: '/shadow-it',
    path: '/shadow-it',
    getParentRoute: () => StaffAppsListAlertsAlertsRoute,
  } as any)

const StaffStarlinksIdLayoutDetailIndexLazyRoute =
  StaffStarlinksIdLayoutDetailIndexLazyImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => StaffStarlinksIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/$id/_layout/detail/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffStarlinksIdLayoutOverviewIndexLazyRoute =
  StaffStarlinksIdLayoutOverviewIndexLazyImport.update({
    id: '/_overview/',
    path: '/',
    getParentRoute: () => StaffStarlinksIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/starlinks/$id/_layout/_overview/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPlacesIdLayoutProfileIndexLazyRoute =
  StaffPlacesIdLayoutProfileIndexLazyImport.update({
    id: '/_profile/',
    path: '/',
    getParentRoute: () => StaffPlacesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/$id/_layout/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffNetworksIdLayoutProfileIndexLazyRoute =
  StaffNetworksIdLayoutProfileIndexLazyImport.update({
    id: '/_profile/',
    path: '/',
    getParentRoute: () => StaffNetworksIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/networks/$id/_layout/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffFleetsIdLayoutProfileIndexLazyRoute =
  StaffFleetsIdLayoutProfileIndexLazyImport.update({
    id: '/_profile/',
    path: '/',
    getParentRoute: () => StaffFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/fleets/$id/_layout/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffEquipmentIdLayoutProfileIndexLazyRoute =
  StaffEquipmentIdLayoutProfileIndexLazyImport.update({
    id: '/_profile/',
    path: '/',
    getParentRoute: () => StaffEquipmentIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/equipment/$id/_layout/_profile/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractIdLayoutStructureIndexLazyRoute =
  StaffContractIdLayoutStructureIndexLazyImport.update({
    id: '/structure/',
    path: '/structure/',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contract/$id/_layout/structure/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractIdLayoutIndexIndexLazyRoute =
  StaffContractIdLayoutIndexIndexLazyImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/contract/$id/_layout/_index/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute =
  StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexImport.update({
    id: '/attendance-links/$placeId/',
    path: '/attendance-links/$placeId/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffTimeAndAttendanceLayoutListSummaryIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryIndexImport.update({
    id: '/_list/summary/',
    path: '/summary/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any)

const StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute =
  StaffSoftwareCustomSaasAddCustomSaasTypeIndexImport.update({
    id: '/custom-saas/add/$customSaasType/',
    path: '/custom-saas/add/$customSaasType/',
    getParentRoute: () => StaffSoftwareRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/custom-saas/add/$customSaasType/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutAlertsAlertsIndexRoute =
  StaffSoftwareLayoutAlertsAlertsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareIdIdUsersIndexRoute =
  StaffSoftwareIdIdUsersIndexImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/software/$id/_$id/users/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSoftwareIdIdSettingsIndexRoute =
  StaffSoftwareIdIdSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdRuleAndPolicyIndexRoute =
  StaffSoftwareIdIdRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdDetailIndexRoute =
  StaffSoftwareIdIdDetailIndexImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdContractsCostIndexRoute =
  StaffSoftwareIdIdContractsCostIndexImport.update({
    id: '/contracts-cost/',
    path: '/contracts-cost/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdArchitectureIndexRoute =
  StaffSoftwareIdIdArchitectureIndexImport.update({
    id: '/architecture/',
    path: '/architecture/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSoftwareIdIdActivityMonitoringIndexRoute =
  StaffSoftwareIdIdActivityMonitoringIndexImport.update({
    id: '/activity-monitoring/',
    path: '/activity-monitoring/',
    getParentRoute: () => StaffSoftwareIdIdRoute,
  } as any)

const StaffSettingsPersonsListSettingsIndexRoute =
  StaffSettingsPersonsListSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffSettingsPersonsListRoute,
  } as any).lazy(() =>
    import('./routes/_staff/settings/persons/_list/settings/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffSettingsPermissionAndRolesListRolesIndexRoute =
  StaffSettingsPermissionAndRolesListRolesIndexImport.update({
    id: '/roles/',
    path: '/roles/',
    getParentRoute: () => StaffSettingsPermissionAndRolesListRoute,
  } as any)

const StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute =
  StaffSettingsPermissionAndRolesListProductPermissionsIndexImport.update({
    id: '/product-permissions/',
    path: '/product-permissions/',
    getParentRoute: () => StaffSettingsPermissionAndRolesListRoute,
  } as any)

const StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute =
  StaffSettingsPermissionAndRolesListPeopleGroupsIndexImport.update({
    id: '/people-groups/',
    path: '/people-groups/',
    getParentRoute: () => StaffSettingsPermissionAndRolesListRoute,
  } as any)

const StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutShareholdersIndexImport.update(
    {
      id: '/shareholders/',
      path: '/shareholders/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutRegistrationIndexImport.update(
    {
      id: '/registration/',
      path: '/registration/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffSettingsContractingCorporationProfileLayoutRoute,
  } as any)

const StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexImport.update(
    {
      id: '/group-companies/',
      path: '/group-companies/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexImport.update(
    {
      id: '/corporate-overview/',
      path: '/corporate-overview/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutContactPointsIndexImport.update(
    {
      id: '/contact-points/',
      path: '/contact-points/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute =
  StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexImport.update(
    {
      id: '/board-member/',
      path: '/board-member/',
      getParentRoute: () =>
        StaffSettingsContractingCorporationProfileLayoutRoute,
    } as any,
  )

const StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute =
  StaffPlacesLayoutSettingsPlaceSubCodesIndexImport.update({
    id: '/place-sub-codes/',
    path: '/place-sub-codes/',
    getParentRoute: () => StaffPlacesLayoutSettingsRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/places/_layout/settings/place-sub-codes/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPlacesIdLayoutLaborCoreIndexRoute =
  StaffPlacesIdLayoutLaborCoreIndexImport.update({
    id: '/labor-core/',
    path: '/labor-core/',
    getParentRoute: () => StaffPlacesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/$id/_layout/labor-core/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPlacesIdLayoutAdministratorsIndexRoute =
  StaffPlacesIdLayoutAdministratorsIndexImport.update({
    id: '/administrators/',
    path: '/administrators/',
    getParentRoute: () => StaffPlacesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/_staff/places/$id/_layout/administrators/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute =
  StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexImport.update({
    id: '/person/external-hr-saas/$appIntegrationId/preview/',
    path: '/person/external-hr-saas/$appIntegrationId/preview/',
    getParentRoute: () => StaffRoute,
  } as any)

const StaffPersonIdProfilePublicIdIndexRoute =
  StaffPersonIdProfilePublicIdIndexImport.update({
    id: '/public-id/',
    path: '/public-id/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfilePersonalInformationIndexRoute =
  StaffPersonIdProfilePersonalInformationIndexImport.update({
    id: '/personal-information/',
    path: '/personal-information/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileHistoryIndexRoute =
  StaffPersonIdProfileHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileEquipmentIndexRoute =
  StaffPersonIdProfileEquipmentIndexImport.update({
    id: '/equipment/',
    path: '/equipment/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileEmployeeInformationIndexRoute =
  StaffPersonIdProfileEmployeeInformationIndexImport.update({
    id: '/employee-information/',
    path: '/employee-information/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileEducationAndQualificationIndexRoute =
  StaffPersonIdProfileEducationAndQualificationIndexImport.update({
    id: '/education-and-qualification/',
    path: '/education-and-qualification/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileDevicesIndexRoute =
  StaffPersonIdProfileDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPersonIdProfileAppsIndexRoute =
  StaffPersonIdProfileAppsIndexImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/person/$id/_profile/apps/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonIdProfileActivityIndexRoute =
  StaffPersonIdProfileActivityIndexImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffPeopleListSettingsWorkModeIndexRoute =
  StaffPeopleListSettingsWorkModeIndexImport.update({
    id: '/work-mode/',
    path: '/work-mode/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/work-mode/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsRetirementReasonsIndexRoute =
  StaffPeopleListSettingsRetirementReasonsIndexImport.update({
    id: '/retirement-reasons/',
    path: '/retirement-reasons/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/retirement-reasons/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsPositionsIndexRoute =
  StaffPeopleListSettingsPositionsIndexImport.update({
    id: '/positions/',
    path: '/positions/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/positions/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute =
  StaffPeopleListSettingsPlaceSocialInsurancesIndexImport.update({
    id: '/place-social-insurances/',
    path: '/place-social-insurances/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/place-social-insurances/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsJobTypesIndexRoute =
  StaffPeopleListSettingsJobTypesIndexImport.update({
    id: '/job-types/',
    path: '/job-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-types/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobTitlesIndexRoute =
  StaffPeopleListSettingsJobTitlesIndexImport.update({
    id: '/job-titles/',
    path: '/job-titles/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-titles/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobLevelsIndexRoute =
  StaffPeopleListSettingsJobLevelsIndexImport.update({
    id: '/job-levels/',
    path: '/job-levels/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-levels/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobGradesIndexRoute =
  StaffPeopleListSettingsJobGradesIndexImport.update({
    id: '/job-grades/',
    path: '/job-grades/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/job-grades/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsJobFunctionsIndexRoute =
  StaffPeopleListSettingsJobFunctionsIndexImport.update({
    id: '/job-functions/',
    path: '/job-functions/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/job-functions/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsJobCompetenciesIndexRoute =
  StaffPeopleListSettingsJobCompetenciesIndexImport.update({
    id: '/job-competencies/',
    path: '/job-competencies/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/job-competencies/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute =
  StaffPeopleListSettingsHealthInsuranceAssociationsIndexImport.update({
    id: '/health-insurance-associations/',
    path: '/health-insurance-associations/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/health-insurance-associations/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsGradesIndexRoute =
  StaffPeopleListSettingsGradesIndexImport.update({
    id: '/grades/',
    path: '/grades/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_staff/people/_list/settings/grades/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPeopleListSettingsEmploymentTypesIndexRoute =
  StaffPeopleListSettingsEmploymentTypesIndexImport.update({
    id: '/employment-types/',
    path: '/employment-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/employment-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute =
  StaffPeopleListSettingsEmployeeSubIdNamesIndexImport.update({
    id: '/employee-sub-id-names/',
    path: '/employee-sub-id-names/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/employee-sub-id-names/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsContractorTypesIndexRoute =
  StaffPeopleListSettingsContractorTypesIndexImport.update({
    id: '/contractor-types/',
    path: '/contractor-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/contractor-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsContractEndReasonsIndexRoute =
  StaffPeopleListSettingsContractEndReasonsIndexImport.update({
    id: '/contract-end-reasons/',
    path: '/contract-end-reasons/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/contract-end-reasons/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsCollaboratorTypesIndexRoute =
  StaffPeopleListSettingsCollaboratorTypesIndexImport.update({
    id: '/collaborator-types/',
    path: '/collaborator-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/collaborator-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffPeopleListSettingsBoardMemberTypesIndexRoute =
  StaffPeopleListSettingsBoardMemberTypesIndexImport.update({
    id: '/board-member-types/',
    path: '/board-member-types/',
    getParentRoute: () => StaffPeopleListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/people/_list/settings/board-member-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffOrganizationPlanIdAddIndexRoute =
  StaffOrganizationPlanIdAddIndexImport.update({
    id: '/plan/$id/add/',
    path: '/plan/$id/add/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffOrganizationIdLayoutHistoryIndexRoute =
  StaffOrganizationIdLayoutHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffOrganizationIdLayoutRoute,
  } as any)

const StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute =
  StaffMarketplaceSentOrdersOrderIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffMarketplaceSentOrdersOrderIdLayoutRoute,
  } as any)

const StaffMarketplaceStoreStoreStarlinksIndexRoute =
  StaffMarketplaceStoreStoreStarlinksIndexImport.update({
    id: '/store/starlinks/',
    path: '/store/starlinks/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreSentOrdersIndexRoute =
  StaffMarketplaceStoreStoreSentOrdersIndexImport.update({
    id: '/store/sent-orders/',
    path: '/store/sent-orders/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreSalesOrdersIndexRoute =
  StaffMarketplaceStoreStoreSalesOrdersIndexImport.update({
    id: '/store/sales-orders/',
    path: '/store/sales-orders/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreDevicesIndexRoute =
  StaffMarketplaceStoreStoreDevicesIndexImport.update({
    id: '/store/devices/',
    path: '/store/devices/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffLicensesIdProfileServicePlansIndexRoute =
  StaffLicensesIdProfileServicePlansIndexImport.update({
    id: '/service-plans/',
    path: '/service-plans/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any)

const StaffLicensesIdProfilePeopleIndexRoute =
  StaffLicensesIdProfilePeopleIndexImport.update({
    id: '/people/',
    path: '/people/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any)

const StaffLicensesIdProfileAssignmentsIndexRoute =
  StaffLicensesIdProfileAssignmentsIndexImport.update({
    id: '/assignments/',
    path: '/assignments/',
    getParentRoute: () => StaffLicensesIdProfileRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      StaffItOperationCoreDetailOperationInstancesInstanceIdRoute,
  } as any)

const StaffIdsGroupIdIdIdIndexRoute = StaffIdsGroupIdIdIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffIdsGroupIdIdIdRoute,
} as any)

const StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute =
  StaffEquipmentLayoutSettingsEquipmentTypesIndexImport.update({
    id: '/equipment-types/',
    path: '/equipment-types/',
    getParentRoute: () => StaffEquipmentLayoutSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/_layout/settings/equipment-types/index.lazy'
    ).then((d) => d.Route),
  )

const StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute =
  StaffEquipmentLayoutSettingsEquipmentItemsIndexImport.update({
    id: '/equipment-items/',
    path: '/equipment-items/',
    getParentRoute: () => StaffEquipmentLayoutSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/equipment/_layout/settings/equipment-items/index.lazy'
    ).then((d) => d.Route),
  )

const StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute =
  StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexImport.update({
    id: '/external-it-saas/$appIntegrationId/preview/',
    path: '/external-it-saas/$appIntegrationId/preview/',
    getParentRoute: () => StaffDevicesRoute,
  } as any)

const StaffCertificationListSettingsSpecialtyCategoryIndexRoute =
  StaffCertificationListSettingsSpecialtyCategoryIndexImport.update({
    id: '/specialty-category/',
    path: '/specialty-category/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/_list/settings/specialty-category/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute =
  StaffCertificationListSettingsSpecialtyCategoryLevelIndexImport.update({
    id: '/specialty-category-level/',
    path: '/specialty-category-level/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/_list/settings/specialty-category-level/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationListSettingsIssuingOrganizationIndexRoute =
  StaffCertificationListSettingsIssuingOrganizationIndexImport.update({
    id: '/issuing-organization/',
    path: '/issuing-organization/',
    getParentRoute: () => StaffCertificationListSettingsRouteLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/_list/settings/issuing-organization/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute =
  StaffCertificationIdLayoutSpecialtyCertificationsIndexImport.update({
    id: '/specialty-certifications/',
    path: '/specialty-certifications/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/$id/_layout/specialty-certifications/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutHandlingCertificationsIndexRoute =
  StaffCertificationIdLayoutHandlingCertificationsIndexImport.update({
    id: '/handling-certifications/',
    path: '/handling-certifications/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/$id/_layout/handling-certifications/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutCertificationHoldersIndexRoute =
  StaffCertificationIdLayoutCertificationHoldersIndexImport.update({
    id: '/certification-holders/',
    path: '/certification-holders/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/certification/$id/_layout/certification-holders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationIdLayoutIndexIndexRoute =
  StaffCertificationIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffCertificationIdLayoutRoute,
  } as any)

const StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute =
  StaffBusinessPartnerIdLayoutAddressAndContactIndexImport.update({
    id: '/address-and-contact/',
    path: '/address-and-contact/',
    getParentRoute: () => StaffBusinessPartnerIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-partner/$id/_layout/address-and-contact/index.lazy'
    ).then((d) => d.Route),
  )

const StaffBusinessPartnerIdLayoutIndexIndexRoute =
  StaffBusinessPartnerIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffBusinessPartnerIdLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/business-partner/$id/_layout/_index/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAppsCustomAppAddCustomAppTypeIndexRoute =
  StaffAppsCustomAppAddCustomAppTypeIndexImport.update({
    id: '/custom-app/add/$customAppType/',
    path: '/custom-app/add/$customAppType/',
    getParentRoute: () => StaffAppsRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/apps/custom-app/add/$customAppType/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAppsListAlertsAlertsIndexRoute =
  StaffAppsListAlertsAlertsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAppsListAlertsAlertsRoute,
  } as any)

const StaffAppIntegrationsIdIdUsersIndexRoute =
  StaffAppIntegrationsIdIdUsersIndexImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/app-integrations/$id/_$id/users/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffAppIntegrationsIdIdSettingsIndexRoute =
  StaffAppIntegrationsIdIdSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any)

const StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute =
  StaffAppIntegrationsIdIdRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any)

const StaffAppIntegrationsIdIdDetailIndexRoute =
  StaffAppIntegrationsIdIdDetailIndexImport.update({
    id: '/detail/',
    path: '/detail/',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any)

const StaffAppIntegrationsIdIdArchitectureIndexRoute =
  StaffAppIntegrationsIdIdArchitectureIndexImport.update({
    id: '/architecture/',
    path: '/architecture/',
    getParentRoute: () => StaffAppIntegrationsIdIdRoute,
  } as any)

const IndividualIndividualTaskIdApprovalIndexRoute =
  IndividualIndividualTaskIdApprovalIndexImport.update({
    id: '/individual/task/$id/approval/',
    path: '/individual/task/$id/approval/',
    getParentRoute: () => IndividualRoute,
  } as any)

const StaffProfileDeviceIdProfileStatusRouteLazyRoute =
  StaffProfileDeviceIdProfileStatusRouteLazyImport.update({
    id: '/status',
    path: '/status',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/profile/device/$id/_profile/status/route.lazy'
    ).then((d) => d.Route),
  )

const StaffProfileDeviceIdProfileMdmRouteLazyRoute =
  StaffProfileDeviceIdProfileMdmRouteLazyImport.update({
    id: '/mdm',
    path: '/mdm',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/profile/device/$id/_profile/mdm/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffProfileDeviceIdProfileControlRouteLazyRoute =
  StaffProfileDeviceIdProfileControlRouteLazyImport.update({
    id: '/control',
    path: '/control',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/profile/device/$id/_profile/control/route.lazy'
    ).then((d) => d.Route),
  )

const StaffProfileDeviceIdProfileIndexRouteLazyRoute =
  StaffProfileDeviceIdProfileIndexRouteLazyImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/profile/device/$id/_profile/index/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffProfileDeviceIdProfileMonitoringRoute =
  StaffProfileDeviceIdProfileMonitoringImport.update({
    id: '/monitoring',
    path: '/monitoring',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any)

const StaffProfileDeviceIdProfileConfigurationRoute =
  StaffProfileDeviceIdProfileConfigurationImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any)

const StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute =
  StaffMarketplaceSentOrdersOrderIdLayoutActivitiesImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => StaffMarketplaceSentOrdersOrderIdLayoutRoute,
  } as any)

const StaffLicensesIdServicePlansLicenseServiceIdDetailRoute =
  StaffLicensesIdServicePlansLicenseServiceIdDetailImport.update({
    id: '/_detail',
    getParentRoute: () => StaffLicensesIdServicePlansLicenseServiceIdRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      StaffItOperationCoreDetailOperationInstancesInstanceIdRoute,
  } as any)

const StaffProfileDeviceIdProfileFilesRouteRoute =
  StaffProfileDeviceIdProfileFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/profile/device/$id/_profile/files/route.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute =
  StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteImport.update({
    id: '/_placeholders/rule-and-policy',
    path: '/rule-and-policy',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute =
  StaffContractIdLayoutPlaceholdersRiskProvisionsRouteImport.update({
    id: '/_placeholders/risk-provisions',
    path: '/risk-provisions',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute =
  StaffContractIdLayoutPlaceholdersOperationActivityRouteImport.update({
    id: '/_placeholders/operation-activity',
    path: '/operation-activity',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersHistoryRouteRoute =
  StaffContractIdLayoutPlaceholdersHistoryRouteImport.update({
    id: '/_placeholders/history',
    path: '/history',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute =
  StaffContractIdLayoutPlaceholdersApprovalInfoRouteImport.update({
    id: '/_placeholders/approval-info',
    path: '/approval-info',
    getParentRoute: () => StaffContractIdLayoutRoute,
  } as any)

const StaffPersonAlumniIdProfileIndexRouteRoute =
  StaffPersonAlumniIdProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexImport.update({
    id: '/_list/summary/monthly-place/',
    path: '/summary/monthly-place/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-place/index.lazy'
    ).then((d) => d.Route),
  )

const StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexImport.update({
    id: '/_list/summary/monthly-person/',
    path: '/summary/monthly-person/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/time-and-attendance/_layout/_list/summary/monthly-person/index.lazy'
    ).then((d) => d.Route),
  )

const StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute =
  StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexImport.update({
    id: '/_list/summary/daily-place/',
    path: '/summary/daily-place/',
    getParentRoute: () => StaffTimeAndAttendanceLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/time-and-attendance/_layout/_list/summary/daily-place/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute =
  StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexImport.update({
    id: '/violated-role/',
    path: '/violated-role/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute =
  StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexImport.update({
    id: '/violated-assignment/',
    path: '/violated-assignment/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute =
  StaffSoftwareLayoutAlertsAlertsNoWorkerIndexImport.update({
    id: '/no-worker/',
    path: '/no-worker/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute =
  StaffSoftwareLayoutAlertsAlertsNoUserIndexImport.update({
    id: '/no-user/',
    path: '/no-user/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute =
  StaffSoftwareLayoutAlertsAlertsInactiveUserIndexImport.update({
    id: '/inactive-user/',
    path: '/inactive-user/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute =
  StaffSoftwareLayoutAlertsAlertsAlumniIndexImport.update({
    id: '/alumni/',
    path: '/alumni/',
    getParentRoute: () => StaffSoftwareLayoutAlertsAlertsRoute,
  } as any)

const StaffSettingsPersonsListAccountStaffIndexRoute =
  StaffSettingsPersonsListAccountStaffIndexImport.update({
    id: '/staff/',
    path: '/staff/',
    getParentRoute: () => StaffSettingsPersonsListAccountRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/settings/persons/_list/_account/staff/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsPersonsListAccountIndividualIndexRoute =
  StaffSettingsPersonsListAccountIndividualIndexImport.update({
    id: '/individual/',
    path: '/individual/',
    getParentRoute: () => StaffSettingsPersonsListAccountRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/settings/persons/_list/_account/individual/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsPermissionAndRolesFormRolesNewIndexRoute =
  StaffSettingsPermissionAndRolesFormRolesNewIndexImport.update({
    id: '/roles/new/',
    path: '/roles/new/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute =
  StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexImport.update({
    id: '/product-permissions/new/',
    path: '/product-permissions/new/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute =
  StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexImport.update({
    id: '/people-groups/new/',
    path: '/people-groups/new/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute =
  StaffSettingsPermissionAndRolesDetailRolesIdIndexImport.update({
    id: '/roles/$id/',
    path: '/roles/$id/',
    getParentRoute: () => StaffSettingsPermissionAndRolesDetailRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute =
  StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexImport.update({
    id: '/product-permissions/$id/',
    path: '/product-permissions/$id/',
    getParentRoute: () => StaffSettingsPermissionAndRolesDetailRoute,
  } as any)

const StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute =
  StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexImport.update({
    id: '/people-groups/$id/',
    path: '/people-groups/$id/',
    getParentRoute: () => StaffSettingsPermissionAndRolesDetailRoute,
  } as any)

const StaffProfileDeviceIdProfileLifecycleIndexRoute =
  StaffProfileDeviceIdProfileLifecycleIndexImport.update({
    id: '/lifecycle/',
    path: '/lifecycle/',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any)

const StaffProfileDeviceIdProfileHistoryIndexRoute =
  StaffProfileDeviceIdProfileHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffProfileDeviceIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfilePublicIdIndexRoute =
  StaffPersonAlumniIdProfilePublicIdIndexImport.update({
    id: '/public-id/',
    path: '/public-id/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfilePersonalInformationIndexRoute =
  StaffPersonAlumniIdProfilePersonalInformationIndexImport.update({
    id: '/personal-information/',
    path: '/personal-information/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileHistoryIndexRoute =
  StaffPersonAlumniIdProfileHistoryIndexImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileEquipmentIndexRoute =
  StaffPersonAlumniIdProfileEquipmentIndexImport.update({
    id: '/equipment/',
    path: '/equipment/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileEmployeeInformationIndexRoute =
  StaffPersonAlumniIdProfileEmployeeInformationIndexImport.update({
    id: '/employee-information/',
    path: '/employee-information/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute =
  StaffPersonAlumniIdProfileEducationAndQualificationIndexImport.update({
    id: '/education-and-qualification/',
    path: '/education-and-qualification/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileDevicesIndexRoute =
  StaffPersonAlumniIdProfileDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonAlumniIdProfileAppsIndexRoute =
  StaffPersonAlumniIdProfileAppsIndexImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any).lazy(() =>
    import('./routes/_staff/person/alumni/$id/_profile/apps/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffPersonAlumniIdProfileActivityIndexRoute =
  StaffPersonAlumniIdProfileActivityIndexImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => StaffPersonAlumniIdProfileRoute,
  } as any)

const StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute =
  StaffPersonIdProfileFamilyFamilyPersonIdIndexImport.update({
    id: '/family/$familyPersonId/',
    path: '/family/$familyPersonId/',
    getParentRoute: () => StaffPersonIdProfileRoute,
  } as any)

const StaffOrganizationPlanIdEditUnitIdIndexRoute =
  StaffOrganizationPlanIdEditUnitIdIndexImport.update({
    id: '/plan/$id/edit/$unitId/',
    path: '/plan/$id/edit/$unitId/',
    getParentRoute: () => StaffOrganizationRoute,
  } as any)

const StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute =
  StaffMarketplaceStoreStoreStarlinksProductIdIndexImport.update({
    id: '/store/starlinks/$productId/',
    path: '/store/starlinks/$productId/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffMarketplaceStoreStoreDevicesProductIdIndexRoute =
  StaffMarketplaceStoreStoreDevicesProductIdIndexImport.update({
    id: '/store/devices/$productId/',
    path: '/store/devices/$productId/',
    getParentRoute: () => StaffMarketplaceStoreRoute,
  } as any)

const StaffIdsGroupIdIdIdSettingsIndexRoute =
  StaffIdsGroupIdIdIdSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any)

const StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute =
  StaffIdsGroupIdIdIdRuleAndPolicyIndexImport.update({
    id: '/rule-and-policy/',
    path: '/rule-and-policy/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any)

const StaffIdsGroupIdIdIdMembersIndexRoute =
  StaffIdsGroupIdIdIdMembersIndexImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => StaffIdsGroupIdIdIdRoute,
  } as any).lazy(() =>
    import('./routes/_staff/ids/group-id/$id/_$id/members/index.lazy').then(
      (d) => d.Route,
    ),
  )

const StaffDeviceCatalogDraftIdLayoutProfileIndexRoute =
  StaffDeviceCatalogDraftIdLayoutProfileIndexImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => StaffDeviceCatalogDraftIdLayoutRoute,
  } as any)

const StaffDeviceCatalogActiveIdLayoutProfileIndexRoute =
  StaffDeviceCatalogActiveIdLayoutProfileIndexImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => StaffDeviceCatalogActiveIdLayoutRoute,
  } as any)

const StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute =
  StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexImport.update(
    {
      id: '/handling-certifications/',
      path: '/handling-certifications/',
      getParentRoute: () =>
        StaffCertificationSpecialtyCertificationIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/certification/specialty-certification/$id/_layout/handling-certifications/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute =
  StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexImport.update(
    {
      id: '/certification-holders/',
      path: '/certification-holders/',
      getParentRoute: () =>
        StaffCertificationSpecialtyCertificationIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/certification/specialty-certification/$id/_layout/certification-holders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute =
  StaffCertificationSpecialtyCertificationIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffCertificationSpecialtyCertificationIdLayoutRoute,
  } as any)

const StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute =
  StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexImport.update(
    {
      id: '/certification-holders/',
      path: '/certification-holders/',
      getParentRoute: () =>
        StaffCertificationHandlingCertificationIdLayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_staff/certification/handling-certification/$id/_layout/certification-holders/index.lazy'
    ).then((d) => d.Route),
  )

const StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute =
  StaffCertificationHandlingCertificationIdLayoutIndexIndexImport.update({
    id: '/_index/',
    path: '/',
    getParentRoute: () => StaffCertificationHandlingCertificationIdLayoutRoute,
  } as any)

const StaffAppsListAlertsAlertsViolatedRoleIndexRoute =
  StaffAppsListAlertsAlertsViolatedRoleIndexImport.update({
    id: '/violated-role/',
    path: '/violated-role/',
    getParentRoute: () => StaffAppsListAlertsAlertsRoute,
  } as any)

const StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute =
  StaffAppsListAlertsAlertsViolatedAssignmentIndexImport.update({
    id: '/violated-assignment/',
    path: '/violated-assignment/',
    getParentRoute: () => StaffAppsListAlertsAlertsRoute,
  } as any)

const StaffAppsListAlertsAlertsNoWorkerIndexRoute =
  StaffAppsListAlertsAlertsNoWorkerIndexImport.update({
    id: '/no-worker/',
    path: '/no-worker/',
    getParentRoute: () => StaffAppsListAlertsAlertsRoute,
  } as any)

const StaffAppsListAlertsAlertsNoUserIndexRoute =
  StaffAppsListAlertsAlertsNoUserIndexImport.update({
    id: '/no-user/',
    path: '/no-user/',
    getParentRoute: () => StaffAppsListAlertsAlertsRoute,
  } as any)

const StaffAppsListAlertsAlertsInactiveUserIndexRoute =
  StaffAppsListAlertsAlertsInactiveUserIndexImport.update({
    id: '/inactive-user/',
    path: '/inactive-user/',
    getParentRoute: () => StaffAppsListAlertsAlertsRoute,
  } as any)

const StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute =
  StaffAccessesLayoutAlertsDetailShadowItAppIdIndexImport.update({
    id: '/alerts/detail/$shadowItAppId/',
    path: '/alerts/detail/$shadowItAppId/',
    getParentRoute: () => StaffAccessesLayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/accesses/_layout/alerts/detail/$shadowItAppId/index.lazy'
    ).then((d) => d.Route),
  )

const IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute =
  IndividualIndividualOperationPackageIdPatternPatternIdIndexImport.update({
    id: '/individual/operation-package/$id/pattern/$patternId/',
    path: '/individual/operation-package/$id/pattern/$patternId/',
    getParentRoute: () => IndividualRoute,
  } as any)

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute,
    } as any,
  )

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute,
    } as any,
  )

const StaffAppsListAlertsAlertsShadowItShadowItRoute =
  StaffAppsListAlertsAlertsShadowItShadowItImport.update({
    id: '/_shadow-it',
    getParentRoute: () => StaffAppsListAlertsAlertsShadowItRoute,
  } as any)

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport.update(
    {
      id: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      getParentRoute: () => StaffLaborCoreRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport.update(
    {
      id: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      getParentRoute: () => StaffGaOperationCoreRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport.update(
    {
      id: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId',
      getParentRoute: () => StaffContractorCoreRoute,
    } as any,
  )

const StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute =
  StaffSoftwareLayoutMarketplaceIdInstallFinishIndexImport.update({
    id: '/install/finish/',
    path: '/install/finish/',
    getParentRoute: () => StaffSoftwareLayoutMarketplaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/software/_layout/marketplace/$id/install.finish/index.lazy'
    ).then((d) => d.Route),
  )

const StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute =
  StaffSettingsPermissionAndRolesFormRolesIdEditIndexImport.update({
    id: '/roles/$id/edit/',
    path: '/roles/$id/edit/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute =
  StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexImport.update(
    {
      id: '/product-permissions/$id/edit/',
      path: '/product-permissions/$id/edit/',
      getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
    } as any,
  )

const StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute =
  StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexImport.update({
    id: '/people-groups/$id/edit/',
    path: '/people-groups/$id/edit/',
    getParentRoute: () => StaffSettingsPermissionAndRolesFormRoute,
  } as any)

const StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute =
  StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexImport.update({
    id: '/accounts/',
    path: '/accounts/',
    getParentRoute: () =>
      StaffLicensesIdServicePlansLicenseServiceIdDetailRoute,
  } as any)

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexImport.update(
    {
      id: '/operation-activity/',
      path: '/operation-activity/',
      getParentRoute: () =>
        StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute,
    } as any,
  )

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexImport.update(
    {
      id: '/detail/',
      path: '/detail/',
      getParentRoute: () =>
        StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute,
    } as any,
  )

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute,
    } as any,
  )

const StaffAppsListMarketplaceIdInstallFinishIndexRoute =
  StaffAppsListMarketplaceIdInstallFinishIndexImport.update({
    id: '/install/finish/',
    path: '/install/finish/',
    getParentRoute: () => StaffAppsListMarketplaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_staff/apps/_list/marketplace/$id/install.finish/index.lazy'
    ).then((d) => d.Route),
  )

const StaffAppsListAlertsAlertsShadowItShadowItIndexRoute =
  StaffAppsListAlertsAlertsShadowItShadowItIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAppsListAlertsAlertsShadowItShadowItRoute,
  } as any)

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute,
    } as any,
  )

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute,
    } as any,
  )

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexImport.update(
    {
      id: '/_index/',
      path: '/',
      getParentRoute: () =>
        StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute,
    } as any,
  )

const StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute =
  StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexImport.update({
    id: '/visit-histories/',
    path: '/visit-histories/',
    getParentRoute: () => StaffAppsListAlertsAlertsShadowItShadowItRoute,
  } as any)

const StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute =
  StaffAppsListAlertsAlertsShadowItShadowItAppsIndexImport.update({
    id: '/apps/',
    path: '/apps/',
    getParentRoute: () => StaffAppsListAlertsAlertsShadowItShadowItRoute,
  } as any)

const IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute =
  IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexImport.update({
    id: '/individual/task/$id/_operation-package/_common/form/$formId/',
    path: '/individual/task/$id/form/$formId/',
    getParentRoute: () => IndividualRoute,
  } as any)

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport.update(
    {
      id: '/_profile',
      getParentRoute: () =>
        StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport.update(
    {
      id: '/_profile',
      getParentRoute: () =>
        StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport.update(
    {
      id: '/_profile',
      getParentRoute: () =>
        StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute,
    } as any,
  )

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport.update(
    {
      id: '/data/',
      path: '/data/',
      getParentRoute: () =>
        StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_individual': {
      id: '/_individual'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof IndividualImport
      parentRoute: typeof rootRoute
    }
    '/_staff': {
      id: '/_staff'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof StaffImport
      parentRoute: typeof rootRoute
    }
    '/_staff/apps': {
      id: '/_staff/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof StaffAppsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/id-managements': {
      id: '/_staff/id-managements'
      path: '/id-managements'
      fullPath: '/id-managements'
      preLoaderRoute: typeof StaffIdManagementsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/it-operation-core/device-inventory': {
      id: '/_staff/it-operation-core/device-inventory'
      path: '/it-operation-core/device-inventory'
      fullPath: '/it-operation-core/device-inventory'
      preLoaderRoute: typeof StaffItOperationCoreDeviceInventoryRouteImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/import-csv': {
      id: '/_staff/places/import-csv'
      path: '/places/import-csv'
      fullPath: '/places/import-csv'
      preLoaderRoute: typeof StaffPlacesImportCsvRouteImport
      parentRoute: typeof StaffImport
    }
    '/_staff/accesses': {
      id: '/_staff/accesses'
      path: '/accesses'
      fullPath: '/accesses'
      preLoaderRoute: typeof StaffAccessesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/accesses/_layout': {
      id: '/_staff/accesses/_layout'
      path: '/accesses'
      fullPath: '/accesses'
      preLoaderRoute: typeof StaffAccessesLayoutImport
      parentRoute: typeof StaffAccessesRoute
    }
    '/_staff/apps/$': {
      id: '/_staff/apps/$'
      path: '/$'
      fullPath: '/apps/$'
      preLoaderRoute: typeof StaffAppsSplatImport
      parentRoute: typeof StaffAppsImport
    }
    '/_staff/apps/_list': {
      id: '/_staff/apps/_list'
      path: ''
      fullPath: '/apps'
      preLoaderRoute: typeof StaffAppsListImport
      parentRoute: typeof StaffAppsImport
    }
    '/_staff/business-operation-events': {
      id: '/_staff/business-operation-events'
      path: '/business-operation-events'
      fullPath: '/business-operation-events'
      preLoaderRoute: typeof StaffBusinessOperationEventsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/business-operation-events/_list': {
      id: '/_staff/business-operation-events/_list'
      path: '/business-operation-events'
      fullPath: '/business-operation-events'
      preLoaderRoute: typeof StaffBusinessOperationEventsListImport
      parentRoute: typeof StaffBusinessOperationEventsRoute
    }
    '/_staff/business-partner': {
      id: '/_staff/business-partner'
      path: '/business-partner'
      fullPath: '/business-partner'
      preLoaderRoute: typeof StaffBusinessPartnerImport
      parentRoute: typeof StaffImport
    }
    '/_staff/business-partner/_list': {
      id: '/_staff/business-partner/_list'
      path: '/business-partner'
      fullPath: '/business-partner'
      preLoaderRoute: typeof StaffBusinessPartnerListImport
      parentRoute: typeof StaffBusinessPartnerRoute
    }
    '/_staff/certification': {
      id: '/_staff/certification'
      path: '/certification'
      fullPath: '/certification'
      preLoaderRoute: typeof StaffCertificationImport
      parentRoute: typeof StaffImport
    }
    '/_staff/certification/_list': {
      id: '/_staff/certification/_list'
      path: '/certification'
      fullPath: '/certification'
      preLoaderRoute: typeof StaffCertificationListImport
      parentRoute: typeof StaffCertificationRoute
    }
    '/_staff/contract': {
      id: '/_staff/contract'
      path: '/contract'
      fullPath: '/contract'
      preLoaderRoute: typeof StaffContractImport
      parentRoute: typeof StaffImport
    }
    '/_staff/contract/_list': {
      id: '/_staff/contract/_list'
      path: '/contract'
      fullPath: '/contract'
      preLoaderRoute: typeof StaffContractListImport
      parentRoute: typeof StaffContractRoute
    }
    '/_staff/contractor-core': {
      id: '/_staff/contractor-core'
      path: '/contractor-core'
      fullPath: '/contractor-core'
      preLoaderRoute: typeof StaffContractorCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/contractor-core/_packages': {
      id: '/_staff/contractor-core/_packages'
      path: '/contractor-core'
      fullPath: '/contractor-core'
      preLoaderRoute: typeof StaffContractorCorePackagesImport
      parentRoute: typeof StaffContractorCoreRoute
    }
    '/_staff/devices': {
      id: '/_staff/devices'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof StaffDevicesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/devices/_list': {
      id: '/_staff/devices/_list'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof StaffDevicesListImport
      parentRoute: typeof StaffDevicesRoute
    }
    '/_staff/equipment': {
      id: '/_staff/equipment'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof StaffEquipmentImport
      parentRoute: typeof StaffImport
    }
    '/_staff/equipment/_layout': {
      id: '/_staff/equipment/_layout'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof StaffEquipmentLayoutImport
      parentRoute: typeof StaffEquipmentRoute
    }
    '/_staff/fleets': {
      id: '/_staff/fleets'
      path: '/fleets'
      fullPath: '/fleets'
      preLoaderRoute: typeof StaffFleetsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/fleets/_layout': {
      id: '/_staff/fleets/_layout'
      path: '/fleets'
      fullPath: '/fleets'
      preLoaderRoute: typeof StaffFleetsLayoutImport
      parentRoute: typeof StaffFleetsRoute
    }
    '/_staff/ga-operation-core': {
      id: '/_staff/ga-operation-core'
      path: '/ga-operation-core'
      fullPath: '/ga-operation-core'
      preLoaderRoute: typeof StaffGaOperationCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/ga-operation-core/_packages': {
      id: '/_staff/ga-operation-core/_packages'
      path: '/ga-operation-core'
      fullPath: '/ga-operation-core'
      preLoaderRoute: typeof StaffGaOperationCorePackagesImport
      parentRoute: typeof StaffGaOperationCoreRoute
    }
    '/_staff/id-managements/$': {
      id: '/_staff/id-managements/$'
      path: '/$'
      fullPath: '/id-managements/$'
      preLoaderRoute: typeof StaffIdManagementsSplatImport
      parentRoute: typeof StaffIdManagementsImport
    }
    '/_staff/ids': {
      id: '/_staff/ids'
      path: '/ids'
      fullPath: '/ids'
      preLoaderRoute: typeof StaffIdsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/ids/_layout': {
      id: '/_staff/ids/_layout'
      path: '/ids'
      fullPath: '/ids'
      preLoaderRoute: typeof StaffIdsLayoutImport
      parentRoute: typeof StaffIdsRoute
    }
    '/_staff/it-operation-core': {
      id: '/_staff/it-operation-core'
      path: '/it-operation-core'
      fullPath: '/it-operation-core'
      preLoaderRoute: typeof StaffItOperationCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/it-operation-core/_detail': {
      id: '/_staff/it-operation-core/_detail'
      path: '/it-operation-core'
      fullPath: '/it-operation-core'
      preLoaderRoute: typeof StaffItOperationCoreDetailImport
      parentRoute: typeof StaffItOperationCoreRoute
    }
    '/_staff/it-operation-core/_root': {
      id: '/_staff/it-operation-core/_root'
      path: ''
      fullPath: '/it-operation-core'
      preLoaderRoute: typeof StaffItOperationCoreRootImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/labor-core': {
      id: '/_staff/labor-core'
      path: '/labor-core'
      fullPath: '/labor-core'
      preLoaderRoute: typeof StaffLaborCoreImport
      parentRoute: typeof StaffImport
    }
    '/_staff/labor-core/_packages': {
      id: '/_staff/labor-core/_packages'
      path: '/labor-core'
      fullPath: '/labor-core'
      preLoaderRoute: typeof StaffLaborCorePackagesImport
      parentRoute: typeof StaffLaborCoreRoute
    }
    '/_staff/labor-core/anchor-date': {
      id: '/_staff/labor-core/anchor-date'
      path: '/anchor-date'
      fullPath: '/labor-core/anchor-date'
      preLoaderRoute: typeof StaffLaborCoreAnchorDateImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/labor-core/person-targets': {
      id: '/_staff/labor-core/person-targets'
      path: '/person-targets'
      fullPath: '/labor-core/person-targets'
      preLoaderRoute: typeof StaffLaborCorePersonTargetsImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses': {
      id: '/_staff/licenses'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof StaffLicensesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/licenses/_list': {
      id: '/_staff/licenses/_list'
      path: '/licenses'
      fullPath: '/licenses'
      preLoaderRoute: typeof StaffLicensesListImport
      parentRoute: typeof StaffLicensesRoute
    }
    '/_staff/marketplace': {
      id: '/_staff/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof StaffMarketplaceImport
      parentRoute: typeof StaffImport
    }
    '/_staff/marketplace/_store': {
      id: '/_staff/marketplace/_store'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof StaffMarketplaceStoreImport
      parentRoute: typeof StaffMarketplaceRoute
    }
    '/_staff/networks': {
      id: '/_staff/networks'
      path: '/networks'
      fullPath: '/networks'
      preLoaderRoute: typeof StaffNetworksImport
      parentRoute: typeof StaffImport
    }
    '/_staff/networks/_layout': {
      id: '/_staff/networks/_layout'
      path: '/networks'
      fullPath: '/networks'
      preLoaderRoute: typeof StaffNetworksLayoutImport
      parentRoute: typeof StaffNetworksRoute
    }
    '/_staff/organization': {
      id: '/_staff/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof StaffOrganizationImport
      parentRoute: typeof StaffImport
    }
    '/_staff/organization/_list': {
      id: '/_staff/organization/_list'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof StaffOrganizationListImport
      parentRoute: typeof StaffOrganizationRoute
    }
    '/_staff/people': {
      id: '/_staff/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof StaffPeopleImport
      parentRoute: typeof StaffImport
    }
    '/_staff/people/_list': {
      id: '/_staff/people/_list'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof StaffPeopleListImport
      parentRoute: typeof StaffPeopleRoute
    }
    '/_staff/places': {
      id: '/_staff/places'
      path: '/places'
      fullPath: '/places'
      preLoaderRoute: typeof StaffPlacesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout': {
      id: '/_staff/places/_layout'
      path: '/places'
      fullPath: '/places'
      preLoaderRoute: typeof StaffPlacesLayoutImport
      parentRoute: typeof StaffPlacesRoute
    }
    '/_staff/public-ids/$id': {
      id: '/_staff/public-ids/$id'
      path: '/public-ids/$id'
      fullPath: '/public-ids/$id'
      preLoaderRoute: typeof StaffPublicIdsIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/public-ids': {
      id: '/_staff/public-ids'
      path: '/public-ids'
      fullPath: '/public-ids'
      preLoaderRoute: typeof StaffPublicIdsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/public-ids/_list': {
      id: '/_staff/public-ids/_list'
      path: '/public-ids'
      fullPath: '/public-ids'
      preLoaderRoute: typeof StaffPublicIdsListImport
      parentRoute: typeof StaffPublicIdsRoute
    }
    '/_staff/software': {
      id: '/_staff/software'
      path: '/software'
      fullPath: '/software'
      preLoaderRoute: typeof StaffSoftwareImport
      parentRoute: typeof StaffImport
    }
    '/_staff/software/_layout': {
      id: '/_staff/software/_layout'
      path: '/software'
      fullPath: '/software'
      preLoaderRoute: typeof StaffSoftwareLayoutImport
      parentRoute: typeof StaffSoftwareRoute
    }
    '/_staff/starlinks': {
      id: '/_staff/starlinks'
      path: '/starlinks'
      fullPath: '/starlinks'
      preLoaderRoute: typeof StaffStarlinksImport
      parentRoute: typeof StaffImport
    }
    '/_staff/starlinks/_layout': {
      id: '/_staff/starlinks/_layout'
      path: '/starlinks'
      fullPath: '/starlinks'
      preLoaderRoute: typeof StaffStarlinksLayoutImport
      parentRoute: typeof StaffStarlinksRoute
    }
    '/_staff/storage-files': {
      id: '/_staff/storage-files'
      path: '/storage-files'
      fullPath: '/storage-files'
      preLoaderRoute: typeof StaffStorageFilesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/storage-files/_list': {
      id: '/_staff/storage-files/_list'
      path: '/storage-files'
      fullPath: '/storage-files'
      preLoaderRoute: typeof StaffStorageFilesListImport
      parentRoute: typeof StaffStorageFilesRoute
    }
    '/_staff/time-and-attendance': {
      id: '/_staff/time-and-attendance'
      path: '/time-and-attendance'
      fullPath: '/time-and-attendance'
      preLoaderRoute: typeof StaffTimeAndAttendanceImport
      parentRoute: typeof StaffImport
    }
    '/_staff/time-and-attendance/_layout': {
      id: '/_staff/time-and-attendance/_layout'
      path: '/time-and-attendance'
      fullPath: '/time-and-attendance'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutImport
      parentRoute: typeof StaffTimeAndAttendanceRoute
    }
    '/_individual/individual/': {
      id: '/_individual/individual/'
      path: '/individual'
      fullPath: '/individual'
      preLoaderRoute: typeof IndividualIndividualIndexImport
      parentRoute: typeof IndividualImport
    }
    '/_staff/cockpit/': {
      id: '/_staff/cockpit/'
      path: '/cockpit'
      fullPath: '/cockpit'
      preLoaderRoute: typeof StaffCockpitIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/it-operation-core/': {
      id: '/_staff/it-operation-core/'
      path: '/'
      fullPath: '/it-operation-core/'
      preLoaderRoute: typeof StaffItOperationCoreIndexImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/organization/': {
      id: '/_staff/organization/'
      path: '/'
      fullPath: '/organization/'
      preLoaderRoute: typeof StaffOrganizationIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/settings/': {
      id: '/_staff/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof StaffSettingsIndexImport
      parentRoute: typeof StaffImport
    }
    '/auth/sign-in/': {
      id: '/auth/sign-in/'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInIndexImport
      parentRoute: typeof rootRoute
    }
    '/auth/password-reset/': {
      id: '/auth/password-reset/'
      path: '/auth/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetIndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_staff/licenses/_list/': {
      id: '/_staff/licenses/_list/'
      path: '/'
      fullPath: '/licenses/'
      preLoaderRoute: typeof StaffLicensesListIndexRouteImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/app-integrations/import-csv/$id': {
      id: '/_staff/app-integrations/import-csv/$id'
      path: '/app-integrations/import-csv/$id'
      fullPath: '/app-integrations/import-csv/$id'
      preLoaderRoute: typeof StaffAppIntegrationsImportCsvIdRouteImport
      parentRoute: typeof StaffImport
    }
    '/_staff/devices/import-csv/$deviceType': {
      id: '/_staff/devices/import-csv/$deviceType'
      path: '/import-csv/$deviceType'
      fullPath: '/devices/import-csv/$deviceType'
      preLoaderRoute: typeof StaffDevicesImportCsvDeviceTypeRouteImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/it-operation-core/_root/packages': {
      id: '/_staff/it-operation-core/_root/packages'
      path: '/packages'
      fullPath: '/it-operation-core/packages'
      preLoaderRoute: typeof StaffItOperationCoreRootPackagesRouteImport
      parentRoute: typeof StaffItOperationCoreRootImport
    }
    '/_staff/person/import-csv/$workerType': {
      id: '/_staff/person/import-csv/$workerType'
      path: '/person/import-csv/$workerType'
      fullPath: '/person/import-csv/$workerType'
      preLoaderRoute: typeof StaffPersonImportCsvWorkerTypeRouteImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout/settings': {
      id: '/_staff/places/_layout/settings'
      path: '/settings'
      fullPath: '/places/settings'
      preLoaderRoute: typeof StaffPlacesLayoutSettingsRouteImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/public-ids/import-csv/$publicIdType': {
      id: '/_staff/public-ids/import-csv/$publicIdType'
      path: '/import-csv/$publicIdType'
      fullPath: '/public-ids/import-csv/$publicIdType'
      preLoaderRoute: typeof StaffPublicIdsImportCsvPublicIdTypeRouteImport
      parentRoute: typeof StaffPublicIdsImport
    }
    '/_staff/software/$id/import-csv': {
      id: '/_staff/software/$id/import-csv'
      path: '/$id/import-csv'
      fullPath: '/software/$id/import-csv'
      preLoaderRoute: typeof StaffSoftwareIdImportCsvRouteImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/software/_layout/people': {
      id: '/_staff/software/_layout/people'
      path: '/people'
      fullPath: '/software/people'
      preLoaderRoute: typeof StaffSoftwareLayoutPeopleRouteImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/app-integrations/$id': {
      id: '/_staff/app-integrations/$id'
      path: '/app-integrations/$id'
      fullPath: '/app-integrations/$id'
      preLoaderRoute: typeof StaffAppIntegrationsIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/app-integrations/$id/_$id': {
      id: '/_staff/app-integrations/$id/_$id'
      path: '/app-integrations/$id'
      fullPath: '/app-integrations/$id'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdImport
      parentRoute: typeof StaffAppIntegrationsIdRoute
    }
    '/_staff/apps/_list/contract-and-cost': {
      id: '/_staff/apps/_list/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/apps/contract-and-cost'
      preLoaderRoute: typeof StaffAppsListContractAndCostImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/apps/_list/operation-activity': {
      id: '/_staff/apps/_list/operation-activity'
      path: '/operation-activity'
      fullPath: '/apps/operation-activity'
      preLoaderRoute: typeof StaffAppsListOperationActivityImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/apps/_list/rule-and-policy': {
      id: '/_staff/apps/_list/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/apps/rule-and-policy'
      preLoaderRoute: typeof StaffAppsListRuleAndPolicyImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/business-operation-events/_list/archive': {
      id: '/_staff/business-operation-events/_list/archive'
      path: '/archive'
      fullPath: '/business-operation-events/archive'
      preLoaderRoute: typeof StaffBusinessOperationEventsListArchiveImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/config': {
      id: '/_staff/business-operation-events/_list/config'
      path: '/config'
      fullPath: '/business-operation-events/config'
      preLoaderRoute: typeof StaffBusinessOperationEventsListConfigImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/operation-activity': {
      id: '/_staff/business-operation-events/_list/operation-activity'
      path: '/operation-activity'
      fullPath: '/business-operation-events/operation-activity'
      preLoaderRoute: typeof StaffBusinessOperationEventsListOperationActivityImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/overview': {
      id: '/_staff/business-operation-events/_list/overview'
      path: '/overview'
      fullPath: '/business-operation-events/overview'
      preLoaderRoute: typeof StaffBusinessOperationEventsListOverviewImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/rule-and-policy': {
      id: '/_staff/business-operation-events/_list/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/business-operation-events/rule-and-policy'
      preLoaderRoute: typeof StaffBusinessOperationEventsListRuleAndPolicyImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-operation-events/_list/settings': {
      id: '/_staff/business-operation-events/_list/settings'
      path: '/settings'
      fullPath: '/business-operation-events/settings'
      preLoaderRoute: typeof StaffBusinessOperationEventsListSettingsImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-partner/$id': {
      id: '/_staff/business-partner/$id'
      path: '/$id'
      fullPath: '/business-partner/$id'
      preLoaderRoute: typeof StaffBusinessPartnerIdImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/business-partner/$id/_layout': {
      id: '/_staff/business-partner/$id/_layout'
      path: '/$id'
      fullPath: '/business-partner/$id'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutImport
      parentRoute: typeof StaffBusinessPartnerIdRoute
    }
    '/_staff/certification/$id': {
      id: '/_staff/certification/$id'
      path: '/$id'
      fullPath: '/certification/$id'
      preLoaderRoute: typeof StaffCertificationIdImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/$id/_layout': {
      id: '/_staff/certification/$id/_layout'
      path: '/$id'
      fullPath: '/certification/$id'
      preLoaderRoute: typeof StaffCertificationIdLayoutImport
      parentRoute: typeof StaffCertificationIdRoute
    }
    '/_staff/contract/$id': {
      id: '/_staff/contract/$id'
      path: '/$id'
      fullPath: '/contract/$id'
      preLoaderRoute: typeof StaffContractIdImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/contract/$id/_layout': {
      id: '/_staff/contract/$id/_layout'
      path: '/$id'
      fullPath: '/contract/$id'
      preLoaderRoute: typeof StaffContractIdLayoutImport
      parentRoute: typeof StaffContractIdRoute
    }
    '/_staff/devices/_list/alerts': {
      id: '/_staff/devices/_list/alerts'
      path: '/alerts'
      fullPath: '/devices/alerts'
      preLoaderRoute: typeof StaffDevicesListAlertsImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/contract-and-cost': {
      id: '/_staff/devices/_list/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/devices/contract-and-cost'
      preLoaderRoute: typeof StaffDevicesListContractAndCostImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/operation-activity': {
      id: '/_staff/devices/_list/operation-activity'
      path: '/operation-activity'
      fullPath: '/devices/operation-activity'
      preLoaderRoute: typeof StaffDevicesListOperationActivityImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/rule-and-policy': {
      id: '/_staff/devices/_list/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/devices/rule-and-policy'
      preLoaderRoute: typeof StaffDevicesListRuleAndPolicyImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/equipment/$id': {
      id: '/_staff/equipment/$id'
      path: '/$id'
      fullPath: '/equipment/$id'
      preLoaderRoute: typeof StaffEquipmentIdImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/equipment/$id/_layout': {
      id: '/_staff/equipment/$id/_layout'
      path: '/$id'
      fullPath: '/equipment/$id'
      preLoaderRoute: typeof StaffEquipmentIdLayoutImport
      parentRoute: typeof StaffEquipmentIdRoute
    }
    '/_staff/fleets/$id': {
      id: '/_staff/fleets/$id'
      path: '/$id'
      fullPath: '/fleets/$id'
      preLoaderRoute: typeof StaffFleetsIdImport
      parentRoute: typeof StaffFleetsImport
    }
    '/_staff/fleets/$id/_layout': {
      id: '/_staff/fleets/$id/_layout'
      path: '/$id'
      fullPath: '/fleets/$id'
      preLoaderRoute: typeof StaffFleetsIdLayoutImport
      parentRoute: typeof StaffFleetsIdRoute
    }
    '/_staff/fleets/_layout/alerts': {
      id: '/_staff/fleets/_layout/alerts'
      path: '/alerts'
      fullPath: '/fleets/alerts'
      preLoaderRoute: typeof StaffFleetsLayoutAlertsImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/fleets/_layout/overview': {
      id: '/_staff/fleets/_layout/overview'
      path: '/overview'
      fullPath: '/fleets/overview'
      preLoaderRoute: typeof StaffFleetsLayoutOverviewImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/fleets/_layout/rule-and-policy': {
      id: '/_staff/fleets/_layout/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/fleets/rule-and-policy'
      preLoaderRoute: typeof StaffFleetsLayoutRuleAndPolicyImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/fleets/_layout/settings': {
      id: '/_staff/fleets/_layout/settings'
      path: '/settings'
      fullPath: '/fleets/settings'
      preLoaderRoute: typeof StaffFleetsLayoutSettingsImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/it-operation-core/device-inventory/data': {
      id: '/_staff/it-operation-core/device-inventory/data'
      path: '/data'
      fullPath: '/it-operation-core/device-inventory/data'
      preLoaderRoute: typeof StaffItOperationCoreDeviceInventoryDataImport
      parentRoute: typeof StaffItOperationCoreDeviceInventoryRouteImport
    }
    '/_staff/it-operation-core/device-inventory/detail': {
      id: '/_staff/it-operation-core/device-inventory/detail'
      path: '/detail'
      fullPath: '/it-operation-core/device-inventory/detail'
      preLoaderRoute: typeof StaffItOperationCoreDeviceInventoryDetailImport
      parentRoute: typeof StaffItOperationCoreDeviceInventoryRouteImport
    }
    '/_staff/labor-core/_packages/settings': {
      id: '/_staff/labor-core/_packages/settings'
      path: '/settings'
      fullPath: '/labor-core/settings'
      preLoaderRoute: typeof StaffLaborCorePackagesSettingsImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/labor-core/settings/egov-callback': {
      id: '/_staff/labor-core/settings/egov-callback'
      path: '/settings/egov-callback'
      fullPath: '/labor-core/settings/egov-callback'
      preLoaderRoute: typeof StaffLaborCoreSettingsEgovCallbackImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses/$id': {
      id: '/_staff/licenses/$id'
      path: '/$id'
      fullPath: '/licenses/$id'
      preLoaderRoute: typeof StaffLicensesIdImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/licenses/$id/_profile': {
      id: '/_staff/licenses/$id/_profile'
      path: '/$id'
      fullPath: '/licenses/$id'
      preLoaderRoute: typeof StaffLicensesIdProfileImport
      parentRoute: typeof StaffLicensesIdRoute
    }
    '/_staff/networks/$id': {
      id: '/_staff/networks/$id'
      path: '/$id'
      fullPath: '/networks/$id'
      preLoaderRoute: typeof StaffNetworksIdImport
      parentRoute: typeof StaffNetworksImport
    }
    '/_staff/networks/$id/_layout': {
      id: '/_staff/networks/$id/_layout'
      path: '/$id'
      fullPath: '/networks/$id'
      preLoaderRoute: typeof StaffNetworksIdLayoutImport
      parentRoute: typeof StaffNetworksIdRoute
    }
    '/_staff/organization/$id': {
      id: '/_staff/organization/$id'
      path: '/$id'
      fullPath: '/organization/$id'
      preLoaderRoute: typeof StaffOrganizationIdImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/organization/$id/_layout': {
      id: '/_staff/organization/$id/_layout'
      path: '/$id'
      fullPath: '/organization/$id'
      preLoaderRoute: typeof StaffOrganizationIdLayoutImport
      parentRoute: typeof StaffOrganizationIdRoute
    }
    '/_staff/people/_list/alerts': {
      id: '/_staff/people/_list/alerts'
      path: '/alerts'
      fullPath: '/people/alerts'
      preLoaderRoute: typeof StaffPeopleListAlertsImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/community': {
      id: '/_staff/people/_list/community'
      path: '/community'
      fullPath: '/people/community'
      preLoaderRoute: typeof StaffPeopleListCommunityImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/operation-activity': {
      id: '/_staff/people/_list/operation-activity'
      path: '/operation-activity'
      fullPath: '/people/operation-activity'
      preLoaderRoute: typeof StaffPeopleListOperationActivityImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/people-graph': {
      id: '/_staff/people/_list/people-graph'
      path: '/people-graph'
      fullPath: '/people/people-graph'
      preLoaderRoute: typeof StaffPeopleListPeopleGraphImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/rule-and-policy': {
      id: '/_staff/people/_list/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/people/rule-and-policy'
      preLoaderRoute: typeof StaffPeopleListRuleAndPolicyImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/salary-and-payment': {
      id: '/_staff/people/_list/salary-and-payment'
      path: '/salary-and-payment'
      fullPath: '/people/salary-and-payment'
      preLoaderRoute: typeof StaffPeopleListSalaryAndPaymentImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/person/$id': {
      id: '/_staff/person/$id'
      path: '/person/$id'
      fullPath: '/person/$id'
      preLoaderRoute: typeof StaffPersonIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/$id/_profile': {
      id: '/_staff/person/$id/_profile'
      path: '/person/$id'
      fullPath: '/person/$id'
      preLoaderRoute: typeof StaffPersonIdProfileImport
      parentRoute: typeof StaffPersonIdRoute
    }
    '/_staff/places/$id': {
      id: '/_staff/places/$id'
      path: '/$id'
      fullPath: '/places/$id'
      preLoaderRoute: typeof StaffPlacesIdImport
      parentRoute: typeof StaffPlacesImport
    }
    '/_staff/places/$id/_layout': {
      id: '/_staff/places/$id/_layout'
      path: '/$id'
      fullPath: '/places/$id'
      preLoaderRoute: typeof StaffPlacesIdLayoutImport
      parentRoute: typeof StaffPlacesIdRoute
    }
    '/_staff/settings/contracting-corporation-profile': {
      id: '/_staff/settings/contracting-corporation-profile'
      path: '/settings/contracting-corporation-profile'
      fullPath: '/settings/contracting-corporation-profile'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout': {
      id: '/_staff/settings/contracting-corporation-profile/_layout'
      path: '/settings/contracting-corporation-profile'
      fullPath: '/settings/contracting-corporation-profile'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileRoute
    }
    '/_staff/settings/permission-and-roles': {
      id: '/_staff/settings/permission-and-roles'
      path: '/settings/permission-and-roles'
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/permission-and-roles/_detail': {
      id: '/_staff/settings/permission-and-roles/_detail'
      path: '/settings/permission-and-roles'
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailImport
      parentRoute: typeof StaffSettingsPermissionAndRolesRoute
    }
    '/_staff/settings/permission-and-roles/_form': {
      id: '/_staff/settings/permission-and-roles/_form'
      path: ''
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormImport
      parentRoute: typeof StaffSettingsPermissionAndRolesImport
    }
    '/_staff/settings/permission-and-roles/_list': {
      id: '/_staff/settings/permission-and-roles/_list'
      path: ''
      fullPath: '/settings/permission-and-roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListImport
      parentRoute: typeof StaffSettingsPermissionAndRolesImport
    }
    '/_staff/settings/persons': {
      id: '/_staff/settings/persons'
      path: '/settings/persons'
      fullPath: '/settings/persons'
      preLoaderRoute: typeof StaffSettingsPersonsImport
      parentRoute: typeof StaffImport
    }
    '/_staff/settings/persons/_list': {
      id: '/_staff/settings/persons/_list'
      path: '/settings/persons'
      fullPath: '/settings/persons'
      preLoaderRoute: typeof StaffSettingsPersonsListImport
      parentRoute: typeof StaffSettingsPersonsRoute
    }
    '/_staff/software/$id': {
      id: '/_staff/software/$id'
      path: '/$id'
      fullPath: '/software/$id'
      preLoaderRoute: typeof StaffSoftwareIdImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/software/$id/_$id': {
      id: '/_staff/software/$id/_$id'
      path: '/$id'
      fullPath: '/software/$id'
      preLoaderRoute: typeof StaffSoftwareIdIdImport
      parentRoute: typeof StaffSoftwareIdRoute
    }
    '/_staff/software/_layout/integrations': {
      id: '/_staff/software/_layout/integrations'
      path: '/integrations'
      fullPath: '/software/integrations'
      preLoaderRoute: typeof StaffSoftwareLayoutIntegrationsImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/starlinks/$id': {
      id: '/_staff/starlinks/$id'
      path: '/$id'
      fullPath: '/starlinks/$id'
      preLoaderRoute: typeof StaffStarlinksIdImport
      parentRoute: typeof StaffStarlinksImport
    }
    '/_staff/starlinks/$id/_layout': {
      id: '/_staff/starlinks/$id/_layout'
      path: '/$id'
      fullPath: '/starlinks/$id'
      preLoaderRoute: typeof StaffStarlinksIdLayoutImport
      parentRoute: typeof StaffStarlinksIdRoute
    }
    '/_staff/apps/_list/': {
      id: '/_staff/apps/_list/'
      path: '/'
      fullPath: '/apps/'
      preLoaderRoute: typeof StaffAppsListIndexRouteLazyImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/devices/_list/': {
      id: '/_staff/devices/_list/'
      path: '/'
      fullPath: '/devices/'
      preLoaderRoute: typeof StaffDevicesListIndexRouteLazyImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/people/_list/': {
      id: '/_staff/people/_list/'
      path: '/'
      fullPath: '/people/'
      preLoaderRoute: typeof StaffPeopleListIndexRouteLazyImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/software/_layout/': {
      id: '/_staff/software/_layout/'
      path: '/'
      fullPath: '/software/'
      preLoaderRoute: typeof StaffSoftwareLayoutIndexRouteLazyImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/certification/_list/settings': {
      id: '/_staff/certification/_list/settings'
      path: '/settings'
      fullPath: '/certification/settings'
      preLoaderRoute: typeof StaffCertificationListSettingsRouteLazyImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/equipment/_layout/settings': {
      id: '/_staff/equipment/_layout/settings'
      path: '/settings'
      fullPath: '/equipment/settings'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/people/_list/settings': {
      id: '/_staff/people/_list/settings'
      path: '/settings'
      fullPath: '/people/settings'
      preLoaderRoute: typeof StaffPeopleListSettingsRouteLazyImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/accesses/_layout/': {
      id: '/_staff/accesses/_layout/'
      path: '/'
      fullPath: '/accesses/'
      preLoaderRoute: typeof StaffAccessesLayoutIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/business-operation-events/$eventInstanceId/': {
      id: '/_staff/business-operation-events/$eventInstanceId/'
      path: '/$eventInstanceId'
      fullPath: '/business-operation-events/$eventInstanceId'
      preLoaderRoute: typeof StaffBusinessOperationEventsEventInstanceIdIndexImport
      parentRoute: typeof StaffBusinessOperationEventsImport
    }
    '/_staff/business-operation-events/_list/': {
      id: '/_staff/business-operation-events/_list/'
      path: '/'
      fullPath: '/business-operation-events/'
      preLoaderRoute: typeof StaffBusinessOperationEventsListIndexImport
      parentRoute: typeof StaffBusinessOperationEventsListImport
    }
    '/_staff/business-partner/_list/': {
      id: '/_staff/business-partner/_list/'
      path: '/'
      fullPath: '/business-partner/'
      preLoaderRoute: typeof StaffBusinessPartnerListIndexImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/add/': {
      id: '/_staff/business-partner/add/'
      path: '/add'
      fullPath: '/business-partner/add'
      preLoaderRoute: typeof StaffBusinessPartnerAddIndexImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/certification/_list/': {
      id: '/_staff/certification/_list/'
      path: '/'
      fullPath: '/certification/'
      preLoaderRoute: typeof StaffCertificationListIndexImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/add/': {
      id: '/_staff/certification/add/'
      path: '/add'
      fullPath: '/certification/add'
      preLoaderRoute: typeof StaffCertificationAddIndexImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/cockpit/$id/': {
      id: '/_staff/cockpit/$id/'
      path: '/cockpit/$id'
      fullPath: '/cockpit/$id'
      preLoaderRoute: typeof StaffCockpitIdIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/contract/_list/': {
      id: '/_staff/contract/_list/'
      path: '/'
      fullPath: '/contract/'
      preLoaderRoute: typeof StaffContractListIndexImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/add/': {
      id: '/_staff/contract/add/'
      path: '/add'
      fullPath: '/contract/add'
      preLoaderRoute: typeof StaffContractAddIndexImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/contractor-core/_packages/': {
      id: '/_staff/contractor-core/_packages/'
      path: '/'
      fullPath: '/contractor-core/'
      preLoaderRoute: typeof StaffContractorCorePackagesIndexImport
      parentRoute: typeof StaffContractorCorePackagesImport
    }
    '/_staff/device-catalog/add/': {
      id: '/_staff/device-catalog/add/'
      path: '/device-catalog/add'
      fullPath: '/device-catalog/add'
      preLoaderRoute: typeof StaffDeviceCatalogAddIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/devices/add/': {
      id: '/_staff/devices/add/'
      path: '/add'
      fullPath: '/devices/add'
      preLoaderRoute: typeof StaffDevicesAddIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/devices/external-it-saas/': {
      id: '/_staff/devices/external-it-saas/'
      path: '/external-it-saas'
      fullPath: '/devices/external-it-saas'
      preLoaderRoute: typeof StaffDevicesExternalItSaasIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/': {
      id: '/_staff/equipment/_layout/'
      path: '/'
      fullPath: '/equipment/'
      preLoaderRoute: typeof StaffEquipmentLayoutIndexImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/add-select/': {
      id: '/_staff/equipment/add-select/'
      path: '/add-select'
      fullPath: '/equipment/add-select'
      preLoaderRoute: typeof StaffEquipmentAddSelectIndexImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/equipment/add/': {
      id: '/_staff/equipment/add/'
      path: '/add'
      fullPath: '/equipment/add'
      preLoaderRoute: typeof StaffEquipmentAddIndexImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/equipment/import-csv/': {
      id: '/_staff/equipment/import-csv/'
      path: '/import-csv'
      fullPath: '/equipment/import-csv'
      preLoaderRoute: typeof StaffEquipmentImportCsvIndexImport
      parentRoute: typeof StaffEquipmentImport
    }
    '/_staff/fleets/add-select/': {
      id: '/_staff/fleets/add-select/'
      path: '/add-select'
      fullPath: '/fleets/add-select'
      preLoaderRoute: typeof StaffFleetsAddSelectIndexImport
      parentRoute: typeof StaffFleetsImport
    }
    '/_staff/fleets/add/': {
      id: '/_staff/fleets/add/'
      path: '/add'
      fullPath: '/fleets/add'
      preLoaderRoute: typeof StaffFleetsAddIndexImport
      parentRoute: typeof StaffFleetsImport
    }
    '/_staff/ga-operation-core/_packages/': {
      id: '/_staff/ga-operation-core/_packages/'
      path: '/'
      fullPath: '/ga-operation-core/'
      preLoaderRoute: typeof StaffGaOperationCorePackagesIndexImport
      parentRoute: typeof StaffGaOperationCorePackagesImport
    }
    '/_staff/ids/_layout/': {
      id: '/_staff/ids/_layout/'
      path: '/'
      fullPath: '/ids/'
      preLoaderRoute: typeof StaffIdsLayoutIndexImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/labor-core/_packages/': {
      id: '/_staff/labor-core/_packages/'
      path: '/'
      fullPath: '/labor-core/'
      preLoaderRoute: typeof StaffLaborCorePackagesIndexImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/licenses/add/': {
      id: '/_staff/licenses/add/'
      path: '/add'
      fullPath: '/licenses/add'
      preLoaderRoute: typeof StaffLicensesAddIndexImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/marketplace/cart/': {
      id: '/_staff/marketplace/cart/'
      path: '/cart'
      fullPath: '/marketplace/cart'
      preLoaderRoute: typeof StaffMarketplaceCartIndexImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/marketplace/unavailable/': {
      id: '/_staff/marketplace/unavailable/'
      path: '/unavailable'
      fullPath: '/marketplace/unavailable'
      preLoaderRoute: typeof StaffMarketplaceUnavailableIndexImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/networks/_layout/': {
      id: '/_staff/networks/_layout/'
      path: '/'
      fullPath: '/networks/'
      preLoaderRoute: typeof StaffNetworksLayoutIndexImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/add/': {
      id: '/_staff/networks/add/'
      path: '/add'
      fullPath: '/networks/add'
      preLoaderRoute: typeof StaffNetworksAddIndexImport
      parentRoute: typeof StaffNetworksImport
    }
    '/_staff/organization/plan/': {
      id: '/_staff/organization/plan/'
      path: '/plan'
      fullPath: '/organization/plan'
      preLoaderRoute: typeof StaffOrganizationPlanIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/person/add-person-certification/': {
      id: '/_staff/person/add-person-certification/'
      path: '/person/add-person-certification'
      fullPath: '/person/add-person-certification'
      preLoaderRoute: typeof StaffPersonAddPersonCertificationIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/add/': {
      id: '/_staff/person/add/'
      path: '/person/add'
      fullPath: '/person/add'
      preLoaderRoute: typeof StaffPersonAddIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/external-hr-saas/': {
      id: '/_staff/person/external-hr-saas/'
      path: '/person/external-hr-saas'
      fullPath: '/person/external-hr-saas'
      preLoaderRoute: typeof StaffPersonExternalHrSaasIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout/': {
      id: '/_staff/places/_layout/'
      path: '/'
      fullPath: '/places/'
      preLoaderRoute: typeof StaffPlacesLayoutIndexImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/add-select/': {
      id: '/_staff/places/add-select/'
      path: '/add-select'
      fullPath: '/places/add-select'
      preLoaderRoute: typeof StaffPlacesAddSelectIndexImport
      parentRoute: typeof StaffPlacesImport
    }
    '/_staff/places/add/': {
      id: '/_staff/places/add/'
      path: '/add'
      fullPath: '/places/add'
      preLoaderRoute: typeof StaffPlacesAddIndexImport
      parentRoute: typeof StaffPlacesImport
    }
    '/_staff/public-ids/$id/': {
      id: '/_staff/public-ids/$id/'
      path: '/'
      fullPath: '/public-ids/$id/'
      preLoaderRoute: typeof StaffPublicIdsIdIndexImport
      parentRoute: typeof StaffPublicIdsIdImport
    }
    '/_staff/public-ids/_list/': {
      id: '/_staff/public-ids/_list/'
      path: '/'
      fullPath: '/public-ids/'
      preLoaderRoute: typeof StaffPublicIdsListIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/add/': {
      id: '/_staff/public-ids/add/'
      path: '/add'
      fullPath: '/public-ids/add'
      preLoaderRoute: typeof StaffPublicIdsAddIndexImport
      parentRoute: typeof StaffPublicIdsImport
    }
    '/_staff/settings/contracting-corporation-profile/': {
      id: '/_staff/settings/contracting-corporation-profile/'
      path: '/'
      fullPath: '/settings/contracting-corporation-profile/'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileImport
    }
    '/_staff/settings/permission-and-roles/': {
      id: '/_staff/settings/permission-and-roles/'
      path: '/'
      fullPath: '/settings/permission-and-roles/'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesImport
    }
    '/_staff/settings/persons/': {
      id: '/_staff/settings/persons/'
      path: '/'
      fullPath: '/settings/persons/'
      preLoaderRoute: typeof StaffSettingsPersonsIndexImport
      parentRoute: typeof StaffSettingsPersonsImport
    }
    '/_staff/software/add/': {
      id: '/_staff/software/add/'
      path: '/add'
      fullPath: '/software/add'
      preLoaderRoute: typeof StaffSoftwareAddIndexImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/starlinks/_layout/': {
      id: '/_staff/starlinks/_layout/'
      path: '/'
      fullPath: '/starlinks/'
      preLoaderRoute: typeof StaffStarlinksLayoutIndexImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/time-and-attendance/_layout/': {
      id: '/_staff/time-and-attendance/_layout/'
      path: '/'
      fullPath: '/time-and-attendance/'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/auth/invitation/$invitationCode/': {
      id: '/auth/invitation/$invitationCode/'
      path: '/auth/invitation/$invitationCode'
      fullPath: '/auth/invitation/$invitationCode'
      preLoaderRoute: typeof AuthInvitationInvitationCodeIndexImport
      parentRoute: typeof rootRoute
    }
    '/_staff/person/$id/_profile/': {
      id: '/_staff/person/$id/_profile/'
      path: '/'
      fullPath: '/person/$id/'
      preLoaderRoute: typeof StaffPersonIdProfileIndexRouteImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/apps/_list/marketplace/$id': {
      id: '/_staff/apps/_list/marketplace/$id'
      path: '/marketplace/$id'
      fullPath: '/apps/marketplace/$id'
      preLoaderRoute: typeof StaffAppsListMarketplaceIdRouteImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/business-partner/_list/_placeholders/alerts': {
      id: '/_staff/business-partner/_list/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/business-partner/alerts'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersAlertsRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/contract-and-cost': {
      id: '/_staff/business-partner/_list/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/business-partner/contract-and-cost'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/operation-activity': {
      id: '/_staff/business-partner/_list/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/business-partner/operation-activity'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/rule-and-policy': {
      id: '/_staff/business-partner/_list/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/business-partner/rule-and-policy'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/_list/_placeholders/settings': {
      id: '/_staff/business-partner/_list/_placeholders/settings'
      path: '/settings'
      fullPath: '/business-partner/settings'
      preLoaderRoute: typeof StaffBusinessPartnerListPlaceholdersSettingsRouteImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/certification/_list/_placeholders/alerts': {
      id: '/_staff/certification/_list/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/certification/alerts'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersAlertsRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/_list/_placeholders/operation-activity': {
      id: '/_staff/certification/_list/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/certification/operation-activity'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/_list/_placeholders/overview': {
      id: '/_staff/certification/_list/_placeholders/overview'
      path: '/overview'
      fullPath: '/certification/overview'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersOverviewRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/certification/_list/_placeholders/rule-and-policy': {
      id: '/_staff/certification/_list/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/certification/rule-and-policy'
      preLoaderRoute: typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteImport
      parentRoute: typeof StaffCertificationListImport
    }
    '/_staff/contract/_list/_placeholders/alerts': {
      id: '/_staff/contract/_list/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/contract/alerts'
      preLoaderRoute: typeof StaffContractListPlaceholdersAlertsRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/contract-and-cost': {
      id: '/_staff/contract/_list/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/contract/contract-and-cost'
      preLoaderRoute: typeof StaffContractListPlaceholdersContractAndCostRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/operation-activity': {
      id: '/_staff/contract/_list/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/contract/operation-activity'
      preLoaderRoute: typeof StaffContractListPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/overview': {
      id: '/_staff/contract/_list/_placeholders/overview'
      path: '/overview'
      fullPath: '/contract/overview'
      preLoaderRoute: typeof StaffContractListPlaceholdersOverviewRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/contract/_list/_placeholders/people': {
      id: '/_staff/contract/_list/_placeholders/people'
      path: '/people'
      fullPath: '/contract/people'
      preLoaderRoute: typeof StaffContractListPlaceholdersPeopleRouteImport
      parentRoute: typeof StaffContractListImport
    }
    '/_staff/software/_layout/marketplace/$id': {
      id: '/_staff/software/_layout/marketplace/$id'
      path: '/marketplace/$id'
      fullPath: '/software/marketplace/$id'
      preLoaderRoute: typeof StaffSoftwareLayoutMarketplaceIdRouteImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_individual/individual/task/$id/approval-dialog': {
      id: '/_individual/individual/task/$id/approval-dialog'
      path: '/individual/task/$id/approval-dialog'
      fullPath: '/individual/task/$id/approval-dialog'
      preLoaderRoute: typeof IndividualIndividualTaskIdApprovalDialogImport
      parentRoute: typeof IndividualImport
    }
    '/_staff/accesses/_layout/_placeholders/contract-and-cost': {
      id: '/_staff/accesses/_layout/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/accesses/contract-and-cost'
      preLoaderRoute: typeof StaffAccessesLayoutPlaceholdersContractAndCostImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/_placeholders/overview': {
      id: '/_staff/accesses/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/accesses/overview'
      preLoaderRoute: typeof StaffAccessesLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/_placeholders/settings': {
      id: '/_staff/accesses/_layout/_placeholders/settings'
      path: '/settings'
      fullPath: '/accesses/settings'
      preLoaderRoute: typeof StaffAccessesLayoutPlaceholdersSettingsImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/_placeholders/software': {
      id: '/_staff/accesses/_layout/_placeholders/software'
      path: '/software'
      fullPath: '/accesses/software'
      preLoaderRoute: typeof StaffAccessesLayoutPlaceholdersSoftwareImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/app-integrations/$id/_$id/groups': {
      id: '/_staff/app-integrations/$id/_$id/groups'
      path: '/groups'
      fullPath: '/app-integrations/$id/groups'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdGroupsImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/apps/_list/alerts': {
      id: '/_staff/apps/_list/alerts'
      path: '/alerts'
      fullPath: '/apps/alerts'
      preLoaderRoute: typeof StaffAppsListAlertsImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/apps/_list/alerts/_alerts': {
      id: '/_staff/apps/_list/alerts/_alerts'
      path: '/alerts'
      fullPath: '/apps/alerts'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsImport
      parentRoute: typeof StaffAppsListAlertsRoute
    }
    '/_staff/business-partner/add/$businessPartnerType/completed': {
      id: '/_staff/business-partner/add/$businessPartnerType/completed'
      path: '/add/$businessPartnerType/completed'
      fullPath: '/business-partner/add/$businessPartnerType/completed'
      preLoaderRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/certification/add/$certificationKind/completed': {
      id: '/_staff/certification/add/$certificationKind/completed'
      path: '/add/$certificationKind/completed'
      fullPath: '/certification/add/$certificationKind/completed'
      preLoaderRoute: typeof StaffCertificationAddCertificationKindCompletedImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/handling-certification/$id': {
      id: '/_staff/certification/handling-certification/$id'
      path: '/handling-certification/$id'
      fullPath: '/certification/handling-certification/$id'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/handling-certification/$id/_layout': {
      id: '/_staff/certification/handling-certification/$id/_layout'
      path: '/handling-certification/$id'
      fullPath: '/certification/handling-certification/$id'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdLayoutImport
      parentRoute: typeof StaffCertificationHandlingCertificationIdRoute
    }
    '/_staff/certification/specialty-certification/$id': {
      id: '/_staff/certification/specialty-certification/$id'
      path: '/specialty-certification/$id'
      fullPath: '/certification/specialty-certification/$id'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/certification/specialty-certification/$id/_layout': {
      id: '/_staff/certification/specialty-certification/$id/_layout'
      path: '/specialty-certification/$id'
      fullPath: '/certification/specialty-certification/$id'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdRoute
    }
    '/_staff/device-catalog/active/$id': {
      id: '/_staff/device-catalog/active/$id'
      path: '/device-catalog/active/$id'
      fullPath: '/device-catalog/active/$id'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/device-catalog/active/$id/_layout': {
      id: '/_staff/device-catalog/active/$id/_layout'
      path: '/device-catalog/active/$id'
      fullPath: '/device-catalog/active/$id'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutImport
      parentRoute: typeof StaffDeviceCatalogActiveIdRoute
    }
    '/_staff/device-catalog/add/$deviceType/completed': {
      id: '/_staff/device-catalog/add/$deviceType/completed'
      path: '/device-catalog/add/$deviceType/completed'
      fullPath: '/device-catalog/add/$deviceType/completed'
      preLoaderRoute: typeof StaffDeviceCatalogAddDeviceTypeCompletedImport
      parentRoute: typeof StaffImport
    }
    '/_staff/device-catalog/draft/$id': {
      id: '/_staff/device-catalog/draft/$id'
      path: '/device-catalog/draft/$id'
      fullPath: '/device-catalog/draft/$id'
      preLoaderRoute: typeof StaffDeviceCatalogDraftIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/device-catalog/draft/$id/_layout': {
      id: '/_staff/device-catalog/draft/$id/_layout'
      path: '/device-catalog/draft/$id'
      fullPath: '/device-catalog/draft/$id'
      preLoaderRoute: typeof StaffDeviceCatalogDraftIdLayoutImport
      parentRoute: typeof StaffDeviceCatalogDraftIdRoute
    }
    '/_staff/devices/_list/settings/catalog': {
      id: '/_staff/devices/_list/settings/catalog'
      path: '/settings/catalog'
      fullPath: '/devices/settings/catalog'
      preLoaderRoute: typeof StaffDevicesListSettingsCatalogImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/add/$deviceType/completed': {
      id: '/_staff/devices/add/$deviceType/completed'
      path: '/add/$deviceType/completed'
      fullPath: '/devices/add/$deviceType/completed'
      preLoaderRoute: typeof StaffDevicesAddDeviceTypeCompletedImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/_placeholders/alerts': {
      id: '/_staff/equipment/_layout/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/equipment/alerts'
      preLoaderRoute: typeof StaffEquipmentLayoutPlaceholdersAlertsImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/_layout/_placeholders/overview': {
      id: '/_staff/equipment/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/equipment/overview'
      preLoaderRoute: typeof StaffEquipmentLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/equipment/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/equipment/rule-and-policy'
      preLoaderRoute: typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/equipment/_layout/_placeholders/settings': {
      id: '/_staff/equipment/_layout/_placeholders/settings'
      path: '/settings'
      fullPath: '/equipment/settings'
      preLoaderRoute: typeof StaffEquipmentLayoutPlaceholdersSettingsImport
      parentRoute: typeof StaffEquipmentLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/alerts': {
      id: '/_staff/ids/_layout/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/ids/alerts'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersAlertsImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/group-id': {
      id: '/_staff/ids/_layout/_placeholders/group-id'
      path: '/group-id'
      fullPath: '/ids/group-id'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersGroupIdImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/operation-activity': {
      id: '/_staff/ids/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/ids/operation-activity'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/overview': {
      id: '/_staff/ids/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/ids/overview'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/ids/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/ids/rule-and-policy'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/_layout/_placeholders/settings': {
      id: '/_staff/ids/_layout/_placeholders/settings'
      path: '/settings'
      fullPath: '/ids/settings'
      preLoaderRoute: typeof StaffIdsLayoutPlaceholdersSettingsImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/group-id/$id': {
      id: '/_staff/ids/group-id/$id'
      path: '/group-id/$id'
      fullPath: '/ids/group-id/$id'
      preLoaderRoute: typeof StaffIdsGroupIdIdImport
      parentRoute: typeof StaffIdsImport
    }
    '/_staff/ids/group-id/$id/_$id': {
      id: '/_staff/ids/group-id/$id/_$id'
      path: '/group-id/$id'
      fullPath: '/ids/group-id/$id'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdImport
      parentRoute: typeof StaffIdsGroupIdIdRoute
    }
    '/_staff/it-operation-core/_root/packages/$packageId': {
      id: '/_staff/it-operation-core/_root/packages/$packageId'
      path: '/$packageId'
      fullPath: '/it-operation-core/packages/$packageId'
      preLoaderRoute: typeof StaffItOperationCoreRootPackagesPackageIdImport
      parentRoute: typeof StaffItOperationCoreRootPackagesRouteImport
    }
    '/_staff/labor-core/settings/profile/$profileId': {
      id: '/_staff/labor-core/settings/profile/$profileId'
      path: '/settings/profile/$profileId'
      fullPath: '/labor-core/settings/profile/$profileId'
      preLoaderRoute: typeof StaffLaborCoreSettingsProfileProfileIdImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses/add/$allocationType/completed': {
      id: '/_staff/licenses/add/$allocationType/completed'
      path: '/add/$allocationType/completed'
      fullPath: '/licenses/add/$allocationType/completed'
      preLoaderRoute: typeof StaffLicensesAddAllocationTypeCompletedImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/marketplace/sent-orders/$orderId': {
      id: '/_staff/marketplace/sent-orders/$orderId'
      path: '/sent-orders/$orderId'
      fullPath: '/marketplace/sent-orders/$orderId'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/marketplace/sent-orders/$orderId/_layout': {
      id: '/_staff/marketplace/sent-orders/$orderId/_layout'
      path: '/sent-orders/$orderId'
      fullPath: '/marketplace/sent-orders/$orderId'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutImport
      parentRoute: typeof StaffMarketplaceSentOrdersOrderIdRoute
    }
    '/_staff/networks/_layout/_placeholders/alerts': {
      id: '/_staff/networks/_layout/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/networks/alerts'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersAlertsImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/contract-and-cost': {
      id: '/_staff/networks/_layout/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/networks/contract-and-cost'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersContractAndCostImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/operation-activity': {
      id: '/_staff/networks/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/networks/operation-activity'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/overview': {
      id: '/_staff/networks/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/networks/overview'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/networks/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/networks/rule-and-policy'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/networks/_layout/_placeholders/settings': {
      id: '/_staff/networks/_layout/_placeholders/settings'
      path: '/settings'
      fullPath: '/networks/settings'
      preLoaderRoute: typeof StaffNetworksLayoutPlaceholdersSettingsImport
      parentRoute: typeof StaffNetworksLayoutImport
    }
    '/_staff/person/add-person-certification/$certificationKind/completed': {
      id: '/_staff/person/add-person-certification/$certificationKind/completed'
      path: '/person/add-person-certification/$certificationKind/completed'
      fullPath: '/person/add-person-certification/$certificationKind/completed'
      preLoaderRoute: typeof StaffPersonAddPersonCertificationCertificationKindCompletedImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/add/$workerType/completed': {
      id: '/_staff/person/add/$workerType/completed'
      path: '/person/add/$workerType/completed'
      fullPath: '/person/add/$workerType/completed'
      preLoaderRoute: typeof StaffPersonAddWorkerTypeCompletedImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/alumni/$id': {
      id: '/_staff/person/alumni/$id'
      path: '/person/alumni/$id'
      fullPath: '/person/alumni/$id'
      preLoaderRoute: typeof StaffPersonAlumniIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/alumni/$id/_profile': {
      id: '/_staff/person/alumni/$id/_profile'
      path: '/person/alumni/$id'
      fullPath: '/person/alumni/$id'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileImport
      parentRoute: typeof StaffPersonAlumniIdRoute
    }
    '/_staff/places/_layout/_placeholders/alerts': {
      id: '/_staff/places/_layout/_placeholders/alerts'
      path: '/alerts'
      fullPath: '/places/alerts'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersAlertsImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/contract-and-cost': {
      id: '/_staff/places/_layout/_placeholders/contract-and-cost'
      path: '/contract-and-cost'
      fullPath: '/places/contract-and-cost'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersContractAndCostImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/operation-activity': {
      id: '/_staff/places/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/places/operation-activity'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/overview': {
      id: '/_staff/places/_layout/_placeholders/overview'
      path: '/overview'
      fullPath: '/places/overview'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersOverviewImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/people': {
      id: '/_staff/places/_layout/_placeholders/people'
      path: '/people'
      fullPath: '/places/people'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersPeopleImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/places/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/places/rule-and-policy'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/places/_layout/_placeholders/store': {
      id: '/_staff/places/_layout/_placeholders/store'
      path: '/store'
      fullPath: '/places/store'
      preLoaderRoute: typeof StaffPlacesLayoutPlaceholdersStoreImport
      parentRoute: typeof StaffPlacesLayoutImport
    }
    '/_staff/profile/device/$id': {
      id: '/_staff/profile/device/$id'
      path: '/profile/device/$id'
      fullPath: '/profile/device/$id'
      preLoaderRoute: typeof StaffProfileDeviceIdImport
      parentRoute: typeof StaffImport
    }
    '/_staff/profile/device/$id/_profile': {
      id: '/_staff/profile/device/$id/_profile'
      path: '/profile/device/$id'
      fullPath: '/profile/device/$id'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileImport
      parentRoute: typeof StaffProfileDeviceIdRoute
    }
    '/_staff/settings/persons/_list/_account': {
      id: '/_staff/settings/persons/_list/_account'
      path: ''
      fullPath: '/settings/persons'
      preLoaderRoute: typeof StaffSettingsPersonsListAccountImport
      parentRoute: typeof StaffSettingsPersonsListImport
    }
    '/_staff/software/_layout/alerts': {
      id: '/_staff/software/_layout/alerts'
      path: '/alerts'
      fullPath: '/software/alerts'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/alerts/_alerts': {
      id: '/_staff/software/_layout/alerts/_alerts'
      path: '/alerts'
      fullPath: '/software/alerts'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
      parentRoute: typeof StaffSoftwareLayoutAlertsRoute
    }
    '/_staff/starlinks/_layout/_placeholders/billing-and-cost': {
      id: '/_staff/starlinks/_layout/_placeholders/billing-and-cost'
      path: '/billing-and-cost'
      fullPath: '/starlinks/billing-and-cost'
      preLoaderRoute: typeof StaffStarlinksLayoutPlaceholdersBillingAndCostImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/starlinks/_layout/_placeholders/marketplace': {
      id: '/_staff/starlinks/_layout/_placeholders/marketplace'
      path: '/marketplace'
      fullPath: '/starlinks/marketplace'
      preLoaderRoute: typeof StaffStarlinksLayoutPlaceholdersMarketplaceImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/starlinks/_layout/_placeholders/operation-activity': {
      id: '/_staff/starlinks/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/starlinks/operation-activity'
      preLoaderRoute: typeof StaffStarlinksLayoutPlaceholdersOperationActivityImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/time-and-attendance/_layout/_placeholders/attendances': {
      id: '/_staff/time-and-attendance/_layout/_placeholders/attendances'
      path: '/attendances'
      fullPath: '/time-and-attendance/attendances'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutPlaceholdersAttendancesImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/time-and-attendance/_layout/_placeholders/clocking': {
      id: '/_staff/time-and-attendance/_layout/_placeholders/clocking'
      path: '/clocking'
      fullPath: '/time-and-attendance/clocking'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutPlaceholdersClockingImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_individual/individual/operation-package/$id/': {
      id: '/_individual/individual/operation-package/$id/'
      path: '/individual/operation-package/$id'
      fullPath: '/individual/operation-package/$id'
      preLoaderRoute: typeof IndividualIndividualOperationPackageIdIndexImport
      parentRoute: typeof IndividualImport
    }
    '/_individual/individual/task/$id/': {
      id: '/_individual/individual/task/$id/'
      path: '/individual/task/$id'
      fullPath: '/individual/task/$id'
      preLoaderRoute: typeof IndividualIndividualTaskIdIndexImport
      parentRoute: typeof IndividualImport
    }
    '/_staff/accesses/_layout/alerts/': {
      id: '/_staff/accesses/_layout/alerts/'
      path: '/alerts'
      fullPath: '/accesses/alerts'
      preLoaderRoute: typeof StaffAccessesLayoutAlertsIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/accesses/_layout/list/': {
      id: '/_staff/accesses/_layout/list/'
      path: '/list'
      fullPath: '/accesses/list'
      preLoaderRoute: typeof StaffAccessesLayoutListIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/app-integrations/$id/_$id/': {
      id: '/_staff/app-integrations/$id/_$id/'
      path: '/'
      fullPath: '/app-integrations/$id/'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdIndexImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/apps/_list/integrations/': {
      id: '/_staff/apps/_list/integrations/'
      path: '/integrations'
      fullPath: '/apps/integrations'
      preLoaderRoute: typeof StaffAppsListIntegrationsIndexImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/apps/_list/marketplace/': {
      id: '/_staff/apps/_list/marketplace/'
      path: '/marketplace'
      fullPath: '/apps/marketplace'
      preLoaderRoute: typeof StaffAppsListMarketplaceIndexImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/apps/_list/people/': {
      id: '/_staff/apps/_list/people/'
      path: '/people'
      fullPath: '/apps/people'
      preLoaderRoute: typeof StaffAppsListPeopleIndexImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/apps/_list/settings/': {
      id: '/_staff/apps/_list/settings/'
      path: '/settings'
      fullPath: '/apps/settings'
      preLoaderRoute: typeof StaffAppsListSettingsIndexImport
      parentRoute: typeof StaffAppsListImport
    }
    '/_staff/apps/custom-app/add/': {
      id: '/_staff/apps/custom-app/add/'
      path: '/custom-app/add'
      fullPath: '/apps/custom-app/add'
      preLoaderRoute: typeof StaffAppsCustomAppAddIndexImport
      parentRoute: typeof StaffAppsImport
    }
    '/_staff/business-partner/_list/terminated/': {
      id: '/_staff/business-partner/_list/terminated/'
      path: '/terminated'
      fullPath: '/business-partner/terminated'
      preLoaderRoute: typeof StaffBusinessPartnerListTerminatedIndexImport
      parentRoute: typeof StaffBusinessPartnerListImport
    }
    '/_staff/business-partner/add/$businessPartnerType/': {
      id: '/_staff/business-partner/add/$businessPartnerType/'
      path: '/add/$businessPartnerType'
      fullPath: '/business-partner/add/$businessPartnerType'
      preLoaderRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexImport
      parentRoute: typeof StaffBusinessPartnerImport
    }
    '/_staff/certification/_list/settings/': {
      id: '/_staff/certification/_list/settings/'
      path: '/'
      fullPath: '/certification/settings/'
      preLoaderRoute: typeof StaffCertificationListSettingsIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/certification/add/$certificationKind/': {
      id: '/_staff/certification/add/$certificationKind/'
      path: '/add/$certificationKind'
      fullPath: '/certification/add/$certificationKind'
      preLoaderRoute: typeof StaffCertificationAddCertificationKindIndexImport
      parentRoute: typeof StaffCertificationImport
    }
    '/_staff/contract/import-csv/$contractType/': {
      id: '/_staff/contract/import-csv/$contractType/'
      path: '/import-csv/$contractType'
      fullPath: '/contract/import-csv/$contractType'
      preLoaderRoute: typeof StaffContractImportCsvContractTypeIndexImport
      parentRoute: typeof StaffContractImport
    }
    '/_staff/contractor-core/_packages/archives/': {
      id: '/_staff/contractor-core/_packages/archives/'
      path: '/archives'
      fullPath: '/contractor-core/archives'
      preLoaderRoute: typeof StaffContractorCorePackagesArchivesIndexImport
      parentRoute: typeof StaffContractorCorePackagesImport
    }
    '/_staff/contractor-core/_packages/configs/': {
      id: '/_staff/contractor-core/_packages/configs/'
      path: '/configs'
      fullPath: '/contractor-core/configs'
      preLoaderRoute: typeof StaffContractorCorePackagesConfigsIndexImport
      parentRoute: typeof StaffContractorCorePackagesImport
    }
    '/_staff/contractor-core/config/$patternId/': {
      id: '/_staff/contractor-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/contractor-core/config/$patternId'
      preLoaderRoute: typeof StaffContractorCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffContractorCoreImport
    }
    '/_staff/device-catalog/add/$deviceType/': {
      id: '/_staff/device-catalog/add/$deviceType/'
      path: '/device-catalog/add/$deviceType'
      fullPath: '/device-catalog/add/$deviceType'
      preLoaderRoute: typeof StaffDeviceCatalogAddDeviceTypeIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/devices/_list/catalog/': {
      id: '/_staff/devices/_list/catalog/'
      path: '/catalog'
      fullPath: '/devices/catalog'
      preLoaderRoute: typeof StaffDevicesListCatalogIndexImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/inventory/': {
      id: '/_staff/devices/_list/inventory/'
      path: '/inventory'
      fullPath: '/devices/inventory'
      preLoaderRoute: typeof StaffDevicesListInventoryIndexImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/people/': {
      id: '/_staff/devices/_list/people/'
      path: '/people'
      fullPath: '/devices/people'
      preLoaderRoute: typeof StaffDevicesListPeopleIndexImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/_list/settings/': {
      id: '/_staff/devices/_list/settings/'
      path: '/settings'
      fullPath: '/devices/settings'
      preLoaderRoute: typeof StaffDevicesListSettingsIndexImport
      parentRoute: typeof StaffDevicesListImport
    }
    '/_staff/devices/add/$deviceType/': {
      id: '/_staff/devices/add/$deviceType/'
      path: '/add/$deviceType'
      fullPath: '/devices/add/$deviceType'
      preLoaderRoute: typeof StaffDevicesAddDeviceTypeIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/settings/': {
      id: '/_staff/equipment/_layout/settings/'
      path: '/'
      fullPath: '/equipment/settings/'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsIndexImport
      parentRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
    }
    '/_staff/fleets/_layout/_list/': {
      id: '/_staff/fleets/_layout/_list/'
      path: '/'
      fullPath: '/fleets/'
      preLoaderRoute: typeof StaffFleetsLayoutListIndexImport
      parentRoute: typeof StaffFleetsLayoutImport
    }
    '/_staff/ga-operation-core/_packages/archives/': {
      id: '/_staff/ga-operation-core/_packages/archives/'
      path: '/archives'
      fullPath: '/ga-operation-core/archives'
      preLoaderRoute: typeof StaffGaOperationCorePackagesArchivesIndexImport
      parentRoute: typeof StaffGaOperationCorePackagesImport
    }
    '/_staff/ga-operation-core/_packages/configs/': {
      id: '/_staff/ga-operation-core/_packages/configs/'
      path: '/configs'
      fullPath: '/ga-operation-core/configs'
      preLoaderRoute: typeof StaffGaOperationCorePackagesConfigsIndexImport
      parentRoute: typeof StaffGaOperationCorePackagesImport
    }
    '/_staff/ga-operation-core/config/$patternId/': {
      id: '/_staff/ga-operation-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/ga-operation-core/config/$patternId'
      preLoaderRoute: typeof StaffGaOperationCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffGaOperationCoreImport
    }
    '/_staff/ids/_layout/people/': {
      id: '/_staff/ids/_layout/people/'
      path: '/people'
      fullPath: '/ids/people'
      preLoaderRoute: typeof StaffIdsLayoutPeopleIndexImport
      parentRoute: typeof StaffIdsLayoutImport
    }
    '/_staff/ids/group-id/add/': {
      id: '/_staff/ids/group-id/add/'
      path: '/group-id/add'
      fullPath: '/ids/group-id/add'
      preLoaderRoute: typeof StaffIdsGroupIdAddIndexImport
      parentRoute: typeof StaffIdsImport
    }
    '/_staff/it-operation-core/_root/archives/': {
      id: '/_staff/it-operation-core/_root/archives/'
      path: '/archives'
      fullPath: '/it-operation-core/archives'
      preLoaderRoute: typeof StaffItOperationCoreRootArchivesIndexImport
      parentRoute: typeof StaffItOperationCoreRootImport
    }
    '/_staff/it-operation-core/_root/config/': {
      id: '/_staff/it-operation-core/_root/config/'
      path: '/config'
      fullPath: '/it-operation-core/config'
      preLoaderRoute: typeof StaffItOperationCoreRootConfigIndexImport
      parentRoute: typeof StaffItOperationCoreRootImport
    }
    '/_staff/it-operation-core/_root/packages/': {
      id: '/_staff/it-operation-core/_root/packages/'
      path: '/'
      fullPath: '/it-operation-core/packages/'
      preLoaderRoute: typeof StaffItOperationCoreRootPackagesIndexImport
      parentRoute: typeof StaffItOperationCoreRootPackagesRouteImport
    }
    '/_staff/it-operation-core/config/$patternId/': {
      id: '/_staff/it-operation-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/it-operation-core/config/$patternId'
      preLoaderRoute: typeof StaffItOperationCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffItOperationCoreImport
    }
    '/_staff/labor-core/_packages/archives/': {
      id: '/_staff/labor-core/_packages/archives/'
      path: '/archives'
      fullPath: '/labor-core/archives'
      preLoaderRoute: typeof StaffLaborCorePackagesArchivesIndexImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/labor-core/_packages/configs/': {
      id: '/_staff/labor-core/_packages/configs/'
      path: '/configs'
      fullPath: '/labor-core/configs'
      preLoaderRoute: typeof StaffLaborCorePackagesConfigsIndexImport
      parentRoute: typeof StaffLaborCorePackagesImport
    }
    '/_staff/labor-core/_packages/settings/': {
      id: '/_staff/labor-core/_packages/settings/'
      path: '/'
      fullPath: '/labor-core/settings/'
      preLoaderRoute: typeof StaffLaborCorePackagesSettingsIndexImport
      parentRoute: typeof StaffLaborCorePackagesSettingsImport
    }
    '/_staff/labor-core/config/$patternId/': {
      id: '/_staff/labor-core/config/$patternId/'
      path: '/config/$patternId'
      fullPath: '/labor-core/config/$patternId'
      preLoaderRoute: typeof StaffLaborCoreConfigPatternIdIndexImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/licenses/_list/alerts/': {
      id: '/_staff/licenses/_list/alerts/'
      path: '/alerts'
      fullPath: '/licenses/alerts'
      preLoaderRoute: typeof StaffLicensesListAlertsIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/contract-and-cost/': {
      id: '/_staff/licenses/_list/contract-and-cost/'
      path: '/contract-and-cost'
      fullPath: '/licenses/contract-and-cost'
      preLoaderRoute: typeof StaffLicensesListContractAndCostIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/inventory/': {
      id: '/_staff/licenses/_list/inventory/'
      path: '/inventory'
      fullPath: '/licenses/inventory'
      preLoaderRoute: typeof StaffLicensesListInventoryIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/operation-activity/': {
      id: '/_staff/licenses/_list/operation-activity/'
      path: '/operation-activity'
      fullPath: '/licenses/operation-activity'
      preLoaderRoute: typeof StaffLicensesListOperationActivityIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/people/': {
      id: '/_staff/licenses/_list/people/'
      path: '/people'
      fullPath: '/licenses/people'
      preLoaderRoute: typeof StaffLicensesListPeopleIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/rule-and-policy/': {
      id: '/_staff/licenses/_list/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/licenses/rule-and-policy'
      preLoaderRoute: typeof StaffLicensesListRuleAndPolicyIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/_list/settings/': {
      id: '/_staff/licenses/_list/settings/'
      path: '/settings'
      fullPath: '/licenses/settings'
      preLoaderRoute: typeof StaffLicensesListSettingsIndexImport
      parentRoute: typeof StaffLicensesListImport
    }
    '/_staff/licenses/add/$allocationType/': {
      id: '/_staff/licenses/add/$allocationType/'
      path: '/add/$allocationType'
      fullPath: '/licenses/add/$allocationType'
      preLoaderRoute: typeof StaffLicensesAddAllocationTypeIndexImport
      parentRoute: typeof StaffLicensesImport
    }
    '/_staff/marketplace/sales-orders/$orderId/': {
      id: '/_staff/marketplace/sales-orders/$orderId/'
      path: '/sales-orders/$orderId'
      fullPath: '/marketplace/sales-orders/$orderId'
      preLoaderRoute: typeof StaffMarketplaceSalesOrdersOrderIdIndexImport
      parentRoute: typeof StaffMarketplaceImport
    }
    '/_staff/organization/$id/_layout/': {
      id: '/_staff/organization/$id/_layout/'
      path: '/'
      fullPath: '/organization/$id/'
      preLoaderRoute: typeof StaffOrganizationIdLayoutIndexImport
      parentRoute: typeof StaffOrganizationIdLayoutImport
    }
    '/_staff/organization/_list/alert/': {
      id: '/_staff/organization/_list/alert/'
      path: '/alert'
      fullPath: '/organization/alert'
      preLoaderRoute: typeof StaffOrganizationListAlertIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/chart/': {
      id: '/_staff/organization/_list/chart/'
      path: '/chart'
      fullPath: '/organization/chart'
      preLoaderRoute: typeof StaffOrganizationListChartIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/cost/': {
      id: '/_staff/organization/_list/cost/'
      path: '/cost'
      fullPath: '/organization/cost'
      preLoaderRoute: typeof StaffOrganizationListCostIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/history/': {
      id: '/_staff/organization/_list/history/'
      path: '/history'
      fullPath: '/organization/history'
      preLoaderRoute: typeof StaffOrganizationListHistoryIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/rule-policy/': {
      id: '/_staff/organization/_list/rule-policy/'
      path: '/rule-policy'
      fullPath: '/organization/rule-policy'
      preLoaderRoute: typeof StaffOrganizationListRulePolicyIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/_list/settings/': {
      id: '/_staff/organization/_list/settings/'
      path: '/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof StaffOrganizationListSettingsIndexImport
      parentRoute: typeof StaffOrganizationListImport
    }
    '/_staff/organization/plan/$id/': {
      id: '/_staff/organization/plan/$id/'
      path: '/plan/$id'
      fullPath: '/organization/plan/$id'
      preLoaderRoute: typeof StaffOrganizationPlanIdIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/organization/plan/create/': {
      id: '/_staff/organization/plan/create/'
      path: '/plan/create'
      fullPath: '/organization/plan/create'
      preLoaderRoute: typeof StaffOrganizationPlanCreateIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/people/_list/alumni/': {
      id: '/_staff/people/_list/alumni/'
      path: '/alumni'
      fullPath: '/people/alumni'
      preLoaderRoute: typeof StaffPeopleListAlumniIndexImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/people/_list/settings/': {
      id: '/_staff/people/_list/settings/'
      path: '/'
      fullPath: '/people/settings/'
      preLoaderRoute: typeof StaffPeopleListSettingsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/workforce/': {
      id: '/_staff/people/_list/workforce/'
      path: '/workforce'
      fullPath: '/people/workforce'
      preLoaderRoute: typeof StaffPeopleListWorkforceIndexImport
      parentRoute: typeof StaffPeopleListImport
    }
    '/_staff/person/add-person-certification/$certificationKind/': {
      id: '/_staff/person/add-person-certification/$certificationKind/'
      path: '/person/add-person-certification/$certificationKind'
      fullPath: '/person/add-person-certification/$certificationKind'
      preLoaderRoute: typeof StaffPersonAddPersonCertificationCertificationKindIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/person/add/$workerType/': {
      id: '/_staff/person/add/$workerType/'
      path: '/person/add/$workerType'
      fullPath: '/person/add/$workerType'
      preLoaderRoute: typeof StaffPersonAddWorkerTypeIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/_layout/settings/': {
      id: '/_staff/places/_layout/settings/'
      path: '/'
      fullPath: '/places/settings/'
      preLoaderRoute: typeof StaffPlacesLayoutSettingsIndexImport
      parentRoute: typeof StaffPlacesLayoutSettingsRouteImport
    }
    '/_staff/public-ids/$id/details/': {
      id: '/_staff/public-ids/$id/details/'
      path: '/details'
      fullPath: '/public-ids/$id/details'
      preLoaderRoute: typeof StaffPublicIdsIdDetailsIndexImport
      parentRoute: typeof StaffPublicIdsIdImport
    }
    '/_staff/public-ids/$id/files/': {
      id: '/_staff/public-ids/$id/files/'
      path: '/files'
      fullPath: '/public-ids/$id/files'
      preLoaderRoute: typeof StaffPublicIdsIdFilesIndexImport
      parentRoute: typeof StaffPublicIdsIdImport
    }
    '/_staff/public-ids/_list/alerts/': {
      id: '/_staff/public-ids/_list/alerts/'
      path: '/alerts'
      fullPath: '/public-ids/alerts'
      preLoaderRoute: typeof StaffPublicIdsListAlertsIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/members/': {
      id: '/_staff/public-ids/_list/members/'
      path: '/members'
      fullPath: '/public-ids/members'
      preLoaderRoute: typeof StaffPublicIdsListMembersIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/operation-activity/': {
      id: '/_staff/public-ids/_list/operation-activity/'
      path: '/operation-activity'
      fullPath: '/public-ids/operation-activity'
      preLoaderRoute: typeof StaffPublicIdsListOperationActivityIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/registry/': {
      id: '/_staff/public-ids/_list/registry/'
      path: '/registry'
      fullPath: '/public-ids/registry'
      preLoaderRoute: typeof StaffPublicIdsListRegistryIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/rules-and-policies/': {
      id: '/_staff/public-ids/_list/rules-and-policies/'
      path: '/rules-and-policies'
      fullPath: '/public-ids/rules-and-policies'
      preLoaderRoute: typeof StaffPublicIdsListRulesAndPoliciesIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/public-ids/_list/settings/': {
      id: '/_staff/public-ids/_list/settings/'
      path: '/settings'
      fullPath: '/public-ids/settings'
      preLoaderRoute: typeof StaffPublicIdsListSettingsIndexImport
      parentRoute: typeof StaffPublicIdsListImport
    }
    '/_staff/software/$id/_$id/': {
      id: '/_staff/software/$id/_$id/'
      path: '/'
      fullPath: '/software/$id/'
      preLoaderRoute: typeof StaffSoftwareIdIdIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/_layout/contract-and-cost/': {
      id: '/_staff/software/_layout/contract-and-cost/'
      path: '/contract-and-cost'
      fullPath: '/software/contract-and-cost'
      preLoaderRoute: typeof StaffSoftwareLayoutContractAndCostIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/marketplace/': {
      id: '/_staff/software/_layout/marketplace/'
      path: '/marketplace'
      fullPath: '/software/marketplace'
      preLoaderRoute: typeof StaffSoftwareLayoutMarketplaceIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/operation-activity/': {
      id: '/_staff/software/_layout/operation-activity/'
      path: '/operation-activity'
      fullPath: '/software/operation-activity'
      preLoaderRoute: typeof StaffSoftwareLayoutOperationActivityIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/people/': {
      id: '/_staff/software/_layout/people/'
      path: '/'
      fullPath: '/software/people/'
      preLoaderRoute: typeof StaffSoftwareLayoutPeopleIndexImport
      parentRoute: typeof StaffSoftwareLayoutPeopleRouteImport
    }
    '/_staff/software/_layout/registry/': {
      id: '/_staff/software/_layout/registry/'
      path: '/registry'
      fullPath: '/software/registry'
      preLoaderRoute: typeof StaffSoftwareLayoutRegistryIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/rule-and-policy/': {
      id: '/_staff/software/_layout/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/software/rule-and-policy'
      preLoaderRoute: typeof StaffSoftwareLayoutRuleAndPolicyIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/_layout/settings/': {
      id: '/_staff/software/_layout/settings/'
      path: '/settings'
      fullPath: '/software/settings'
      preLoaderRoute: typeof StaffSoftwareLayoutSettingsIndexImport
      parentRoute: typeof StaffSoftwareLayoutImport
    }
    '/_staff/software/add/$type/': {
      id: '/_staff/software/add/$type/'
      path: '/add/$type'
      fullPath: '/software/add/$type'
      preLoaderRoute: typeof StaffSoftwareAddTypeIndexImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/starlinks/_layout/alerts/': {
      id: '/_staff/starlinks/_layout/alerts/'
      path: '/alerts'
      fullPath: '/starlinks/alerts'
      preLoaderRoute: typeof StaffStarlinksLayoutAlertsIndexImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/starlinks/_layout/user-terminals/': {
      id: '/_staff/starlinks/_layout/user-terminals/'
      path: '/user-terminals'
      fullPath: '/starlinks/user-terminals'
      preLoaderRoute: typeof StaffStarlinksLayoutUserTerminalsIndexImport
      parentRoute: typeof StaffStarlinksLayoutImport
    }
    '/_staff/storage-files/_list/files/': {
      id: '/_staff/storage-files/_list/files/'
      path: '/files'
      fullPath: '/storage-files/files'
      preLoaderRoute: typeof StaffStorageFilesListFilesIndexImport
      parentRoute: typeof StaffStorageFilesListImport
    }
    '/_staff/storage-files/_list/folders/': {
      id: '/_staff/storage-files/_list/folders/'
      path: '/folders'
      fullPath: '/storage-files/folders'
      preLoaderRoute: typeof StaffStorageFilesListFoldersIndexImport
      parentRoute: typeof StaffStorageFilesListImport
    }
    '/_staff/time-and-attendance/_layout/attendance-links/': {
      id: '/_staff/time-and-attendance/_layout/attendance-links/'
      path: '/attendance-links'
      fullPath: '/time-and-attendance/attendance-links'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/licenses/$id/_profile/': {
      id: '/_staff/licenses/$id/_profile/'
      path: '/'
      fullPath: '/licenses/$id/'
      preLoaderRoute: typeof StaffLicensesIdProfileIndexLazyImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/': {
      id: '/_staff/person/alumni/$id/_profile/'
      path: '/'
      fullPath: '/person/alumni/$id/'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileIndexRouteImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/contract/$id/_layout/_placeholders/approval-info': {
      id: '/_staff/contract/$id/_layout/_placeholders/approval-info'
      path: '/approval-info'
      fullPath: '/contract/$id/approval-info'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/history': {
      id: '/_staff/contract/$id/_layout/_placeholders/history'
      path: '/history'
      fullPath: '/contract/$id/history'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersHistoryRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/operation-activity': {
      id: '/_staff/contract/$id/_layout/_placeholders/operation-activity'
      path: '/operation-activity'
      fullPath: '/contract/$id/operation-activity'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/risk-provisions': {
      id: '/_staff/contract/$id/_layout/_placeholders/risk-provisions'
      path: '/risk-provisions'
      fullPath: '/contract/$id/risk-provisions'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/_placeholders/rule-and-policy': {
      id: '/_staff/contract/$id/_layout/_placeholders/rule-and-policy'
      path: '/rule-and-policy'
      fullPath: '/contract/$id/rule-and-policy'
      preLoaderRoute: typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/profile/device/$id/_profile/files': {
      id: '/_staff/profile/device/$id/_profile/files'
      path: '/files'
      fullPath: '/profile/device/$id/files'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileFilesRouteImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId'
      path: '/operation-instances/$instanceId'
      fullPath: '/it-operation-core/operation-instances/$instanceId'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdImport
      parentRoute: typeof StaffItOperationCoreDetailImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout'
      path: '/operation-instances/$instanceId'
      fullPath: '/it-operation-core/operation-instances/$instanceId'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdRoute
    }
    '/_staff/licenses/$id/service-plans/$licenseServiceId': {
      id: '/_staff/licenses/$id/service-plans/$licenseServiceId'
      path: '/service-plans/$licenseServiceId'
      fullPath: '/licenses/$id/service-plans/$licenseServiceId'
      preLoaderRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdImport
      parentRoute: typeof StaffLicensesIdImport
    }
    '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail': {
      id: '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail'
      path: '/service-plans/$licenseServiceId'
      fullPath: '/licenses/$id/service-plans/$licenseServiceId'
      preLoaderRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailImport
      parentRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdRoute
    }
    '/_staff/marketplace/sent-orders/$orderId/_layout/activities': {
      id: '/_staff/marketplace/sent-orders/$orderId/_layout/activities'
      path: '/activities'
      fullPath: '/marketplace/sent-orders/$orderId/activities'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesImport
      parentRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutImport
    }
    '/_staff/profile/device/$id/_profile/configuration': {
      id: '/_staff/profile/device/$id/_profile/configuration'
      path: '/configuration'
      fullPath: '/profile/device/$id/configuration'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileConfigurationImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/profile/device/$id/_profile/monitoring': {
      id: '/_staff/profile/device/$id/_profile/monitoring'
      path: '/monitoring'
      fullPath: '/profile/device/$id/monitoring'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileMonitoringImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/profile/device/$id/_profile/': {
      id: '/_staff/profile/device/$id/_profile/'
      path: '/'
      fullPath: '/profile/device/$id/'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileIndexRouteLazyImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/profile/device/$id/_profile/control': {
      id: '/_staff/profile/device/$id/_profile/control'
      path: '/control'
      fullPath: '/profile/device/$id/control'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileControlRouteLazyImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/profile/device/$id/_profile/mdm': {
      id: '/_staff/profile/device/$id/_profile/mdm'
      path: '/mdm'
      fullPath: '/profile/device/$id/mdm'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileMdmRouteLazyImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/profile/device/$id/_profile/status': {
      id: '/_staff/profile/device/$id/_profile/status'
      path: '/status'
      fullPath: '/profile/device/$id/status'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileStatusRouteLazyImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_individual/individual/task/$id/approval/': {
      id: '/_individual/individual/task/$id/approval/'
      path: '/individual/task/$id/approval'
      fullPath: '/individual/task/$id/approval'
      preLoaderRoute: typeof IndividualIndividualTaskIdApprovalIndexImport
      parentRoute: typeof IndividualImport
    }
    '/_staff/app-integrations/$id/_$id/architecture/': {
      id: '/_staff/app-integrations/$id/_$id/architecture/'
      path: '/architecture'
      fullPath: '/app-integrations/$id/architecture'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdArchitectureIndexImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/app-integrations/$id/_$id/detail/': {
      id: '/_staff/app-integrations/$id/_$id/detail/'
      path: '/detail'
      fullPath: '/app-integrations/$id/detail'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdDetailIndexImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/app-integrations/$id/_$id/rule-and-policy/': {
      id: '/_staff/app-integrations/$id/_$id/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/app-integrations/$id/rule-and-policy'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdRuleAndPolicyIndexImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/app-integrations/$id/_$id/settings/': {
      id: '/_staff/app-integrations/$id/_$id/settings/'
      path: '/settings'
      fullPath: '/app-integrations/$id/settings'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdSettingsIndexImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/app-integrations/$id/_$id/users/': {
      id: '/_staff/app-integrations/$id/_$id/users/'
      path: '/users'
      fullPath: '/app-integrations/$id/users'
      preLoaderRoute: typeof StaffAppIntegrationsIdIdUsersIndexImport
      parentRoute: typeof StaffAppIntegrationsIdIdImport
    }
    '/_staff/apps/_list/alerts/_alerts/': {
      id: '/_staff/apps/_list/alerts/_alerts/'
      path: '/'
      fullPath: '/apps/alerts/'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsImport
    }
    '/_staff/apps/custom-app/add/$customAppType/': {
      id: '/_staff/apps/custom-app/add/$customAppType/'
      path: '/custom-app/add/$customAppType'
      fullPath: '/apps/custom-app/add/$customAppType'
      preLoaderRoute: typeof StaffAppsCustomAppAddCustomAppTypeIndexImport
      parentRoute: typeof StaffAppsImport
    }
    '/_staff/business-partner/$id/_layout/_index/': {
      id: '/_staff/business-partner/$id/_layout/_index/'
      path: '/'
      fullPath: '/business-partner/$id/'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutIndexIndexImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutImport
    }
    '/_staff/business-partner/$id/_layout/address-and-contact/': {
      id: '/_staff/business-partner/$id/_layout/address-and-contact/'
      path: '/address-and-contact'
      fullPath: '/business-partner/$id/address-and-contact'
      preLoaderRoute: typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexImport
      parentRoute: typeof StaffBusinessPartnerIdLayoutImport
    }
    '/_staff/certification/$id/_layout/_index/': {
      id: '/_staff/certification/$id/_layout/_index/'
      path: '/'
      fullPath: '/certification/$id/'
      preLoaderRoute: typeof StaffCertificationIdLayoutIndexIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/$id/_layout/certification-holders/': {
      id: '/_staff/certification/$id/_layout/certification-holders/'
      path: '/certification-holders'
      fullPath: '/certification/$id/certification-holders'
      preLoaderRoute: typeof StaffCertificationIdLayoutCertificationHoldersIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/$id/_layout/handling-certifications/': {
      id: '/_staff/certification/$id/_layout/handling-certifications/'
      path: '/handling-certifications'
      fullPath: '/certification/$id/handling-certifications'
      preLoaderRoute: typeof StaffCertificationIdLayoutHandlingCertificationsIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/$id/_layout/specialty-certifications/': {
      id: '/_staff/certification/$id/_layout/specialty-certifications/'
      path: '/specialty-certifications'
      fullPath: '/certification/$id/specialty-certifications'
      preLoaderRoute: typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexImport
      parentRoute: typeof StaffCertificationIdLayoutImport
    }
    '/_staff/certification/_list/settings/issuing-organization/': {
      id: '/_staff/certification/_list/settings/issuing-organization/'
      path: '/issuing-organization'
      fullPath: '/certification/settings/issuing-organization'
      preLoaderRoute: typeof StaffCertificationListSettingsIssuingOrganizationIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/certification/_list/settings/specialty-category-level/': {
      id: '/_staff/certification/_list/settings/specialty-category-level/'
      path: '/specialty-category-level'
      fullPath: '/certification/settings/specialty-category-level'
      preLoaderRoute: typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/certification/_list/settings/specialty-category/': {
      id: '/_staff/certification/_list/settings/specialty-category/'
      path: '/specialty-category'
      fullPath: '/certification/settings/specialty-category'
      preLoaderRoute: typeof StaffCertificationListSettingsSpecialtyCategoryIndexImport
      parentRoute: typeof StaffCertificationListSettingsRouteLazyImport
    }
    '/_staff/devices/external-it-saas/$appIntegrationId/preview/': {
      id: '/_staff/devices/external-it-saas/$appIntegrationId/preview/'
      path: '/external-it-saas/$appIntegrationId/preview'
      fullPath: '/devices/external-it-saas/$appIntegrationId/preview'
      preLoaderRoute: typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexImport
      parentRoute: typeof StaffDevicesImport
    }
    '/_staff/equipment/_layout/settings/equipment-items/': {
      id: '/_staff/equipment/_layout/settings/equipment-items/'
      path: '/equipment-items'
      fullPath: '/equipment/settings/equipment-items'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexImport
      parentRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
    }
    '/_staff/equipment/_layout/settings/equipment-types/': {
      id: '/_staff/equipment/_layout/settings/equipment-types/'
      path: '/equipment-types'
      fullPath: '/equipment/settings/equipment-types'
      preLoaderRoute: typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexImport
      parentRoute: typeof StaffEquipmentLayoutSettingsRouteLazyImport
    }
    '/_staff/ids/group-id/$id/_$id/': {
      id: '/_staff/ids/group-id/$id/_$id/'
      path: '/'
      fullPath: '/ids/group-id/$id/'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/'
      path: '/'
      fullPath: '/it-operation-core/operation-instances/$instanceId/'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdImport
    }
    '/_staff/licenses/$id/_profile/assignments/': {
      id: '/_staff/licenses/$id/_profile/assignments/'
      path: '/assignments'
      fullPath: '/licenses/$id/assignments'
      preLoaderRoute: typeof StaffLicensesIdProfileAssignmentsIndexImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/licenses/$id/_profile/people/': {
      id: '/_staff/licenses/$id/_profile/people/'
      path: '/people'
      fullPath: '/licenses/$id/people'
      preLoaderRoute: typeof StaffLicensesIdProfilePeopleIndexImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/licenses/$id/_profile/service-plans/': {
      id: '/_staff/licenses/$id/_profile/service-plans/'
      path: '/service-plans'
      fullPath: '/licenses/$id/service-plans'
      preLoaderRoute: typeof StaffLicensesIdProfileServicePlansIndexImport
      parentRoute: typeof StaffLicensesIdProfileImport
    }
    '/_staff/marketplace/_store/store/devices/': {
      id: '/_staff/marketplace/_store/store/devices/'
      path: '/store/devices'
      fullPath: '/marketplace/store/devices'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreDevicesIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/sales-orders/': {
      id: '/_staff/marketplace/_store/store/sales-orders/'
      path: '/store/sales-orders'
      fullPath: '/marketplace/store/sales-orders'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreSalesOrdersIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/sent-orders/': {
      id: '/_staff/marketplace/_store/store/sent-orders/'
      path: '/store/sent-orders'
      fullPath: '/marketplace/store/sent-orders'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreSentOrdersIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/starlinks/': {
      id: '/_staff/marketplace/_store/store/starlinks/'
      path: '/store/starlinks'
      fullPath: '/marketplace/store/starlinks'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreStarlinksIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/sent-orders/$orderId/_layout/': {
      id: '/_staff/marketplace/sent-orders/$orderId/_layout/'
      path: '/'
      fullPath: '/marketplace/sent-orders/$orderId/'
      preLoaderRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexImport
      parentRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutImport
    }
    '/_staff/organization/$id/_layout/history/': {
      id: '/_staff/organization/$id/_layout/history/'
      path: '/history'
      fullPath: '/organization/$id/history'
      preLoaderRoute: typeof StaffOrganizationIdLayoutHistoryIndexImport
      parentRoute: typeof StaffOrganizationIdLayoutImport
    }
    '/_staff/organization/plan/$id/add/': {
      id: '/_staff/organization/plan/$id/add/'
      path: '/plan/$id/add'
      fullPath: '/organization/plan/$id/add'
      preLoaderRoute: typeof StaffOrganizationPlanIdAddIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/people/_list/settings/board-member-types/': {
      id: '/_staff/people/_list/settings/board-member-types/'
      path: '/board-member-types'
      fullPath: '/people/settings/board-member-types'
      preLoaderRoute: typeof StaffPeopleListSettingsBoardMemberTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/collaborator-types/': {
      id: '/_staff/people/_list/settings/collaborator-types/'
      path: '/collaborator-types'
      fullPath: '/people/settings/collaborator-types'
      preLoaderRoute: typeof StaffPeopleListSettingsCollaboratorTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/contract-end-reasons/': {
      id: '/_staff/people/_list/settings/contract-end-reasons/'
      path: '/contract-end-reasons'
      fullPath: '/people/settings/contract-end-reasons'
      preLoaderRoute: typeof StaffPeopleListSettingsContractEndReasonsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/contractor-types/': {
      id: '/_staff/people/_list/settings/contractor-types/'
      path: '/contractor-types'
      fullPath: '/people/settings/contractor-types'
      preLoaderRoute: typeof StaffPeopleListSettingsContractorTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/employee-sub-id-names/': {
      id: '/_staff/people/_list/settings/employee-sub-id-names/'
      path: '/employee-sub-id-names'
      fullPath: '/people/settings/employee-sub-id-names'
      preLoaderRoute: typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/employment-types/': {
      id: '/_staff/people/_list/settings/employment-types/'
      path: '/employment-types'
      fullPath: '/people/settings/employment-types'
      preLoaderRoute: typeof StaffPeopleListSettingsEmploymentTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/grades/': {
      id: '/_staff/people/_list/settings/grades/'
      path: '/grades'
      fullPath: '/people/settings/grades'
      preLoaderRoute: typeof StaffPeopleListSettingsGradesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/health-insurance-associations/': {
      id: '/_staff/people/_list/settings/health-insurance-associations/'
      path: '/health-insurance-associations'
      fullPath: '/people/settings/health-insurance-associations'
      preLoaderRoute: typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-competencies/': {
      id: '/_staff/people/_list/settings/job-competencies/'
      path: '/job-competencies'
      fullPath: '/people/settings/job-competencies'
      preLoaderRoute: typeof StaffPeopleListSettingsJobCompetenciesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-functions/': {
      id: '/_staff/people/_list/settings/job-functions/'
      path: '/job-functions'
      fullPath: '/people/settings/job-functions'
      preLoaderRoute: typeof StaffPeopleListSettingsJobFunctionsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-grades/': {
      id: '/_staff/people/_list/settings/job-grades/'
      path: '/job-grades'
      fullPath: '/people/settings/job-grades'
      preLoaderRoute: typeof StaffPeopleListSettingsJobGradesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-levels/': {
      id: '/_staff/people/_list/settings/job-levels/'
      path: '/job-levels'
      fullPath: '/people/settings/job-levels'
      preLoaderRoute: typeof StaffPeopleListSettingsJobLevelsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-titles/': {
      id: '/_staff/people/_list/settings/job-titles/'
      path: '/job-titles'
      fullPath: '/people/settings/job-titles'
      preLoaderRoute: typeof StaffPeopleListSettingsJobTitlesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/job-types/': {
      id: '/_staff/people/_list/settings/job-types/'
      path: '/job-types'
      fullPath: '/people/settings/job-types'
      preLoaderRoute: typeof StaffPeopleListSettingsJobTypesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/place-social-insurances/': {
      id: '/_staff/people/_list/settings/place-social-insurances/'
      path: '/place-social-insurances'
      fullPath: '/people/settings/place-social-insurances'
      preLoaderRoute: typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/positions/': {
      id: '/_staff/people/_list/settings/positions/'
      path: '/positions'
      fullPath: '/people/settings/positions'
      preLoaderRoute: typeof StaffPeopleListSettingsPositionsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/retirement-reasons/': {
      id: '/_staff/people/_list/settings/retirement-reasons/'
      path: '/retirement-reasons'
      fullPath: '/people/settings/retirement-reasons'
      preLoaderRoute: typeof StaffPeopleListSettingsRetirementReasonsIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/people/_list/settings/work-mode/': {
      id: '/_staff/people/_list/settings/work-mode/'
      path: '/work-mode'
      fullPath: '/people/settings/work-mode'
      preLoaderRoute: typeof StaffPeopleListSettingsWorkModeIndexImport
      parentRoute: typeof StaffPeopleListSettingsRouteLazyImport
    }
    '/_staff/person/$id/_profile/activity/': {
      id: '/_staff/person/$id/_profile/activity/'
      path: '/activity'
      fullPath: '/person/$id/activity'
      preLoaderRoute: typeof StaffPersonIdProfileActivityIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/apps/': {
      id: '/_staff/person/$id/_profile/apps/'
      path: '/apps'
      fullPath: '/person/$id/apps'
      preLoaderRoute: typeof StaffPersonIdProfileAppsIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/devices/': {
      id: '/_staff/person/$id/_profile/devices/'
      path: '/devices'
      fullPath: '/person/$id/devices'
      preLoaderRoute: typeof StaffPersonIdProfileDevicesIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/education-and-qualification/': {
      id: '/_staff/person/$id/_profile/education-and-qualification/'
      path: '/education-and-qualification'
      fullPath: '/person/$id/education-and-qualification'
      preLoaderRoute: typeof StaffPersonIdProfileEducationAndQualificationIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/employee-information/': {
      id: '/_staff/person/$id/_profile/employee-information/'
      path: '/employee-information'
      fullPath: '/person/$id/employee-information'
      preLoaderRoute: typeof StaffPersonIdProfileEmployeeInformationIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/equipment/': {
      id: '/_staff/person/$id/_profile/equipment/'
      path: '/equipment'
      fullPath: '/person/$id/equipment'
      preLoaderRoute: typeof StaffPersonIdProfileEquipmentIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/history/': {
      id: '/_staff/person/$id/_profile/history/'
      path: '/history'
      fullPath: '/person/$id/history'
      preLoaderRoute: typeof StaffPersonIdProfileHistoryIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/personal-information/': {
      id: '/_staff/person/$id/_profile/personal-information/'
      path: '/personal-information'
      fullPath: '/person/$id/personal-information'
      preLoaderRoute: typeof StaffPersonIdProfilePersonalInformationIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/$id/_profile/public-id/': {
      id: '/_staff/person/$id/_profile/public-id/'
      path: '/public-id'
      fullPath: '/person/$id/public-id'
      preLoaderRoute: typeof StaffPersonIdProfilePublicIdIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/external-hr-saas/$appIntegrationId/preview/': {
      id: '/_staff/person/external-hr-saas/$appIntegrationId/preview/'
      path: '/person/external-hr-saas/$appIntegrationId/preview'
      fullPath: '/person/external-hr-saas/$appIntegrationId/preview'
      preLoaderRoute: typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexImport
      parentRoute: typeof StaffImport
    }
    '/_staff/places/$id/_layout/administrators/': {
      id: '/_staff/places/$id/_layout/administrators/'
      path: '/administrators'
      fullPath: '/places/$id/administrators'
      preLoaderRoute: typeof StaffPlacesIdLayoutAdministratorsIndexImport
      parentRoute: typeof StaffPlacesIdLayoutImport
    }
    '/_staff/places/$id/_layout/labor-core/': {
      id: '/_staff/places/$id/_layout/labor-core/'
      path: '/labor-core'
      fullPath: '/places/$id/labor-core'
      preLoaderRoute: typeof StaffPlacesIdLayoutLaborCoreIndexImport
      parentRoute: typeof StaffPlacesIdLayoutImport
    }
    '/_staff/places/_layout/settings/place-sub-codes/': {
      id: '/_staff/places/_layout/settings/place-sub-codes/'
      path: '/place-sub-codes'
      fullPath: '/places/settings/place-sub-codes'
      preLoaderRoute: typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexImport
      parentRoute: typeof StaffPlacesLayoutSettingsRouteImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/board-member/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/board-member/'
      path: '/board-member'
      fullPath: '/settings/contracting-corporation-profile/board-member'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/contact-points/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/contact-points/'
      path: '/contact-points'
      fullPath: '/settings/contracting-corporation-profile/contact-points'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/'
      path: '/corporate-overview'
      fullPath: '/settings/contracting-corporation-profile/corporate-overview'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/group-companies/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/group-companies/'
      path: '/group-companies'
      fullPath: '/settings/contracting-corporation-profile/group-companies'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/history/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/history/'
      path: '/history'
      fullPath: '/settings/contracting-corporation-profile/history'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/registration/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/registration/'
      path: '/registration'
      fullPath: '/settings/contracting-corporation-profile/registration'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/contracting-corporation-profile/_layout/shareholders/': {
      id: '/_staff/settings/contracting-corporation-profile/_layout/shareholders/'
      path: '/shareholders'
      fullPath: '/settings/contracting-corporation-profile/shareholders'
      preLoaderRoute: typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexImport
      parentRoute: typeof StaffSettingsContractingCorporationProfileLayoutImport
    }
    '/_staff/settings/permission-and-roles/_list/people-groups/': {
      id: '/_staff/settings/permission-and-roles/_list/people-groups/'
      path: '/people-groups'
      fullPath: '/settings/permission-and-roles/people-groups'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesListImport
    }
    '/_staff/settings/permission-and-roles/_list/product-permissions/': {
      id: '/_staff/settings/permission-and-roles/_list/product-permissions/'
      path: '/product-permissions'
      fullPath: '/settings/permission-and-roles/product-permissions'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesListImport
    }
    '/_staff/settings/permission-and-roles/_list/roles/': {
      id: '/_staff/settings/permission-and-roles/_list/roles/'
      path: '/roles'
      fullPath: '/settings/permission-and-roles/roles'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesListRolesIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesListImport
    }
    '/_staff/settings/persons/_list/settings/': {
      id: '/_staff/settings/persons/_list/settings/'
      path: '/settings'
      fullPath: '/settings/persons/settings'
      preLoaderRoute: typeof StaffSettingsPersonsListSettingsIndexImport
      parentRoute: typeof StaffSettingsPersonsListImport
    }
    '/_staff/software/$id/_$id/activity-monitoring/': {
      id: '/_staff/software/$id/_$id/activity-monitoring/'
      path: '/activity-monitoring'
      fullPath: '/software/$id/activity-monitoring'
      preLoaderRoute: typeof StaffSoftwareIdIdActivityMonitoringIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/architecture/': {
      id: '/_staff/software/$id/_$id/architecture/'
      path: '/architecture'
      fullPath: '/software/$id/architecture'
      preLoaderRoute: typeof StaffSoftwareIdIdArchitectureIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/contracts-cost/': {
      id: '/_staff/software/$id/_$id/contracts-cost/'
      path: '/contracts-cost'
      fullPath: '/software/$id/contracts-cost'
      preLoaderRoute: typeof StaffSoftwareIdIdContractsCostIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/detail/': {
      id: '/_staff/software/$id/_$id/detail/'
      path: '/detail'
      fullPath: '/software/$id/detail'
      preLoaderRoute: typeof StaffSoftwareIdIdDetailIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/rule-and-policy/': {
      id: '/_staff/software/$id/_$id/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/software/$id/rule-and-policy'
      preLoaderRoute: typeof StaffSoftwareIdIdRuleAndPolicyIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/settings/': {
      id: '/_staff/software/$id/_$id/settings/'
      path: '/settings'
      fullPath: '/software/$id/settings'
      preLoaderRoute: typeof StaffSoftwareIdIdSettingsIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/$id/_$id/users/': {
      id: '/_staff/software/$id/_$id/users/'
      path: '/users'
      fullPath: '/software/$id/users'
      preLoaderRoute: typeof StaffSoftwareIdIdUsersIndexImport
      parentRoute: typeof StaffSoftwareIdIdImport
    }
    '/_staff/software/_layout/alerts/_alerts/': {
      id: '/_staff/software/_layout/alerts/_alerts/'
      path: '/'
      fullPath: '/software/alerts/'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/custom-saas/add/$customSaasType/': {
      id: '/_staff/software/custom-saas/add/$customSaasType/'
      path: '/custom-saas/add/$customSaasType'
      fullPath: '/software/custom-saas/add/$customSaasType'
      preLoaderRoute: typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexImport
      parentRoute: typeof StaffSoftwareImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/'
      path: '/summary'
      fullPath: '/time-and-attendance/summary'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/time-and-attendance/_layout/attendance-links/$placeId/': {
      id: '/_staff/time-and-attendance/_layout/attendance-links/$placeId/'
      path: '/attendance-links/$placeId'
      fullPath: '/time-and-attendance/attendance-links/$placeId'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/contract/$id/_layout/_index/': {
      id: '/_staff/contract/$id/_layout/_index/'
      path: '/'
      fullPath: '/contract/$id/'
      preLoaderRoute: typeof StaffContractIdLayoutIndexIndexLazyImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/contract/$id/_layout/structure/': {
      id: '/_staff/contract/$id/_layout/structure/'
      path: '/structure'
      fullPath: '/contract/$id/structure'
      preLoaderRoute: typeof StaffContractIdLayoutStructureIndexLazyImport
      parentRoute: typeof StaffContractIdLayoutImport
    }
    '/_staff/equipment/$id/_layout/_profile/': {
      id: '/_staff/equipment/$id/_layout/_profile/'
      path: '/'
      fullPath: '/equipment/$id/'
      preLoaderRoute: typeof StaffEquipmentIdLayoutProfileIndexLazyImport
      parentRoute: typeof StaffEquipmentIdLayoutImport
    }
    '/_staff/fleets/$id/_layout/_profile/': {
      id: '/_staff/fleets/$id/_layout/_profile/'
      path: '/'
      fullPath: '/fleets/$id/'
      preLoaderRoute: typeof StaffFleetsIdLayoutProfileIndexLazyImport
      parentRoute: typeof StaffFleetsIdLayoutImport
    }
    '/_staff/networks/$id/_layout/_profile/': {
      id: '/_staff/networks/$id/_layout/_profile/'
      path: '/'
      fullPath: '/networks/$id/'
      preLoaderRoute: typeof StaffNetworksIdLayoutProfileIndexLazyImport
      parentRoute: typeof StaffNetworksIdLayoutImport
    }
    '/_staff/places/$id/_layout/_profile/': {
      id: '/_staff/places/$id/_layout/_profile/'
      path: '/'
      fullPath: '/places/$id/'
      preLoaderRoute: typeof StaffPlacesIdLayoutProfileIndexLazyImport
      parentRoute: typeof StaffPlacesIdLayoutImport
    }
    '/_staff/starlinks/$id/_layout/_overview/': {
      id: '/_staff/starlinks/$id/_layout/_overview/'
      path: '/'
      fullPath: '/starlinks/$id/'
      preLoaderRoute: typeof StaffStarlinksIdLayoutOverviewIndexLazyImport
      parentRoute: typeof StaffStarlinksIdLayoutImport
    }
    '/_staff/starlinks/$id/_layout/detail/': {
      id: '/_staff/starlinks/$id/_layout/detail/'
      path: '/detail'
      fullPath: '/starlinks/$id/detail'
      preLoaderRoute: typeof StaffStarlinksIdLayoutDetailIndexLazyImport
      parentRoute: typeof StaffStarlinksIdLayoutImport
    }
    '/_staff/apps/_list/alerts/_alerts/shadow-it': {
      id: '/_staff/apps/_list/alerts/_alerts/shadow-it'
      path: '/shadow-it'
      fullPath: '/apps/alerts/shadow-it'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsShadowItImport
      parentRoute: typeof StaffAppsListAlertsAlertsImport
    }
    '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it': {
      id: '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it'
      path: '/shadow-it'
      fullPath: '/apps/alerts/shadow-it'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItImport
      parentRoute: typeof StaffAppsListAlertsAlertsShadowItRoute
    }
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId': {
      id: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId'
      path: '/certifications/base-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/base-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdImport
      parentRoute: typeof StaffPersonIdImport
    }
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout': {
      id: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout'
      path: '/certifications/base-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/base-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport
      parentRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute
    }
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId': {
      id: '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId'
      path: '/certifications/handling-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdImport
      parentRoute: typeof StaffPersonIdImport
    }
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout': {
      id: '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout'
      path: '/certifications/handling-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport
      parentRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute
    }
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId': {
      id: '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
      path: '/certifications/specialty-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdImport
      parentRoute: typeof StaffPersonIdImport
    }
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout': {
      id: '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout'
      path: '/certifications/specialty-certifications/$personCertificationInformationId'
      fullPath: '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
      preLoaderRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport
      parentRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute
    }
    '/_individual/individual/operation-package/$id/pattern/$patternId/': {
      id: '/_individual/individual/operation-package/$id/pattern/$patternId/'
      path: '/individual/operation-package/$id/pattern/$patternId'
      fullPath: '/individual/operation-package/$id/pattern/$patternId'
      preLoaderRoute: typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexImport
      parentRoute: typeof IndividualImport
    }
    '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/': {
      id: '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/'
      path: '/alerts/detail/$shadowItAppId'
      fullPath: '/accesses/alerts/detail/$shadowItAppId'
      preLoaderRoute: typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexImport
      parentRoute: typeof StaffAccessesLayoutImport
    }
    '/_staff/apps/_list/alerts/_alerts/inactive-user/': {
      id: '/_staff/apps/_list/alerts/_alerts/inactive-user/'
      path: '/inactive-user'
      fullPath: '/apps/alerts/inactive-user'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsInactiveUserIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsImport
    }
    '/_staff/apps/_list/alerts/_alerts/no-user/': {
      id: '/_staff/apps/_list/alerts/_alerts/no-user/'
      path: '/no-user'
      fullPath: '/apps/alerts/no-user'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsNoUserIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsImport
    }
    '/_staff/apps/_list/alerts/_alerts/no-worker/': {
      id: '/_staff/apps/_list/alerts/_alerts/no-worker/'
      path: '/no-worker'
      fullPath: '/apps/alerts/no-worker'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsNoWorkerIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsImport
    }
    '/_staff/apps/_list/alerts/_alerts/violated-assignment/': {
      id: '/_staff/apps/_list/alerts/_alerts/violated-assignment/'
      path: '/violated-assignment'
      fullPath: '/apps/alerts/violated-assignment'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsViolatedAssignmentIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsImport
    }
    '/_staff/apps/_list/alerts/_alerts/violated-role/': {
      id: '/_staff/apps/_list/alerts/_alerts/violated-role/'
      path: '/violated-role'
      fullPath: '/apps/alerts/violated-role'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsViolatedRoleIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsImport
    }
    '/_staff/certification/handling-certification/$id/_layout/_index/': {
      id: '/_staff/certification/handling-certification/$id/_layout/_index/'
      path: '/'
      fullPath: '/certification/handling-certification/$id/'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexImport
      parentRoute: typeof StaffCertificationHandlingCertificationIdLayoutImport
    }
    '/_staff/certification/handling-certification/$id/_layout/certification-holders/': {
      id: '/_staff/certification/handling-certification/$id/_layout/certification-holders/'
      path: '/certification-holders'
      fullPath: '/certification/handling-certification/$id/certification-holders'
      preLoaderRoute: typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexImport
      parentRoute: typeof StaffCertificationHandlingCertificationIdLayoutImport
    }
    '/_staff/certification/specialty-certification/$id/_layout/_index/': {
      id: '/_staff/certification/specialty-certification/$id/_layout/_index/'
      path: '/'
      fullPath: '/certification/specialty-certification/$id/'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
    }
    '/_staff/certification/specialty-certification/$id/_layout/certification-holders/': {
      id: '/_staff/certification/specialty-certification/$id/_layout/certification-holders/'
      path: '/certification-holders'
      fullPath: '/certification/specialty-certification/$id/certification-holders'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
    }
    '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/': {
      id: '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/'
      path: '/handling-certifications'
      fullPath: '/certification/specialty-certification/$id/handling-certifications'
      preLoaderRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexImport
      parentRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutImport
    }
    '/_staff/device-catalog/active/$id/_layout/profile/': {
      id: '/_staff/device-catalog/active/$id/_layout/profile/'
      path: '/profile'
      fullPath: '/device-catalog/active/$id/profile'
      preLoaderRoute: typeof StaffDeviceCatalogActiveIdLayoutProfileIndexImport
      parentRoute: typeof StaffDeviceCatalogActiveIdLayoutImport
    }
    '/_staff/device-catalog/draft/$id/_layout/profile/': {
      id: '/_staff/device-catalog/draft/$id/_layout/profile/'
      path: '/profile'
      fullPath: '/device-catalog/draft/$id/profile'
      preLoaderRoute: typeof StaffDeviceCatalogDraftIdLayoutProfileIndexImport
      parentRoute: typeof StaffDeviceCatalogDraftIdLayoutImport
    }
    '/_staff/ids/group-id/$id/_$id/members/': {
      id: '/_staff/ids/group-id/$id/_$id/members/'
      path: '/members'
      fullPath: '/ids/group-id/$id/members'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdMembersIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/$id/_$id/rule-and-policy/': {
      id: '/_staff/ids/group-id/$id/_$id/rule-and-policy/'
      path: '/rule-and-policy'
      fullPath: '/ids/group-id/$id/rule-and-policy'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/ids/group-id/$id/_$id/settings/': {
      id: '/_staff/ids/group-id/$id/_$id/settings/'
      path: '/settings'
      fullPath: '/ids/group-id/$id/settings'
      preLoaderRoute: typeof StaffIdsGroupIdIdIdSettingsIndexImport
      parentRoute: typeof StaffIdsGroupIdIdIdImport
    }
    '/_staff/marketplace/_store/store/devices/$productId/': {
      id: '/_staff/marketplace/_store/store/devices/$productId/'
      path: '/store/devices/$productId'
      fullPath: '/marketplace/store/devices/$productId'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreDevicesProductIdIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/marketplace/_store/store/starlinks/$productId/': {
      id: '/_staff/marketplace/_store/store/starlinks/$productId/'
      path: '/store/starlinks/$productId'
      fullPath: '/marketplace/store/starlinks/$productId'
      preLoaderRoute: typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexImport
      parentRoute: typeof StaffMarketplaceStoreImport
    }
    '/_staff/organization/plan/$id/edit/$unitId/': {
      id: '/_staff/organization/plan/$id/edit/$unitId/'
      path: '/plan/$id/edit/$unitId'
      fullPath: '/organization/plan/$id/edit/$unitId'
      preLoaderRoute: typeof StaffOrganizationPlanIdEditUnitIdIndexImport
      parentRoute: typeof StaffOrganizationImport
    }
    '/_staff/person/$id/_profile/family/$familyPersonId/': {
      id: '/_staff/person/$id/_profile/family/$familyPersonId/'
      path: '/family/$familyPersonId'
      fullPath: '/person/$id/family/$familyPersonId'
      preLoaderRoute: typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexImport
      parentRoute: typeof StaffPersonIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/activity/': {
      id: '/_staff/person/alumni/$id/_profile/activity/'
      path: '/activity'
      fullPath: '/person/alumni/$id/activity'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileActivityIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/apps/': {
      id: '/_staff/person/alumni/$id/_profile/apps/'
      path: '/apps'
      fullPath: '/person/alumni/$id/apps'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileAppsIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/devices/': {
      id: '/_staff/person/alumni/$id/_profile/devices/'
      path: '/devices'
      fullPath: '/person/alumni/$id/devices'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileDevicesIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/education-and-qualification/': {
      id: '/_staff/person/alumni/$id/_profile/education-and-qualification/'
      path: '/education-and-qualification'
      fullPath: '/person/alumni/$id/education-and-qualification'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/employee-information/': {
      id: '/_staff/person/alumni/$id/_profile/employee-information/'
      path: '/employee-information'
      fullPath: '/person/alumni/$id/employee-information'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileEmployeeInformationIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/equipment/': {
      id: '/_staff/person/alumni/$id/_profile/equipment/'
      path: '/equipment'
      fullPath: '/person/alumni/$id/equipment'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileEquipmentIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/history/': {
      id: '/_staff/person/alumni/$id/_profile/history/'
      path: '/history'
      fullPath: '/person/alumni/$id/history'
      preLoaderRoute: typeof StaffPersonAlumniIdProfileHistoryIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/personal-information/': {
      id: '/_staff/person/alumni/$id/_profile/personal-information/'
      path: '/personal-information'
      fullPath: '/person/alumni/$id/personal-information'
      preLoaderRoute: typeof StaffPersonAlumniIdProfilePersonalInformationIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/person/alumni/$id/_profile/public-id/': {
      id: '/_staff/person/alumni/$id/_profile/public-id/'
      path: '/public-id'
      fullPath: '/person/alumni/$id/public-id'
      preLoaderRoute: typeof StaffPersonAlumniIdProfilePublicIdIndexImport
      parentRoute: typeof StaffPersonAlumniIdProfileImport
    }
    '/_staff/profile/device/$id/_profile/history/': {
      id: '/_staff/profile/device/$id/_profile/history/'
      path: '/history'
      fullPath: '/profile/device/$id/history'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileHistoryIndexImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/profile/device/$id/_profile/lifecycle/': {
      id: '/_staff/profile/device/$id/_profile/lifecycle/'
      path: '/lifecycle'
      fullPath: '/profile/device/$id/lifecycle'
      preLoaderRoute: typeof StaffProfileDeviceIdProfileLifecycleIndexImport
      parentRoute: typeof StaffProfileDeviceIdProfileImport
    }
    '/_staff/settings/permission-and-roles/_detail/people-groups/$id/': {
      id: '/_staff/settings/permission-and-roles/_detail/people-groups/$id/'
      path: '/people-groups/$id'
      fullPath: '/settings/permission-and-roles/people-groups/$id'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesDetailImport
    }
    '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/': {
      id: '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/'
      path: '/product-permissions/$id'
      fullPath: '/settings/permission-and-roles/product-permissions/$id'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesDetailImport
    }
    '/_staff/settings/permission-and-roles/_detail/roles/$id/': {
      id: '/_staff/settings/permission-and-roles/_detail/roles/$id/'
      path: '/roles/$id'
      fullPath: '/settings/permission-and-roles/roles/$id'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesDetailImport
    }
    '/_staff/settings/permission-and-roles/_form/people-groups/new/': {
      id: '/_staff/settings/permission-and-roles/_form/people-groups/new/'
      path: '/people-groups/new'
      fullPath: '/settings/permission-and-roles/people-groups/new'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/product-permissions/new/': {
      id: '/_staff/settings/permission-and-roles/_form/product-permissions/new/'
      path: '/product-permissions/new'
      fullPath: '/settings/permission-and-roles/product-permissions/new'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/roles/new/': {
      id: '/_staff/settings/permission-and-roles/_form/roles/new/'
      path: '/roles/new'
      fullPath: '/settings/permission-and-roles/roles/new'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormRolesNewIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/persons/_list/_account/individual/': {
      id: '/_staff/settings/persons/_list/_account/individual/'
      path: '/individual'
      fullPath: '/settings/persons/individual'
      preLoaderRoute: typeof StaffSettingsPersonsListAccountIndividualIndexImport
      parentRoute: typeof StaffSettingsPersonsListAccountImport
    }
    '/_staff/settings/persons/_list/_account/staff/': {
      id: '/_staff/settings/persons/_list/_account/staff/'
      path: '/staff'
      fullPath: '/settings/persons/staff'
      preLoaderRoute: typeof StaffSettingsPersonsListAccountStaffIndexImport
      parentRoute: typeof StaffSettingsPersonsListAccountImport
    }
    '/_staff/software/_layout/alerts/_alerts/alumni/': {
      id: '/_staff/software/_layout/alerts/_alerts/alumni/'
      path: '/alumni'
      fullPath: '/software/alerts/alumni'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/inactive-user/': {
      id: '/_staff/software/_layout/alerts/_alerts/inactive-user/'
      path: '/inactive-user'
      fullPath: '/software/alerts/inactive-user'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/no-user/': {
      id: '/_staff/software/_layout/alerts/_alerts/no-user/'
      path: '/no-user'
      fullPath: '/software/alerts/no-user'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/no-worker/': {
      id: '/_staff/software/_layout/alerts/_alerts/no-worker/'
      path: '/no-worker'
      fullPath: '/software/alerts/no-worker'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/violated-assignment/': {
      id: '/_staff/software/_layout/alerts/_alerts/violated-assignment/'
      path: '/violated-assignment'
      fullPath: '/software/alerts/violated-assignment'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/software/_layout/alerts/_alerts/violated-role/': {
      id: '/_staff/software/_layout/alerts/_alerts/violated-role/'
      path: '/violated-role'
      fullPath: '/software/alerts/violated-role'
      preLoaderRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexImport
      parentRoute: typeof StaffSoftwareLayoutAlertsAlertsImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/daily-place/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/daily-place/'
      path: '/summary/daily-place'
      fullPath: '/time-and-attendance/summary/daily-place'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/'
      path: '/summary/monthly-person'
      fullPath: '/time-and-attendance/summary/monthly-person'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/': {
      id: '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/'
      path: '/summary/monthly-place'
      fullPath: '/time-and-attendance/summary/monthly-place'
      preLoaderRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexImport
      parentRoute: typeof StaffTimeAndAttendanceLayoutImport
    }
    '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/': {
      id: '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/'
      path: '/'
      fullPath: '/apps/alerts/shadow-it/'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItImport
    }
    '/_staff/apps/_list/marketplace/$id/install/finish/': {
      id: '/_staff/apps/_list/marketplace/$id/install/finish/'
      path: '/install/finish'
      fullPath: '/apps/marketplace/$id/install/finish'
      preLoaderRoute: typeof StaffAppsListMarketplaceIdInstallFinishIndexImport
      parentRoute: typeof StaffAppsListMarketplaceIdRouteImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/'
      path: '/data'
      fullPath: '/it-operation-core/operation-instances/$instanceId/data'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/'
      path: '/detail'
      fullPath: '/it-operation-core/operation-instances/$instanceId/detail'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
    }
    '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/': {
      id: '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/'
      path: '/operation-activity'
      fullPath: '/it-operation-core/operation-instances/$instanceId/operation-activity'
      preLoaderRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexImport
      parentRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutImport
    }
    '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/': {
      id: '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/'
      path: '/accounts'
      fullPath: '/licenses/$id/service-plans/$licenseServiceId/accounts'
      preLoaderRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexImport
      parentRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailImport
    }
    '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/': {
      id: '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/'
      path: '/people-groups/$id/edit'
      fullPath: '/settings/permission-and-roles/people-groups/$id/edit'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/': {
      id: '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/'
      path: '/product-permissions/$id/edit'
      fullPath: '/settings/permission-and-roles/product-permissions/$id/edit'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/settings/permission-and-roles/_form/roles/$id/edit/': {
      id: '/_staff/settings/permission-and-roles/_form/roles/$id/edit/'
      path: '/roles/$id/edit'
      fullPath: '/settings/permission-and-roles/roles/$id/edit'
      preLoaderRoute: typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexImport
      parentRoute: typeof StaffSettingsPermissionAndRolesFormImport
    }
    '/_staff/software/_layout/marketplace/$id/install/finish/': {
      id: '/_staff/software/_layout/marketplace/$id/install/finish/'
      path: '/install/finish'
      fullPath: '/software/marketplace/$id/install/finish'
      preLoaderRoute: typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexImport
      parentRoute: typeof StaffSoftwareLayoutMarketplaceIdRouteImport
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport
      parentRoute: typeof StaffContractorCoreImport
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
      parentRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport
      parentRoute: typeof StaffGaOperationCoreImport
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
      parentRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdImport
      parentRoute: typeof StaffLaborCoreImport
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
      path: '/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
      parentRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute
    }
    '/_individual/individual/task/$id/_operation-package/_common/form/$formId/': {
      id: '/_individual/individual/task/$id/_operation-package/_common/form/$formId/'
      path: '/individual/task/$id/form/$formId'
      fullPath: '/individual/task/$id/form/$formId'
      preLoaderRoute: typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexImport
      parentRoute: typeof IndividualImport
    }
    '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/': {
      id: '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/'
      path: '/apps'
      fullPath: '/apps/alerts/shadow-it/apps'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItAppsIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItImport
    }
    '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/': {
      id: '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/'
      path: '/visit-histories'
      fullPath: '/apps/alerts/shadow-it/visit-histories'
      preLoaderRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexImport
      parentRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItImport
    }
    '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/': {
      id: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/'
      path: '/'
      fullPath: '/person/$id/certifications/base-certifications/$personCertificationInformationId/'
      preLoaderRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexImport
      parentRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutImport
    }
    '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/': {
      id: '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/'
      path: '/'
      fullPath: '/person/$id/certifications/handling-certifications/$personCertificationInformationId/'
      preLoaderRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexImport
      parentRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutImport
    }
    '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/': {
      id: '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/'
      path: '/'
      fullPath: '/person/$id/certifications/specialty-certifications/$personCertificationInformationId/'
      preLoaderRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexImport
      parentRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutImport
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
      path: '/'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport
      parentRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
      path: '/'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport
      parentRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
      path: '/'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexImport
      parentRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': {
      id: '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
      path: '/data'
      fullPath: '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
      preLoaderRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport
      parentRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': {
      id: '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
      path: '/data'
      fullPath: '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
      preLoaderRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport
      parentRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
    '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': {
      id: '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
      path: '/data'
      fullPath: '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
      preLoaderRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexImport
      parentRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileImport
    }
  }
}

// Create and export the route tree

interface IndividualRouteChildren {
  IndividualIndividualIndexRoute: typeof IndividualIndividualIndexRoute
  IndividualIndividualTaskIdApprovalDialogRoute: typeof IndividualIndividualTaskIdApprovalDialogRoute
  IndividualIndividualOperationPackageIdIndexRoute: typeof IndividualIndividualOperationPackageIdIndexRoute
  IndividualIndividualTaskIdIndexRoute: typeof IndividualIndividualTaskIdIndexRoute
  IndividualIndividualTaskIdApprovalIndexRoute: typeof IndividualIndividualTaskIdApprovalIndexRoute
  IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute: typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute: typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
}

const IndividualRouteChildren: IndividualRouteChildren = {
  IndividualIndividualIndexRoute: IndividualIndividualIndexRoute,
  IndividualIndividualTaskIdApprovalDialogRoute:
    IndividualIndividualTaskIdApprovalDialogRoute,
  IndividualIndividualOperationPackageIdIndexRoute:
    IndividualIndividualOperationPackageIdIndexRoute,
  IndividualIndividualTaskIdIndexRoute: IndividualIndividualTaskIdIndexRoute,
  IndividualIndividualTaskIdApprovalIndexRoute:
    IndividualIndividualTaskIdApprovalIndexRoute,
  IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute:
    IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute,
  IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute:
    IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute,
}

const IndividualRouteWithChildren = IndividualRoute._addFileChildren(
  IndividualRouteChildren,
)

interface StaffAppsListMarketplaceIdRouteRouteChildren {
  StaffAppsListMarketplaceIdInstallFinishIndexRoute: typeof StaffAppsListMarketplaceIdInstallFinishIndexRoute
}

const StaffAppsListMarketplaceIdRouteRouteChildren: StaffAppsListMarketplaceIdRouteRouteChildren =
  {
    StaffAppsListMarketplaceIdInstallFinishIndexRoute:
      StaffAppsListMarketplaceIdInstallFinishIndexRoute,
  }

const StaffAppsListMarketplaceIdRouteRouteWithChildren =
  StaffAppsListMarketplaceIdRouteRoute._addFileChildren(
    StaffAppsListMarketplaceIdRouteRouteChildren,
  )

interface StaffAppsListAlertsAlertsShadowItShadowItRouteChildren {
  StaffAppsListAlertsAlertsShadowItShadowItIndexRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItIndexRoute
  StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute
  StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute
}

const StaffAppsListAlertsAlertsShadowItShadowItRouteChildren: StaffAppsListAlertsAlertsShadowItShadowItRouteChildren =
  {
    StaffAppsListAlertsAlertsShadowItShadowItIndexRoute:
      StaffAppsListAlertsAlertsShadowItShadowItIndexRoute,
    StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute:
      StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute,
    StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute:
      StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute,
  }

const StaffAppsListAlertsAlertsShadowItShadowItRouteWithChildren =
  StaffAppsListAlertsAlertsShadowItShadowItRoute._addFileChildren(
    StaffAppsListAlertsAlertsShadowItShadowItRouteChildren,
  )

interface StaffAppsListAlertsAlertsShadowItRouteChildren {
  StaffAppsListAlertsAlertsShadowItShadowItRoute: typeof StaffAppsListAlertsAlertsShadowItShadowItRouteWithChildren
}

const StaffAppsListAlertsAlertsShadowItRouteChildren: StaffAppsListAlertsAlertsShadowItRouteChildren =
  {
    StaffAppsListAlertsAlertsShadowItShadowItRoute:
      StaffAppsListAlertsAlertsShadowItShadowItRouteWithChildren,
  }

const StaffAppsListAlertsAlertsShadowItRouteWithChildren =
  StaffAppsListAlertsAlertsShadowItRoute._addFileChildren(
    StaffAppsListAlertsAlertsShadowItRouteChildren,
  )

interface StaffAppsListAlertsAlertsRouteChildren {
  StaffAppsListAlertsAlertsIndexRoute: typeof StaffAppsListAlertsAlertsIndexRoute
  StaffAppsListAlertsAlertsShadowItRoute: typeof StaffAppsListAlertsAlertsShadowItRouteWithChildren
  StaffAppsListAlertsAlertsInactiveUserIndexRoute: typeof StaffAppsListAlertsAlertsInactiveUserIndexRoute
  StaffAppsListAlertsAlertsNoUserIndexRoute: typeof StaffAppsListAlertsAlertsNoUserIndexRoute
  StaffAppsListAlertsAlertsNoWorkerIndexRoute: typeof StaffAppsListAlertsAlertsNoWorkerIndexRoute
  StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute: typeof StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute
  StaffAppsListAlertsAlertsViolatedRoleIndexRoute: typeof StaffAppsListAlertsAlertsViolatedRoleIndexRoute
}

const StaffAppsListAlertsAlertsRouteChildren: StaffAppsListAlertsAlertsRouteChildren =
  {
    StaffAppsListAlertsAlertsIndexRoute: StaffAppsListAlertsAlertsIndexRoute,
    StaffAppsListAlertsAlertsShadowItRoute:
      StaffAppsListAlertsAlertsShadowItRouteWithChildren,
    StaffAppsListAlertsAlertsInactiveUserIndexRoute:
      StaffAppsListAlertsAlertsInactiveUserIndexRoute,
    StaffAppsListAlertsAlertsNoUserIndexRoute:
      StaffAppsListAlertsAlertsNoUserIndexRoute,
    StaffAppsListAlertsAlertsNoWorkerIndexRoute:
      StaffAppsListAlertsAlertsNoWorkerIndexRoute,
    StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute:
      StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute,
    StaffAppsListAlertsAlertsViolatedRoleIndexRoute:
      StaffAppsListAlertsAlertsViolatedRoleIndexRoute,
  }

const StaffAppsListAlertsAlertsRouteWithChildren =
  StaffAppsListAlertsAlertsRoute._addFileChildren(
    StaffAppsListAlertsAlertsRouteChildren,
  )

interface StaffAppsListAlertsRouteChildren {
  StaffAppsListAlertsAlertsRoute: typeof StaffAppsListAlertsAlertsRouteWithChildren
}

const StaffAppsListAlertsRouteChildren: StaffAppsListAlertsRouteChildren = {
  StaffAppsListAlertsAlertsRoute: StaffAppsListAlertsAlertsRouteWithChildren,
}

const StaffAppsListAlertsRouteWithChildren =
  StaffAppsListAlertsRoute._addFileChildren(StaffAppsListAlertsRouteChildren)

interface StaffAppsListRouteChildren {
  StaffAppsListContractAndCostRoute: typeof StaffAppsListContractAndCostRoute
  StaffAppsListOperationActivityRoute: typeof StaffAppsListOperationActivityRoute
  StaffAppsListRuleAndPolicyRoute: typeof StaffAppsListRuleAndPolicyRoute
  StaffAppsListIndexRouteLazyRoute: typeof StaffAppsListIndexRouteLazyRoute
  StaffAppsListMarketplaceIdRouteRoute: typeof StaffAppsListMarketplaceIdRouteRouteWithChildren
  StaffAppsListAlertsRoute: typeof StaffAppsListAlertsRouteWithChildren
  StaffAppsListIntegrationsIndexRoute: typeof StaffAppsListIntegrationsIndexRoute
  StaffAppsListMarketplaceIndexRoute: typeof StaffAppsListMarketplaceIndexRoute
  StaffAppsListPeopleIndexRoute: typeof StaffAppsListPeopleIndexRoute
  StaffAppsListSettingsIndexRoute: typeof StaffAppsListSettingsIndexRoute
}

const StaffAppsListRouteChildren: StaffAppsListRouteChildren = {
  StaffAppsListContractAndCostRoute: StaffAppsListContractAndCostRoute,
  StaffAppsListOperationActivityRoute: StaffAppsListOperationActivityRoute,
  StaffAppsListRuleAndPolicyRoute: StaffAppsListRuleAndPolicyRoute,
  StaffAppsListIndexRouteLazyRoute: StaffAppsListIndexRouteLazyRoute,
  StaffAppsListMarketplaceIdRouteRoute:
    StaffAppsListMarketplaceIdRouteRouteWithChildren,
  StaffAppsListAlertsRoute: StaffAppsListAlertsRouteWithChildren,
  StaffAppsListIntegrationsIndexRoute: StaffAppsListIntegrationsIndexRoute,
  StaffAppsListMarketplaceIndexRoute: StaffAppsListMarketplaceIndexRoute,
  StaffAppsListPeopleIndexRoute: StaffAppsListPeopleIndexRoute,
  StaffAppsListSettingsIndexRoute: StaffAppsListSettingsIndexRoute,
}

const StaffAppsListRouteWithChildren = StaffAppsListRoute._addFileChildren(
  StaffAppsListRouteChildren,
)

interface StaffAppsRouteChildren {
  StaffAppsSplatRoute: typeof StaffAppsSplatRoute
  StaffAppsListRoute: typeof StaffAppsListRouteWithChildren
  StaffAppsCustomAppAddIndexRoute: typeof StaffAppsCustomAppAddIndexRoute
  StaffAppsCustomAppAddCustomAppTypeIndexRoute: typeof StaffAppsCustomAppAddCustomAppTypeIndexRoute
}

const StaffAppsRouteChildren: StaffAppsRouteChildren = {
  StaffAppsSplatRoute: StaffAppsSplatRoute,
  StaffAppsListRoute: StaffAppsListRouteWithChildren,
  StaffAppsCustomAppAddIndexRoute: StaffAppsCustomAppAddIndexRoute,
  StaffAppsCustomAppAddCustomAppTypeIndexRoute:
    StaffAppsCustomAppAddCustomAppTypeIndexRoute,
}

const StaffAppsRouteWithChildren = StaffAppsRoute._addFileChildren(
  StaffAppsRouteChildren,
)

interface StaffIdManagementsRouteChildren {
  StaffIdManagementsSplatRoute: typeof StaffIdManagementsSplatRoute
}

const StaffIdManagementsRouteChildren: StaffIdManagementsRouteChildren = {
  StaffIdManagementsSplatRoute: StaffIdManagementsSplatRoute,
}

const StaffIdManagementsRouteWithChildren =
  StaffIdManagementsRoute._addFileChildren(StaffIdManagementsRouteChildren)

interface StaffItOperationCoreDeviceInventoryRouteRouteChildren {
  StaffItOperationCoreDeviceInventoryDataRoute: typeof StaffItOperationCoreDeviceInventoryDataRoute
  StaffItOperationCoreDeviceInventoryDetailRoute: typeof StaffItOperationCoreDeviceInventoryDetailRoute
}

const StaffItOperationCoreDeviceInventoryRouteRouteChildren: StaffItOperationCoreDeviceInventoryRouteRouteChildren =
  {
    StaffItOperationCoreDeviceInventoryDataRoute:
      StaffItOperationCoreDeviceInventoryDataRoute,
    StaffItOperationCoreDeviceInventoryDetailRoute:
      StaffItOperationCoreDeviceInventoryDetailRoute,
  }

const StaffItOperationCoreDeviceInventoryRouteRouteWithChildren =
  StaffItOperationCoreDeviceInventoryRouteRoute._addFileChildren(
    StaffItOperationCoreDeviceInventoryRouteRouteChildren,
  )

interface StaffAccessesLayoutRouteChildren {
  StaffAccessesLayoutIndexRoute: typeof StaffAccessesLayoutIndexRoute
  StaffAccessesLayoutPlaceholdersContractAndCostRoute: typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  StaffAccessesLayoutPlaceholdersOverviewRoute: typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  StaffAccessesLayoutPlaceholdersSettingsRoute: typeof StaffAccessesLayoutPlaceholdersSettingsRoute
  StaffAccessesLayoutPlaceholdersSoftwareRoute: typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  StaffAccessesLayoutAlertsIndexRoute: typeof StaffAccessesLayoutAlertsIndexRoute
  StaffAccessesLayoutListIndexRoute: typeof StaffAccessesLayoutListIndexRoute
  StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute: typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
}

const StaffAccessesLayoutRouteChildren: StaffAccessesLayoutRouteChildren = {
  StaffAccessesLayoutIndexRoute: StaffAccessesLayoutIndexRoute,
  StaffAccessesLayoutPlaceholdersContractAndCostRoute:
    StaffAccessesLayoutPlaceholdersContractAndCostRoute,
  StaffAccessesLayoutPlaceholdersOverviewRoute:
    StaffAccessesLayoutPlaceholdersOverviewRoute,
  StaffAccessesLayoutPlaceholdersSettingsRoute:
    StaffAccessesLayoutPlaceholdersSettingsRoute,
  StaffAccessesLayoutPlaceholdersSoftwareRoute:
    StaffAccessesLayoutPlaceholdersSoftwareRoute,
  StaffAccessesLayoutAlertsIndexRoute: StaffAccessesLayoutAlertsIndexRoute,
  StaffAccessesLayoutListIndexRoute: StaffAccessesLayoutListIndexRoute,
  StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute:
    StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute,
}

const StaffAccessesLayoutRouteWithChildren =
  StaffAccessesLayoutRoute._addFileChildren(StaffAccessesLayoutRouteChildren)

interface StaffAccessesRouteChildren {
  StaffAccessesLayoutRoute: typeof StaffAccessesLayoutRouteWithChildren
}

const StaffAccessesRouteChildren: StaffAccessesRouteChildren = {
  StaffAccessesLayoutRoute: StaffAccessesLayoutRouteWithChildren,
}

const StaffAccessesRouteWithChildren = StaffAccessesRoute._addFileChildren(
  StaffAccessesRouteChildren,
)

interface StaffBusinessOperationEventsListRouteChildren {
  StaffBusinessOperationEventsListArchiveRoute: typeof StaffBusinessOperationEventsListArchiveRoute
  StaffBusinessOperationEventsListConfigRoute: typeof StaffBusinessOperationEventsListConfigRoute
  StaffBusinessOperationEventsListOperationActivityRoute: typeof StaffBusinessOperationEventsListOperationActivityRoute
  StaffBusinessOperationEventsListOverviewRoute: typeof StaffBusinessOperationEventsListOverviewRoute
  StaffBusinessOperationEventsListRuleAndPolicyRoute: typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  StaffBusinessOperationEventsListSettingsRoute: typeof StaffBusinessOperationEventsListSettingsRoute
  StaffBusinessOperationEventsListIndexRoute: typeof StaffBusinessOperationEventsListIndexRoute
}

const StaffBusinessOperationEventsListRouteChildren: StaffBusinessOperationEventsListRouteChildren =
  {
    StaffBusinessOperationEventsListArchiveRoute:
      StaffBusinessOperationEventsListArchiveRoute,
    StaffBusinessOperationEventsListConfigRoute:
      StaffBusinessOperationEventsListConfigRoute,
    StaffBusinessOperationEventsListOperationActivityRoute:
      StaffBusinessOperationEventsListOperationActivityRoute,
    StaffBusinessOperationEventsListOverviewRoute:
      StaffBusinessOperationEventsListOverviewRoute,
    StaffBusinessOperationEventsListRuleAndPolicyRoute:
      StaffBusinessOperationEventsListRuleAndPolicyRoute,
    StaffBusinessOperationEventsListSettingsRoute:
      StaffBusinessOperationEventsListSettingsRoute,
    StaffBusinessOperationEventsListIndexRoute:
      StaffBusinessOperationEventsListIndexRoute,
  }

const StaffBusinessOperationEventsListRouteWithChildren =
  StaffBusinessOperationEventsListRoute._addFileChildren(
    StaffBusinessOperationEventsListRouteChildren,
  )

interface StaffBusinessOperationEventsRouteChildren {
  StaffBusinessOperationEventsListRoute: typeof StaffBusinessOperationEventsListRouteWithChildren
  StaffBusinessOperationEventsEventInstanceIdIndexRoute: typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
}

const StaffBusinessOperationEventsRouteChildren: StaffBusinessOperationEventsRouteChildren =
  {
    StaffBusinessOperationEventsListRoute:
      StaffBusinessOperationEventsListRouteWithChildren,
    StaffBusinessOperationEventsEventInstanceIdIndexRoute:
      StaffBusinessOperationEventsEventInstanceIdIndexRoute,
  }

const StaffBusinessOperationEventsRouteWithChildren =
  StaffBusinessOperationEventsRoute._addFileChildren(
    StaffBusinessOperationEventsRouteChildren,
  )

interface StaffBusinessPartnerListRouteChildren {
  StaffBusinessPartnerListIndexRoute: typeof StaffBusinessPartnerListIndexRoute
  StaffBusinessPartnerListPlaceholdersAlertsRouteRoute: typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute: typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute: typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute: typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  StaffBusinessPartnerListPlaceholdersSettingsRouteRoute: typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  StaffBusinessPartnerListTerminatedIndexRoute: typeof StaffBusinessPartnerListTerminatedIndexRoute
}

const StaffBusinessPartnerListRouteChildren: StaffBusinessPartnerListRouteChildren =
  {
    StaffBusinessPartnerListIndexRoute: StaffBusinessPartnerListIndexRoute,
    StaffBusinessPartnerListPlaceholdersAlertsRouteRoute:
      StaffBusinessPartnerListPlaceholdersAlertsRouteRoute,
    StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute:
      StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute,
    StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute:
      StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute,
    StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute:
      StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute,
    StaffBusinessPartnerListPlaceholdersSettingsRouteRoute:
      StaffBusinessPartnerListPlaceholdersSettingsRouteRoute,
    StaffBusinessPartnerListTerminatedIndexRoute:
      StaffBusinessPartnerListTerminatedIndexRoute,
  }

const StaffBusinessPartnerListRouteWithChildren =
  StaffBusinessPartnerListRoute._addFileChildren(
    StaffBusinessPartnerListRouteChildren,
  )

interface StaffBusinessPartnerIdLayoutRouteChildren {
  StaffBusinessPartnerIdLayoutIndexIndexRoute: typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute: typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
}

const StaffBusinessPartnerIdLayoutRouteChildren: StaffBusinessPartnerIdLayoutRouteChildren =
  {
    StaffBusinessPartnerIdLayoutIndexIndexRoute:
      StaffBusinessPartnerIdLayoutIndexIndexRoute,
    StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute:
      StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute,
  }

const StaffBusinessPartnerIdLayoutRouteWithChildren =
  StaffBusinessPartnerIdLayoutRoute._addFileChildren(
    StaffBusinessPartnerIdLayoutRouteChildren,
  )

interface StaffBusinessPartnerIdRouteChildren {
  StaffBusinessPartnerIdLayoutRoute: typeof StaffBusinessPartnerIdLayoutRouteWithChildren
}

const StaffBusinessPartnerIdRouteChildren: StaffBusinessPartnerIdRouteChildren =
  {
    StaffBusinessPartnerIdLayoutRoute:
      StaffBusinessPartnerIdLayoutRouteWithChildren,
  }

const StaffBusinessPartnerIdRouteWithChildren =
  StaffBusinessPartnerIdRoute._addFileChildren(
    StaffBusinessPartnerIdRouteChildren,
  )

interface StaffBusinessPartnerRouteChildren {
  StaffBusinessPartnerListRoute: typeof StaffBusinessPartnerListRouteWithChildren
  StaffBusinessPartnerIdRoute: typeof StaffBusinessPartnerIdRouteWithChildren
  StaffBusinessPartnerAddIndexRoute: typeof StaffBusinessPartnerAddIndexRoute
  StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute: typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
}

const StaffBusinessPartnerRouteChildren: StaffBusinessPartnerRouteChildren = {
  StaffBusinessPartnerListRoute: StaffBusinessPartnerListRouteWithChildren,
  StaffBusinessPartnerIdRoute: StaffBusinessPartnerIdRouteWithChildren,
  StaffBusinessPartnerAddIndexRoute: StaffBusinessPartnerAddIndexRoute,
  StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute:
    StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute,
  StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute:
    StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute,
}

const StaffBusinessPartnerRouteWithChildren =
  StaffBusinessPartnerRoute._addFileChildren(StaffBusinessPartnerRouteChildren)

interface StaffCertificationListSettingsRouteLazyRouteChildren {
  StaffCertificationListSettingsIndexRoute: typeof StaffCertificationListSettingsIndexRoute
  StaffCertificationListSettingsIssuingOrganizationIndexRoute: typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute: typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  StaffCertificationListSettingsSpecialtyCategoryIndexRoute: typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
}

const StaffCertificationListSettingsRouteLazyRouteChildren: StaffCertificationListSettingsRouteLazyRouteChildren =
  {
    StaffCertificationListSettingsIndexRoute:
      StaffCertificationListSettingsIndexRoute,
    StaffCertificationListSettingsIssuingOrganizationIndexRoute:
      StaffCertificationListSettingsIssuingOrganizationIndexRoute,
    StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute:
      StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute,
    StaffCertificationListSettingsSpecialtyCategoryIndexRoute:
      StaffCertificationListSettingsSpecialtyCategoryIndexRoute,
  }

const StaffCertificationListSettingsRouteLazyRouteWithChildren =
  StaffCertificationListSettingsRouteLazyRoute._addFileChildren(
    StaffCertificationListSettingsRouteLazyRouteChildren,
  )

interface StaffCertificationListRouteChildren {
  StaffCertificationListSettingsRouteLazyRoute: typeof StaffCertificationListSettingsRouteLazyRouteWithChildren
  StaffCertificationListIndexRoute: typeof StaffCertificationListIndexRoute
  StaffCertificationListPlaceholdersAlertsRouteRoute: typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  StaffCertificationListPlaceholdersOperationActivityRouteRoute: typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  StaffCertificationListPlaceholdersOverviewRouteRoute: typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute: typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
}

const StaffCertificationListRouteChildren: StaffCertificationListRouteChildren =
  {
    StaffCertificationListSettingsRouteLazyRoute:
      StaffCertificationListSettingsRouteLazyRouteWithChildren,
    StaffCertificationListIndexRoute: StaffCertificationListIndexRoute,
    StaffCertificationListPlaceholdersAlertsRouteRoute:
      StaffCertificationListPlaceholdersAlertsRouteRoute,
    StaffCertificationListPlaceholdersOperationActivityRouteRoute:
      StaffCertificationListPlaceholdersOperationActivityRouteRoute,
    StaffCertificationListPlaceholdersOverviewRouteRoute:
      StaffCertificationListPlaceholdersOverviewRouteRoute,
    StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute:
      StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute,
  }

const StaffCertificationListRouteWithChildren =
  StaffCertificationListRoute._addFileChildren(
    StaffCertificationListRouteChildren,
  )

interface StaffCertificationIdLayoutRouteChildren {
  StaffCertificationIdLayoutIndexIndexRoute: typeof StaffCertificationIdLayoutIndexIndexRoute
  StaffCertificationIdLayoutCertificationHoldersIndexRoute: typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  StaffCertificationIdLayoutHandlingCertificationsIndexRoute: typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute: typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
}

const StaffCertificationIdLayoutRouteChildren: StaffCertificationIdLayoutRouteChildren =
  {
    StaffCertificationIdLayoutIndexIndexRoute:
      StaffCertificationIdLayoutIndexIndexRoute,
    StaffCertificationIdLayoutCertificationHoldersIndexRoute:
      StaffCertificationIdLayoutCertificationHoldersIndexRoute,
    StaffCertificationIdLayoutHandlingCertificationsIndexRoute:
      StaffCertificationIdLayoutHandlingCertificationsIndexRoute,
    StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute:
      StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute,
  }

const StaffCertificationIdLayoutRouteWithChildren =
  StaffCertificationIdLayoutRoute._addFileChildren(
    StaffCertificationIdLayoutRouteChildren,
  )

interface StaffCertificationIdRouteChildren {
  StaffCertificationIdLayoutRoute: typeof StaffCertificationIdLayoutRouteWithChildren
}

const StaffCertificationIdRouteChildren: StaffCertificationIdRouteChildren = {
  StaffCertificationIdLayoutRoute: StaffCertificationIdLayoutRouteWithChildren,
}

const StaffCertificationIdRouteWithChildren =
  StaffCertificationIdRoute._addFileChildren(StaffCertificationIdRouteChildren)

interface StaffCertificationHandlingCertificationIdLayoutRouteChildren {
  StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute: typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute: typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
}

const StaffCertificationHandlingCertificationIdLayoutRouteChildren: StaffCertificationHandlingCertificationIdLayoutRouteChildren =
  {
    StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute:
      StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute,
    StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute:
      StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute,
  }

const StaffCertificationHandlingCertificationIdLayoutRouteWithChildren =
  StaffCertificationHandlingCertificationIdLayoutRoute._addFileChildren(
    StaffCertificationHandlingCertificationIdLayoutRouteChildren,
  )

interface StaffCertificationHandlingCertificationIdRouteChildren {
  StaffCertificationHandlingCertificationIdLayoutRoute: typeof StaffCertificationHandlingCertificationIdLayoutRouteWithChildren
}

const StaffCertificationHandlingCertificationIdRouteChildren: StaffCertificationHandlingCertificationIdRouteChildren =
  {
    StaffCertificationHandlingCertificationIdLayoutRoute:
      StaffCertificationHandlingCertificationIdLayoutRouteWithChildren,
  }

const StaffCertificationHandlingCertificationIdRouteWithChildren =
  StaffCertificationHandlingCertificationIdRoute._addFileChildren(
    StaffCertificationHandlingCertificationIdRouteChildren,
  )

interface StaffCertificationSpecialtyCertificationIdLayoutRouteChildren {
  StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
}

const StaffCertificationSpecialtyCertificationIdLayoutRouteChildren: StaffCertificationSpecialtyCertificationIdLayoutRouteChildren =
  {
    StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute:
      StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute,
    StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute:
      StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute,
    StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute:
      StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute,
  }

const StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren =
  StaffCertificationSpecialtyCertificationIdLayoutRoute._addFileChildren(
    StaffCertificationSpecialtyCertificationIdLayoutRouteChildren,
  )

interface StaffCertificationSpecialtyCertificationIdRouteChildren {
  StaffCertificationSpecialtyCertificationIdLayoutRoute: typeof StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren
}

const StaffCertificationSpecialtyCertificationIdRouteChildren: StaffCertificationSpecialtyCertificationIdRouteChildren =
  {
    StaffCertificationSpecialtyCertificationIdLayoutRoute:
      StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren,
  }

const StaffCertificationSpecialtyCertificationIdRouteWithChildren =
  StaffCertificationSpecialtyCertificationIdRoute._addFileChildren(
    StaffCertificationSpecialtyCertificationIdRouteChildren,
  )

interface StaffCertificationRouteChildren {
  StaffCertificationListRoute: typeof StaffCertificationListRouteWithChildren
  StaffCertificationIdRoute: typeof StaffCertificationIdRouteWithChildren
  StaffCertificationAddIndexRoute: typeof StaffCertificationAddIndexRoute
  StaffCertificationAddCertificationKindCompletedRoute: typeof StaffCertificationAddCertificationKindCompletedRoute
  StaffCertificationHandlingCertificationIdRoute: typeof StaffCertificationHandlingCertificationIdRouteWithChildren
  StaffCertificationSpecialtyCertificationIdRoute: typeof StaffCertificationSpecialtyCertificationIdRouteWithChildren
  StaffCertificationAddCertificationKindIndexRoute: typeof StaffCertificationAddCertificationKindIndexRoute
}

const StaffCertificationRouteChildren: StaffCertificationRouteChildren = {
  StaffCertificationListRoute: StaffCertificationListRouteWithChildren,
  StaffCertificationIdRoute: StaffCertificationIdRouteWithChildren,
  StaffCertificationAddIndexRoute: StaffCertificationAddIndexRoute,
  StaffCertificationAddCertificationKindCompletedRoute:
    StaffCertificationAddCertificationKindCompletedRoute,
  StaffCertificationHandlingCertificationIdRoute:
    StaffCertificationHandlingCertificationIdRouteWithChildren,
  StaffCertificationSpecialtyCertificationIdRoute:
    StaffCertificationSpecialtyCertificationIdRouteWithChildren,
  StaffCertificationAddCertificationKindIndexRoute:
    StaffCertificationAddCertificationKindIndexRoute,
}

const StaffCertificationRouteWithChildren =
  StaffCertificationRoute._addFileChildren(StaffCertificationRouteChildren)

interface StaffContractListRouteChildren {
  StaffContractListIndexRoute: typeof StaffContractListIndexRoute
  StaffContractListPlaceholdersAlertsRouteRoute: typeof StaffContractListPlaceholdersAlertsRouteRoute
  StaffContractListPlaceholdersContractAndCostRouteRoute: typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  StaffContractListPlaceholdersOperationActivityRouteRoute: typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  StaffContractListPlaceholdersOverviewRouteRoute: typeof StaffContractListPlaceholdersOverviewRouteRoute
  StaffContractListPlaceholdersPeopleRouteRoute: typeof StaffContractListPlaceholdersPeopleRouteRoute
}

const StaffContractListRouteChildren: StaffContractListRouteChildren = {
  StaffContractListIndexRoute: StaffContractListIndexRoute,
  StaffContractListPlaceholdersAlertsRouteRoute:
    StaffContractListPlaceholdersAlertsRouteRoute,
  StaffContractListPlaceholdersContractAndCostRouteRoute:
    StaffContractListPlaceholdersContractAndCostRouteRoute,
  StaffContractListPlaceholdersOperationActivityRouteRoute:
    StaffContractListPlaceholdersOperationActivityRouteRoute,
  StaffContractListPlaceholdersOverviewRouteRoute:
    StaffContractListPlaceholdersOverviewRouteRoute,
  StaffContractListPlaceholdersPeopleRouteRoute:
    StaffContractListPlaceholdersPeopleRouteRoute,
}

const StaffContractListRouteWithChildren =
  StaffContractListRoute._addFileChildren(StaffContractListRouteChildren)

interface StaffContractIdLayoutRouteChildren {
  StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute: typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  StaffContractIdLayoutPlaceholdersHistoryRouteRoute: typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute: typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute: typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute: typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  StaffContractIdLayoutIndexIndexLazyRoute: typeof StaffContractIdLayoutIndexIndexLazyRoute
  StaffContractIdLayoutStructureIndexLazyRoute: typeof StaffContractIdLayoutStructureIndexLazyRoute
}

const StaffContractIdLayoutRouteChildren: StaffContractIdLayoutRouteChildren = {
  StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute:
    StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute,
  StaffContractIdLayoutPlaceholdersHistoryRouteRoute:
    StaffContractIdLayoutPlaceholdersHistoryRouteRoute,
  StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute:
    StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute,
  StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute:
    StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute,
  StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute:
    StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute,
  StaffContractIdLayoutIndexIndexLazyRoute:
    StaffContractIdLayoutIndexIndexLazyRoute,
  StaffContractIdLayoutStructureIndexLazyRoute:
    StaffContractIdLayoutStructureIndexLazyRoute,
}

const StaffContractIdLayoutRouteWithChildren =
  StaffContractIdLayoutRoute._addFileChildren(
    StaffContractIdLayoutRouteChildren,
  )

interface StaffContractIdRouteChildren {
  StaffContractIdLayoutRoute: typeof StaffContractIdLayoutRouteWithChildren
}

const StaffContractIdRouteChildren: StaffContractIdRouteChildren = {
  StaffContractIdLayoutRoute: StaffContractIdLayoutRouteWithChildren,
}

const StaffContractIdRouteWithChildren = StaffContractIdRoute._addFileChildren(
  StaffContractIdRouteChildren,
)

interface StaffContractRouteChildren {
  StaffContractListRoute: typeof StaffContractListRouteWithChildren
  StaffContractIdRoute: typeof StaffContractIdRouteWithChildren
  StaffContractAddIndexRoute: typeof StaffContractAddIndexRoute
  StaffContractImportCsvContractTypeIndexRoute: typeof StaffContractImportCsvContractTypeIndexRoute
}

const StaffContractRouteChildren: StaffContractRouteChildren = {
  StaffContractListRoute: StaffContractListRouteWithChildren,
  StaffContractIdRoute: StaffContractIdRouteWithChildren,
  StaffContractAddIndexRoute: StaffContractAddIndexRoute,
  StaffContractImportCsvContractTypeIndexRoute:
    StaffContractImportCsvContractTypeIndexRoute,
}

const StaffContractRouteWithChildren = StaffContractRoute._addFileChildren(
  StaffContractRouteChildren,
)

interface StaffContractorCorePackagesRouteChildren {
  StaffContractorCorePackagesIndexRoute: typeof StaffContractorCorePackagesIndexRoute
  StaffContractorCorePackagesArchivesIndexRoute: typeof StaffContractorCorePackagesArchivesIndexRoute
  StaffContractorCorePackagesConfigsIndexRoute: typeof StaffContractorCorePackagesConfigsIndexRoute
}

const StaffContractorCorePackagesRouteChildren: StaffContractorCorePackagesRouteChildren =
  {
    StaffContractorCorePackagesIndexRoute:
      StaffContractorCorePackagesIndexRoute,
    StaffContractorCorePackagesArchivesIndexRoute:
      StaffContractorCorePackagesArchivesIndexRoute,
    StaffContractorCorePackagesConfigsIndexRoute:
      StaffContractorCorePackagesConfigsIndexRoute,
  }

const StaffContractorCorePackagesRouteWithChildren =
  StaffContractorCorePackagesRoute._addFileChildren(
    StaffContractorCorePackagesRouteChildren,
  )

interface StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren {
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren: StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren =
  {
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute:
      StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute,
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute:
      StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute,
  }

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute._addFileChildren(
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren,
  )

interface StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren {
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
}

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren: StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren =
  {
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute:
      StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren,
  }

const StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren =
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute._addFileChildren(
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren,
  )

interface StaffContractorCoreRouteChildren {
  StaffContractorCorePackagesRoute: typeof StaffContractorCorePackagesRouteWithChildren
  StaffContractorCoreConfigPatternIdIndexRoute: typeof StaffContractorCoreConfigPatternIdIndexRoute
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute: typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
}

const StaffContractorCoreRouteChildren: StaffContractorCoreRouteChildren = {
  StaffContractorCorePackagesRoute:
    StaffContractorCorePackagesRouteWithChildren,
  StaffContractorCoreConfigPatternIdIndexRoute:
    StaffContractorCoreConfigPatternIdIndexRoute,
  StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute:
    StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren,
}

const StaffContractorCoreRouteWithChildren =
  StaffContractorCoreRoute._addFileChildren(StaffContractorCoreRouteChildren)

interface StaffDevicesListRouteChildren {
  StaffDevicesListAlertsRoute: typeof StaffDevicesListAlertsRoute
  StaffDevicesListContractAndCostRoute: typeof StaffDevicesListContractAndCostRoute
  StaffDevicesListOperationActivityRoute: typeof StaffDevicesListOperationActivityRoute
  StaffDevicesListRuleAndPolicyRoute: typeof StaffDevicesListRuleAndPolicyRoute
  StaffDevicesListIndexRouteLazyRoute: typeof StaffDevicesListIndexRouteLazyRoute
  StaffDevicesListSettingsCatalogRoute: typeof StaffDevicesListSettingsCatalogRoute
  StaffDevicesListCatalogIndexRoute: typeof StaffDevicesListCatalogIndexRoute
  StaffDevicesListInventoryIndexRoute: typeof StaffDevicesListInventoryIndexRoute
  StaffDevicesListPeopleIndexRoute: typeof StaffDevicesListPeopleIndexRoute
  StaffDevicesListSettingsIndexRoute: typeof StaffDevicesListSettingsIndexRoute
}

const StaffDevicesListRouteChildren: StaffDevicesListRouteChildren = {
  StaffDevicesListAlertsRoute: StaffDevicesListAlertsRoute,
  StaffDevicesListContractAndCostRoute: StaffDevicesListContractAndCostRoute,
  StaffDevicesListOperationActivityRoute:
    StaffDevicesListOperationActivityRoute,
  StaffDevicesListRuleAndPolicyRoute: StaffDevicesListRuleAndPolicyRoute,
  StaffDevicesListIndexRouteLazyRoute: StaffDevicesListIndexRouteLazyRoute,
  StaffDevicesListSettingsCatalogRoute: StaffDevicesListSettingsCatalogRoute,
  StaffDevicesListCatalogIndexRoute: StaffDevicesListCatalogIndexRoute,
  StaffDevicesListInventoryIndexRoute: StaffDevicesListInventoryIndexRoute,
  StaffDevicesListPeopleIndexRoute: StaffDevicesListPeopleIndexRoute,
  StaffDevicesListSettingsIndexRoute: StaffDevicesListSettingsIndexRoute,
}

const StaffDevicesListRouteWithChildren =
  StaffDevicesListRoute._addFileChildren(StaffDevicesListRouteChildren)

interface StaffDevicesRouteChildren {
  StaffDevicesListRoute: typeof StaffDevicesListRouteWithChildren
  StaffDevicesImportCsvDeviceTypeRouteRoute: typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  StaffDevicesAddIndexRoute: typeof StaffDevicesAddIndexRoute
  StaffDevicesExternalItSaasIndexRoute: typeof StaffDevicesExternalItSaasIndexRoute
  StaffDevicesAddDeviceTypeCompletedRoute: typeof StaffDevicesAddDeviceTypeCompletedRoute
  StaffDevicesAddDeviceTypeIndexRoute: typeof StaffDevicesAddDeviceTypeIndexRoute
  StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute: typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
}

const StaffDevicesRouteChildren: StaffDevicesRouteChildren = {
  StaffDevicesListRoute: StaffDevicesListRouteWithChildren,
  StaffDevicesImportCsvDeviceTypeRouteRoute:
    StaffDevicesImportCsvDeviceTypeRouteRoute,
  StaffDevicesAddIndexRoute: StaffDevicesAddIndexRoute,
  StaffDevicesExternalItSaasIndexRoute: StaffDevicesExternalItSaasIndexRoute,
  StaffDevicesAddDeviceTypeCompletedRoute:
    StaffDevicesAddDeviceTypeCompletedRoute,
  StaffDevicesAddDeviceTypeIndexRoute: StaffDevicesAddDeviceTypeIndexRoute,
  StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute:
    StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute,
}

const StaffDevicesRouteWithChildren = StaffDevicesRoute._addFileChildren(
  StaffDevicesRouteChildren,
)

interface StaffEquipmentLayoutSettingsRouteLazyRouteChildren {
  StaffEquipmentLayoutSettingsIndexRoute: typeof StaffEquipmentLayoutSettingsIndexRoute
  StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute: typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute: typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
}

const StaffEquipmentLayoutSettingsRouteLazyRouteChildren: StaffEquipmentLayoutSettingsRouteLazyRouteChildren =
  {
    StaffEquipmentLayoutSettingsIndexRoute:
      StaffEquipmentLayoutSettingsIndexRoute,
    StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute:
      StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute,
    StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute:
      StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute,
  }

const StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren =
  StaffEquipmentLayoutSettingsRouteLazyRoute._addFileChildren(
    StaffEquipmentLayoutSettingsRouteLazyRouteChildren,
  )

interface StaffEquipmentLayoutRouteChildren {
  StaffEquipmentLayoutSettingsRouteLazyRoute: typeof StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren
  StaffEquipmentLayoutIndexRoute: typeof StaffEquipmentLayoutIndexRoute
  StaffEquipmentLayoutPlaceholdersAlertsRoute: typeof StaffEquipmentLayoutPlaceholdersAlertsRoute
  StaffEquipmentLayoutPlaceholdersOverviewRoute: typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  StaffEquipmentLayoutPlaceholdersSettingsRoute: typeof StaffEquipmentLayoutPlaceholdersSettingsRoute
}

const StaffEquipmentLayoutRouteChildren: StaffEquipmentLayoutRouteChildren = {
  StaffEquipmentLayoutSettingsRouteLazyRoute:
    StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren,
  StaffEquipmentLayoutIndexRoute: StaffEquipmentLayoutIndexRoute,
  StaffEquipmentLayoutPlaceholdersAlertsRoute:
    StaffEquipmentLayoutPlaceholdersAlertsRoute,
  StaffEquipmentLayoutPlaceholdersOverviewRoute:
    StaffEquipmentLayoutPlaceholdersOverviewRoute,
  StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute:
    StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute,
  StaffEquipmentLayoutPlaceholdersSettingsRoute:
    StaffEquipmentLayoutPlaceholdersSettingsRoute,
}

const StaffEquipmentLayoutRouteWithChildren =
  StaffEquipmentLayoutRoute._addFileChildren(StaffEquipmentLayoutRouteChildren)

interface StaffEquipmentIdLayoutRouteChildren {
  StaffEquipmentIdLayoutProfileIndexLazyRoute: typeof StaffEquipmentIdLayoutProfileIndexLazyRoute
}

const StaffEquipmentIdLayoutRouteChildren: StaffEquipmentIdLayoutRouteChildren =
  {
    StaffEquipmentIdLayoutProfileIndexLazyRoute:
      StaffEquipmentIdLayoutProfileIndexLazyRoute,
  }

const StaffEquipmentIdLayoutRouteWithChildren =
  StaffEquipmentIdLayoutRoute._addFileChildren(
    StaffEquipmentIdLayoutRouteChildren,
  )

interface StaffEquipmentIdRouteChildren {
  StaffEquipmentIdLayoutRoute: typeof StaffEquipmentIdLayoutRouteWithChildren
}

const StaffEquipmentIdRouteChildren: StaffEquipmentIdRouteChildren = {
  StaffEquipmentIdLayoutRoute: StaffEquipmentIdLayoutRouteWithChildren,
}

const StaffEquipmentIdRouteWithChildren =
  StaffEquipmentIdRoute._addFileChildren(StaffEquipmentIdRouteChildren)

interface StaffEquipmentRouteChildren {
  StaffEquipmentLayoutRoute: typeof StaffEquipmentLayoutRouteWithChildren
  StaffEquipmentIdRoute: typeof StaffEquipmentIdRouteWithChildren
  StaffEquipmentAddSelectIndexRoute: typeof StaffEquipmentAddSelectIndexRoute
  StaffEquipmentAddIndexRoute: typeof StaffEquipmentAddIndexRoute
  StaffEquipmentImportCsvIndexRoute: typeof StaffEquipmentImportCsvIndexRoute
}

const StaffEquipmentRouteChildren: StaffEquipmentRouteChildren = {
  StaffEquipmentLayoutRoute: StaffEquipmentLayoutRouteWithChildren,
  StaffEquipmentIdRoute: StaffEquipmentIdRouteWithChildren,
  StaffEquipmentAddSelectIndexRoute: StaffEquipmentAddSelectIndexRoute,
  StaffEquipmentAddIndexRoute: StaffEquipmentAddIndexRoute,
  StaffEquipmentImportCsvIndexRoute: StaffEquipmentImportCsvIndexRoute,
}

const StaffEquipmentRouteWithChildren = StaffEquipmentRoute._addFileChildren(
  StaffEquipmentRouteChildren,
)

interface StaffFleetsLayoutRouteChildren {
  StaffFleetsLayoutAlertsRoute: typeof StaffFleetsLayoutAlertsRoute
  StaffFleetsLayoutOverviewRoute: typeof StaffFleetsLayoutOverviewRoute
  StaffFleetsLayoutRuleAndPolicyRoute: typeof StaffFleetsLayoutRuleAndPolicyRoute
  StaffFleetsLayoutSettingsRoute: typeof StaffFleetsLayoutSettingsRoute
  StaffFleetsLayoutListIndexRoute: typeof StaffFleetsLayoutListIndexRoute
}

const StaffFleetsLayoutRouteChildren: StaffFleetsLayoutRouteChildren = {
  StaffFleetsLayoutAlertsRoute: StaffFleetsLayoutAlertsRoute,
  StaffFleetsLayoutOverviewRoute: StaffFleetsLayoutOverviewRoute,
  StaffFleetsLayoutRuleAndPolicyRoute: StaffFleetsLayoutRuleAndPolicyRoute,
  StaffFleetsLayoutSettingsRoute: StaffFleetsLayoutSettingsRoute,
  StaffFleetsLayoutListIndexRoute: StaffFleetsLayoutListIndexRoute,
}

const StaffFleetsLayoutRouteWithChildren =
  StaffFleetsLayoutRoute._addFileChildren(StaffFleetsLayoutRouteChildren)

interface StaffFleetsIdLayoutRouteChildren {
  StaffFleetsIdLayoutProfileIndexLazyRoute: typeof StaffFleetsIdLayoutProfileIndexLazyRoute
}

const StaffFleetsIdLayoutRouteChildren: StaffFleetsIdLayoutRouteChildren = {
  StaffFleetsIdLayoutProfileIndexLazyRoute:
    StaffFleetsIdLayoutProfileIndexLazyRoute,
}

const StaffFleetsIdLayoutRouteWithChildren =
  StaffFleetsIdLayoutRoute._addFileChildren(StaffFleetsIdLayoutRouteChildren)

interface StaffFleetsIdRouteChildren {
  StaffFleetsIdLayoutRoute: typeof StaffFleetsIdLayoutRouteWithChildren
}

const StaffFleetsIdRouteChildren: StaffFleetsIdRouteChildren = {
  StaffFleetsIdLayoutRoute: StaffFleetsIdLayoutRouteWithChildren,
}

const StaffFleetsIdRouteWithChildren = StaffFleetsIdRoute._addFileChildren(
  StaffFleetsIdRouteChildren,
)

interface StaffFleetsRouteChildren {
  StaffFleetsLayoutRoute: typeof StaffFleetsLayoutRouteWithChildren
  StaffFleetsIdRoute: typeof StaffFleetsIdRouteWithChildren
  StaffFleetsAddSelectIndexRoute: typeof StaffFleetsAddSelectIndexRoute
  StaffFleetsAddIndexRoute: typeof StaffFleetsAddIndexRoute
}

const StaffFleetsRouteChildren: StaffFleetsRouteChildren = {
  StaffFleetsLayoutRoute: StaffFleetsLayoutRouteWithChildren,
  StaffFleetsIdRoute: StaffFleetsIdRouteWithChildren,
  StaffFleetsAddSelectIndexRoute: StaffFleetsAddSelectIndexRoute,
  StaffFleetsAddIndexRoute: StaffFleetsAddIndexRoute,
}

const StaffFleetsRouteWithChildren = StaffFleetsRoute._addFileChildren(
  StaffFleetsRouteChildren,
)

interface StaffGaOperationCorePackagesRouteChildren {
  StaffGaOperationCorePackagesIndexRoute: typeof StaffGaOperationCorePackagesIndexRoute
  StaffGaOperationCorePackagesArchivesIndexRoute: typeof StaffGaOperationCorePackagesArchivesIndexRoute
  StaffGaOperationCorePackagesConfigsIndexRoute: typeof StaffGaOperationCorePackagesConfigsIndexRoute
}

const StaffGaOperationCorePackagesRouteChildren: StaffGaOperationCorePackagesRouteChildren =
  {
    StaffGaOperationCorePackagesIndexRoute:
      StaffGaOperationCorePackagesIndexRoute,
    StaffGaOperationCorePackagesArchivesIndexRoute:
      StaffGaOperationCorePackagesArchivesIndexRoute,
    StaffGaOperationCorePackagesConfigsIndexRoute:
      StaffGaOperationCorePackagesConfigsIndexRoute,
  }

const StaffGaOperationCorePackagesRouteWithChildren =
  StaffGaOperationCorePackagesRoute._addFileChildren(
    StaffGaOperationCorePackagesRouteChildren,
  )

interface StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren {
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren: StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren =
  {
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute:
      StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute,
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute:
      StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute,
  }

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute._addFileChildren(
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren,
  )

interface StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren {
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
}

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren: StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren =
  {
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute:
      StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren,
  }

const StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren =
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute._addFileChildren(
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren,
  )

interface StaffGaOperationCoreRouteChildren {
  StaffGaOperationCorePackagesRoute: typeof StaffGaOperationCorePackagesRouteWithChildren
  StaffGaOperationCoreConfigPatternIdIndexRoute: typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute: typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
}

const StaffGaOperationCoreRouteChildren: StaffGaOperationCoreRouteChildren = {
  StaffGaOperationCorePackagesRoute:
    StaffGaOperationCorePackagesRouteWithChildren,
  StaffGaOperationCoreConfigPatternIdIndexRoute:
    StaffGaOperationCoreConfigPatternIdIndexRoute,
  StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute:
    StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren,
}

const StaffGaOperationCoreRouteWithChildren =
  StaffGaOperationCoreRoute._addFileChildren(StaffGaOperationCoreRouteChildren)

interface StaffIdsLayoutRouteChildren {
  StaffIdsLayoutIndexRoute: typeof StaffIdsLayoutIndexRoute
  StaffIdsLayoutPlaceholdersAlertsRoute: typeof StaffIdsLayoutPlaceholdersAlertsRoute
  StaffIdsLayoutPlaceholdersGroupIdRoute: typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  StaffIdsLayoutPlaceholdersOperationActivityRoute: typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  StaffIdsLayoutPlaceholdersOverviewRoute: typeof StaffIdsLayoutPlaceholdersOverviewRoute
  StaffIdsLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  StaffIdsLayoutPlaceholdersSettingsRoute: typeof StaffIdsLayoutPlaceholdersSettingsRoute
  StaffIdsLayoutPeopleIndexRoute: typeof StaffIdsLayoutPeopleIndexRoute
}

const StaffIdsLayoutRouteChildren: StaffIdsLayoutRouteChildren = {
  StaffIdsLayoutIndexRoute: StaffIdsLayoutIndexRoute,
  StaffIdsLayoutPlaceholdersAlertsRoute: StaffIdsLayoutPlaceholdersAlertsRoute,
  StaffIdsLayoutPlaceholdersGroupIdRoute:
    StaffIdsLayoutPlaceholdersGroupIdRoute,
  StaffIdsLayoutPlaceholdersOperationActivityRoute:
    StaffIdsLayoutPlaceholdersOperationActivityRoute,
  StaffIdsLayoutPlaceholdersOverviewRoute:
    StaffIdsLayoutPlaceholdersOverviewRoute,
  StaffIdsLayoutPlaceholdersRuleAndPolicyRoute:
    StaffIdsLayoutPlaceholdersRuleAndPolicyRoute,
  StaffIdsLayoutPlaceholdersSettingsRoute:
    StaffIdsLayoutPlaceholdersSettingsRoute,
  StaffIdsLayoutPeopleIndexRoute: StaffIdsLayoutPeopleIndexRoute,
}

const StaffIdsLayoutRouteWithChildren = StaffIdsLayoutRoute._addFileChildren(
  StaffIdsLayoutRouteChildren,
)

interface StaffIdsGroupIdIdIdRouteChildren {
  StaffIdsGroupIdIdIdIndexRoute: typeof StaffIdsGroupIdIdIdIndexRoute
  StaffIdsGroupIdIdIdMembersIndexRoute: typeof StaffIdsGroupIdIdIdMembersIndexRoute
  StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute: typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  StaffIdsGroupIdIdIdSettingsIndexRoute: typeof StaffIdsGroupIdIdIdSettingsIndexRoute
}

const StaffIdsGroupIdIdIdRouteChildren: StaffIdsGroupIdIdIdRouteChildren = {
  StaffIdsGroupIdIdIdIndexRoute: StaffIdsGroupIdIdIdIndexRoute,
  StaffIdsGroupIdIdIdMembersIndexRoute: StaffIdsGroupIdIdIdMembersIndexRoute,
  StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute:
    StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute,
  StaffIdsGroupIdIdIdSettingsIndexRoute: StaffIdsGroupIdIdIdSettingsIndexRoute,
}

const StaffIdsGroupIdIdIdRouteWithChildren =
  StaffIdsGroupIdIdIdRoute._addFileChildren(StaffIdsGroupIdIdIdRouteChildren)

interface StaffIdsGroupIdIdRouteChildren {
  StaffIdsGroupIdIdIdRoute: typeof StaffIdsGroupIdIdIdRouteWithChildren
}

const StaffIdsGroupIdIdRouteChildren: StaffIdsGroupIdIdRouteChildren = {
  StaffIdsGroupIdIdIdRoute: StaffIdsGroupIdIdIdRouteWithChildren,
}

const StaffIdsGroupIdIdRouteWithChildren =
  StaffIdsGroupIdIdRoute._addFileChildren(StaffIdsGroupIdIdRouteChildren)

interface StaffIdsRouteChildren {
  StaffIdsLayoutRoute: typeof StaffIdsLayoutRouteWithChildren
  StaffIdsGroupIdIdRoute: typeof StaffIdsGroupIdIdRouteWithChildren
  StaffIdsGroupIdAddIndexRoute: typeof StaffIdsGroupIdAddIndexRoute
}

const StaffIdsRouteChildren: StaffIdsRouteChildren = {
  StaffIdsLayoutRoute: StaffIdsLayoutRouteWithChildren,
  StaffIdsGroupIdIdRoute: StaffIdsGroupIdIdRouteWithChildren,
  StaffIdsGroupIdAddIndexRoute: StaffIdsGroupIdAddIndexRoute,
}

const StaffIdsRouteWithChildren = StaffIdsRoute._addFileChildren(
  StaffIdsRouteChildren,
)

interface StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren {
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
}

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren: StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren =
  {
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute,
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute,
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute,
  }

const StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren =
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute._addFileChildren(
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteChildren,
  )

interface StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren {
  StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren
  StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
}

const StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren: StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren =
  {
    StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren,
    StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute,
  }

const StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren =
  StaffItOperationCoreDetailOperationInstancesInstanceIdRoute._addFileChildren(
    StaffItOperationCoreDetailOperationInstancesInstanceIdRouteChildren,
  )

interface StaffItOperationCoreDetailRouteChildren {
  StaffItOperationCoreDetailOperationInstancesInstanceIdRoute: typeof StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren
}

const StaffItOperationCoreDetailRouteChildren: StaffItOperationCoreDetailRouteChildren =
  {
    StaffItOperationCoreDetailOperationInstancesInstanceIdRoute:
      StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren,
  }

const StaffItOperationCoreDetailRouteWithChildren =
  StaffItOperationCoreDetailRoute._addFileChildren(
    StaffItOperationCoreDetailRouteChildren,
  )

interface StaffItOperationCoreRootPackagesRouteRouteChildren {
  StaffItOperationCoreRootPackagesPackageIdRoute: typeof StaffItOperationCoreRootPackagesPackageIdRoute
  StaffItOperationCoreRootPackagesIndexRoute: typeof StaffItOperationCoreRootPackagesIndexRoute
}

const StaffItOperationCoreRootPackagesRouteRouteChildren: StaffItOperationCoreRootPackagesRouteRouteChildren =
  {
    StaffItOperationCoreRootPackagesPackageIdRoute:
      StaffItOperationCoreRootPackagesPackageIdRoute,
    StaffItOperationCoreRootPackagesIndexRoute:
      StaffItOperationCoreRootPackagesIndexRoute,
  }

const StaffItOperationCoreRootPackagesRouteRouteWithChildren =
  StaffItOperationCoreRootPackagesRouteRoute._addFileChildren(
    StaffItOperationCoreRootPackagesRouteRouteChildren,
  )

interface StaffItOperationCoreRootRouteChildren {
  StaffItOperationCoreRootPackagesRouteRoute: typeof StaffItOperationCoreRootPackagesRouteRouteWithChildren
  StaffItOperationCoreRootArchivesIndexRoute: typeof StaffItOperationCoreRootArchivesIndexRoute
  StaffItOperationCoreRootConfigIndexRoute: typeof StaffItOperationCoreRootConfigIndexRoute
}

const StaffItOperationCoreRootRouteChildren: StaffItOperationCoreRootRouteChildren =
  {
    StaffItOperationCoreRootPackagesRouteRoute:
      StaffItOperationCoreRootPackagesRouteRouteWithChildren,
    StaffItOperationCoreRootArchivesIndexRoute:
      StaffItOperationCoreRootArchivesIndexRoute,
    StaffItOperationCoreRootConfigIndexRoute:
      StaffItOperationCoreRootConfigIndexRoute,
  }

const StaffItOperationCoreRootRouteWithChildren =
  StaffItOperationCoreRootRoute._addFileChildren(
    StaffItOperationCoreRootRouteChildren,
  )

interface StaffItOperationCoreRouteChildren {
  StaffItOperationCoreDetailRoute: typeof StaffItOperationCoreDetailRouteWithChildren
  StaffItOperationCoreRootRoute: typeof StaffItOperationCoreRootRouteWithChildren
  StaffItOperationCoreIndexRoute: typeof StaffItOperationCoreIndexRoute
  StaffItOperationCoreConfigPatternIdIndexRoute: typeof StaffItOperationCoreConfigPatternIdIndexRoute
}

const StaffItOperationCoreRouteChildren: StaffItOperationCoreRouteChildren = {
  StaffItOperationCoreDetailRoute: StaffItOperationCoreDetailRouteWithChildren,
  StaffItOperationCoreRootRoute: StaffItOperationCoreRootRouteWithChildren,
  StaffItOperationCoreIndexRoute: StaffItOperationCoreIndexRoute,
  StaffItOperationCoreConfigPatternIdIndexRoute:
    StaffItOperationCoreConfigPatternIdIndexRoute,
}

const StaffItOperationCoreRouteWithChildren =
  StaffItOperationCoreRoute._addFileChildren(StaffItOperationCoreRouteChildren)

interface StaffLaborCorePackagesSettingsRouteChildren {
  StaffLaborCorePackagesSettingsIndexRoute: typeof StaffLaborCorePackagesSettingsIndexRoute
}

const StaffLaborCorePackagesSettingsRouteChildren: StaffLaborCorePackagesSettingsRouteChildren =
  {
    StaffLaborCorePackagesSettingsIndexRoute:
      StaffLaborCorePackagesSettingsIndexRoute,
  }

const StaffLaborCorePackagesSettingsRouteWithChildren =
  StaffLaborCorePackagesSettingsRoute._addFileChildren(
    StaffLaborCorePackagesSettingsRouteChildren,
  )

interface StaffLaborCorePackagesRouteChildren {
  StaffLaborCorePackagesSettingsRoute: typeof StaffLaborCorePackagesSettingsRouteWithChildren
  StaffLaborCorePackagesIndexRoute: typeof StaffLaborCorePackagesIndexRoute
  StaffLaborCorePackagesArchivesIndexRoute: typeof StaffLaborCorePackagesArchivesIndexRoute
  StaffLaborCorePackagesConfigsIndexRoute: typeof StaffLaborCorePackagesConfigsIndexRoute
}

const StaffLaborCorePackagesRouteChildren: StaffLaborCorePackagesRouteChildren =
  {
    StaffLaborCorePackagesSettingsRoute:
      StaffLaborCorePackagesSettingsRouteWithChildren,
    StaffLaborCorePackagesIndexRoute: StaffLaborCorePackagesIndexRoute,
    StaffLaborCorePackagesArchivesIndexRoute:
      StaffLaborCorePackagesArchivesIndexRoute,
    StaffLaborCorePackagesConfigsIndexRoute:
      StaffLaborCorePackagesConfigsIndexRoute,
  }

const StaffLaborCorePackagesRouteWithChildren =
  StaffLaborCorePackagesRoute._addFileChildren(
    StaffLaborCorePackagesRouteChildren,
  )

interface StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren {
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren: StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren =
  {
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute:
      StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute,
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute:
      StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute,
  }

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute._addFileChildren(
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteChildren,
  )

interface StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren {
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
}

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren: StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren =
  {
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRoute:
      StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren,
  }

const StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren =
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute._addFileChildren(
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteChildren,
  )

interface StaffLaborCoreRouteChildren {
  StaffLaborCorePackagesRoute: typeof StaffLaborCorePackagesRouteWithChildren
  StaffLaborCoreAnchorDateRoute: typeof StaffLaborCoreAnchorDateRoute
  StaffLaborCorePersonTargetsRoute: typeof StaffLaborCorePersonTargetsRoute
  StaffLaborCoreSettingsEgovCallbackRoute: typeof StaffLaborCoreSettingsEgovCallbackRoute
  StaffLaborCoreSettingsProfileProfileIdRoute: typeof StaffLaborCoreSettingsProfileProfileIdRoute
  StaffLaborCoreConfigPatternIdIndexRoute: typeof StaffLaborCoreConfigPatternIdIndexRoute
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute: typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
}

const StaffLaborCoreRouteChildren: StaffLaborCoreRouteChildren = {
  StaffLaborCorePackagesRoute: StaffLaborCorePackagesRouteWithChildren,
  StaffLaborCoreAnchorDateRoute: StaffLaborCoreAnchorDateRoute,
  StaffLaborCorePersonTargetsRoute: StaffLaborCorePersonTargetsRoute,
  StaffLaborCoreSettingsEgovCallbackRoute:
    StaffLaborCoreSettingsEgovCallbackRoute,
  StaffLaborCoreSettingsProfileProfileIdRoute:
    StaffLaborCoreSettingsProfileProfileIdRoute,
  StaffLaborCoreConfigPatternIdIndexRoute:
    StaffLaborCoreConfigPatternIdIndexRoute,
  StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRoute:
    StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren,
}

const StaffLaborCoreRouteWithChildren = StaffLaborCoreRoute._addFileChildren(
  StaffLaborCoreRouteChildren,
)

interface StaffLicensesListRouteChildren {
  StaffLicensesListIndexRouteRoute: typeof StaffLicensesListIndexRouteRoute
  StaffLicensesListAlertsIndexRoute: typeof StaffLicensesListAlertsIndexRoute
  StaffLicensesListContractAndCostIndexRoute: typeof StaffLicensesListContractAndCostIndexRoute
  StaffLicensesListInventoryIndexRoute: typeof StaffLicensesListInventoryIndexRoute
  StaffLicensesListOperationActivityIndexRoute: typeof StaffLicensesListOperationActivityIndexRoute
  StaffLicensesListPeopleIndexRoute: typeof StaffLicensesListPeopleIndexRoute
  StaffLicensesListRuleAndPolicyIndexRoute: typeof StaffLicensesListRuleAndPolicyIndexRoute
  StaffLicensesListSettingsIndexRoute: typeof StaffLicensesListSettingsIndexRoute
}

const StaffLicensesListRouteChildren: StaffLicensesListRouteChildren = {
  StaffLicensesListIndexRouteRoute: StaffLicensesListIndexRouteRoute,
  StaffLicensesListAlertsIndexRoute: StaffLicensesListAlertsIndexRoute,
  StaffLicensesListContractAndCostIndexRoute:
    StaffLicensesListContractAndCostIndexRoute,
  StaffLicensesListInventoryIndexRoute: StaffLicensesListInventoryIndexRoute,
  StaffLicensesListOperationActivityIndexRoute:
    StaffLicensesListOperationActivityIndexRoute,
  StaffLicensesListPeopleIndexRoute: StaffLicensesListPeopleIndexRoute,
  StaffLicensesListRuleAndPolicyIndexRoute:
    StaffLicensesListRuleAndPolicyIndexRoute,
  StaffLicensesListSettingsIndexRoute: StaffLicensesListSettingsIndexRoute,
}

const StaffLicensesListRouteWithChildren =
  StaffLicensesListRoute._addFileChildren(StaffLicensesListRouteChildren)

interface StaffLicensesIdProfileRouteChildren {
  StaffLicensesIdProfileIndexLazyRoute: typeof StaffLicensesIdProfileIndexLazyRoute
  StaffLicensesIdProfileAssignmentsIndexRoute: typeof StaffLicensesIdProfileAssignmentsIndexRoute
  StaffLicensesIdProfilePeopleIndexRoute: typeof StaffLicensesIdProfilePeopleIndexRoute
  StaffLicensesIdProfileServicePlansIndexRoute: typeof StaffLicensesIdProfileServicePlansIndexRoute
}

const StaffLicensesIdProfileRouteChildren: StaffLicensesIdProfileRouteChildren =
  {
    StaffLicensesIdProfileIndexLazyRoute: StaffLicensesIdProfileIndexLazyRoute,
    StaffLicensesIdProfileAssignmentsIndexRoute:
      StaffLicensesIdProfileAssignmentsIndexRoute,
    StaffLicensesIdProfilePeopleIndexRoute:
      StaffLicensesIdProfilePeopleIndexRoute,
    StaffLicensesIdProfileServicePlansIndexRoute:
      StaffLicensesIdProfileServicePlansIndexRoute,
  }

const StaffLicensesIdProfileRouteWithChildren =
  StaffLicensesIdProfileRoute._addFileChildren(
    StaffLicensesIdProfileRouteChildren,
  )

interface StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren {
  StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
}

const StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren: StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren =
  {
    StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute:
      StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute,
  }

const StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren =
  StaffLicensesIdServicePlansLicenseServiceIdDetailRoute._addFileChildren(
    StaffLicensesIdServicePlansLicenseServiceIdDetailRouteChildren,
  )

interface StaffLicensesIdServicePlansLicenseServiceIdRouteChildren {
  StaffLicensesIdServicePlansLicenseServiceIdDetailRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
}

const StaffLicensesIdServicePlansLicenseServiceIdRouteChildren: StaffLicensesIdServicePlansLicenseServiceIdRouteChildren =
  {
    StaffLicensesIdServicePlansLicenseServiceIdDetailRoute:
      StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren,
  }

const StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren =
  StaffLicensesIdServicePlansLicenseServiceIdRoute._addFileChildren(
    StaffLicensesIdServicePlansLicenseServiceIdRouteChildren,
  )

interface StaffLicensesIdRouteChildren {
  StaffLicensesIdProfileRoute: typeof StaffLicensesIdProfileRouteWithChildren
  StaffLicensesIdServicePlansLicenseServiceIdRoute: typeof StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren
}

const StaffLicensesIdRouteChildren: StaffLicensesIdRouteChildren = {
  StaffLicensesIdProfileRoute: StaffLicensesIdProfileRouteWithChildren,
  StaffLicensesIdServicePlansLicenseServiceIdRoute:
    StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren,
}

const StaffLicensesIdRouteWithChildren = StaffLicensesIdRoute._addFileChildren(
  StaffLicensesIdRouteChildren,
)

interface StaffLicensesRouteChildren {
  StaffLicensesListRoute: typeof StaffLicensesListRouteWithChildren
  StaffLicensesIdRoute: typeof StaffLicensesIdRouteWithChildren
  StaffLicensesAddIndexRoute: typeof StaffLicensesAddIndexRoute
  StaffLicensesAddAllocationTypeCompletedRoute: typeof StaffLicensesAddAllocationTypeCompletedRoute
  StaffLicensesAddAllocationTypeIndexRoute: typeof StaffLicensesAddAllocationTypeIndexRoute
}

const StaffLicensesRouteChildren: StaffLicensesRouteChildren = {
  StaffLicensesListRoute: StaffLicensesListRouteWithChildren,
  StaffLicensesIdRoute: StaffLicensesIdRouteWithChildren,
  StaffLicensesAddIndexRoute: StaffLicensesAddIndexRoute,
  StaffLicensesAddAllocationTypeCompletedRoute:
    StaffLicensesAddAllocationTypeCompletedRoute,
  StaffLicensesAddAllocationTypeIndexRoute:
    StaffLicensesAddAllocationTypeIndexRoute,
}

const StaffLicensesRouteWithChildren = StaffLicensesRoute._addFileChildren(
  StaffLicensesRouteChildren,
)

interface StaffMarketplaceStoreRouteChildren {
  StaffMarketplaceStoreStoreDevicesIndexRoute: typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  StaffMarketplaceStoreStoreSalesOrdersIndexRoute: typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  StaffMarketplaceStoreStoreSentOrdersIndexRoute: typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  StaffMarketplaceStoreStoreStarlinksIndexRoute: typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  StaffMarketplaceStoreStoreDevicesProductIdIndexRoute: typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute: typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
}

const StaffMarketplaceStoreRouteChildren: StaffMarketplaceStoreRouteChildren = {
  StaffMarketplaceStoreStoreDevicesIndexRoute:
    StaffMarketplaceStoreStoreDevicesIndexRoute,
  StaffMarketplaceStoreStoreSalesOrdersIndexRoute:
    StaffMarketplaceStoreStoreSalesOrdersIndexRoute,
  StaffMarketplaceStoreStoreSentOrdersIndexRoute:
    StaffMarketplaceStoreStoreSentOrdersIndexRoute,
  StaffMarketplaceStoreStoreStarlinksIndexRoute:
    StaffMarketplaceStoreStoreStarlinksIndexRoute,
  StaffMarketplaceStoreStoreDevicesProductIdIndexRoute:
    StaffMarketplaceStoreStoreDevicesProductIdIndexRoute,
  StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute:
    StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute,
}

const StaffMarketplaceStoreRouteWithChildren =
  StaffMarketplaceStoreRoute._addFileChildren(
    StaffMarketplaceStoreRouteChildren,
  )

interface StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren {
  StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
}

const StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren: StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren =
  {
    StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute:
      StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute,
    StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute:
      StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute,
  }

const StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren =
  StaffMarketplaceSentOrdersOrderIdLayoutRoute._addFileChildren(
    StaffMarketplaceSentOrdersOrderIdLayoutRouteChildren,
  )

interface StaffMarketplaceSentOrdersOrderIdRouteChildren {
  StaffMarketplaceSentOrdersOrderIdLayoutRoute: typeof StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren
}

const StaffMarketplaceSentOrdersOrderIdRouteChildren: StaffMarketplaceSentOrdersOrderIdRouteChildren =
  {
    StaffMarketplaceSentOrdersOrderIdLayoutRoute:
      StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren,
  }

const StaffMarketplaceSentOrdersOrderIdRouteWithChildren =
  StaffMarketplaceSentOrdersOrderIdRoute._addFileChildren(
    StaffMarketplaceSentOrdersOrderIdRouteChildren,
  )

interface StaffMarketplaceRouteChildren {
  StaffMarketplaceStoreRoute: typeof StaffMarketplaceStoreRouteWithChildren
  StaffMarketplaceCartIndexRoute: typeof StaffMarketplaceCartIndexRoute
  StaffMarketplaceUnavailableIndexRoute: typeof StaffMarketplaceUnavailableIndexRoute
  StaffMarketplaceSentOrdersOrderIdRoute: typeof StaffMarketplaceSentOrdersOrderIdRouteWithChildren
  StaffMarketplaceSalesOrdersOrderIdIndexRoute: typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
}

const StaffMarketplaceRouteChildren: StaffMarketplaceRouteChildren = {
  StaffMarketplaceStoreRoute: StaffMarketplaceStoreRouteWithChildren,
  StaffMarketplaceCartIndexRoute: StaffMarketplaceCartIndexRoute,
  StaffMarketplaceUnavailableIndexRoute: StaffMarketplaceUnavailableIndexRoute,
  StaffMarketplaceSentOrdersOrderIdRoute:
    StaffMarketplaceSentOrdersOrderIdRouteWithChildren,
  StaffMarketplaceSalesOrdersOrderIdIndexRoute:
    StaffMarketplaceSalesOrdersOrderIdIndexRoute,
}

const StaffMarketplaceRouteWithChildren =
  StaffMarketplaceRoute._addFileChildren(StaffMarketplaceRouteChildren)

interface StaffNetworksLayoutRouteChildren {
  StaffNetworksLayoutIndexRoute: typeof StaffNetworksLayoutIndexRoute
  StaffNetworksLayoutPlaceholdersAlertsRoute: typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  StaffNetworksLayoutPlaceholdersContractAndCostRoute: typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  StaffNetworksLayoutPlaceholdersOperationActivityRoute: typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  StaffNetworksLayoutPlaceholdersOverviewRoute: typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  StaffNetworksLayoutPlaceholdersSettingsRoute: typeof StaffNetworksLayoutPlaceholdersSettingsRoute
}

const StaffNetworksLayoutRouteChildren: StaffNetworksLayoutRouteChildren = {
  StaffNetworksLayoutIndexRoute: StaffNetworksLayoutIndexRoute,
  StaffNetworksLayoutPlaceholdersAlertsRoute:
    StaffNetworksLayoutPlaceholdersAlertsRoute,
  StaffNetworksLayoutPlaceholdersContractAndCostRoute:
    StaffNetworksLayoutPlaceholdersContractAndCostRoute,
  StaffNetworksLayoutPlaceholdersOperationActivityRoute:
    StaffNetworksLayoutPlaceholdersOperationActivityRoute,
  StaffNetworksLayoutPlaceholdersOverviewRoute:
    StaffNetworksLayoutPlaceholdersOverviewRoute,
  StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute:
    StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute,
  StaffNetworksLayoutPlaceholdersSettingsRoute:
    StaffNetworksLayoutPlaceholdersSettingsRoute,
}

const StaffNetworksLayoutRouteWithChildren =
  StaffNetworksLayoutRoute._addFileChildren(StaffNetworksLayoutRouteChildren)

interface StaffNetworksIdLayoutRouteChildren {
  StaffNetworksIdLayoutProfileIndexLazyRoute: typeof StaffNetworksIdLayoutProfileIndexLazyRoute
}

const StaffNetworksIdLayoutRouteChildren: StaffNetworksIdLayoutRouteChildren = {
  StaffNetworksIdLayoutProfileIndexLazyRoute:
    StaffNetworksIdLayoutProfileIndexLazyRoute,
}

const StaffNetworksIdLayoutRouteWithChildren =
  StaffNetworksIdLayoutRoute._addFileChildren(
    StaffNetworksIdLayoutRouteChildren,
  )

interface StaffNetworksIdRouteChildren {
  StaffNetworksIdLayoutRoute: typeof StaffNetworksIdLayoutRouteWithChildren
}

const StaffNetworksIdRouteChildren: StaffNetworksIdRouteChildren = {
  StaffNetworksIdLayoutRoute: StaffNetworksIdLayoutRouteWithChildren,
}

const StaffNetworksIdRouteWithChildren = StaffNetworksIdRoute._addFileChildren(
  StaffNetworksIdRouteChildren,
)

interface StaffNetworksRouteChildren {
  StaffNetworksLayoutRoute: typeof StaffNetworksLayoutRouteWithChildren
  StaffNetworksIdRoute: typeof StaffNetworksIdRouteWithChildren
  StaffNetworksAddIndexRoute: typeof StaffNetworksAddIndexRoute
}

const StaffNetworksRouteChildren: StaffNetworksRouteChildren = {
  StaffNetworksLayoutRoute: StaffNetworksLayoutRouteWithChildren,
  StaffNetworksIdRoute: StaffNetworksIdRouteWithChildren,
  StaffNetworksAddIndexRoute: StaffNetworksAddIndexRoute,
}

const StaffNetworksRouteWithChildren = StaffNetworksRoute._addFileChildren(
  StaffNetworksRouteChildren,
)

interface StaffOrganizationListRouteChildren {
  StaffOrganizationListAlertIndexRoute: typeof StaffOrganizationListAlertIndexRoute
  StaffOrganizationListChartIndexRoute: typeof StaffOrganizationListChartIndexRoute
  StaffOrganizationListCostIndexRoute: typeof StaffOrganizationListCostIndexRoute
  StaffOrganizationListHistoryIndexRoute: typeof StaffOrganizationListHistoryIndexRoute
  StaffOrganizationListRulePolicyIndexRoute: typeof StaffOrganizationListRulePolicyIndexRoute
  StaffOrganizationListSettingsIndexRoute: typeof StaffOrganizationListSettingsIndexRoute
}

const StaffOrganizationListRouteChildren: StaffOrganizationListRouteChildren = {
  StaffOrganizationListAlertIndexRoute: StaffOrganizationListAlertIndexRoute,
  StaffOrganizationListChartIndexRoute: StaffOrganizationListChartIndexRoute,
  StaffOrganizationListCostIndexRoute: StaffOrganizationListCostIndexRoute,
  StaffOrganizationListHistoryIndexRoute:
    StaffOrganizationListHistoryIndexRoute,
  StaffOrganizationListRulePolicyIndexRoute:
    StaffOrganizationListRulePolicyIndexRoute,
  StaffOrganizationListSettingsIndexRoute:
    StaffOrganizationListSettingsIndexRoute,
}

const StaffOrganizationListRouteWithChildren =
  StaffOrganizationListRoute._addFileChildren(
    StaffOrganizationListRouteChildren,
  )

interface StaffOrganizationIdLayoutRouteChildren {
  StaffOrganizationIdLayoutIndexRoute: typeof StaffOrganizationIdLayoutIndexRoute
  StaffOrganizationIdLayoutHistoryIndexRoute: typeof StaffOrganizationIdLayoutHistoryIndexRoute
}

const StaffOrganizationIdLayoutRouteChildren: StaffOrganizationIdLayoutRouteChildren =
  {
    StaffOrganizationIdLayoutIndexRoute: StaffOrganizationIdLayoutIndexRoute,
    StaffOrganizationIdLayoutHistoryIndexRoute:
      StaffOrganizationIdLayoutHistoryIndexRoute,
  }

const StaffOrganizationIdLayoutRouteWithChildren =
  StaffOrganizationIdLayoutRoute._addFileChildren(
    StaffOrganizationIdLayoutRouteChildren,
  )

interface StaffOrganizationIdRouteChildren {
  StaffOrganizationIdLayoutRoute: typeof StaffOrganizationIdLayoutRouteWithChildren
}

const StaffOrganizationIdRouteChildren: StaffOrganizationIdRouteChildren = {
  StaffOrganizationIdLayoutRoute: StaffOrganizationIdLayoutRouteWithChildren,
}

const StaffOrganizationIdRouteWithChildren =
  StaffOrganizationIdRoute._addFileChildren(StaffOrganizationIdRouteChildren)

interface StaffOrganizationRouteChildren {
  StaffOrganizationListRoute: typeof StaffOrganizationListRouteWithChildren
  StaffOrganizationIndexRoute: typeof StaffOrganizationIndexRoute
  StaffOrganizationIdRoute: typeof StaffOrganizationIdRouteWithChildren
  StaffOrganizationPlanIndexRoute: typeof StaffOrganizationPlanIndexRoute
  StaffOrganizationPlanIdIndexRoute: typeof StaffOrganizationPlanIdIndexRoute
  StaffOrganizationPlanCreateIndexRoute: typeof StaffOrganizationPlanCreateIndexRoute
  StaffOrganizationPlanIdAddIndexRoute: typeof StaffOrganizationPlanIdAddIndexRoute
  StaffOrganizationPlanIdEditUnitIdIndexRoute: typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
}

const StaffOrganizationRouteChildren: StaffOrganizationRouteChildren = {
  StaffOrganizationListRoute: StaffOrganizationListRouteWithChildren,
  StaffOrganizationIndexRoute: StaffOrganizationIndexRoute,
  StaffOrganizationIdRoute: StaffOrganizationIdRouteWithChildren,
  StaffOrganizationPlanIndexRoute: StaffOrganizationPlanIndexRoute,
  StaffOrganizationPlanIdIndexRoute: StaffOrganizationPlanIdIndexRoute,
  StaffOrganizationPlanCreateIndexRoute: StaffOrganizationPlanCreateIndexRoute,
  StaffOrganizationPlanIdAddIndexRoute: StaffOrganizationPlanIdAddIndexRoute,
  StaffOrganizationPlanIdEditUnitIdIndexRoute:
    StaffOrganizationPlanIdEditUnitIdIndexRoute,
}

const StaffOrganizationRouteWithChildren =
  StaffOrganizationRoute._addFileChildren(StaffOrganizationRouteChildren)

interface StaffPeopleListSettingsRouteLazyRouteChildren {
  StaffPeopleListSettingsIndexRoute: typeof StaffPeopleListSettingsIndexRoute
  StaffPeopleListSettingsBoardMemberTypesIndexRoute: typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  StaffPeopleListSettingsCollaboratorTypesIndexRoute: typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  StaffPeopleListSettingsContractEndReasonsIndexRoute: typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  StaffPeopleListSettingsContractorTypesIndexRoute: typeof StaffPeopleListSettingsContractorTypesIndexRoute
  StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute: typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  StaffPeopleListSettingsEmploymentTypesIndexRoute: typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  StaffPeopleListSettingsGradesIndexRoute: typeof StaffPeopleListSettingsGradesIndexRoute
  StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute: typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  StaffPeopleListSettingsJobCompetenciesIndexRoute: typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  StaffPeopleListSettingsJobFunctionsIndexRoute: typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  StaffPeopleListSettingsJobGradesIndexRoute: typeof StaffPeopleListSettingsJobGradesIndexRoute
  StaffPeopleListSettingsJobLevelsIndexRoute: typeof StaffPeopleListSettingsJobLevelsIndexRoute
  StaffPeopleListSettingsJobTitlesIndexRoute: typeof StaffPeopleListSettingsJobTitlesIndexRoute
  StaffPeopleListSettingsJobTypesIndexRoute: typeof StaffPeopleListSettingsJobTypesIndexRoute
  StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute: typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  StaffPeopleListSettingsPositionsIndexRoute: typeof StaffPeopleListSettingsPositionsIndexRoute
  StaffPeopleListSettingsRetirementReasonsIndexRoute: typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  StaffPeopleListSettingsWorkModeIndexRoute: typeof StaffPeopleListSettingsWorkModeIndexRoute
}

const StaffPeopleListSettingsRouteLazyRouteChildren: StaffPeopleListSettingsRouteLazyRouteChildren =
  {
    StaffPeopleListSettingsIndexRoute: StaffPeopleListSettingsIndexRoute,
    StaffPeopleListSettingsBoardMemberTypesIndexRoute:
      StaffPeopleListSettingsBoardMemberTypesIndexRoute,
    StaffPeopleListSettingsCollaboratorTypesIndexRoute:
      StaffPeopleListSettingsCollaboratorTypesIndexRoute,
    StaffPeopleListSettingsContractEndReasonsIndexRoute:
      StaffPeopleListSettingsContractEndReasonsIndexRoute,
    StaffPeopleListSettingsContractorTypesIndexRoute:
      StaffPeopleListSettingsContractorTypesIndexRoute,
    StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute:
      StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute,
    StaffPeopleListSettingsEmploymentTypesIndexRoute:
      StaffPeopleListSettingsEmploymentTypesIndexRoute,
    StaffPeopleListSettingsGradesIndexRoute:
      StaffPeopleListSettingsGradesIndexRoute,
    StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute:
      StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute,
    StaffPeopleListSettingsJobCompetenciesIndexRoute:
      StaffPeopleListSettingsJobCompetenciesIndexRoute,
    StaffPeopleListSettingsJobFunctionsIndexRoute:
      StaffPeopleListSettingsJobFunctionsIndexRoute,
    StaffPeopleListSettingsJobGradesIndexRoute:
      StaffPeopleListSettingsJobGradesIndexRoute,
    StaffPeopleListSettingsJobLevelsIndexRoute:
      StaffPeopleListSettingsJobLevelsIndexRoute,
    StaffPeopleListSettingsJobTitlesIndexRoute:
      StaffPeopleListSettingsJobTitlesIndexRoute,
    StaffPeopleListSettingsJobTypesIndexRoute:
      StaffPeopleListSettingsJobTypesIndexRoute,
    StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute:
      StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute,
    StaffPeopleListSettingsPositionsIndexRoute:
      StaffPeopleListSettingsPositionsIndexRoute,
    StaffPeopleListSettingsRetirementReasonsIndexRoute:
      StaffPeopleListSettingsRetirementReasonsIndexRoute,
    StaffPeopleListSettingsWorkModeIndexRoute:
      StaffPeopleListSettingsWorkModeIndexRoute,
  }

const StaffPeopleListSettingsRouteLazyRouteWithChildren =
  StaffPeopleListSettingsRouteLazyRoute._addFileChildren(
    StaffPeopleListSettingsRouteLazyRouteChildren,
  )

interface StaffPeopleListRouteChildren {
  StaffPeopleListAlertsRoute: typeof StaffPeopleListAlertsRoute
  StaffPeopleListCommunityRoute: typeof StaffPeopleListCommunityRoute
  StaffPeopleListOperationActivityRoute: typeof StaffPeopleListOperationActivityRoute
  StaffPeopleListPeopleGraphRoute: typeof StaffPeopleListPeopleGraphRoute
  StaffPeopleListRuleAndPolicyRoute: typeof StaffPeopleListRuleAndPolicyRoute
  StaffPeopleListSalaryAndPaymentRoute: typeof StaffPeopleListSalaryAndPaymentRoute
  StaffPeopleListIndexRouteLazyRoute: typeof StaffPeopleListIndexRouteLazyRoute
  StaffPeopleListSettingsRouteLazyRoute: typeof StaffPeopleListSettingsRouteLazyRouteWithChildren
  StaffPeopleListAlumniIndexRoute: typeof StaffPeopleListAlumniIndexRoute
  StaffPeopleListWorkforceIndexRoute: typeof StaffPeopleListWorkforceIndexRoute
}

const StaffPeopleListRouteChildren: StaffPeopleListRouteChildren = {
  StaffPeopleListAlertsRoute: StaffPeopleListAlertsRoute,
  StaffPeopleListCommunityRoute: StaffPeopleListCommunityRoute,
  StaffPeopleListOperationActivityRoute: StaffPeopleListOperationActivityRoute,
  StaffPeopleListPeopleGraphRoute: StaffPeopleListPeopleGraphRoute,
  StaffPeopleListRuleAndPolicyRoute: StaffPeopleListRuleAndPolicyRoute,
  StaffPeopleListSalaryAndPaymentRoute: StaffPeopleListSalaryAndPaymentRoute,
  StaffPeopleListIndexRouteLazyRoute: StaffPeopleListIndexRouteLazyRoute,
  StaffPeopleListSettingsRouteLazyRoute:
    StaffPeopleListSettingsRouteLazyRouteWithChildren,
  StaffPeopleListAlumniIndexRoute: StaffPeopleListAlumniIndexRoute,
  StaffPeopleListWorkforceIndexRoute: StaffPeopleListWorkforceIndexRoute,
}

const StaffPeopleListRouteWithChildren = StaffPeopleListRoute._addFileChildren(
  StaffPeopleListRouteChildren,
)

interface StaffPeopleRouteChildren {
  StaffPeopleListRoute: typeof StaffPeopleListRouteWithChildren
}

const StaffPeopleRouteChildren: StaffPeopleRouteChildren = {
  StaffPeopleListRoute: StaffPeopleListRouteWithChildren,
}

const StaffPeopleRouteWithChildren = StaffPeopleRoute._addFileChildren(
  StaffPeopleRouteChildren,
)

interface StaffPlacesLayoutSettingsRouteRouteChildren {
  StaffPlacesLayoutSettingsIndexRoute: typeof StaffPlacesLayoutSettingsIndexRoute
  StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute: typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
}

const StaffPlacesLayoutSettingsRouteRouteChildren: StaffPlacesLayoutSettingsRouteRouteChildren =
  {
    StaffPlacesLayoutSettingsIndexRoute: StaffPlacesLayoutSettingsIndexRoute,
    StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute:
      StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute,
  }

const StaffPlacesLayoutSettingsRouteRouteWithChildren =
  StaffPlacesLayoutSettingsRouteRoute._addFileChildren(
    StaffPlacesLayoutSettingsRouteRouteChildren,
  )

interface StaffPlacesLayoutRouteChildren {
  StaffPlacesLayoutSettingsRouteRoute: typeof StaffPlacesLayoutSettingsRouteRouteWithChildren
  StaffPlacesLayoutIndexRoute: typeof StaffPlacesLayoutIndexRoute
  StaffPlacesLayoutPlaceholdersAlertsRoute: typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  StaffPlacesLayoutPlaceholdersContractAndCostRoute: typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  StaffPlacesLayoutPlaceholdersOperationActivityRoute: typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  StaffPlacesLayoutPlaceholdersOverviewRoute: typeof StaffPlacesLayoutPlaceholdersOverviewRoute
  StaffPlacesLayoutPlaceholdersPeopleRoute: typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute: typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  StaffPlacesLayoutPlaceholdersStoreRoute: typeof StaffPlacesLayoutPlaceholdersStoreRoute
}

const StaffPlacesLayoutRouteChildren: StaffPlacesLayoutRouteChildren = {
  StaffPlacesLayoutSettingsRouteRoute:
    StaffPlacesLayoutSettingsRouteRouteWithChildren,
  StaffPlacesLayoutIndexRoute: StaffPlacesLayoutIndexRoute,
  StaffPlacesLayoutPlaceholdersAlertsRoute:
    StaffPlacesLayoutPlaceholdersAlertsRoute,
  StaffPlacesLayoutPlaceholdersContractAndCostRoute:
    StaffPlacesLayoutPlaceholdersContractAndCostRoute,
  StaffPlacesLayoutPlaceholdersOperationActivityRoute:
    StaffPlacesLayoutPlaceholdersOperationActivityRoute,
  StaffPlacesLayoutPlaceholdersOverviewRoute:
    StaffPlacesLayoutPlaceholdersOverviewRoute,
  StaffPlacesLayoutPlaceholdersPeopleRoute:
    StaffPlacesLayoutPlaceholdersPeopleRoute,
  StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute:
    StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute,
  StaffPlacesLayoutPlaceholdersStoreRoute:
    StaffPlacesLayoutPlaceholdersStoreRoute,
}

const StaffPlacesLayoutRouteWithChildren =
  StaffPlacesLayoutRoute._addFileChildren(StaffPlacesLayoutRouteChildren)

interface StaffPlacesIdLayoutRouteChildren {
  StaffPlacesIdLayoutAdministratorsIndexRoute: typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  StaffPlacesIdLayoutLaborCoreIndexRoute: typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  StaffPlacesIdLayoutProfileIndexLazyRoute: typeof StaffPlacesIdLayoutProfileIndexLazyRoute
}

const StaffPlacesIdLayoutRouteChildren: StaffPlacesIdLayoutRouteChildren = {
  StaffPlacesIdLayoutAdministratorsIndexRoute:
    StaffPlacesIdLayoutAdministratorsIndexRoute,
  StaffPlacesIdLayoutLaborCoreIndexRoute:
    StaffPlacesIdLayoutLaborCoreIndexRoute,
  StaffPlacesIdLayoutProfileIndexLazyRoute:
    StaffPlacesIdLayoutProfileIndexLazyRoute,
}

const StaffPlacesIdLayoutRouteWithChildren =
  StaffPlacesIdLayoutRoute._addFileChildren(StaffPlacesIdLayoutRouteChildren)

interface StaffPlacesIdRouteChildren {
  StaffPlacesIdLayoutRoute: typeof StaffPlacesIdLayoutRouteWithChildren
}

const StaffPlacesIdRouteChildren: StaffPlacesIdRouteChildren = {
  StaffPlacesIdLayoutRoute: StaffPlacesIdLayoutRouteWithChildren,
}

const StaffPlacesIdRouteWithChildren = StaffPlacesIdRoute._addFileChildren(
  StaffPlacesIdRouteChildren,
)

interface StaffPlacesRouteChildren {
  StaffPlacesLayoutRoute: typeof StaffPlacesLayoutRouteWithChildren
  StaffPlacesIdRoute: typeof StaffPlacesIdRouteWithChildren
  StaffPlacesAddSelectIndexRoute: typeof StaffPlacesAddSelectIndexRoute
  StaffPlacesAddIndexRoute: typeof StaffPlacesAddIndexRoute
}

const StaffPlacesRouteChildren: StaffPlacesRouteChildren = {
  StaffPlacesLayoutRoute: StaffPlacesLayoutRouteWithChildren,
  StaffPlacesIdRoute: StaffPlacesIdRouteWithChildren,
  StaffPlacesAddSelectIndexRoute: StaffPlacesAddSelectIndexRoute,
  StaffPlacesAddIndexRoute: StaffPlacesAddIndexRoute,
}

const StaffPlacesRouteWithChildren = StaffPlacesRoute._addFileChildren(
  StaffPlacesRouteChildren,
)

interface StaffPublicIdsIdRouteChildren {
  StaffPublicIdsIdIndexRoute: typeof StaffPublicIdsIdIndexRoute
  StaffPublicIdsIdDetailsIndexRoute: typeof StaffPublicIdsIdDetailsIndexRoute
  StaffPublicIdsIdFilesIndexRoute: typeof StaffPublicIdsIdFilesIndexRoute
}

const StaffPublicIdsIdRouteChildren: StaffPublicIdsIdRouteChildren = {
  StaffPublicIdsIdIndexRoute: StaffPublicIdsIdIndexRoute,
  StaffPublicIdsIdDetailsIndexRoute: StaffPublicIdsIdDetailsIndexRoute,
  StaffPublicIdsIdFilesIndexRoute: StaffPublicIdsIdFilesIndexRoute,
}

const StaffPublicIdsIdRouteWithChildren =
  StaffPublicIdsIdRoute._addFileChildren(StaffPublicIdsIdRouteChildren)

interface StaffPublicIdsListRouteChildren {
  StaffPublicIdsListIndexRoute: typeof StaffPublicIdsListIndexRoute
  StaffPublicIdsListAlertsIndexRoute: typeof StaffPublicIdsListAlertsIndexRoute
  StaffPublicIdsListMembersIndexRoute: typeof StaffPublicIdsListMembersIndexRoute
  StaffPublicIdsListOperationActivityIndexRoute: typeof StaffPublicIdsListOperationActivityIndexRoute
  StaffPublicIdsListRegistryIndexRoute: typeof StaffPublicIdsListRegistryIndexRoute
  StaffPublicIdsListRulesAndPoliciesIndexRoute: typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  StaffPublicIdsListSettingsIndexRoute: typeof StaffPublicIdsListSettingsIndexRoute
}

const StaffPublicIdsListRouteChildren: StaffPublicIdsListRouteChildren = {
  StaffPublicIdsListIndexRoute: StaffPublicIdsListIndexRoute,
  StaffPublicIdsListAlertsIndexRoute: StaffPublicIdsListAlertsIndexRoute,
  StaffPublicIdsListMembersIndexRoute: StaffPublicIdsListMembersIndexRoute,
  StaffPublicIdsListOperationActivityIndexRoute:
    StaffPublicIdsListOperationActivityIndexRoute,
  StaffPublicIdsListRegistryIndexRoute: StaffPublicIdsListRegistryIndexRoute,
  StaffPublicIdsListRulesAndPoliciesIndexRoute:
    StaffPublicIdsListRulesAndPoliciesIndexRoute,
  StaffPublicIdsListSettingsIndexRoute: StaffPublicIdsListSettingsIndexRoute,
}

const StaffPublicIdsListRouteWithChildren =
  StaffPublicIdsListRoute._addFileChildren(StaffPublicIdsListRouteChildren)

interface StaffPublicIdsRouteChildren {
  StaffPublicIdsListRoute: typeof StaffPublicIdsListRouteWithChildren
  StaffPublicIdsImportCsvPublicIdTypeRouteRoute: typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  StaffPublicIdsAddIndexRoute: typeof StaffPublicIdsAddIndexRoute
}

const StaffPublicIdsRouteChildren: StaffPublicIdsRouteChildren = {
  StaffPublicIdsListRoute: StaffPublicIdsListRouteWithChildren,
  StaffPublicIdsImportCsvPublicIdTypeRouteRoute:
    StaffPublicIdsImportCsvPublicIdTypeRouteRoute,
  StaffPublicIdsAddIndexRoute: StaffPublicIdsAddIndexRoute,
}

const StaffPublicIdsRouteWithChildren = StaffPublicIdsRoute._addFileChildren(
  StaffPublicIdsRouteChildren,
)

interface StaffSoftwareLayoutPeopleRouteRouteChildren {
  StaffSoftwareLayoutPeopleIndexRoute: typeof StaffSoftwareLayoutPeopleIndexRoute
}

const StaffSoftwareLayoutPeopleRouteRouteChildren: StaffSoftwareLayoutPeopleRouteRouteChildren =
  {
    StaffSoftwareLayoutPeopleIndexRoute: StaffSoftwareLayoutPeopleIndexRoute,
  }

const StaffSoftwareLayoutPeopleRouteRouteWithChildren =
  StaffSoftwareLayoutPeopleRouteRoute._addFileChildren(
    StaffSoftwareLayoutPeopleRouteRouteChildren,
  )

interface StaffSoftwareLayoutMarketplaceIdRouteRouteChildren {
  StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute: typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
}

const StaffSoftwareLayoutMarketplaceIdRouteRouteChildren: StaffSoftwareLayoutMarketplaceIdRouteRouteChildren =
  {
    StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute:
      StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute,
  }

const StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren =
  StaffSoftwareLayoutMarketplaceIdRouteRoute._addFileChildren(
    StaffSoftwareLayoutMarketplaceIdRouteRouteChildren,
  )

interface StaffSoftwareLayoutAlertsAlertsRouteChildren {
  StaffSoftwareLayoutAlertsAlertsIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute: typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
}

const StaffSoftwareLayoutAlertsAlertsRouteChildren: StaffSoftwareLayoutAlertsAlertsRouteChildren =
  {
    StaffSoftwareLayoutAlertsAlertsIndexRoute:
      StaffSoftwareLayoutAlertsAlertsIndexRoute,
    StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute:
      StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute,
    StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute:
      StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute,
    StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute:
      StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute,
    StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute:
      StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute,
    StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute:
      StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute,
    StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute:
      StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute,
  }

const StaffSoftwareLayoutAlertsAlertsRouteWithChildren =
  StaffSoftwareLayoutAlertsAlertsRoute._addFileChildren(
    StaffSoftwareLayoutAlertsAlertsRouteChildren,
  )

interface StaffSoftwareLayoutAlertsRouteChildren {
  StaffSoftwareLayoutAlertsAlertsRoute: typeof StaffSoftwareLayoutAlertsAlertsRouteWithChildren
}

const StaffSoftwareLayoutAlertsRouteChildren: StaffSoftwareLayoutAlertsRouteChildren =
  {
    StaffSoftwareLayoutAlertsAlertsRoute:
      StaffSoftwareLayoutAlertsAlertsRouteWithChildren,
  }

const StaffSoftwareLayoutAlertsRouteWithChildren =
  StaffSoftwareLayoutAlertsRoute._addFileChildren(
    StaffSoftwareLayoutAlertsRouteChildren,
  )

interface StaffSoftwareLayoutRouteChildren {
  StaffSoftwareLayoutPeopleRouteRoute: typeof StaffSoftwareLayoutPeopleRouteRouteWithChildren
  StaffSoftwareLayoutIntegrationsRoute: typeof StaffSoftwareLayoutIntegrationsRoute
  StaffSoftwareLayoutIndexRouteLazyRoute: typeof StaffSoftwareLayoutIndexRouteLazyRoute
  StaffSoftwareLayoutMarketplaceIdRouteRoute: typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  StaffSoftwareLayoutAlertsRoute: typeof StaffSoftwareLayoutAlertsRouteWithChildren
  StaffSoftwareLayoutContractAndCostIndexRoute: typeof StaffSoftwareLayoutContractAndCostIndexRoute
  StaffSoftwareLayoutMarketplaceIndexRoute: typeof StaffSoftwareLayoutMarketplaceIndexRoute
  StaffSoftwareLayoutOperationActivityIndexRoute: typeof StaffSoftwareLayoutOperationActivityIndexRoute
  StaffSoftwareLayoutRegistryIndexRoute: typeof StaffSoftwareLayoutRegistryIndexRoute
  StaffSoftwareLayoutRuleAndPolicyIndexRoute: typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  StaffSoftwareLayoutSettingsIndexRoute: typeof StaffSoftwareLayoutSettingsIndexRoute
}

const StaffSoftwareLayoutRouteChildren: StaffSoftwareLayoutRouteChildren = {
  StaffSoftwareLayoutPeopleRouteRoute:
    StaffSoftwareLayoutPeopleRouteRouteWithChildren,
  StaffSoftwareLayoutIntegrationsRoute: StaffSoftwareLayoutIntegrationsRoute,
  StaffSoftwareLayoutIndexRouteLazyRoute:
    StaffSoftwareLayoutIndexRouteLazyRoute,
  StaffSoftwareLayoutMarketplaceIdRouteRoute:
    StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren,
  StaffSoftwareLayoutAlertsRoute: StaffSoftwareLayoutAlertsRouteWithChildren,
  StaffSoftwareLayoutContractAndCostIndexRoute:
    StaffSoftwareLayoutContractAndCostIndexRoute,
  StaffSoftwareLayoutMarketplaceIndexRoute:
    StaffSoftwareLayoutMarketplaceIndexRoute,
  StaffSoftwareLayoutOperationActivityIndexRoute:
    StaffSoftwareLayoutOperationActivityIndexRoute,
  StaffSoftwareLayoutRegistryIndexRoute: StaffSoftwareLayoutRegistryIndexRoute,
  StaffSoftwareLayoutRuleAndPolicyIndexRoute:
    StaffSoftwareLayoutRuleAndPolicyIndexRoute,
  StaffSoftwareLayoutSettingsIndexRoute: StaffSoftwareLayoutSettingsIndexRoute,
}

const StaffSoftwareLayoutRouteWithChildren =
  StaffSoftwareLayoutRoute._addFileChildren(StaffSoftwareLayoutRouteChildren)

interface StaffSoftwareIdIdRouteChildren {
  StaffSoftwareIdIdIndexRoute: typeof StaffSoftwareIdIdIndexRoute
  StaffSoftwareIdIdActivityMonitoringIndexRoute: typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  StaffSoftwareIdIdArchitectureIndexRoute: typeof StaffSoftwareIdIdArchitectureIndexRoute
  StaffSoftwareIdIdContractsCostIndexRoute: typeof StaffSoftwareIdIdContractsCostIndexRoute
  StaffSoftwareIdIdDetailIndexRoute: typeof StaffSoftwareIdIdDetailIndexRoute
  StaffSoftwareIdIdRuleAndPolicyIndexRoute: typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
  StaffSoftwareIdIdSettingsIndexRoute: typeof StaffSoftwareIdIdSettingsIndexRoute
  StaffSoftwareIdIdUsersIndexRoute: typeof StaffSoftwareIdIdUsersIndexRoute
}

const StaffSoftwareIdIdRouteChildren: StaffSoftwareIdIdRouteChildren = {
  StaffSoftwareIdIdIndexRoute: StaffSoftwareIdIdIndexRoute,
  StaffSoftwareIdIdActivityMonitoringIndexRoute:
    StaffSoftwareIdIdActivityMonitoringIndexRoute,
  StaffSoftwareIdIdArchitectureIndexRoute:
    StaffSoftwareIdIdArchitectureIndexRoute,
  StaffSoftwareIdIdContractsCostIndexRoute:
    StaffSoftwareIdIdContractsCostIndexRoute,
  StaffSoftwareIdIdDetailIndexRoute: StaffSoftwareIdIdDetailIndexRoute,
  StaffSoftwareIdIdRuleAndPolicyIndexRoute:
    StaffSoftwareIdIdRuleAndPolicyIndexRoute,
  StaffSoftwareIdIdSettingsIndexRoute: StaffSoftwareIdIdSettingsIndexRoute,
  StaffSoftwareIdIdUsersIndexRoute: StaffSoftwareIdIdUsersIndexRoute,
}

const StaffSoftwareIdIdRouteWithChildren =
  StaffSoftwareIdIdRoute._addFileChildren(StaffSoftwareIdIdRouteChildren)

interface StaffSoftwareIdRouteChildren {
  StaffSoftwareIdIdRoute: typeof StaffSoftwareIdIdRouteWithChildren
}

const StaffSoftwareIdRouteChildren: StaffSoftwareIdRouteChildren = {
  StaffSoftwareIdIdRoute: StaffSoftwareIdIdRouteWithChildren,
}

const StaffSoftwareIdRouteWithChildren = StaffSoftwareIdRoute._addFileChildren(
  StaffSoftwareIdRouteChildren,
)

interface StaffSoftwareRouteChildren {
  StaffSoftwareLayoutRoute: typeof StaffSoftwareLayoutRouteWithChildren
  StaffSoftwareIdImportCsvRouteRoute: typeof StaffSoftwareIdImportCsvRouteRoute
  StaffSoftwareIdRoute: typeof StaffSoftwareIdRouteWithChildren
  StaffSoftwareAddIndexRoute: typeof StaffSoftwareAddIndexRoute
  StaffSoftwareAddTypeIndexRoute: typeof StaffSoftwareAddTypeIndexRoute
  StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute: typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
}

const StaffSoftwareRouteChildren: StaffSoftwareRouteChildren = {
  StaffSoftwareLayoutRoute: StaffSoftwareLayoutRouteWithChildren,
  StaffSoftwareIdImportCsvRouteRoute: StaffSoftwareIdImportCsvRouteRoute,
  StaffSoftwareIdRoute: StaffSoftwareIdRouteWithChildren,
  StaffSoftwareAddIndexRoute: StaffSoftwareAddIndexRoute,
  StaffSoftwareAddTypeIndexRoute: StaffSoftwareAddTypeIndexRoute,
  StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute:
    StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute,
}

const StaffSoftwareRouteWithChildren = StaffSoftwareRoute._addFileChildren(
  StaffSoftwareRouteChildren,
)

interface StaffStarlinksLayoutRouteChildren {
  StaffStarlinksLayoutIndexRoute: typeof StaffStarlinksLayoutIndexRoute
  StaffStarlinksLayoutPlaceholdersBillingAndCostRoute: typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  StaffStarlinksLayoutPlaceholdersMarketplaceRoute: typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  StaffStarlinksLayoutPlaceholdersOperationActivityRoute: typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  StaffStarlinksLayoutAlertsIndexRoute: typeof StaffStarlinksLayoutAlertsIndexRoute
  StaffStarlinksLayoutUserTerminalsIndexRoute: typeof StaffStarlinksLayoutUserTerminalsIndexRoute
}

const StaffStarlinksLayoutRouteChildren: StaffStarlinksLayoutRouteChildren = {
  StaffStarlinksLayoutIndexRoute: StaffStarlinksLayoutIndexRoute,
  StaffStarlinksLayoutPlaceholdersBillingAndCostRoute:
    StaffStarlinksLayoutPlaceholdersBillingAndCostRoute,
  StaffStarlinksLayoutPlaceholdersMarketplaceRoute:
    StaffStarlinksLayoutPlaceholdersMarketplaceRoute,
  StaffStarlinksLayoutPlaceholdersOperationActivityRoute:
    StaffStarlinksLayoutPlaceholdersOperationActivityRoute,
  StaffStarlinksLayoutAlertsIndexRoute: StaffStarlinksLayoutAlertsIndexRoute,
  StaffStarlinksLayoutUserTerminalsIndexRoute:
    StaffStarlinksLayoutUserTerminalsIndexRoute,
}

const StaffStarlinksLayoutRouteWithChildren =
  StaffStarlinksLayoutRoute._addFileChildren(StaffStarlinksLayoutRouteChildren)

interface StaffStarlinksIdLayoutRouteChildren {
  StaffStarlinksIdLayoutOverviewIndexLazyRoute: typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  StaffStarlinksIdLayoutDetailIndexLazyRoute: typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
}

const StaffStarlinksIdLayoutRouteChildren: StaffStarlinksIdLayoutRouteChildren =
  {
    StaffStarlinksIdLayoutOverviewIndexLazyRoute:
      StaffStarlinksIdLayoutOverviewIndexLazyRoute,
    StaffStarlinksIdLayoutDetailIndexLazyRoute:
      StaffStarlinksIdLayoutDetailIndexLazyRoute,
  }

const StaffStarlinksIdLayoutRouteWithChildren =
  StaffStarlinksIdLayoutRoute._addFileChildren(
    StaffStarlinksIdLayoutRouteChildren,
  )

interface StaffStarlinksIdRouteChildren {
  StaffStarlinksIdLayoutRoute: typeof StaffStarlinksIdLayoutRouteWithChildren
}

const StaffStarlinksIdRouteChildren: StaffStarlinksIdRouteChildren = {
  StaffStarlinksIdLayoutRoute: StaffStarlinksIdLayoutRouteWithChildren,
}

const StaffStarlinksIdRouteWithChildren =
  StaffStarlinksIdRoute._addFileChildren(StaffStarlinksIdRouteChildren)

interface StaffStarlinksRouteChildren {
  StaffStarlinksLayoutRoute: typeof StaffStarlinksLayoutRouteWithChildren
  StaffStarlinksIdRoute: typeof StaffStarlinksIdRouteWithChildren
}

const StaffStarlinksRouteChildren: StaffStarlinksRouteChildren = {
  StaffStarlinksLayoutRoute: StaffStarlinksLayoutRouteWithChildren,
  StaffStarlinksIdRoute: StaffStarlinksIdRouteWithChildren,
}

const StaffStarlinksRouteWithChildren = StaffStarlinksRoute._addFileChildren(
  StaffStarlinksRouteChildren,
)

interface StaffStorageFilesListRouteChildren {
  StaffStorageFilesListFilesIndexRoute: typeof StaffStorageFilesListFilesIndexRoute
  StaffStorageFilesListFoldersIndexRoute: typeof StaffStorageFilesListFoldersIndexRoute
}

const StaffStorageFilesListRouteChildren: StaffStorageFilesListRouteChildren = {
  StaffStorageFilesListFilesIndexRoute: StaffStorageFilesListFilesIndexRoute,
  StaffStorageFilesListFoldersIndexRoute:
    StaffStorageFilesListFoldersIndexRoute,
}

const StaffStorageFilesListRouteWithChildren =
  StaffStorageFilesListRoute._addFileChildren(
    StaffStorageFilesListRouteChildren,
  )

interface StaffStorageFilesRouteChildren {
  StaffStorageFilesListRoute: typeof StaffStorageFilesListRouteWithChildren
}

const StaffStorageFilesRouteChildren: StaffStorageFilesRouteChildren = {
  StaffStorageFilesListRoute: StaffStorageFilesListRouteWithChildren,
}

const StaffStorageFilesRouteWithChildren =
  StaffStorageFilesRoute._addFileChildren(StaffStorageFilesRouteChildren)

interface StaffTimeAndAttendanceLayoutRouteChildren {
  StaffTimeAndAttendanceLayoutIndexRoute: typeof StaffTimeAndAttendanceLayoutIndexRoute
  StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute: typeof StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute
  StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute: typeof StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute
  StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute: typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute: typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
}

const StaffTimeAndAttendanceLayoutRouteChildren: StaffTimeAndAttendanceLayoutRouteChildren =
  {
    StaffTimeAndAttendanceLayoutIndexRoute:
      StaffTimeAndAttendanceLayoutIndexRoute,
    StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute:
      StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute,
    StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute:
      StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute,
    StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute:
      StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryIndexRoute,
    StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute:
      StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute,
    StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute:
      StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute,
  }

const StaffTimeAndAttendanceLayoutRouteWithChildren =
  StaffTimeAndAttendanceLayoutRoute._addFileChildren(
    StaffTimeAndAttendanceLayoutRouteChildren,
  )

interface StaffTimeAndAttendanceRouteChildren {
  StaffTimeAndAttendanceLayoutRoute: typeof StaffTimeAndAttendanceLayoutRouteWithChildren
}

const StaffTimeAndAttendanceRouteChildren: StaffTimeAndAttendanceRouteChildren =
  {
    StaffTimeAndAttendanceLayoutRoute:
      StaffTimeAndAttendanceLayoutRouteWithChildren,
  }

const StaffTimeAndAttendanceRouteWithChildren =
  StaffTimeAndAttendanceRoute._addFileChildren(
    StaffTimeAndAttendanceRouteChildren,
  )

interface StaffAppIntegrationsIdIdRouteChildren {
  StaffAppIntegrationsIdIdGroupsRoute: typeof StaffAppIntegrationsIdIdGroupsRoute
  StaffAppIntegrationsIdIdIndexRoute: typeof StaffAppIntegrationsIdIdIndexRoute
  StaffAppIntegrationsIdIdArchitectureIndexRoute: typeof StaffAppIntegrationsIdIdArchitectureIndexRoute
  StaffAppIntegrationsIdIdDetailIndexRoute: typeof StaffAppIntegrationsIdIdDetailIndexRoute
  StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute: typeof StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute
  StaffAppIntegrationsIdIdSettingsIndexRoute: typeof StaffAppIntegrationsIdIdSettingsIndexRoute
  StaffAppIntegrationsIdIdUsersIndexRoute: typeof StaffAppIntegrationsIdIdUsersIndexRoute
}

const StaffAppIntegrationsIdIdRouteChildren: StaffAppIntegrationsIdIdRouteChildren =
  {
    StaffAppIntegrationsIdIdGroupsRoute: StaffAppIntegrationsIdIdGroupsRoute,
    StaffAppIntegrationsIdIdIndexRoute: StaffAppIntegrationsIdIdIndexRoute,
    StaffAppIntegrationsIdIdArchitectureIndexRoute:
      StaffAppIntegrationsIdIdArchitectureIndexRoute,
    StaffAppIntegrationsIdIdDetailIndexRoute:
      StaffAppIntegrationsIdIdDetailIndexRoute,
    StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute:
      StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute,
    StaffAppIntegrationsIdIdSettingsIndexRoute:
      StaffAppIntegrationsIdIdSettingsIndexRoute,
    StaffAppIntegrationsIdIdUsersIndexRoute:
      StaffAppIntegrationsIdIdUsersIndexRoute,
  }

const StaffAppIntegrationsIdIdRouteWithChildren =
  StaffAppIntegrationsIdIdRoute._addFileChildren(
    StaffAppIntegrationsIdIdRouteChildren,
  )

interface StaffAppIntegrationsIdRouteChildren {
  StaffAppIntegrationsIdIdRoute: typeof StaffAppIntegrationsIdIdRouteWithChildren
}

const StaffAppIntegrationsIdRouteChildren: StaffAppIntegrationsIdRouteChildren =
  {
    StaffAppIntegrationsIdIdRoute: StaffAppIntegrationsIdIdRouteWithChildren,
  }

const StaffAppIntegrationsIdRouteWithChildren =
  StaffAppIntegrationsIdRoute._addFileChildren(
    StaffAppIntegrationsIdRouteChildren,
  )

interface StaffPersonIdProfileRouteChildren {
  StaffPersonIdProfileIndexRouteRoute: typeof StaffPersonIdProfileIndexRouteRoute
  StaffPersonIdProfileActivityIndexRoute: typeof StaffPersonIdProfileActivityIndexRoute
  StaffPersonIdProfileAppsIndexRoute: typeof StaffPersonIdProfileAppsIndexRoute
  StaffPersonIdProfileDevicesIndexRoute: typeof StaffPersonIdProfileDevicesIndexRoute
  StaffPersonIdProfileEducationAndQualificationIndexRoute: typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  StaffPersonIdProfileEmployeeInformationIndexRoute: typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  StaffPersonIdProfileEquipmentIndexRoute: typeof StaffPersonIdProfileEquipmentIndexRoute
  StaffPersonIdProfileHistoryIndexRoute: typeof StaffPersonIdProfileHistoryIndexRoute
  StaffPersonIdProfilePersonalInformationIndexRoute: typeof StaffPersonIdProfilePersonalInformationIndexRoute
  StaffPersonIdProfilePublicIdIndexRoute: typeof StaffPersonIdProfilePublicIdIndexRoute
  StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute: typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
}

const StaffPersonIdProfileRouteChildren: StaffPersonIdProfileRouteChildren = {
  StaffPersonIdProfileIndexRouteRoute: StaffPersonIdProfileIndexRouteRoute,
  StaffPersonIdProfileActivityIndexRoute:
    StaffPersonIdProfileActivityIndexRoute,
  StaffPersonIdProfileAppsIndexRoute: StaffPersonIdProfileAppsIndexRoute,
  StaffPersonIdProfileDevicesIndexRoute: StaffPersonIdProfileDevicesIndexRoute,
  StaffPersonIdProfileEducationAndQualificationIndexRoute:
    StaffPersonIdProfileEducationAndQualificationIndexRoute,
  StaffPersonIdProfileEmployeeInformationIndexRoute:
    StaffPersonIdProfileEmployeeInformationIndexRoute,
  StaffPersonIdProfileEquipmentIndexRoute:
    StaffPersonIdProfileEquipmentIndexRoute,
  StaffPersonIdProfileHistoryIndexRoute: StaffPersonIdProfileHistoryIndexRoute,
  StaffPersonIdProfilePersonalInformationIndexRoute:
    StaffPersonIdProfilePersonalInformationIndexRoute,
  StaffPersonIdProfilePublicIdIndexRoute:
    StaffPersonIdProfilePublicIdIndexRoute,
  StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute:
    StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute,
}

const StaffPersonIdProfileRouteWithChildren =
  StaffPersonIdProfileRoute._addFileChildren(StaffPersonIdProfileRouteChildren)

interface StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren {
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
}

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren: StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren =
  {
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute:
      StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute,
  }

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute._addFileChildren(
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteChildren,
  )

interface StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren {
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
}

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren: StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren =
  {
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRoute:
      StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren,
  }

const StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren =
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute._addFileChildren(
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteChildren,
  )

interface StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren {
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
}

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren: StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren =
  {
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute:
      StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute,
  }

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute._addFileChildren(
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteChildren,
  )

interface StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren {
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
}

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren: StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren =
  {
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRoute:
      StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren,
  }

const StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren =
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute._addFileChildren(
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteChildren,
  )

interface StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren {
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
}

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren: StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren =
  {
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute:
      StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute,
  }

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute._addFileChildren(
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteChildren,
  )

interface StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren {
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
}

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren: StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren =
  {
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRoute:
      StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren,
  }

const StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren =
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute._addFileChildren(
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteChildren,
  )

interface StaffPersonIdRouteChildren {
  StaffPersonIdProfileRoute: typeof StaffPersonIdProfileRouteWithChildren
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute: typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute: typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute: typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren
}

const StaffPersonIdRouteChildren: StaffPersonIdRouteChildren = {
  StaffPersonIdProfileRoute: StaffPersonIdProfileRouteWithChildren,
  StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRoute:
    StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren,
  StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRoute:
    StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren,
  StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRoute:
    StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren,
}

const StaffPersonIdRouteWithChildren = StaffPersonIdRoute._addFileChildren(
  StaffPersonIdRouteChildren,
)

interface StaffSettingsContractingCorporationProfileLayoutRouteChildren {
  StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute: typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
}

const StaffSettingsContractingCorporationProfileLayoutRouteChildren: StaffSettingsContractingCorporationProfileLayoutRouteChildren =
  {
    StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute,
    StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute:
      StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute,
  }

const StaffSettingsContractingCorporationProfileLayoutRouteWithChildren =
  StaffSettingsContractingCorporationProfileLayoutRoute._addFileChildren(
    StaffSettingsContractingCorporationProfileLayoutRouteChildren,
  )

interface StaffSettingsContractingCorporationProfileRouteChildren {
  StaffSettingsContractingCorporationProfileLayoutRoute: typeof StaffSettingsContractingCorporationProfileLayoutRouteWithChildren
  StaffSettingsContractingCorporationProfileIndexRoute: typeof StaffSettingsContractingCorporationProfileIndexRoute
}

const StaffSettingsContractingCorporationProfileRouteChildren: StaffSettingsContractingCorporationProfileRouteChildren =
  {
    StaffSettingsContractingCorporationProfileLayoutRoute:
      StaffSettingsContractingCorporationProfileLayoutRouteWithChildren,
    StaffSettingsContractingCorporationProfileIndexRoute:
      StaffSettingsContractingCorporationProfileIndexRoute,
  }

const StaffSettingsContractingCorporationProfileRouteWithChildren =
  StaffSettingsContractingCorporationProfileRoute._addFileChildren(
    StaffSettingsContractingCorporationProfileRouteChildren,
  )

interface StaffSettingsPermissionAndRolesDetailRouteChildren {
  StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute: typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute: typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute: typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
}

const StaffSettingsPermissionAndRolesDetailRouteChildren: StaffSettingsPermissionAndRolesDetailRouteChildren =
  {
    StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute:
      StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute,
    StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute:
      StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute,
    StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute:
      StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute,
  }

const StaffSettingsPermissionAndRolesDetailRouteWithChildren =
  StaffSettingsPermissionAndRolesDetailRoute._addFileChildren(
    StaffSettingsPermissionAndRolesDetailRouteChildren,
  )

interface StaffSettingsPermissionAndRolesFormRouteChildren {
  StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  StaffSettingsPermissionAndRolesFormRolesNewIndexRoute: typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute: typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute: typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute: typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
}

const StaffSettingsPermissionAndRolesFormRouteChildren: StaffSettingsPermissionAndRolesFormRouteChildren =
  {
    StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute:
      StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute,
    StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute:
      StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute,
    StaffSettingsPermissionAndRolesFormRolesNewIndexRoute:
      StaffSettingsPermissionAndRolesFormRolesNewIndexRoute,
    StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute:
      StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute,
    StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute:
      StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute,
    StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute:
      StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute,
  }

const StaffSettingsPermissionAndRolesFormRouteWithChildren =
  StaffSettingsPermissionAndRolesFormRoute._addFileChildren(
    StaffSettingsPermissionAndRolesFormRouteChildren,
  )

interface StaffSettingsPermissionAndRolesListRouteChildren {
  StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute: typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute: typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  StaffSettingsPermissionAndRolesListRolesIndexRoute: typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
}

const StaffSettingsPermissionAndRolesListRouteChildren: StaffSettingsPermissionAndRolesListRouteChildren =
  {
    StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute:
      StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute,
    StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute:
      StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute,
    StaffSettingsPermissionAndRolesListRolesIndexRoute:
      StaffSettingsPermissionAndRolesListRolesIndexRoute,
  }

const StaffSettingsPermissionAndRolesListRouteWithChildren =
  StaffSettingsPermissionAndRolesListRoute._addFileChildren(
    StaffSettingsPermissionAndRolesListRouteChildren,
  )

interface StaffSettingsPermissionAndRolesRouteChildren {
  StaffSettingsPermissionAndRolesDetailRoute: typeof StaffSettingsPermissionAndRolesDetailRouteWithChildren
  StaffSettingsPermissionAndRolesFormRoute: typeof StaffSettingsPermissionAndRolesFormRouteWithChildren
  StaffSettingsPermissionAndRolesListRoute: typeof StaffSettingsPermissionAndRolesListRouteWithChildren
  StaffSettingsPermissionAndRolesIndexRoute: typeof StaffSettingsPermissionAndRolesIndexRoute
}

const StaffSettingsPermissionAndRolesRouteChildren: StaffSettingsPermissionAndRolesRouteChildren =
  {
    StaffSettingsPermissionAndRolesDetailRoute:
      StaffSettingsPermissionAndRolesDetailRouteWithChildren,
    StaffSettingsPermissionAndRolesFormRoute:
      StaffSettingsPermissionAndRolesFormRouteWithChildren,
    StaffSettingsPermissionAndRolesListRoute:
      StaffSettingsPermissionAndRolesListRouteWithChildren,
    StaffSettingsPermissionAndRolesIndexRoute:
      StaffSettingsPermissionAndRolesIndexRoute,
  }

const StaffSettingsPermissionAndRolesRouteWithChildren =
  StaffSettingsPermissionAndRolesRoute._addFileChildren(
    StaffSettingsPermissionAndRolesRouteChildren,
  )

interface StaffSettingsPersonsListAccountRouteChildren {
  StaffSettingsPersonsListAccountIndividualIndexRoute: typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  StaffSettingsPersonsListAccountStaffIndexRoute: typeof StaffSettingsPersonsListAccountStaffIndexRoute
}

const StaffSettingsPersonsListAccountRouteChildren: StaffSettingsPersonsListAccountRouteChildren =
  {
    StaffSettingsPersonsListAccountIndividualIndexRoute:
      StaffSettingsPersonsListAccountIndividualIndexRoute,
    StaffSettingsPersonsListAccountStaffIndexRoute:
      StaffSettingsPersonsListAccountStaffIndexRoute,
  }

const StaffSettingsPersonsListAccountRouteWithChildren =
  StaffSettingsPersonsListAccountRoute._addFileChildren(
    StaffSettingsPersonsListAccountRouteChildren,
  )

interface StaffSettingsPersonsListRouteChildren {
  StaffSettingsPersonsListAccountRoute: typeof StaffSettingsPersonsListAccountRouteWithChildren
  StaffSettingsPersonsListSettingsIndexRoute: typeof StaffSettingsPersonsListSettingsIndexRoute
}

const StaffSettingsPersonsListRouteChildren: StaffSettingsPersonsListRouteChildren =
  {
    StaffSettingsPersonsListAccountRoute:
      StaffSettingsPersonsListAccountRouteWithChildren,
    StaffSettingsPersonsListSettingsIndexRoute:
      StaffSettingsPersonsListSettingsIndexRoute,
  }

const StaffSettingsPersonsListRouteWithChildren =
  StaffSettingsPersonsListRoute._addFileChildren(
    StaffSettingsPersonsListRouteChildren,
  )

interface StaffSettingsPersonsRouteChildren {
  StaffSettingsPersonsListRoute: typeof StaffSettingsPersonsListRouteWithChildren
  StaffSettingsPersonsIndexRoute: typeof StaffSettingsPersonsIndexRoute
}

const StaffSettingsPersonsRouteChildren: StaffSettingsPersonsRouteChildren = {
  StaffSettingsPersonsListRoute: StaffSettingsPersonsListRouteWithChildren,
  StaffSettingsPersonsIndexRoute: StaffSettingsPersonsIndexRoute,
}

const StaffSettingsPersonsRouteWithChildren =
  StaffSettingsPersonsRoute._addFileChildren(StaffSettingsPersonsRouteChildren)

interface StaffDeviceCatalogActiveIdLayoutRouteChildren {
  StaffDeviceCatalogActiveIdLayoutProfileIndexRoute: typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
}

const StaffDeviceCatalogActiveIdLayoutRouteChildren: StaffDeviceCatalogActiveIdLayoutRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutProfileIndexRoute:
      StaffDeviceCatalogActiveIdLayoutProfileIndexRoute,
  }

const StaffDeviceCatalogActiveIdLayoutRouteWithChildren =
  StaffDeviceCatalogActiveIdLayoutRoute._addFileChildren(
    StaffDeviceCatalogActiveIdLayoutRouteChildren,
  )

interface StaffDeviceCatalogActiveIdRouteChildren {
  StaffDeviceCatalogActiveIdLayoutRoute: typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
}

const StaffDeviceCatalogActiveIdRouteChildren: StaffDeviceCatalogActiveIdRouteChildren =
  {
    StaffDeviceCatalogActiveIdLayoutRoute:
      StaffDeviceCatalogActiveIdLayoutRouteWithChildren,
  }

const StaffDeviceCatalogActiveIdRouteWithChildren =
  StaffDeviceCatalogActiveIdRoute._addFileChildren(
    StaffDeviceCatalogActiveIdRouteChildren,
  )

interface StaffDeviceCatalogDraftIdLayoutRouteChildren {
  StaffDeviceCatalogDraftIdLayoutProfileIndexRoute: typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
}

const StaffDeviceCatalogDraftIdLayoutRouteChildren: StaffDeviceCatalogDraftIdLayoutRouteChildren =
  {
    StaffDeviceCatalogDraftIdLayoutProfileIndexRoute:
      StaffDeviceCatalogDraftIdLayoutProfileIndexRoute,
  }

const StaffDeviceCatalogDraftIdLayoutRouteWithChildren =
  StaffDeviceCatalogDraftIdLayoutRoute._addFileChildren(
    StaffDeviceCatalogDraftIdLayoutRouteChildren,
  )

interface StaffDeviceCatalogDraftIdRouteChildren {
  StaffDeviceCatalogDraftIdLayoutRoute: typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
}

const StaffDeviceCatalogDraftIdRouteChildren: StaffDeviceCatalogDraftIdRouteChildren =
  {
    StaffDeviceCatalogDraftIdLayoutRoute:
      StaffDeviceCatalogDraftIdLayoutRouteWithChildren,
  }

const StaffDeviceCatalogDraftIdRouteWithChildren =
  StaffDeviceCatalogDraftIdRoute._addFileChildren(
    StaffDeviceCatalogDraftIdRouteChildren,
  )

interface StaffPersonAlumniIdProfileRouteChildren {
  StaffPersonAlumniIdProfileIndexRouteRoute: typeof StaffPersonAlumniIdProfileIndexRouteRoute
  StaffPersonAlumniIdProfileActivityIndexRoute: typeof StaffPersonAlumniIdProfileActivityIndexRoute
  StaffPersonAlumniIdProfileAppsIndexRoute: typeof StaffPersonAlumniIdProfileAppsIndexRoute
  StaffPersonAlumniIdProfileDevicesIndexRoute: typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute: typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  StaffPersonAlumniIdProfileEmployeeInformationIndexRoute: typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  StaffPersonAlumniIdProfileEquipmentIndexRoute: typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  StaffPersonAlumniIdProfileHistoryIndexRoute: typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  StaffPersonAlumniIdProfilePersonalInformationIndexRoute: typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  StaffPersonAlumniIdProfilePublicIdIndexRoute: typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
}

const StaffPersonAlumniIdProfileRouteChildren: StaffPersonAlumniIdProfileRouteChildren =
  {
    StaffPersonAlumniIdProfileIndexRouteRoute:
      StaffPersonAlumniIdProfileIndexRouteRoute,
    StaffPersonAlumniIdProfileActivityIndexRoute:
      StaffPersonAlumniIdProfileActivityIndexRoute,
    StaffPersonAlumniIdProfileAppsIndexRoute:
      StaffPersonAlumniIdProfileAppsIndexRoute,
    StaffPersonAlumniIdProfileDevicesIndexRoute:
      StaffPersonAlumniIdProfileDevicesIndexRoute,
    StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute:
      StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute,
    StaffPersonAlumniIdProfileEmployeeInformationIndexRoute:
      StaffPersonAlumniIdProfileEmployeeInformationIndexRoute,
    StaffPersonAlumniIdProfileEquipmentIndexRoute:
      StaffPersonAlumniIdProfileEquipmentIndexRoute,
    StaffPersonAlumniIdProfileHistoryIndexRoute:
      StaffPersonAlumniIdProfileHistoryIndexRoute,
    StaffPersonAlumniIdProfilePersonalInformationIndexRoute:
      StaffPersonAlumniIdProfilePersonalInformationIndexRoute,
    StaffPersonAlumniIdProfilePublicIdIndexRoute:
      StaffPersonAlumniIdProfilePublicIdIndexRoute,
  }

const StaffPersonAlumniIdProfileRouteWithChildren =
  StaffPersonAlumniIdProfileRoute._addFileChildren(
    StaffPersonAlumniIdProfileRouteChildren,
  )

interface StaffPersonAlumniIdRouteChildren {
  StaffPersonAlumniIdProfileRoute: typeof StaffPersonAlumniIdProfileRouteWithChildren
}

const StaffPersonAlumniIdRouteChildren: StaffPersonAlumniIdRouteChildren = {
  StaffPersonAlumniIdProfileRoute: StaffPersonAlumniIdProfileRouteWithChildren,
}

const StaffPersonAlumniIdRouteWithChildren =
  StaffPersonAlumniIdRoute._addFileChildren(StaffPersonAlumniIdRouteChildren)

interface StaffProfileDeviceIdProfileRouteChildren {
  StaffProfileDeviceIdProfileFilesRouteRoute: typeof StaffProfileDeviceIdProfileFilesRouteRoute
  StaffProfileDeviceIdProfileConfigurationRoute: typeof StaffProfileDeviceIdProfileConfigurationRoute
  StaffProfileDeviceIdProfileMonitoringRoute: typeof StaffProfileDeviceIdProfileMonitoringRoute
  StaffProfileDeviceIdProfileIndexRouteLazyRoute: typeof StaffProfileDeviceIdProfileIndexRouteLazyRoute
  StaffProfileDeviceIdProfileControlRouteLazyRoute: typeof StaffProfileDeviceIdProfileControlRouteLazyRoute
  StaffProfileDeviceIdProfileMdmRouteLazyRoute: typeof StaffProfileDeviceIdProfileMdmRouteLazyRoute
  StaffProfileDeviceIdProfileStatusRouteLazyRoute: typeof StaffProfileDeviceIdProfileStatusRouteLazyRoute
  StaffProfileDeviceIdProfileHistoryIndexRoute: typeof StaffProfileDeviceIdProfileHistoryIndexRoute
  StaffProfileDeviceIdProfileLifecycleIndexRoute: typeof StaffProfileDeviceIdProfileLifecycleIndexRoute
}

const StaffProfileDeviceIdProfileRouteChildren: StaffProfileDeviceIdProfileRouteChildren =
  {
    StaffProfileDeviceIdProfileFilesRouteRoute:
      StaffProfileDeviceIdProfileFilesRouteRoute,
    StaffProfileDeviceIdProfileConfigurationRoute:
      StaffProfileDeviceIdProfileConfigurationRoute,
    StaffProfileDeviceIdProfileMonitoringRoute:
      StaffProfileDeviceIdProfileMonitoringRoute,
    StaffProfileDeviceIdProfileIndexRouteLazyRoute:
      StaffProfileDeviceIdProfileIndexRouteLazyRoute,
    StaffProfileDeviceIdProfileControlRouteLazyRoute:
      StaffProfileDeviceIdProfileControlRouteLazyRoute,
    StaffProfileDeviceIdProfileMdmRouteLazyRoute:
      StaffProfileDeviceIdProfileMdmRouteLazyRoute,
    StaffProfileDeviceIdProfileStatusRouteLazyRoute:
      StaffProfileDeviceIdProfileStatusRouteLazyRoute,
    StaffProfileDeviceIdProfileHistoryIndexRoute:
      StaffProfileDeviceIdProfileHistoryIndexRoute,
    StaffProfileDeviceIdProfileLifecycleIndexRoute:
      StaffProfileDeviceIdProfileLifecycleIndexRoute,
  }

const StaffProfileDeviceIdProfileRouteWithChildren =
  StaffProfileDeviceIdProfileRoute._addFileChildren(
    StaffProfileDeviceIdProfileRouteChildren,
  )

interface StaffProfileDeviceIdRouteChildren {
  StaffProfileDeviceIdProfileRoute: typeof StaffProfileDeviceIdProfileRouteWithChildren
}

const StaffProfileDeviceIdRouteChildren: StaffProfileDeviceIdRouteChildren = {
  StaffProfileDeviceIdProfileRoute:
    StaffProfileDeviceIdProfileRouteWithChildren,
}

const StaffProfileDeviceIdRouteWithChildren =
  StaffProfileDeviceIdRoute._addFileChildren(StaffProfileDeviceIdRouteChildren)

interface StaffRouteChildren {
  StaffAppsRoute: typeof StaffAppsRouteWithChildren
  StaffIdManagementsRoute: typeof StaffIdManagementsRouteWithChildren
  StaffItOperationCoreDeviceInventoryRouteRoute: typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  StaffPlacesImportCsvRouteRoute: typeof StaffPlacesImportCsvRouteRoute
  StaffAccessesRoute: typeof StaffAccessesRouteWithChildren
  StaffBusinessOperationEventsRoute: typeof StaffBusinessOperationEventsRouteWithChildren
  StaffBusinessPartnerRoute: typeof StaffBusinessPartnerRouteWithChildren
  StaffCertificationRoute: typeof StaffCertificationRouteWithChildren
  StaffContractRoute: typeof StaffContractRouteWithChildren
  StaffContractorCoreRoute: typeof StaffContractorCoreRouteWithChildren
  StaffDevicesRoute: typeof StaffDevicesRouteWithChildren
  StaffEquipmentRoute: typeof StaffEquipmentRouteWithChildren
  StaffFleetsRoute: typeof StaffFleetsRouteWithChildren
  StaffGaOperationCoreRoute: typeof StaffGaOperationCoreRouteWithChildren
  StaffIdsRoute: typeof StaffIdsRouteWithChildren
  StaffItOperationCoreRoute: typeof StaffItOperationCoreRouteWithChildren
  StaffLaborCoreRoute: typeof StaffLaborCoreRouteWithChildren
  StaffLicensesRoute: typeof StaffLicensesRouteWithChildren
  StaffMarketplaceRoute: typeof StaffMarketplaceRouteWithChildren
  StaffNetworksRoute: typeof StaffNetworksRouteWithChildren
  StaffOrganizationRoute: typeof StaffOrganizationRouteWithChildren
  StaffPeopleRoute: typeof StaffPeopleRouteWithChildren
  StaffPlacesRoute: typeof StaffPlacesRouteWithChildren
  StaffPublicIdsIdRoute: typeof StaffPublicIdsIdRouteWithChildren
  StaffPublicIdsRoute: typeof StaffPublicIdsRouteWithChildren
  StaffSoftwareRoute: typeof StaffSoftwareRouteWithChildren
  StaffStarlinksRoute: typeof StaffStarlinksRouteWithChildren
  StaffStorageFilesRoute: typeof StaffStorageFilesRouteWithChildren
  StaffTimeAndAttendanceRoute: typeof StaffTimeAndAttendanceRouteWithChildren
  StaffCockpitIndexRoute: typeof StaffCockpitIndexRoute
  StaffSettingsIndexRoute: typeof StaffSettingsIndexRoute
  StaffAppIntegrationsImportCsvIdRouteRoute: typeof StaffAppIntegrationsImportCsvIdRouteRoute
  StaffPersonImportCsvWorkerTypeRouteRoute: typeof StaffPersonImportCsvWorkerTypeRouteRoute
  StaffAppIntegrationsIdRoute: typeof StaffAppIntegrationsIdRouteWithChildren
  StaffPersonIdRoute: typeof StaffPersonIdRouteWithChildren
  StaffSettingsContractingCorporationProfileRoute: typeof StaffSettingsContractingCorporationProfileRouteWithChildren
  StaffSettingsPermissionAndRolesRoute: typeof StaffSettingsPermissionAndRolesRouteWithChildren
  StaffSettingsPersonsRoute: typeof StaffSettingsPersonsRouteWithChildren
  StaffCockpitIdIndexRoute: typeof StaffCockpitIdIndexRoute
  StaffDeviceCatalogAddIndexRoute: typeof StaffDeviceCatalogAddIndexRoute
  StaffPersonAddPersonCertificationIndexRoute: typeof StaffPersonAddPersonCertificationIndexRoute
  StaffPersonAddIndexRoute: typeof StaffPersonAddIndexRoute
  StaffPersonExternalHrSaasIndexRoute: typeof StaffPersonExternalHrSaasIndexRoute
  StaffDeviceCatalogActiveIdRoute: typeof StaffDeviceCatalogActiveIdRouteWithChildren
  StaffDeviceCatalogAddDeviceTypeCompletedRoute: typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  StaffDeviceCatalogDraftIdRoute: typeof StaffDeviceCatalogDraftIdRouteWithChildren
  StaffPersonAddPersonCertificationCertificationKindCompletedRoute: typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  StaffPersonAddWorkerTypeCompletedRoute: typeof StaffPersonAddWorkerTypeCompletedRoute
  StaffPersonAlumniIdRoute: typeof StaffPersonAlumniIdRouteWithChildren
  StaffProfileDeviceIdRoute: typeof StaffProfileDeviceIdRouteWithChildren
  StaffDeviceCatalogAddDeviceTypeIndexRoute: typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  StaffPersonAddPersonCertificationCertificationKindIndexRoute: typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  StaffPersonAddWorkerTypeIndexRoute: typeof StaffPersonAddWorkerTypeIndexRoute
  StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute: typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
}

const StaffRouteChildren: StaffRouteChildren = {
  StaffAppsRoute: StaffAppsRouteWithChildren,
  StaffIdManagementsRoute: StaffIdManagementsRouteWithChildren,
  StaffItOperationCoreDeviceInventoryRouteRoute:
    StaffItOperationCoreDeviceInventoryRouteRouteWithChildren,
  StaffPlacesImportCsvRouteRoute: StaffPlacesImportCsvRouteRoute,
  StaffAccessesRoute: StaffAccessesRouteWithChildren,
  StaffBusinessOperationEventsRoute:
    StaffBusinessOperationEventsRouteWithChildren,
  StaffBusinessPartnerRoute: StaffBusinessPartnerRouteWithChildren,
  StaffCertificationRoute: StaffCertificationRouteWithChildren,
  StaffContractRoute: StaffContractRouteWithChildren,
  StaffContractorCoreRoute: StaffContractorCoreRouteWithChildren,
  StaffDevicesRoute: StaffDevicesRouteWithChildren,
  StaffEquipmentRoute: StaffEquipmentRouteWithChildren,
  StaffFleetsRoute: StaffFleetsRouteWithChildren,
  StaffGaOperationCoreRoute: StaffGaOperationCoreRouteWithChildren,
  StaffIdsRoute: StaffIdsRouteWithChildren,
  StaffItOperationCoreRoute: StaffItOperationCoreRouteWithChildren,
  StaffLaborCoreRoute: StaffLaborCoreRouteWithChildren,
  StaffLicensesRoute: StaffLicensesRouteWithChildren,
  StaffMarketplaceRoute: StaffMarketplaceRouteWithChildren,
  StaffNetworksRoute: StaffNetworksRouteWithChildren,
  StaffOrganizationRoute: StaffOrganizationRouteWithChildren,
  StaffPeopleRoute: StaffPeopleRouteWithChildren,
  StaffPlacesRoute: StaffPlacesRouteWithChildren,
  StaffPublicIdsIdRoute: StaffPublicIdsIdRouteWithChildren,
  StaffPublicIdsRoute: StaffPublicIdsRouteWithChildren,
  StaffSoftwareRoute: StaffSoftwareRouteWithChildren,
  StaffStarlinksRoute: StaffStarlinksRouteWithChildren,
  StaffStorageFilesRoute: StaffStorageFilesRouteWithChildren,
  StaffTimeAndAttendanceRoute: StaffTimeAndAttendanceRouteWithChildren,
  StaffCockpitIndexRoute: StaffCockpitIndexRoute,
  StaffSettingsIndexRoute: StaffSettingsIndexRoute,
  StaffAppIntegrationsImportCsvIdRouteRoute:
    StaffAppIntegrationsImportCsvIdRouteRoute,
  StaffPersonImportCsvWorkerTypeRouteRoute:
    StaffPersonImportCsvWorkerTypeRouteRoute,
  StaffAppIntegrationsIdRoute: StaffAppIntegrationsIdRouteWithChildren,
  StaffPersonIdRoute: StaffPersonIdRouteWithChildren,
  StaffSettingsContractingCorporationProfileRoute:
    StaffSettingsContractingCorporationProfileRouteWithChildren,
  StaffSettingsPermissionAndRolesRoute:
    StaffSettingsPermissionAndRolesRouteWithChildren,
  StaffSettingsPersonsRoute: StaffSettingsPersonsRouteWithChildren,
  StaffCockpitIdIndexRoute: StaffCockpitIdIndexRoute,
  StaffDeviceCatalogAddIndexRoute: StaffDeviceCatalogAddIndexRoute,
  StaffPersonAddPersonCertificationIndexRoute:
    StaffPersonAddPersonCertificationIndexRoute,
  StaffPersonAddIndexRoute: StaffPersonAddIndexRoute,
  StaffPersonExternalHrSaasIndexRoute: StaffPersonExternalHrSaasIndexRoute,
  StaffDeviceCatalogActiveIdRoute: StaffDeviceCatalogActiveIdRouteWithChildren,
  StaffDeviceCatalogAddDeviceTypeCompletedRoute:
    StaffDeviceCatalogAddDeviceTypeCompletedRoute,
  StaffDeviceCatalogDraftIdRoute: StaffDeviceCatalogDraftIdRouteWithChildren,
  StaffPersonAddPersonCertificationCertificationKindCompletedRoute:
    StaffPersonAddPersonCertificationCertificationKindCompletedRoute,
  StaffPersonAddWorkerTypeCompletedRoute:
    StaffPersonAddWorkerTypeCompletedRoute,
  StaffPersonAlumniIdRoute: StaffPersonAlumniIdRouteWithChildren,
  StaffProfileDeviceIdRoute: StaffProfileDeviceIdRouteWithChildren,
  StaffDeviceCatalogAddDeviceTypeIndexRoute:
    StaffDeviceCatalogAddDeviceTypeIndexRoute,
  StaffPersonAddPersonCertificationCertificationKindIndexRoute:
    StaffPersonAddPersonCertificationCertificationKindIndexRoute,
  StaffPersonAddWorkerTypeIndexRoute: StaffPersonAddWorkerTypeIndexRoute,
  StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute:
    StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute,
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof StaffRouteWithChildren
  '/apps': typeof StaffAppsListRouteWithChildren
  '/id-managements': typeof StaffIdManagementsRouteWithChildren
  '/it-operation-core/device-inventory': typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  '/places/import-csv': typeof StaffPlacesImportCsvRouteRoute
  '/accesses': typeof StaffAccessesLayoutRouteWithChildren
  '/apps/$': typeof StaffAppsSplatRoute
  '/business-operation-events': typeof StaffBusinessOperationEventsListRouteWithChildren
  '/business-partner': typeof StaffBusinessPartnerListRouteWithChildren
  '/certification': typeof StaffCertificationListRouteWithChildren
  '/contract': typeof StaffContractListRouteWithChildren
  '/contractor-core': typeof StaffContractorCorePackagesRouteWithChildren
  '/devices': typeof StaffDevicesListRouteWithChildren
  '/equipment': typeof StaffEquipmentLayoutRouteWithChildren
  '/fleets': typeof StaffFleetsLayoutRouteWithChildren
  '/ga-operation-core': typeof StaffGaOperationCorePackagesRouteWithChildren
  '/id-managements/$': typeof StaffIdManagementsSplatRoute
  '/ids': typeof StaffIdsLayoutRouteWithChildren
  '/it-operation-core': typeof StaffItOperationCoreRootRouteWithChildren
  '/labor-core': typeof StaffLaborCorePackagesRouteWithChildren
  '/labor-core/anchor-date': typeof StaffLaborCoreAnchorDateRoute
  '/labor-core/person-targets': typeof StaffLaborCorePersonTargetsRoute
  '/licenses': typeof StaffLicensesListRouteWithChildren
  '/marketplace': typeof StaffMarketplaceStoreRouteWithChildren
  '/networks': typeof StaffNetworksLayoutRouteWithChildren
  '/organization': typeof StaffOrganizationListRouteWithChildren
  '/people': typeof StaffPeopleListRouteWithChildren
  '/places': typeof StaffPlacesLayoutRouteWithChildren
  '/public-ids/$id': typeof StaffPublicIdsIdRouteWithChildren
  '/public-ids': typeof StaffPublicIdsListRouteWithChildren
  '/software': typeof StaffSoftwareLayoutRouteWithChildren
  '/starlinks': typeof StaffStarlinksLayoutRouteWithChildren
  '/storage-files': typeof StaffStorageFilesListRouteWithChildren
  '/time-and-attendance': typeof StaffTimeAndAttendanceLayoutRouteWithChildren
  '/individual': typeof IndividualIndividualIndexRoute
  '/cockpit': typeof StaffCockpitIndexRoute
  '/it-operation-core/': typeof StaffItOperationCoreIndexRoute
  '/organization/': typeof StaffOrganizationIndexRoute
  '/settings': typeof StaffSettingsIndexRoute
  '/auth/sign-in': typeof AuthSignInIndexRoute
  '/auth/password-reset': typeof AuthPasswordResetIndexLazyRoute
  '/licenses/': typeof StaffLicensesListIndexRouteRoute
  '/app-integrations/import-csv/$id': typeof StaffAppIntegrationsImportCsvIdRouteRoute
  '/devices/import-csv/$deviceType': typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  '/it-operation-core/packages': typeof StaffItOperationCoreRootPackagesRouteRouteWithChildren
  '/person/import-csv/$workerType': typeof StaffPersonImportCsvWorkerTypeRouteRoute
  '/places/settings': typeof StaffPlacesLayoutSettingsRouteRouteWithChildren
  '/public-ids/import-csv/$publicIdType': typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  '/software/$id/import-csv': typeof StaffSoftwareIdImportCsvRouteRoute
  '/software/people': typeof StaffSoftwareLayoutPeopleRouteRouteWithChildren
  '/app-integrations/$id': typeof StaffAppIntegrationsIdIdRouteWithChildren
  '/apps/contract-and-cost': typeof StaffAppsListContractAndCostRoute
  '/apps/operation-activity': typeof StaffAppsListOperationActivityRoute
  '/apps/rule-and-policy': typeof StaffAppsListRuleAndPolicyRoute
  '/business-operation-events/archive': typeof StaffBusinessOperationEventsListArchiveRoute
  '/business-operation-events/config': typeof StaffBusinessOperationEventsListConfigRoute
  '/business-operation-events/operation-activity': typeof StaffBusinessOperationEventsListOperationActivityRoute
  '/business-operation-events/overview': typeof StaffBusinessOperationEventsListOverviewRoute
  '/business-operation-events/rule-and-policy': typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  '/business-operation-events/settings': typeof StaffBusinessOperationEventsListSettingsRoute
  '/business-partner/$id': typeof StaffBusinessPartnerIdLayoutRouteWithChildren
  '/certification/$id': typeof StaffCertificationIdLayoutRouteWithChildren
  '/contract/$id': typeof StaffContractIdLayoutRouteWithChildren
  '/devices/alerts': typeof StaffDevicesListAlertsRoute
  '/devices/contract-and-cost': typeof StaffDevicesListContractAndCostRoute
  '/devices/operation-activity': typeof StaffDevicesListOperationActivityRoute
  '/devices/rule-and-policy': typeof StaffDevicesListRuleAndPolicyRoute
  '/equipment/$id': typeof StaffEquipmentIdLayoutRouteWithChildren
  '/fleets/$id': typeof StaffFleetsIdLayoutRouteWithChildren
  '/fleets/alerts': typeof StaffFleetsLayoutAlertsRoute
  '/fleets/overview': typeof StaffFleetsLayoutOverviewRoute
  '/fleets/rule-and-policy': typeof StaffFleetsLayoutRuleAndPolicyRoute
  '/fleets/settings': typeof StaffFleetsLayoutSettingsRoute
  '/it-operation-core/device-inventory/data': typeof StaffItOperationCoreDeviceInventoryDataRoute
  '/it-operation-core/device-inventory/detail': typeof StaffItOperationCoreDeviceInventoryDetailRoute
  '/labor-core/settings': typeof StaffLaborCorePackagesSettingsRouteWithChildren
  '/labor-core/settings/egov-callback': typeof StaffLaborCoreSettingsEgovCallbackRoute
  '/licenses/$id': typeof StaffLicensesIdProfileRouteWithChildren
  '/networks/$id': typeof StaffNetworksIdLayoutRouteWithChildren
  '/organization/$id': typeof StaffOrganizationIdLayoutRouteWithChildren
  '/people/alerts': typeof StaffPeopleListAlertsRoute
  '/people/community': typeof StaffPeopleListCommunityRoute
  '/people/operation-activity': typeof StaffPeopleListOperationActivityRoute
  '/people/people-graph': typeof StaffPeopleListPeopleGraphRoute
  '/people/rule-and-policy': typeof StaffPeopleListRuleAndPolicyRoute
  '/people/salary-and-payment': typeof StaffPeopleListSalaryAndPaymentRoute
  '/person/$id': typeof StaffPersonIdProfileRouteWithChildren
  '/places/$id': typeof StaffPlacesIdLayoutRouteWithChildren
  '/settings/contracting-corporation-profile': typeof StaffSettingsContractingCorporationProfileLayoutRouteWithChildren
  '/settings/permission-and-roles': typeof StaffSettingsPermissionAndRolesListRouteWithChildren
  '/settings/persons': typeof StaffSettingsPersonsListAccountRouteWithChildren
  '/software/$id': typeof StaffSoftwareIdIdRouteWithChildren
  '/software/integrations': typeof StaffSoftwareLayoutIntegrationsRoute
  '/starlinks/$id': typeof StaffStarlinksIdLayoutRouteWithChildren
  '/apps/': typeof StaffAppsListIndexRouteLazyRoute
  '/devices/': typeof StaffDevicesListIndexRouteLazyRoute
  '/people/': typeof StaffPeopleListIndexRouteLazyRoute
  '/software/': typeof StaffSoftwareLayoutIndexRouteLazyRoute
  '/certification/settings': typeof StaffCertificationListSettingsRouteLazyRouteWithChildren
  '/equipment/settings': typeof StaffEquipmentLayoutPlaceholdersSettingsRoute
  '/people/settings': typeof StaffPeopleListSettingsRouteLazyRouteWithChildren
  '/accesses/': typeof StaffAccessesLayoutIndexRoute
  '/business-operation-events/$eventInstanceId': typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
  '/business-operation-events/': typeof StaffBusinessOperationEventsListIndexRoute
  '/business-partner/': typeof StaffBusinessPartnerListIndexRoute
  '/business-partner/add': typeof StaffBusinessPartnerAddIndexRoute
  '/certification/': typeof StaffCertificationListIndexRoute
  '/certification/add': typeof StaffCertificationAddIndexRoute
  '/cockpit/$id': typeof StaffCockpitIdIndexRoute
  '/contract/': typeof StaffContractListIndexRoute
  '/contract/add': typeof StaffContractAddIndexRoute
  '/contractor-core/': typeof StaffContractorCorePackagesIndexRoute
  '/device-catalog/add': typeof StaffDeviceCatalogAddIndexRoute
  '/devices/add': typeof StaffDevicesAddIndexRoute
  '/devices/external-it-saas': typeof StaffDevicesExternalItSaasIndexRoute
  '/equipment/': typeof StaffEquipmentLayoutIndexRoute
  '/equipment/add-select': typeof StaffEquipmentAddSelectIndexRoute
  '/equipment/add': typeof StaffEquipmentAddIndexRoute
  '/equipment/import-csv': typeof StaffEquipmentImportCsvIndexRoute
  '/fleets/add-select': typeof StaffFleetsAddSelectIndexRoute
  '/fleets/add': typeof StaffFleetsAddIndexRoute
  '/ga-operation-core/': typeof StaffGaOperationCorePackagesIndexRoute
  '/ids/': typeof StaffIdsLayoutIndexRoute
  '/labor-core/': typeof StaffLaborCorePackagesIndexRoute
  '/licenses/add': typeof StaffLicensesAddIndexRoute
  '/marketplace/cart': typeof StaffMarketplaceCartIndexRoute
  '/marketplace/unavailable': typeof StaffMarketplaceUnavailableIndexRoute
  '/networks/': typeof StaffNetworksLayoutIndexRoute
  '/networks/add': typeof StaffNetworksAddIndexRoute
  '/organization/plan': typeof StaffOrganizationPlanIndexRoute
  '/person/add-person-certification': typeof StaffPersonAddPersonCertificationIndexRoute
  '/person/add': typeof StaffPersonAddIndexRoute
  '/person/external-hr-saas': typeof StaffPersonExternalHrSaasIndexRoute
  '/places/': typeof StaffPlacesLayoutIndexRoute
  '/places/add-select': typeof StaffPlacesAddSelectIndexRoute
  '/places/add': typeof StaffPlacesAddIndexRoute
  '/public-ids/$id/': typeof StaffPublicIdsIdIndexRoute
  '/public-ids/': typeof StaffPublicIdsListIndexRoute
  '/public-ids/add': typeof StaffPublicIdsAddIndexRoute
  '/settings/contracting-corporation-profile/': typeof StaffSettingsContractingCorporationProfileIndexRoute
  '/settings/permission-and-roles/': typeof StaffSettingsPermissionAndRolesIndexRoute
  '/settings/persons/': typeof StaffSettingsPersonsIndexRoute
  '/software/add': typeof StaffSoftwareAddIndexRoute
  '/starlinks/': typeof StaffStarlinksLayoutIndexRoute
  '/time-and-attendance/': typeof StaffTimeAndAttendanceLayoutIndexRoute
  '/auth/invitation/$invitationCode': typeof AuthInvitationInvitationCodeIndexRoute
  '/person/$id/': typeof StaffPersonIdProfileIndexRouteRoute
  '/apps/marketplace/$id': typeof StaffAppsListMarketplaceIdRouteRouteWithChildren
  '/business-partner/alerts': typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  '/business-partner/contract-and-cost': typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  '/business-partner/operation-activity': typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  '/business-partner/rule-and-policy': typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  '/business-partner/settings': typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  '/certification/alerts': typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  '/certification/operation-activity': typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  '/certification/overview': typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  '/certification/rule-and-policy': typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
  '/contract/alerts': typeof StaffContractListPlaceholdersAlertsRouteRoute
  '/contract/contract-and-cost': typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  '/contract/operation-activity': typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  '/contract/overview': typeof StaffContractListPlaceholdersOverviewRouteRoute
  '/contract/people': typeof StaffContractListPlaceholdersPeopleRouteRoute
  '/software/marketplace/$id': typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  '/individual/task/$id/approval-dialog': typeof IndividualIndividualTaskIdApprovalDialogRoute
  '/accesses/contract-and-cost': typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  '/accesses/overview': typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  '/accesses/settings': typeof StaffAccessesLayoutPlaceholdersSettingsRoute
  '/accesses/software': typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  '/app-integrations/$id/groups': typeof StaffAppIntegrationsIdIdGroupsRoute
  '/apps/alerts': typeof StaffAppsListAlertsAlertsRouteWithChildren
  '/business-partner/add/$businessPartnerType/completed': typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  '/certification/add/$certificationKind/completed': typeof StaffCertificationAddCertificationKindCompletedRoute
  '/certification/handling-certification/$id': typeof StaffCertificationHandlingCertificationIdLayoutRouteWithChildren
  '/certification/specialty-certification/$id': typeof StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren
  '/device-catalog/active/$id': typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
  '/device-catalog/add/$deviceType/completed': typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  '/device-catalog/draft/$id': typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
  '/devices/settings/catalog': typeof StaffDevicesListSettingsCatalogRoute
  '/devices/add/$deviceType/completed': typeof StaffDevicesAddDeviceTypeCompletedRoute
  '/equipment/alerts': typeof StaffEquipmentLayoutPlaceholdersAlertsRoute
  '/equipment/overview': typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  '/equipment/rule-and-policy': typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  '/ids/alerts': typeof StaffIdsLayoutPlaceholdersAlertsRoute
  '/ids/group-id': typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  '/ids/operation-activity': typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  '/ids/overview': typeof StaffIdsLayoutPlaceholdersOverviewRoute
  '/ids/rule-and-policy': typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  '/ids/settings': typeof StaffIdsLayoutPlaceholdersSettingsRoute
  '/ids/group-id/$id': typeof StaffIdsGroupIdIdIdRouteWithChildren
  '/it-operation-core/packages/$packageId': typeof StaffItOperationCoreRootPackagesPackageIdRoute
  '/labor-core/settings/profile/$profileId': typeof StaffLaborCoreSettingsProfileProfileIdRoute
  '/licenses/add/$allocationType/completed': typeof StaffLicensesAddAllocationTypeCompletedRoute
  '/marketplace/sent-orders/$orderId': typeof StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren
  '/networks/alerts': typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  '/networks/contract-and-cost': typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  '/networks/operation-activity': typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  '/networks/overview': typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  '/networks/rule-and-policy': typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  '/networks/settings': typeof StaffNetworksLayoutPlaceholdersSettingsRoute
  '/person/add-person-certification/$certificationKind/completed': typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  '/person/add/$workerType/completed': typeof StaffPersonAddWorkerTypeCompletedRoute
  '/person/alumni/$id': typeof StaffPersonAlumniIdProfileRouteWithChildren
  '/places/alerts': typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  '/places/contract-and-cost': typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  '/places/operation-activity': typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  '/places/overview': typeof StaffPlacesLayoutPlaceholdersOverviewRoute
  '/places/people': typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  '/places/rule-and-policy': typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  '/places/store': typeof StaffPlacesLayoutPlaceholdersStoreRoute
  '/profile/device/$id': typeof StaffProfileDeviceIdProfileRouteWithChildren
  '/software/alerts': typeof StaffSoftwareLayoutAlertsAlertsRouteWithChildren
  '/starlinks/billing-and-cost': typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  '/starlinks/marketplace': typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  '/starlinks/operation-activity': typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  '/time-and-attendance/attendances': typeof StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute
  '/time-and-attendance/clocking': typeof StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute
  '/individual/operation-package/$id': typeof IndividualIndividualOperationPackageIdIndexRoute
  '/individual/task/$id': typeof IndividualIndividualTaskIdIndexRoute
  '/accesses/alerts': typeof StaffAccessesLayoutAlertsIndexRoute
  '/accesses/list': typeof StaffAccessesLayoutListIndexRoute
  '/app-integrations/$id/': typeof StaffAppIntegrationsIdIdIndexRoute
  '/apps/integrations': typeof StaffAppsListIntegrationsIndexRoute
  '/apps/marketplace': typeof StaffAppsListMarketplaceIndexRoute
  '/apps/people': typeof StaffAppsListPeopleIndexRoute
  '/apps/settings': typeof StaffAppsListSettingsIndexRoute
  '/apps/custom-app/add': typeof StaffAppsCustomAppAddIndexRoute
  '/business-partner/terminated': typeof StaffBusinessPartnerListTerminatedIndexRoute
  '/business-partner/add/$businessPartnerType': typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
  '/certification/settings/': typeof StaffCertificationListSettingsIndexRoute
  '/certification/add/$certificationKind': typeof StaffCertificationAddCertificationKindIndexRoute
  '/contract/import-csv/$contractType': typeof StaffContractImportCsvContractTypeIndexRoute
  '/contractor-core/archives': typeof StaffContractorCorePackagesArchivesIndexRoute
  '/contractor-core/configs': typeof StaffContractorCorePackagesConfigsIndexRoute
  '/contractor-core/config/$patternId': typeof StaffContractorCoreConfigPatternIdIndexRoute
  '/device-catalog/add/$deviceType': typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  '/devices/catalog': typeof StaffDevicesListCatalogIndexRoute
  '/devices/inventory': typeof StaffDevicesListInventoryIndexRoute
  '/devices/people': typeof StaffDevicesListPeopleIndexRoute
  '/devices/settings': typeof StaffDevicesListSettingsIndexRoute
  '/devices/add/$deviceType': typeof StaffDevicesAddDeviceTypeIndexRoute
  '/equipment/settings/': typeof StaffEquipmentLayoutSettingsIndexRoute
  '/fleets/': typeof StaffFleetsLayoutListIndexRoute
  '/ga-operation-core/archives': typeof StaffGaOperationCorePackagesArchivesIndexRoute
  '/ga-operation-core/configs': typeof StaffGaOperationCorePackagesConfigsIndexRoute
  '/ga-operation-core/config/$patternId': typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  '/ids/people': typeof StaffIdsLayoutPeopleIndexRoute
  '/ids/group-id/add': typeof StaffIdsGroupIdAddIndexRoute
  '/it-operation-core/archives': typeof StaffItOperationCoreRootArchivesIndexRoute
  '/it-operation-core/config': typeof StaffItOperationCoreRootConfigIndexRoute
  '/it-operation-core/packages/': typeof StaffItOperationCoreRootPackagesIndexRoute
  '/it-operation-core/config/$patternId': typeof StaffItOperationCoreConfigPatternIdIndexRoute
  '/labor-core/archives': typeof StaffLaborCorePackagesArchivesIndexRoute
  '/labor-core/configs': typeof StaffLaborCorePackagesConfigsIndexRoute
  '/labor-core/settings/': typeof StaffLaborCorePackagesSettingsIndexRoute
  '/labor-core/config/$patternId': typeof StaffLaborCoreConfigPatternIdIndexRoute
  '/licenses/alerts': typeof StaffLicensesListAlertsIndexRoute
  '/licenses/contract-and-cost': typeof StaffLicensesListContractAndCostIndexRoute
  '/licenses/inventory': typeof StaffLicensesListInventoryIndexRoute
  '/licenses/operation-activity': typeof StaffLicensesListOperationActivityIndexRoute
  '/licenses/people': typeof StaffLicensesListPeopleIndexRoute
  '/licenses/rule-and-policy': typeof StaffLicensesListRuleAndPolicyIndexRoute
  '/licenses/settings': typeof StaffLicensesListSettingsIndexRoute
  '/licenses/add/$allocationType': typeof StaffLicensesAddAllocationTypeIndexRoute
  '/marketplace/sales-orders/$orderId': typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
  '/organization/$id/': typeof StaffOrganizationIdLayoutIndexRoute
  '/organization/alert': typeof StaffOrganizationListAlertIndexRoute
  '/organization/chart': typeof StaffOrganizationListChartIndexRoute
  '/organization/cost': typeof StaffOrganizationListCostIndexRoute
  '/organization/history': typeof StaffOrganizationListHistoryIndexRoute
  '/organization/rule-policy': typeof StaffOrganizationListRulePolicyIndexRoute
  '/organization/settings': typeof StaffOrganizationListSettingsIndexRoute
  '/organization/plan/$id': typeof StaffOrganizationPlanIdIndexRoute
  '/organization/plan/create': typeof StaffOrganizationPlanCreateIndexRoute
  '/people/alumni': typeof StaffPeopleListAlumniIndexRoute
  '/people/settings/': typeof StaffPeopleListSettingsIndexRoute
  '/people/workforce': typeof StaffPeopleListWorkforceIndexRoute
  '/person/add-person-certification/$certificationKind': typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  '/person/add/$workerType': typeof StaffPersonAddWorkerTypeIndexRoute
  '/places/settings/': typeof StaffPlacesLayoutSettingsIndexRoute
  '/public-ids/$id/details': typeof StaffPublicIdsIdDetailsIndexRoute
  '/public-ids/$id/files': typeof StaffPublicIdsIdFilesIndexRoute
  '/public-ids/alerts': typeof StaffPublicIdsListAlertsIndexRoute
  '/public-ids/members': typeof StaffPublicIdsListMembersIndexRoute
  '/public-ids/operation-activity': typeof StaffPublicIdsListOperationActivityIndexRoute
  '/public-ids/registry': typeof StaffPublicIdsListRegistryIndexRoute
  '/public-ids/rules-and-policies': typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  '/public-ids/settings': typeof StaffPublicIdsListSettingsIndexRoute
  '/software/$id/': typeof StaffSoftwareIdIdIndexRoute
  '/software/contract-and-cost': typeof StaffSoftwareLayoutContractAndCostIndexRoute
  '/software/marketplace': typeof StaffSoftwareLayoutMarketplaceIndexRoute
  '/software/operation-activity': typeof StaffSoftwareLayoutOperationActivityIndexRoute
  '/software/people/': typeof StaffSoftwareLayoutPeopleIndexRoute
  '/software/registry': typeof StaffSoftwareLayoutRegistryIndexRoute
  '/software/rule-and-policy': typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  '/software/settings': typeof StaffSoftwareLayoutSettingsIndexRoute
  '/software/add/$type': typeof StaffSoftwareAddTypeIndexRoute
  '/starlinks/alerts': typeof StaffStarlinksLayoutAlertsIndexRoute
  '/starlinks/user-terminals': typeof StaffStarlinksLayoutUserTerminalsIndexRoute
  '/storage-files/files': typeof StaffStorageFilesListFilesIndexRoute
  '/storage-files/folders': typeof StaffStorageFilesListFoldersIndexRoute
  '/time-and-attendance/attendance-links': typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  '/licenses/$id/': typeof StaffLicensesIdProfileIndexLazyRoute
  '/person/alumni/$id/': typeof StaffPersonAlumniIdProfileIndexRouteRoute
  '/contract/$id/approval-info': typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  '/contract/$id/history': typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  '/contract/$id/operation-activity': typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  '/contract/$id/risk-provisions': typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  '/contract/$id/rule-and-policy': typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  '/profile/device/$id/files': typeof StaffProfileDeviceIdProfileFilesRouteRoute
  '/it-operation-core/operation-instances/$instanceId': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren
  '/licenses/$id/service-plans/$licenseServiceId': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
  '/marketplace/sent-orders/$orderId/activities': typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  '/profile/device/$id/configuration': typeof StaffProfileDeviceIdProfileConfigurationRoute
  '/profile/device/$id/monitoring': typeof StaffProfileDeviceIdProfileMonitoringRoute
  '/profile/device/$id/': typeof StaffProfileDeviceIdProfileIndexRouteLazyRoute
  '/profile/device/$id/control': typeof StaffProfileDeviceIdProfileControlRouteLazyRoute
  '/profile/device/$id/mdm': typeof StaffProfileDeviceIdProfileMdmRouteLazyRoute
  '/profile/device/$id/status': typeof StaffProfileDeviceIdProfileStatusRouteLazyRoute
  '/individual/task/$id/approval': typeof IndividualIndividualTaskIdApprovalIndexRoute
  '/app-integrations/$id/architecture': typeof StaffAppIntegrationsIdIdArchitectureIndexRoute
  '/app-integrations/$id/detail': typeof StaffAppIntegrationsIdIdDetailIndexRoute
  '/app-integrations/$id/rule-and-policy': typeof StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute
  '/app-integrations/$id/settings': typeof StaffAppIntegrationsIdIdSettingsIndexRoute
  '/app-integrations/$id/users': typeof StaffAppIntegrationsIdIdUsersIndexRoute
  '/apps/alerts/': typeof StaffAppsListAlertsAlertsIndexRoute
  '/apps/custom-app/add/$customAppType': typeof StaffAppsCustomAppAddCustomAppTypeIndexRoute
  '/business-partner/$id/': typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  '/business-partner/$id/address-and-contact': typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
  '/certification/$id/': typeof StaffCertificationIdLayoutIndexIndexRoute
  '/certification/$id/certification-holders': typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/$id/handling-certifications': typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  '/certification/$id/specialty-certifications': typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
  '/certification/settings/issuing-organization': typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  '/certification/settings/specialty-category-level': typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  '/certification/settings/specialty-category': typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
  '/devices/external-it-saas/$appIntegrationId/preview': typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
  '/equipment/settings/equipment-items': typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  '/equipment/settings/equipment-types': typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
  '/ids/group-id/$id/': typeof StaffIdsGroupIdIdIdIndexRoute
  '/it-operation-core/operation-instances/$instanceId/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
  '/licenses/$id/assignments': typeof StaffLicensesIdProfileAssignmentsIndexRoute
  '/licenses/$id/people': typeof StaffLicensesIdProfilePeopleIndexRoute
  '/licenses/$id/service-plans': typeof StaffLicensesIdProfileServicePlansIndexRoute
  '/marketplace/store/devices': typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  '/marketplace/store/sales-orders': typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  '/marketplace/store/sent-orders': typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  '/marketplace/store/starlinks': typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  '/marketplace/sent-orders/$orderId/': typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
  '/organization/$id/history': typeof StaffOrganizationIdLayoutHistoryIndexRoute
  '/organization/plan/$id/add': typeof StaffOrganizationPlanIdAddIndexRoute
  '/people/settings/board-member-types': typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  '/people/settings/collaborator-types': typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  '/people/settings/contract-end-reasons': typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  '/people/settings/contractor-types': typeof StaffPeopleListSettingsContractorTypesIndexRoute
  '/people/settings/employee-sub-id-names': typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  '/people/settings/employment-types': typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  '/people/settings/grades': typeof StaffPeopleListSettingsGradesIndexRoute
  '/people/settings/health-insurance-associations': typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  '/people/settings/job-competencies': typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  '/people/settings/job-functions': typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  '/people/settings/job-grades': typeof StaffPeopleListSettingsJobGradesIndexRoute
  '/people/settings/job-levels': typeof StaffPeopleListSettingsJobLevelsIndexRoute
  '/people/settings/job-titles': typeof StaffPeopleListSettingsJobTitlesIndexRoute
  '/people/settings/job-types': typeof StaffPeopleListSettingsJobTypesIndexRoute
  '/people/settings/place-social-insurances': typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  '/people/settings/positions': typeof StaffPeopleListSettingsPositionsIndexRoute
  '/people/settings/retirement-reasons': typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  '/people/settings/work-mode': typeof StaffPeopleListSettingsWorkModeIndexRoute
  '/person/$id/activity': typeof StaffPersonIdProfileActivityIndexRoute
  '/person/$id/apps': typeof StaffPersonIdProfileAppsIndexRoute
  '/person/$id/devices': typeof StaffPersonIdProfileDevicesIndexRoute
  '/person/$id/education-and-qualification': typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  '/person/$id/employee-information': typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  '/person/$id/equipment': typeof StaffPersonIdProfileEquipmentIndexRoute
  '/person/$id/history': typeof StaffPersonIdProfileHistoryIndexRoute
  '/person/$id/personal-information': typeof StaffPersonIdProfilePersonalInformationIndexRoute
  '/person/$id/public-id': typeof StaffPersonIdProfilePublicIdIndexRoute
  '/person/external-hr-saas/$appIntegrationId/preview': typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
  '/places/$id/administrators': typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  '/places/$id/labor-core': typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  '/places/settings/place-sub-codes': typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
  '/settings/contracting-corporation-profile/board-member': typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  '/settings/contracting-corporation-profile/contact-points': typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  '/settings/contracting-corporation-profile/corporate-overview': typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  '/settings/contracting-corporation-profile/group-companies': typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  '/settings/contracting-corporation-profile/history': typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  '/settings/contracting-corporation-profile/registration': typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  '/settings/contracting-corporation-profile/shareholders': typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
  '/settings/permission-and-roles/people-groups': typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  '/settings/permission-and-roles/product-permissions': typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  '/settings/permission-and-roles/roles': typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
  '/settings/persons/settings': typeof StaffSettingsPersonsListSettingsIndexRoute
  '/software/$id/activity-monitoring': typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  '/software/$id/architecture': typeof StaffSoftwareIdIdArchitectureIndexRoute
  '/software/$id/contracts-cost': typeof StaffSoftwareIdIdContractsCostIndexRoute
  '/software/$id/detail': typeof StaffSoftwareIdIdDetailIndexRoute
  '/software/$id/rule-and-policy': typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
  '/software/$id/settings': typeof StaffSoftwareIdIdSettingsIndexRoute
  '/software/$id/users': typeof StaffSoftwareIdIdUsersIndexRoute
  '/software/alerts/': typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  '/software/custom-saas/add/$customSaasType': typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
  '/time-and-attendance/summary': typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  '/time-and-attendance/attendance-links/$placeId': typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  '/contract/$id/': typeof StaffContractIdLayoutIndexIndexLazyRoute
  '/contract/$id/structure': typeof StaffContractIdLayoutStructureIndexLazyRoute
  '/equipment/$id/': typeof StaffEquipmentIdLayoutProfileIndexLazyRoute
  '/fleets/$id/': typeof StaffFleetsIdLayoutProfileIndexLazyRoute
  '/networks/$id/': typeof StaffNetworksIdLayoutProfileIndexLazyRoute
  '/places/$id/': typeof StaffPlacesIdLayoutProfileIndexLazyRoute
  '/starlinks/$id/': typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  '/starlinks/$id/detail': typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
  '/apps/alerts/shadow-it': typeof StaffAppsListAlertsAlertsShadowItShadowItRouteWithChildren
  '/person/$id/certifications/base-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/person/$id/certifications/handling-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/person/$id/certifications/specialty-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/individual/operation-package/$id/pattern/$patternId': typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  '/accesses/alerts/detail/$shadowItAppId': typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
  '/apps/alerts/inactive-user': typeof StaffAppsListAlertsAlertsInactiveUserIndexRoute
  '/apps/alerts/no-user': typeof StaffAppsListAlertsAlertsNoUserIndexRoute
  '/apps/alerts/no-worker': typeof StaffAppsListAlertsAlertsNoWorkerIndexRoute
  '/apps/alerts/violated-assignment': typeof StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute
  '/apps/alerts/violated-role': typeof StaffAppsListAlertsAlertsViolatedRoleIndexRoute
  '/certification/handling-certification/$id/': typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  '/certification/handling-certification/$id/certification-holders': typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/': typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  '/certification/specialty-certification/$id/certification-holders': typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/handling-certifications': typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
  '/device-catalog/active/$id/profile': typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
  '/device-catalog/draft/$id/profile': typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
  '/ids/group-id/$id/members': typeof StaffIdsGroupIdIdIdMembersIndexRoute
  '/ids/group-id/$id/rule-and-policy': typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  '/ids/group-id/$id/settings': typeof StaffIdsGroupIdIdIdSettingsIndexRoute
  '/marketplace/store/devices/$productId': typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  '/marketplace/store/starlinks/$productId': typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
  '/organization/plan/$id/edit/$unitId': typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
  '/person/$id/family/$familyPersonId': typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
  '/person/alumni/$id/activity': typeof StaffPersonAlumniIdProfileActivityIndexRoute
  '/person/alumni/$id/apps': typeof StaffPersonAlumniIdProfileAppsIndexRoute
  '/person/alumni/$id/devices': typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  '/person/alumni/$id/education-and-qualification': typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  '/person/alumni/$id/employee-information': typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  '/person/alumni/$id/equipment': typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  '/person/alumni/$id/history': typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  '/person/alumni/$id/personal-information': typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  '/person/alumni/$id/public-id': typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
  '/profile/device/$id/history': typeof StaffProfileDeviceIdProfileHistoryIndexRoute
  '/profile/device/$id/lifecycle': typeof StaffProfileDeviceIdProfileLifecycleIndexRoute
  '/settings/permission-and-roles/people-groups/$id': typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  '/settings/permission-and-roles/product-permissions/$id': typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  '/settings/permission-and-roles/roles/$id': typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
  '/settings/permission-and-roles/people-groups/new': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  '/settings/permission-and-roles/product-permissions/new': typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  '/settings/permission-and-roles/roles/new': typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  '/settings/persons/individual': typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  '/settings/persons/staff': typeof StaffSettingsPersonsListAccountStaffIndexRoute
  '/software/alerts/alumni': typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  '/software/alerts/inactive-user': typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  '/software/alerts/no-user': typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  '/software/alerts/no-worker': typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  '/software/alerts/violated-assignment': typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  '/software/alerts/violated-role': typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
  '/time-and-attendance/summary/daily-place': typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  '/time-and-attendance/summary/monthly-person': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  '/time-and-attendance/summary/monthly-place': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
  '/apps/alerts/shadow-it/': typeof StaffAppsListAlertsAlertsShadowItShadowItIndexRoute
  '/apps/marketplace/$id/install/finish': typeof StaffAppsListMarketplaceIdInstallFinishIndexRoute
  '/it-operation-core/operation-instances/$instanceId/data': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  '/it-operation-core/operation-instances/$instanceId/detail': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  '/it-operation-core/operation-instances/$instanceId/operation-activity': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
  '/licenses/$id/service-plans/$licenseServiceId/accounts': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
  '/settings/permission-and-roles/people-groups/$id/edit': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  '/settings/permission-and-roles/product-permissions/$id/edit': typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  '/settings/permission-and-roles/roles/$id/edit': typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
  '/software/marketplace/$id/install/finish': typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/individual/task/$id/form/$formId': typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
  '/apps/alerts/shadow-it/apps': typeof StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute
  '/apps/alerts/shadow-it/visit-histories': typeof StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute
  '/person/$id/certifications/base-certifications/$personCertificationInformationId/': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/handling-certifications/$personCertificationInformationId/': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/specialty-certifications/$personCertificationInformationId/': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof StaffRouteWithChildren
  '/apps': typeof StaffAppsListIndexRouteLazyRoute
  '/id-managements': typeof StaffIdManagementsRouteWithChildren
  '/it-operation-core/device-inventory': typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  '/places/import-csv': typeof StaffPlacesImportCsvRouteRoute
  '/accesses': typeof StaffAccessesLayoutIndexRoute
  '/apps/$': typeof StaffAppsSplatRoute
  '/business-operation-events': typeof StaffBusinessOperationEventsListIndexRoute
  '/business-partner': typeof StaffBusinessPartnerListIndexRoute
  '/certification': typeof StaffCertificationListIndexRoute
  '/contract': typeof StaffContractListIndexRoute
  '/contractor-core': typeof StaffContractorCorePackagesIndexRoute
  '/devices': typeof StaffDevicesListIndexRouteLazyRoute
  '/equipment': typeof StaffEquipmentLayoutIndexRoute
  '/fleets': typeof StaffFleetsLayoutListIndexRoute
  '/ga-operation-core': typeof StaffGaOperationCorePackagesIndexRoute
  '/id-managements/$': typeof StaffIdManagementsSplatRoute
  '/ids': typeof StaffIdsLayoutIndexRoute
  '/it-operation-core': typeof StaffItOperationCoreIndexRoute
  '/labor-core': typeof StaffLaborCorePackagesIndexRoute
  '/labor-core/anchor-date': typeof StaffLaborCoreAnchorDateRoute
  '/labor-core/person-targets': typeof StaffLaborCorePersonTargetsRoute
  '/licenses': typeof StaffLicensesListIndexRouteRoute
  '/marketplace': typeof StaffMarketplaceStoreRouteWithChildren
  '/networks': typeof StaffNetworksLayoutIndexRoute
  '/organization': typeof StaffOrganizationIndexRoute
  '/people': typeof StaffPeopleListIndexRouteLazyRoute
  '/places': typeof StaffPlacesLayoutIndexRoute
  '/public-ids': typeof StaffPublicIdsListIndexRoute
  '/software': typeof StaffSoftwareLayoutIndexRouteLazyRoute
  '/starlinks': typeof StaffStarlinksLayoutIndexRoute
  '/storage-files': typeof StaffStorageFilesListRouteWithChildren
  '/time-and-attendance': typeof StaffTimeAndAttendanceLayoutIndexRoute
  '/individual': typeof IndividualIndividualIndexRoute
  '/cockpit': typeof StaffCockpitIndexRoute
  '/settings': typeof StaffSettingsIndexRoute
  '/auth/sign-in': typeof AuthSignInIndexRoute
  '/auth/password-reset': typeof AuthPasswordResetIndexLazyRoute
  '/app-integrations/import-csv/$id': typeof StaffAppIntegrationsImportCsvIdRouteRoute
  '/devices/import-csv/$deviceType': typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  '/person/import-csv/$workerType': typeof StaffPersonImportCsvWorkerTypeRouteRoute
  '/public-ids/import-csv/$publicIdType': typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  '/software/$id/import-csv': typeof StaffSoftwareIdImportCsvRouteRoute
  '/app-integrations/$id': typeof StaffAppIntegrationsIdIdIndexRoute
  '/apps/contract-and-cost': typeof StaffAppsListContractAndCostRoute
  '/apps/operation-activity': typeof StaffAppsListOperationActivityRoute
  '/apps/rule-and-policy': typeof StaffAppsListRuleAndPolicyRoute
  '/business-operation-events/archive': typeof StaffBusinessOperationEventsListArchiveRoute
  '/business-operation-events/config': typeof StaffBusinessOperationEventsListConfigRoute
  '/business-operation-events/operation-activity': typeof StaffBusinessOperationEventsListOperationActivityRoute
  '/business-operation-events/overview': typeof StaffBusinessOperationEventsListOverviewRoute
  '/business-operation-events/rule-and-policy': typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  '/business-operation-events/settings': typeof StaffBusinessOperationEventsListSettingsRoute
  '/business-partner/$id': typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  '/certification/$id': typeof StaffCertificationIdLayoutIndexIndexRoute
  '/contract/$id': typeof StaffContractIdLayoutIndexIndexLazyRoute
  '/devices/alerts': typeof StaffDevicesListAlertsRoute
  '/devices/contract-and-cost': typeof StaffDevicesListContractAndCostRoute
  '/devices/operation-activity': typeof StaffDevicesListOperationActivityRoute
  '/devices/rule-and-policy': typeof StaffDevicesListRuleAndPolicyRoute
  '/equipment/$id': typeof StaffEquipmentIdLayoutProfileIndexLazyRoute
  '/fleets/$id': typeof StaffFleetsIdLayoutProfileIndexLazyRoute
  '/fleets/alerts': typeof StaffFleetsLayoutAlertsRoute
  '/fleets/overview': typeof StaffFleetsLayoutOverviewRoute
  '/fleets/rule-and-policy': typeof StaffFleetsLayoutRuleAndPolicyRoute
  '/fleets/settings': typeof StaffFleetsLayoutSettingsRoute
  '/it-operation-core/device-inventory/data': typeof StaffItOperationCoreDeviceInventoryDataRoute
  '/it-operation-core/device-inventory/detail': typeof StaffItOperationCoreDeviceInventoryDetailRoute
  '/labor-core/settings/egov-callback': typeof StaffLaborCoreSettingsEgovCallbackRoute
  '/licenses/$id': typeof StaffLicensesIdProfileIndexLazyRoute
  '/networks/$id': typeof StaffNetworksIdLayoutProfileIndexLazyRoute
  '/organization/$id': typeof StaffOrganizationIdLayoutIndexRoute
  '/people/alerts': typeof StaffPeopleListAlertsRoute
  '/people/community': typeof StaffPeopleListCommunityRoute
  '/people/operation-activity': typeof StaffPeopleListOperationActivityRoute
  '/people/people-graph': typeof StaffPeopleListPeopleGraphRoute
  '/people/rule-and-policy': typeof StaffPeopleListRuleAndPolicyRoute
  '/people/salary-and-payment': typeof StaffPeopleListSalaryAndPaymentRoute
  '/person/$id': typeof StaffPersonIdProfileIndexRouteRoute
  '/places/$id': typeof StaffPlacesIdLayoutProfileIndexLazyRoute
  '/settings/contracting-corporation-profile': typeof StaffSettingsContractingCorporationProfileIndexRoute
  '/settings/permission-and-roles': typeof StaffSettingsPermissionAndRolesIndexRoute
  '/settings/persons': typeof StaffSettingsPersonsListAccountRouteWithChildren
  '/software/$id': typeof StaffSoftwareIdIdIndexRoute
  '/software/integrations': typeof StaffSoftwareLayoutIntegrationsRoute
  '/starlinks/$id': typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  '/business-operation-events/$eventInstanceId': typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
  '/business-partner/add': typeof StaffBusinessPartnerAddIndexRoute
  '/certification/add': typeof StaffCertificationAddIndexRoute
  '/cockpit/$id': typeof StaffCockpitIdIndexRoute
  '/contract/add': typeof StaffContractAddIndexRoute
  '/device-catalog/add': typeof StaffDeviceCatalogAddIndexRoute
  '/devices/add': typeof StaffDevicesAddIndexRoute
  '/devices/external-it-saas': typeof StaffDevicesExternalItSaasIndexRoute
  '/equipment/add-select': typeof StaffEquipmentAddSelectIndexRoute
  '/equipment/add': typeof StaffEquipmentAddIndexRoute
  '/equipment/import-csv': typeof StaffEquipmentImportCsvIndexRoute
  '/fleets/add-select': typeof StaffFleetsAddSelectIndexRoute
  '/fleets/add': typeof StaffFleetsAddIndexRoute
  '/licenses/add': typeof StaffLicensesAddIndexRoute
  '/marketplace/cart': typeof StaffMarketplaceCartIndexRoute
  '/marketplace/unavailable': typeof StaffMarketplaceUnavailableIndexRoute
  '/networks/add': typeof StaffNetworksAddIndexRoute
  '/organization/plan': typeof StaffOrganizationPlanIndexRoute
  '/person/add-person-certification': typeof StaffPersonAddPersonCertificationIndexRoute
  '/person/add': typeof StaffPersonAddIndexRoute
  '/person/external-hr-saas': typeof StaffPersonExternalHrSaasIndexRoute
  '/places/add-select': typeof StaffPlacesAddSelectIndexRoute
  '/places/add': typeof StaffPlacesAddIndexRoute
  '/public-ids/$id': typeof StaffPublicIdsIdIndexRoute
  '/public-ids/add': typeof StaffPublicIdsAddIndexRoute
  '/software/add': typeof StaffSoftwareAddIndexRoute
  '/auth/invitation/$invitationCode': typeof AuthInvitationInvitationCodeIndexRoute
  '/apps/marketplace/$id': typeof StaffAppsListMarketplaceIdRouteRouteWithChildren
  '/business-partner/alerts': typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  '/business-partner/contract-and-cost': typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  '/business-partner/operation-activity': typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  '/business-partner/rule-and-policy': typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  '/business-partner/settings': typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  '/certification/alerts': typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  '/certification/operation-activity': typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  '/certification/overview': typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  '/certification/rule-and-policy': typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
  '/contract/alerts': typeof StaffContractListPlaceholdersAlertsRouteRoute
  '/contract/contract-and-cost': typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  '/contract/operation-activity': typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  '/contract/overview': typeof StaffContractListPlaceholdersOverviewRouteRoute
  '/contract/people': typeof StaffContractListPlaceholdersPeopleRouteRoute
  '/software/marketplace/$id': typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  '/individual/task/$id/approval-dialog': typeof IndividualIndividualTaskIdApprovalDialogRoute
  '/accesses/contract-and-cost': typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  '/accesses/overview': typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  '/accesses/settings': typeof StaffAccessesLayoutPlaceholdersSettingsRoute
  '/accesses/software': typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  '/app-integrations/$id/groups': typeof StaffAppIntegrationsIdIdGroupsRoute
  '/apps/alerts': typeof StaffAppsListAlertsAlertsIndexRoute
  '/business-partner/add/$businessPartnerType/completed': typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  '/certification/add/$certificationKind/completed': typeof StaffCertificationAddCertificationKindCompletedRoute
  '/certification/handling-certification/$id': typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  '/certification/specialty-certification/$id': typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  '/device-catalog/active/$id': typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
  '/device-catalog/add/$deviceType/completed': typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  '/device-catalog/draft/$id': typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
  '/devices/settings/catalog': typeof StaffDevicesListSettingsCatalogRoute
  '/devices/add/$deviceType/completed': typeof StaffDevicesAddDeviceTypeCompletedRoute
  '/equipment/alerts': typeof StaffEquipmentLayoutPlaceholdersAlertsRoute
  '/equipment/overview': typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  '/equipment/rule-and-policy': typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  '/equipment/settings': typeof StaffEquipmentLayoutSettingsIndexRoute
  '/ids/alerts': typeof StaffIdsLayoutPlaceholdersAlertsRoute
  '/ids/group-id': typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  '/ids/operation-activity': typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  '/ids/overview': typeof StaffIdsLayoutPlaceholdersOverviewRoute
  '/ids/rule-and-policy': typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  '/ids/settings': typeof StaffIdsLayoutPlaceholdersSettingsRoute
  '/ids/group-id/$id': typeof StaffIdsGroupIdIdIdIndexRoute
  '/it-operation-core/packages/$packageId': typeof StaffItOperationCoreRootPackagesPackageIdRoute
  '/labor-core/settings/profile/$profileId': typeof StaffLaborCoreSettingsProfileProfileIdRoute
  '/licenses/add/$allocationType/completed': typeof StaffLicensesAddAllocationTypeCompletedRoute
  '/marketplace/sent-orders/$orderId': typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
  '/networks/alerts': typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  '/networks/contract-and-cost': typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  '/networks/operation-activity': typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  '/networks/overview': typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  '/networks/rule-and-policy': typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  '/networks/settings': typeof StaffNetworksLayoutPlaceholdersSettingsRoute
  '/person/add-person-certification/$certificationKind/completed': typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  '/person/add/$workerType/completed': typeof StaffPersonAddWorkerTypeCompletedRoute
  '/person/alumni/$id': typeof StaffPersonAlumniIdProfileIndexRouteRoute
  '/places/alerts': typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  '/places/contract-and-cost': typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  '/places/operation-activity': typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  '/places/overview': typeof StaffPlacesLayoutPlaceholdersOverviewRoute
  '/places/people': typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  '/places/rule-and-policy': typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  '/places/store': typeof StaffPlacesLayoutPlaceholdersStoreRoute
  '/profile/device/$id': typeof StaffProfileDeviceIdProfileIndexRouteLazyRoute
  '/software/alerts': typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  '/starlinks/billing-and-cost': typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  '/starlinks/marketplace': typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  '/starlinks/operation-activity': typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  '/time-and-attendance/attendances': typeof StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute
  '/time-and-attendance/clocking': typeof StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute
  '/individual/operation-package/$id': typeof IndividualIndividualOperationPackageIdIndexRoute
  '/individual/task/$id': typeof IndividualIndividualTaskIdIndexRoute
  '/accesses/alerts': typeof StaffAccessesLayoutAlertsIndexRoute
  '/accesses/list': typeof StaffAccessesLayoutListIndexRoute
  '/apps/integrations': typeof StaffAppsListIntegrationsIndexRoute
  '/apps/marketplace': typeof StaffAppsListMarketplaceIndexRoute
  '/apps/people': typeof StaffAppsListPeopleIndexRoute
  '/apps/settings': typeof StaffAppsListSettingsIndexRoute
  '/apps/custom-app/add': typeof StaffAppsCustomAppAddIndexRoute
  '/business-partner/terminated': typeof StaffBusinessPartnerListTerminatedIndexRoute
  '/business-partner/add/$businessPartnerType': typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
  '/certification/settings': typeof StaffCertificationListSettingsIndexRoute
  '/certification/add/$certificationKind': typeof StaffCertificationAddCertificationKindIndexRoute
  '/contract/import-csv/$contractType': typeof StaffContractImportCsvContractTypeIndexRoute
  '/contractor-core/archives': typeof StaffContractorCorePackagesArchivesIndexRoute
  '/contractor-core/configs': typeof StaffContractorCorePackagesConfigsIndexRoute
  '/contractor-core/config/$patternId': typeof StaffContractorCoreConfigPatternIdIndexRoute
  '/device-catalog/add/$deviceType': typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  '/devices/catalog': typeof StaffDevicesListCatalogIndexRoute
  '/devices/inventory': typeof StaffDevicesListInventoryIndexRoute
  '/devices/people': typeof StaffDevicesListPeopleIndexRoute
  '/devices/settings': typeof StaffDevicesListSettingsIndexRoute
  '/devices/add/$deviceType': typeof StaffDevicesAddDeviceTypeIndexRoute
  '/ga-operation-core/archives': typeof StaffGaOperationCorePackagesArchivesIndexRoute
  '/ga-operation-core/configs': typeof StaffGaOperationCorePackagesConfigsIndexRoute
  '/ga-operation-core/config/$patternId': typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  '/ids/people': typeof StaffIdsLayoutPeopleIndexRoute
  '/ids/group-id/add': typeof StaffIdsGroupIdAddIndexRoute
  '/it-operation-core/archives': typeof StaffItOperationCoreRootArchivesIndexRoute
  '/it-operation-core/config': typeof StaffItOperationCoreRootConfigIndexRoute
  '/it-operation-core/packages': typeof StaffItOperationCoreRootPackagesIndexRoute
  '/it-operation-core/config/$patternId': typeof StaffItOperationCoreConfigPatternIdIndexRoute
  '/labor-core/archives': typeof StaffLaborCorePackagesArchivesIndexRoute
  '/labor-core/configs': typeof StaffLaborCorePackagesConfigsIndexRoute
  '/labor-core/settings': typeof StaffLaborCorePackagesSettingsIndexRoute
  '/labor-core/config/$patternId': typeof StaffLaborCoreConfigPatternIdIndexRoute
  '/licenses/alerts': typeof StaffLicensesListAlertsIndexRoute
  '/licenses/contract-and-cost': typeof StaffLicensesListContractAndCostIndexRoute
  '/licenses/inventory': typeof StaffLicensesListInventoryIndexRoute
  '/licenses/operation-activity': typeof StaffLicensesListOperationActivityIndexRoute
  '/licenses/people': typeof StaffLicensesListPeopleIndexRoute
  '/licenses/rule-and-policy': typeof StaffLicensesListRuleAndPolicyIndexRoute
  '/licenses/settings': typeof StaffLicensesListSettingsIndexRoute
  '/licenses/add/$allocationType': typeof StaffLicensesAddAllocationTypeIndexRoute
  '/marketplace/sales-orders/$orderId': typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
  '/organization/alert': typeof StaffOrganizationListAlertIndexRoute
  '/organization/chart': typeof StaffOrganizationListChartIndexRoute
  '/organization/cost': typeof StaffOrganizationListCostIndexRoute
  '/organization/history': typeof StaffOrganizationListHistoryIndexRoute
  '/organization/rule-policy': typeof StaffOrganizationListRulePolicyIndexRoute
  '/organization/settings': typeof StaffOrganizationListSettingsIndexRoute
  '/organization/plan/$id': typeof StaffOrganizationPlanIdIndexRoute
  '/organization/plan/create': typeof StaffOrganizationPlanCreateIndexRoute
  '/people/alumni': typeof StaffPeopleListAlumniIndexRoute
  '/people/settings': typeof StaffPeopleListSettingsIndexRoute
  '/people/workforce': typeof StaffPeopleListWorkforceIndexRoute
  '/person/add-person-certification/$certificationKind': typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  '/person/add/$workerType': typeof StaffPersonAddWorkerTypeIndexRoute
  '/places/settings': typeof StaffPlacesLayoutSettingsIndexRoute
  '/public-ids/$id/details': typeof StaffPublicIdsIdDetailsIndexRoute
  '/public-ids/$id/files': typeof StaffPublicIdsIdFilesIndexRoute
  '/public-ids/alerts': typeof StaffPublicIdsListAlertsIndexRoute
  '/public-ids/members': typeof StaffPublicIdsListMembersIndexRoute
  '/public-ids/operation-activity': typeof StaffPublicIdsListOperationActivityIndexRoute
  '/public-ids/registry': typeof StaffPublicIdsListRegistryIndexRoute
  '/public-ids/rules-and-policies': typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  '/public-ids/settings': typeof StaffPublicIdsListSettingsIndexRoute
  '/software/contract-and-cost': typeof StaffSoftwareLayoutContractAndCostIndexRoute
  '/software/marketplace': typeof StaffSoftwareLayoutMarketplaceIndexRoute
  '/software/operation-activity': typeof StaffSoftwareLayoutOperationActivityIndexRoute
  '/software/people': typeof StaffSoftwareLayoutPeopleIndexRoute
  '/software/registry': typeof StaffSoftwareLayoutRegistryIndexRoute
  '/software/rule-and-policy': typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  '/software/settings': typeof StaffSoftwareLayoutSettingsIndexRoute
  '/software/add/$type': typeof StaffSoftwareAddTypeIndexRoute
  '/starlinks/alerts': typeof StaffStarlinksLayoutAlertsIndexRoute
  '/starlinks/user-terminals': typeof StaffStarlinksLayoutUserTerminalsIndexRoute
  '/storage-files/files': typeof StaffStorageFilesListFilesIndexRoute
  '/storage-files/folders': typeof StaffStorageFilesListFoldersIndexRoute
  '/time-and-attendance/attendance-links': typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  '/contract/$id/approval-info': typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  '/contract/$id/history': typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  '/contract/$id/operation-activity': typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  '/contract/$id/risk-provisions': typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  '/contract/$id/rule-and-policy': typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  '/profile/device/$id/files': typeof StaffProfileDeviceIdProfileFilesRouteRoute
  '/it-operation-core/operation-instances/$instanceId': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
  '/licenses/$id/service-plans/$licenseServiceId': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
  '/marketplace/sent-orders/$orderId/activities': typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  '/profile/device/$id/configuration': typeof StaffProfileDeviceIdProfileConfigurationRoute
  '/profile/device/$id/monitoring': typeof StaffProfileDeviceIdProfileMonitoringRoute
  '/profile/device/$id/control': typeof StaffProfileDeviceIdProfileControlRouteLazyRoute
  '/profile/device/$id/mdm': typeof StaffProfileDeviceIdProfileMdmRouteLazyRoute
  '/profile/device/$id/status': typeof StaffProfileDeviceIdProfileStatusRouteLazyRoute
  '/individual/task/$id/approval': typeof IndividualIndividualTaskIdApprovalIndexRoute
  '/app-integrations/$id/architecture': typeof StaffAppIntegrationsIdIdArchitectureIndexRoute
  '/app-integrations/$id/detail': typeof StaffAppIntegrationsIdIdDetailIndexRoute
  '/app-integrations/$id/rule-and-policy': typeof StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute
  '/app-integrations/$id/settings': typeof StaffAppIntegrationsIdIdSettingsIndexRoute
  '/app-integrations/$id/users': typeof StaffAppIntegrationsIdIdUsersIndexRoute
  '/apps/custom-app/add/$customAppType': typeof StaffAppsCustomAppAddCustomAppTypeIndexRoute
  '/business-partner/$id/address-and-contact': typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
  '/certification/$id/certification-holders': typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/$id/handling-certifications': typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  '/certification/$id/specialty-certifications': typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
  '/certification/settings/issuing-organization': typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  '/certification/settings/specialty-category-level': typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  '/certification/settings/specialty-category': typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
  '/devices/external-it-saas/$appIntegrationId/preview': typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
  '/equipment/settings/equipment-items': typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  '/equipment/settings/equipment-types': typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
  '/licenses/$id/assignments': typeof StaffLicensesIdProfileAssignmentsIndexRoute
  '/licenses/$id/people': typeof StaffLicensesIdProfilePeopleIndexRoute
  '/licenses/$id/service-plans': typeof StaffLicensesIdProfileServicePlansIndexRoute
  '/marketplace/store/devices': typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  '/marketplace/store/sales-orders': typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  '/marketplace/store/sent-orders': typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  '/marketplace/store/starlinks': typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  '/organization/$id/history': typeof StaffOrganizationIdLayoutHistoryIndexRoute
  '/organization/plan/$id/add': typeof StaffOrganizationPlanIdAddIndexRoute
  '/people/settings/board-member-types': typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  '/people/settings/collaborator-types': typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  '/people/settings/contract-end-reasons': typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  '/people/settings/contractor-types': typeof StaffPeopleListSettingsContractorTypesIndexRoute
  '/people/settings/employee-sub-id-names': typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  '/people/settings/employment-types': typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  '/people/settings/grades': typeof StaffPeopleListSettingsGradesIndexRoute
  '/people/settings/health-insurance-associations': typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  '/people/settings/job-competencies': typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  '/people/settings/job-functions': typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  '/people/settings/job-grades': typeof StaffPeopleListSettingsJobGradesIndexRoute
  '/people/settings/job-levels': typeof StaffPeopleListSettingsJobLevelsIndexRoute
  '/people/settings/job-titles': typeof StaffPeopleListSettingsJobTitlesIndexRoute
  '/people/settings/job-types': typeof StaffPeopleListSettingsJobTypesIndexRoute
  '/people/settings/place-social-insurances': typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  '/people/settings/positions': typeof StaffPeopleListSettingsPositionsIndexRoute
  '/people/settings/retirement-reasons': typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  '/people/settings/work-mode': typeof StaffPeopleListSettingsWorkModeIndexRoute
  '/person/$id/activity': typeof StaffPersonIdProfileActivityIndexRoute
  '/person/$id/apps': typeof StaffPersonIdProfileAppsIndexRoute
  '/person/$id/devices': typeof StaffPersonIdProfileDevicesIndexRoute
  '/person/$id/education-and-qualification': typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  '/person/$id/employee-information': typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  '/person/$id/equipment': typeof StaffPersonIdProfileEquipmentIndexRoute
  '/person/$id/history': typeof StaffPersonIdProfileHistoryIndexRoute
  '/person/$id/personal-information': typeof StaffPersonIdProfilePersonalInformationIndexRoute
  '/person/$id/public-id': typeof StaffPersonIdProfilePublicIdIndexRoute
  '/person/external-hr-saas/$appIntegrationId/preview': typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
  '/places/$id/administrators': typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  '/places/$id/labor-core': typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  '/places/settings/place-sub-codes': typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
  '/settings/contracting-corporation-profile/board-member': typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  '/settings/contracting-corporation-profile/contact-points': typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  '/settings/contracting-corporation-profile/corporate-overview': typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  '/settings/contracting-corporation-profile/group-companies': typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  '/settings/contracting-corporation-profile/history': typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  '/settings/contracting-corporation-profile/registration': typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  '/settings/contracting-corporation-profile/shareholders': typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
  '/settings/permission-and-roles/people-groups': typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  '/settings/permission-and-roles/product-permissions': typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  '/settings/permission-and-roles/roles': typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
  '/settings/persons/settings': typeof StaffSettingsPersonsListSettingsIndexRoute
  '/software/$id/activity-monitoring': typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  '/software/$id/architecture': typeof StaffSoftwareIdIdArchitectureIndexRoute
  '/software/$id/contracts-cost': typeof StaffSoftwareIdIdContractsCostIndexRoute
  '/software/$id/detail': typeof StaffSoftwareIdIdDetailIndexRoute
  '/software/$id/rule-and-policy': typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
  '/software/$id/settings': typeof StaffSoftwareIdIdSettingsIndexRoute
  '/software/$id/users': typeof StaffSoftwareIdIdUsersIndexRoute
  '/software/custom-saas/add/$customSaasType': typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
  '/time-and-attendance/summary': typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  '/time-and-attendance/attendance-links/$placeId': typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  '/contract/$id/structure': typeof StaffContractIdLayoutStructureIndexLazyRoute
  '/starlinks/$id/detail': typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
  '/apps/alerts/shadow-it': typeof StaffAppsListAlertsAlertsShadowItShadowItIndexRoute
  '/person/$id/certifications/base-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/handling-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/person/$id/certifications/specialty-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/individual/operation-package/$id/pattern/$patternId': typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  '/accesses/alerts/detail/$shadowItAppId': typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
  '/apps/alerts/inactive-user': typeof StaffAppsListAlertsAlertsInactiveUserIndexRoute
  '/apps/alerts/no-user': typeof StaffAppsListAlertsAlertsNoUserIndexRoute
  '/apps/alerts/no-worker': typeof StaffAppsListAlertsAlertsNoWorkerIndexRoute
  '/apps/alerts/violated-assignment': typeof StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute
  '/apps/alerts/violated-role': typeof StaffAppsListAlertsAlertsViolatedRoleIndexRoute
  '/certification/handling-certification/$id/certification-holders': typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/certification-holders': typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  '/certification/specialty-certification/$id/handling-certifications': typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
  '/device-catalog/active/$id/profile': typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
  '/device-catalog/draft/$id/profile': typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
  '/ids/group-id/$id/members': typeof StaffIdsGroupIdIdIdMembersIndexRoute
  '/ids/group-id/$id/rule-and-policy': typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  '/ids/group-id/$id/settings': typeof StaffIdsGroupIdIdIdSettingsIndexRoute
  '/marketplace/store/devices/$productId': typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  '/marketplace/store/starlinks/$productId': typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
  '/organization/plan/$id/edit/$unitId': typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
  '/person/$id/family/$familyPersonId': typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
  '/person/alumni/$id/activity': typeof StaffPersonAlumniIdProfileActivityIndexRoute
  '/person/alumni/$id/apps': typeof StaffPersonAlumniIdProfileAppsIndexRoute
  '/person/alumni/$id/devices': typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  '/person/alumni/$id/education-and-qualification': typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  '/person/alumni/$id/employee-information': typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  '/person/alumni/$id/equipment': typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  '/person/alumni/$id/history': typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  '/person/alumni/$id/personal-information': typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  '/person/alumni/$id/public-id': typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
  '/profile/device/$id/history': typeof StaffProfileDeviceIdProfileHistoryIndexRoute
  '/profile/device/$id/lifecycle': typeof StaffProfileDeviceIdProfileLifecycleIndexRoute
  '/settings/permission-and-roles/people-groups/$id': typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  '/settings/permission-and-roles/product-permissions/$id': typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  '/settings/permission-and-roles/roles/$id': typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
  '/settings/permission-and-roles/people-groups/new': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  '/settings/permission-and-roles/product-permissions/new': typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  '/settings/permission-and-roles/roles/new': typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  '/settings/persons/individual': typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  '/settings/persons/staff': typeof StaffSettingsPersonsListAccountStaffIndexRoute
  '/software/alerts/alumni': typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  '/software/alerts/inactive-user': typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  '/software/alerts/no-user': typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  '/software/alerts/no-worker': typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  '/software/alerts/violated-assignment': typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  '/software/alerts/violated-role': typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
  '/time-and-attendance/summary/daily-place': typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  '/time-and-attendance/summary/monthly-person': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  '/time-and-attendance/summary/monthly-place': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
  '/apps/marketplace/$id/install/finish': typeof StaffAppsListMarketplaceIdInstallFinishIndexRoute
  '/it-operation-core/operation-instances/$instanceId/data': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  '/it-operation-core/operation-instances/$instanceId/detail': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  '/it-operation-core/operation-instances/$instanceId/operation-activity': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
  '/licenses/$id/service-plans/$licenseServiceId/accounts': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
  '/settings/permission-and-roles/people-groups/$id/edit': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  '/settings/permission-and-roles/product-permissions/$id/edit': typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  '/settings/permission-and-roles/roles/$id/edit': typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
  '/software/marketplace/$id/install/finish': typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/individual/task/$id/form/$formId': typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
  '/apps/alerts/shadow-it/apps': typeof StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute
  '/apps/alerts/shadow-it/visit-histories': typeof StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute
  '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_individual': typeof IndividualRouteWithChildren
  '/_staff': typeof StaffRouteWithChildren
  '/_staff/apps': typeof StaffAppsRouteWithChildren
  '/_staff/id-managements': typeof StaffIdManagementsRouteWithChildren
  '/_staff/it-operation-core/device-inventory': typeof StaffItOperationCoreDeviceInventoryRouteRouteWithChildren
  '/_staff/places/import-csv': typeof StaffPlacesImportCsvRouteRoute
  '/_staff/accesses': typeof StaffAccessesRouteWithChildren
  '/_staff/accesses/_layout': typeof StaffAccessesLayoutRouteWithChildren
  '/_staff/apps/$': typeof StaffAppsSplatRoute
  '/_staff/apps/_list': typeof StaffAppsListRouteWithChildren
  '/_staff/business-operation-events': typeof StaffBusinessOperationEventsRouteWithChildren
  '/_staff/business-operation-events/_list': typeof StaffBusinessOperationEventsListRouteWithChildren
  '/_staff/business-partner': typeof StaffBusinessPartnerRouteWithChildren
  '/_staff/business-partner/_list': typeof StaffBusinessPartnerListRouteWithChildren
  '/_staff/certification': typeof StaffCertificationRouteWithChildren
  '/_staff/certification/_list': typeof StaffCertificationListRouteWithChildren
  '/_staff/contract': typeof StaffContractRouteWithChildren
  '/_staff/contract/_list': typeof StaffContractListRouteWithChildren
  '/_staff/contractor-core': typeof StaffContractorCoreRouteWithChildren
  '/_staff/contractor-core/_packages': typeof StaffContractorCorePackagesRouteWithChildren
  '/_staff/devices': typeof StaffDevicesRouteWithChildren
  '/_staff/devices/_list': typeof StaffDevicesListRouteWithChildren
  '/_staff/equipment': typeof StaffEquipmentRouteWithChildren
  '/_staff/equipment/_layout': typeof StaffEquipmentLayoutRouteWithChildren
  '/_staff/fleets': typeof StaffFleetsRouteWithChildren
  '/_staff/fleets/_layout': typeof StaffFleetsLayoutRouteWithChildren
  '/_staff/ga-operation-core': typeof StaffGaOperationCoreRouteWithChildren
  '/_staff/ga-operation-core/_packages': typeof StaffGaOperationCorePackagesRouteWithChildren
  '/_staff/id-managements/$': typeof StaffIdManagementsSplatRoute
  '/_staff/ids': typeof StaffIdsRouteWithChildren
  '/_staff/ids/_layout': typeof StaffIdsLayoutRouteWithChildren
  '/_staff/it-operation-core': typeof StaffItOperationCoreRouteWithChildren
  '/_staff/it-operation-core/_detail': typeof StaffItOperationCoreDetailRouteWithChildren
  '/_staff/it-operation-core/_root': typeof StaffItOperationCoreRootRouteWithChildren
  '/_staff/labor-core': typeof StaffLaborCoreRouteWithChildren
  '/_staff/labor-core/_packages': typeof StaffLaborCorePackagesRouteWithChildren
  '/_staff/labor-core/anchor-date': typeof StaffLaborCoreAnchorDateRoute
  '/_staff/labor-core/person-targets': typeof StaffLaborCorePersonTargetsRoute
  '/_staff/licenses': typeof StaffLicensesRouteWithChildren
  '/_staff/licenses/_list': typeof StaffLicensesListRouteWithChildren
  '/_staff/marketplace': typeof StaffMarketplaceRouteWithChildren
  '/_staff/marketplace/_store': typeof StaffMarketplaceStoreRouteWithChildren
  '/_staff/networks': typeof StaffNetworksRouteWithChildren
  '/_staff/networks/_layout': typeof StaffNetworksLayoutRouteWithChildren
  '/_staff/organization': typeof StaffOrganizationRouteWithChildren
  '/_staff/organization/_list': typeof StaffOrganizationListRouteWithChildren
  '/_staff/people': typeof StaffPeopleRouteWithChildren
  '/_staff/people/_list': typeof StaffPeopleListRouteWithChildren
  '/_staff/places': typeof StaffPlacesRouteWithChildren
  '/_staff/places/_layout': typeof StaffPlacesLayoutRouteWithChildren
  '/_staff/public-ids/$id': typeof StaffPublicIdsIdRouteWithChildren
  '/_staff/public-ids': typeof StaffPublicIdsRouteWithChildren
  '/_staff/public-ids/_list': typeof StaffPublicIdsListRouteWithChildren
  '/_staff/software': typeof StaffSoftwareRouteWithChildren
  '/_staff/software/_layout': typeof StaffSoftwareLayoutRouteWithChildren
  '/_staff/starlinks': typeof StaffStarlinksRouteWithChildren
  '/_staff/starlinks/_layout': typeof StaffStarlinksLayoutRouteWithChildren
  '/_staff/storage-files': typeof StaffStorageFilesRouteWithChildren
  '/_staff/storage-files/_list': typeof StaffStorageFilesListRouteWithChildren
  '/_staff/time-and-attendance': typeof StaffTimeAndAttendanceRouteWithChildren
  '/_staff/time-and-attendance/_layout': typeof StaffTimeAndAttendanceLayoutRouteWithChildren
  '/_individual/individual/': typeof IndividualIndividualIndexRoute
  '/_staff/cockpit/': typeof StaffCockpitIndexRoute
  '/_staff/it-operation-core/': typeof StaffItOperationCoreIndexRoute
  '/_staff/organization/': typeof StaffOrganizationIndexRoute
  '/_staff/settings/': typeof StaffSettingsIndexRoute
  '/auth/sign-in/': typeof AuthSignInIndexRoute
  '/auth/password-reset/': typeof AuthPasswordResetIndexLazyRoute
  '/_staff/licenses/_list/': typeof StaffLicensesListIndexRouteRoute
  '/_staff/app-integrations/import-csv/$id': typeof StaffAppIntegrationsImportCsvIdRouteRoute
  '/_staff/devices/import-csv/$deviceType': typeof StaffDevicesImportCsvDeviceTypeRouteRoute
  '/_staff/it-operation-core/_root/packages': typeof StaffItOperationCoreRootPackagesRouteRouteWithChildren
  '/_staff/person/import-csv/$workerType': typeof StaffPersonImportCsvWorkerTypeRouteRoute
  '/_staff/places/_layout/settings': typeof StaffPlacesLayoutSettingsRouteRouteWithChildren
  '/_staff/public-ids/import-csv/$publicIdType': typeof StaffPublicIdsImportCsvPublicIdTypeRouteRoute
  '/_staff/software/$id/import-csv': typeof StaffSoftwareIdImportCsvRouteRoute
  '/_staff/software/_layout/people': typeof StaffSoftwareLayoutPeopleRouteRouteWithChildren
  '/_staff/app-integrations/$id': typeof StaffAppIntegrationsIdRouteWithChildren
  '/_staff/app-integrations/$id/_$id': typeof StaffAppIntegrationsIdIdRouteWithChildren
  '/_staff/apps/_list/contract-and-cost': typeof StaffAppsListContractAndCostRoute
  '/_staff/apps/_list/operation-activity': typeof StaffAppsListOperationActivityRoute
  '/_staff/apps/_list/rule-and-policy': typeof StaffAppsListRuleAndPolicyRoute
  '/_staff/business-operation-events/_list/archive': typeof StaffBusinessOperationEventsListArchiveRoute
  '/_staff/business-operation-events/_list/config': typeof StaffBusinessOperationEventsListConfigRoute
  '/_staff/business-operation-events/_list/operation-activity': typeof StaffBusinessOperationEventsListOperationActivityRoute
  '/_staff/business-operation-events/_list/overview': typeof StaffBusinessOperationEventsListOverviewRoute
  '/_staff/business-operation-events/_list/rule-and-policy': typeof StaffBusinessOperationEventsListRuleAndPolicyRoute
  '/_staff/business-operation-events/_list/settings': typeof StaffBusinessOperationEventsListSettingsRoute
  '/_staff/business-partner/$id': typeof StaffBusinessPartnerIdRouteWithChildren
  '/_staff/business-partner/$id/_layout': typeof StaffBusinessPartnerIdLayoutRouteWithChildren
  '/_staff/certification/$id': typeof StaffCertificationIdRouteWithChildren
  '/_staff/certification/$id/_layout': typeof StaffCertificationIdLayoutRouteWithChildren
  '/_staff/contract/$id': typeof StaffContractIdRouteWithChildren
  '/_staff/contract/$id/_layout': typeof StaffContractIdLayoutRouteWithChildren
  '/_staff/devices/_list/alerts': typeof StaffDevicesListAlertsRoute
  '/_staff/devices/_list/contract-and-cost': typeof StaffDevicesListContractAndCostRoute
  '/_staff/devices/_list/operation-activity': typeof StaffDevicesListOperationActivityRoute
  '/_staff/devices/_list/rule-and-policy': typeof StaffDevicesListRuleAndPolicyRoute
  '/_staff/equipment/$id': typeof StaffEquipmentIdRouteWithChildren
  '/_staff/equipment/$id/_layout': typeof StaffEquipmentIdLayoutRouteWithChildren
  '/_staff/fleets/$id': typeof StaffFleetsIdRouteWithChildren
  '/_staff/fleets/$id/_layout': typeof StaffFleetsIdLayoutRouteWithChildren
  '/_staff/fleets/_layout/alerts': typeof StaffFleetsLayoutAlertsRoute
  '/_staff/fleets/_layout/overview': typeof StaffFleetsLayoutOverviewRoute
  '/_staff/fleets/_layout/rule-and-policy': typeof StaffFleetsLayoutRuleAndPolicyRoute
  '/_staff/fleets/_layout/settings': typeof StaffFleetsLayoutSettingsRoute
  '/_staff/it-operation-core/device-inventory/data': typeof StaffItOperationCoreDeviceInventoryDataRoute
  '/_staff/it-operation-core/device-inventory/detail': typeof StaffItOperationCoreDeviceInventoryDetailRoute
  '/_staff/labor-core/_packages/settings': typeof StaffLaborCorePackagesSettingsRouteWithChildren
  '/_staff/labor-core/settings/egov-callback': typeof StaffLaborCoreSettingsEgovCallbackRoute
  '/_staff/licenses/$id': typeof StaffLicensesIdRouteWithChildren
  '/_staff/licenses/$id/_profile': typeof StaffLicensesIdProfileRouteWithChildren
  '/_staff/networks/$id': typeof StaffNetworksIdRouteWithChildren
  '/_staff/networks/$id/_layout': typeof StaffNetworksIdLayoutRouteWithChildren
  '/_staff/organization/$id': typeof StaffOrganizationIdRouteWithChildren
  '/_staff/organization/$id/_layout': typeof StaffOrganizationIdLayoutRouteWithChildren
  '/_staff/people/_list/alerts': typeof StaffPeopleListAlertsRoute
  '/_staff/people/_list/community': typeof StaffPeopleListCommunityRoute
  '/_staff/people/_list/operation-activity': typeof StaffPeopleListOperationActivityRoute
  '/_staff/people/_list/people-graph': typeof StaffPeopleListPeopleGraphRoute
  '/_staff/people/_list/rule-and-policy': typeof StaffPeopleListRuleAndPolicyRoute
  '/_staff/people/_list/salary-and-payment': typeof StaffPeopleListSalaryAndPaymentRoute
  '/_staff/person/$id': typeof StaffPersonIdRouteWithChildren
  '/_staff/person/$id/_profile': typeof StaffPersonIdProfileRouteWithChildren
  '/_staff/places/$id': typeof StaffPlacesIdRouteWithChildren
  '/_staff/places/$id/_layout': typeof StaffPlacesIdLayoutRouteWithChildren
  '/_staff/settings/contracting-corporation-profile': typeof StaffSettingsContractingCorporationProfileRouteWithChildren
  '/_staff/settings/contracting-corporation-profile/_layout': typeof StaffSettingsContractingCorporationProfileLayoutRouteWithChildren
  '/_staff/settings/permission-and-roles': typeof StaffSettingsPermissionAndRolesRouteWithChildren
  '/_staff/settings/permission-and-roles/_detail': typeof StaffSettingsPermissionAndRolesDetailRouteWithChildren
  '/_staff/settings/permission-and-roles/_form': typeof StaffSettingsPermissionAndRolesFormRouteWithChildren
  '/_staff/settings/permission-and-roles/_list': typeof StaffSettingsPermissionAndRolesListRouteWithChildren
  '/_staff/settings/persons': typeof StaffSettingsPersonsRouteWithChildren
  '/_staff/settings/persons/_list': typeof StaffSettingsPersonsListRouteWithChildren
  '/_staff/software/$id': typeof StaffSoftwareIdRouteWithChildren
  '/_staff/software/$id/_$id': typeof StaffSoftwareIdIdRouteWithChildren
  '/_staff/software/_layout/integrations': typeof StaffSoftwareLayoutIntegrationsRoute
  '/_staff/starlinks/$id': typeof StaffStarlinksIdRouteWithChildren
  '/_staff/starlinks/$id/_layout': typeof StaffStarlinksIdLayoutRouteWithChildren
  '/_staff/apps/_list/': typeof StaffAppsListIndexRouteLazyRoute
  '/_staff/devices/_list/': typeof StaffDevicesListIndexRouteLazyRoute
  '/_staff/people/_list/': typeof StaffPeopleListIndexRouteLazyRoute
  '/_staff/software/_layout/': typeof StaffSoftwareLayoutIndexRouteLazyRoute
  '/_staff/certification/_list/settings': typeof StaffCertificationListSettingsRouteLazyRouteWithChildren
  '/_staff/equipment/_layout/settings': typeof StaffEquipmentLayoutSettingsRouteLazyRouteWithChildren
  '/_staff/people/_list/settings': typeof StaffPeopleListSettingsRouteLazyRouteWithChildren
  '/_staff/accesses/_layout/': typeof StaffAccessesLayoutIndexRoute
  '/_staff/business-operation-events/$eventInstanceId/': typeof StaffBusinessOperationEventsEventInstanceIdIndexRoute
  '/_staff/business-operation-events/_list/': typeof StaffBusinessOperationEventsListIndexRoute
  '/_staff/business-partner/_list/': typeof StaffBusinessPartnerListIndexRoute
  '/_staff/business-partner/add/': typeof StaffBusinessPartnerAddIndexRoute
  '/_staff/certification/_list/': typeof StaffCertificationListIndexRoute
  '/_staff/certification/add/': typeof StaffCertificationAddIndexRoute
  '/_staff/cockpit/$id/': typeof StaffCockpitIdIndexRoute
  '/_staff/contract/_list/': typeof StaffContractListIndexRoute
  '/_staff/contract/add/': typeof StaffContractAddIndexRoute
  '/_staff/contractor-core/_packages/': typeof StaffContractorCorePackagesIndexRoute
  '/_staff/device-catalog/add/': typeof StaffDeviceCatalogAddIndexRoute
  '/_staff/devices/add/': typeof StaffDevicesAddIndexRoute
  '/_staff/devices/external-it-saas/': typeof StaffDevicesExternalItSaasIndexRoute
  '/_staff/equipment/_layout/': typeof StaffEquipmentLayoutIndexRoute
  '/_staff/equipment/add-select/': typeof StaffEquipmentAddSelectIndexRoute
  '/_staff/equipment/add/': typeof StaffEquipmentAddIndexRoute
  '/_staff/equipment/import-csv/': typeof StaffEquipmentImportCsvIndexRoute
  '/_staff/fleets/add-select/': typeof StaffFleetsAddSelectIndexRoute
  '/_staff/fleets/add/': typeof StaffFleetsAddIndexRoute
  '/_staff/ga-operation-core/_packages/': typeof StaffGaOperationCorePackagesIndexRoute
  '/_staff/ids/_layout/': typeof StaffIdsLayoutIndexRoute
  '/_staff/labor-core/_packages/': typeof StaffLaborCorePackagesIndexRoute
  '/_staff/licenses/add/': typeof StaffLicensesAddIndexRoute
  '/_staff/marketplace/cart/': typeof StaffMarketplaceCartIndexRoute
  '/_staff/marketplace/unavailable/': typeof StaffMarketplaceUnavailableIndexRoute
  '/_staff/networks/_layout/': typeof StaffNetworksLayoutIndexRoute
  '/_staff/networks/add/': typeof StaffNetworksAddIndexRoute
  '/_staff/organization/plan/': typeof StaffOrganizationPlanIndexRoute
  '/_staff/person/add-person-certification/': typeof StaffPersonAddPersonCertificationIndexRoute
  '/_staff/person/add/': typeof StaffPersonAddIndexRoute
  '/_staff/person/external-hr-saas/': typeof StaffPersonExternalHrSaasIndexRoute
  '/_staff/places/_layout/': typeof StaffPlacesLayoutIndexRoute
  '/_staff/places/add-select/': typeof StaffPlacesAddSelectIndexRoute
  '/_staff/places/add/': typeof StaffPlacesAddIndexRoute
  '/_staff/public-ids/$id/': typeof StaffPublicIdsIdIndexRoute
  '/_staff/public-ids/_list/': typeof StaffPublicIdsListIndexRoute
  '/_staff/public-ids/add/': typeof StaffPublicIdsAddIndexRoute
  '/_staff/settings/contracting-corporation-profile/': typeof StaffSettingsContractingCorporationProfileIndexRoute
  '/_staff/settings/permission-and-roles/': typeof StaffSettingsPermissionAndRolesIndexRoute
  '/_staff/settings/persons/': typeof StaffSettingsPersonsIndexRoute
  '/_staff/software/add/': typeof StaffSoftwareAddIndexRoute
  '/_staff/starlinks/_layout/': typeof StaffStarlinksLayoutIndexRoute
  '/_staff/time-and-attendance/_layout/': typeof StaffTimeAndAttendanceLayoutIndexRoute
  '/auth/invitation/$invitationCode/': typeof AuthInvitationInvitationCodeIndexRoute
  '/_staff/person/$id/_profile/': typeof StaffPersonIdProfileIndexRouteRoute
  '/_staff/apps/_list/marketplace/$id': typeof StaffAppsListMarketplaceIdRouteRouteWithChildren
  '/_staff/business-partner/_list/_placeholders/alerts': typeof StaffBusinessPartnerListPlaceholdersAlertsRouteRoute
  '/_staff/business-partner/_list/_placeholders/contract-and-cost': typeof StaffBusinessPartnerListPlaceholdersContractAndCostRouteRoute
  '/_staff/business-partner/_list/_placeholders/operation-activity': typeof StaffBusinessPartnerListPlaceholdersOperationActivityRouteRoute
  '/_staff/business-partner/_list/_placeholders/rule-and-policy': typeof StaffBusinessPartnerListPlaceholdersRuleAndPolicyRouteRoute
  '/_staff/business-partner/_list/_placeholders/settings': typeof StaffBusinessPartnerListPlaceholdersSettingsRouteRoute
  '/_staff/certification/_list/_placeholders/alerts': typeof StaffCertificationListPlaceholdersAlertsRouteRoute
  '/_staff/certification/_list/_placeholders/operation-activity': typeof StaffCertificationListPlaceholdersOperationActivityRouteRoute
  '/_staff/certification/_list/_placeholders/overview': typeof StaffCertificationListPlaceholdersOverviewRouteRoute
  '/_staff/certification/_list/_placeholders/rule-and-policy': typeof StaffCertificationListPlaceholdersRuleAndPolicyRouteRoute
  '/_staff/contract/_list/_placeholders/alerts': typeof StaffContractListPlaceholdersAlertsRouteRoute
  '/_staff/contract/_list/_placeholders/contract-and-cost': typeof StaffContractListPlaceholdersContractAndCostRouteRoute
  '/_staff/contract/_list/_placeholders/operation-activity': typeof StaffContractListPlaceholdersOperationActivityRouteRoute
  '/_staff/contract/_list/_placeholders/overview': typeof StaffContractListPlaceholdersOverviewRouteRoute
  '/_staff/contract/_list/_placeholders/people': typeof StaffContractListPlaceholdersPeopleRouteRoute
  '/_staff/software/_layout/marketplace/$id': typeof StaffSoftwareLayoutMarketplaceIdRouteRouteWithChildren
  '/_individual/individual/task/$id/approval-dialog': typeof IndividualIndividualTaskIdApprovalDialogRoute
  '/_staff/accesses/_layout/_placeholders/contract-and-cost': typeof StaffAccessesLayoutPlaceholdersContractAndCostRoute
  '/_staff/accesses/_layout/_placeholders/overview': typeof StaffAccessesLayoutPlaceholdersOverviewRoute
  '/_staff/accesses/_layout/_placeholders/settings': typeof StaffAccessesLayoutPlaceholdersSettingsRoute
  '/_staff/accesses/_layout/_placeholders/software': typeof StaffAccessesLayoutPlaceholdersSoftwareRoute
  '/_staff/app-integrations/$id/_$id/groups': typeof StaffAppIntegrationsIdIdGroupsRoute
  '/_staff/apps/_list/alerts': typeof StaffAppsListAlertsRouteWithChildren
  '/_staff/apps/_list/alerts/_alerts': typeof StaffAppsListAlertsAlertsRouteWithChildren
  '/_staff/business-partner/add/$businessPartnerType/completed': typeof StaffBusinessPartnerAddBusinessPartnerTypeCompletedRoute
  '/_staff/certification/add/$certificationKind/completed': typeof StaffCertificationAddCertificationKindCompletedRoute
  '/_staff/certification/handling-certification/$id': typeof StaffCertificationHandlingCertificationIdRouteWithChildren
  '/_staff/certification/handling-certification/$id/_layout': typeof StaffCertificationHandlingCertificationIdLayoutRouteWithChildren
  '/_staff/certification/specialty-certification/$id': typeof StaffCertificationSpecialtyCertificationIdRouteWithChildren
  '/_staff/certification/specialty-certification/$id/_layout': typeof StaffCertificationSpecialtyCertificationIdLayoutRouteWithChildren
  '/_staff/device-catalog/active/$id': typeof StaffDeviceCatalogActiveIdRouteWithChildren
  '/_staff/device-catalog/active/$id/_layout': typeof StaffDeviceCatalogActiveIdLayoutRouteWithChildren
  '/_staff/device-catalog/add/$deviceType/completed': typeof StaffDeviceCatalogAddDeviceTypeCompletedRoute
  '/_staff/device-catalog/draft/$id': typeof StaffDeviceCatalogDraftIdRouteWithChildren
  '/_staff/device-catalog/draft/$id/_layout': typeof StaffDeviceCatalogDraftIdLayoutRouteWithChildren
  '/_staff/devices/_list/settings/catalog': typeof StaffDevicesListSettingsCatalogRoute
  '/_staff/devices/add/$deviceType/completed': typeof StaffDevicesAddDeviceTypeCompletedRoute
  '/_staff/equipment/_layout/_placeholders/alerts': typeof StaffEquipmentLayoutPlaceholdersAlertsRoute
  '/_staff/equipment/_layout/_placeholders/overview': typeof StaffEquipmentLayoutPlaceholdersOverviewRoute
  '/_staff/equipment/_layout/_placeholders/rule-and-policy': typeof StaffEquipmentLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/equipment/_layout/_placeholders/settings': typeof StaffEquipmentLayoutPlaceholdersSettingsRoute
  '/_staff/ids/_layout/_placeholders/alerts': typeof StaffIdsLayoutPlaceholdersAlertsRoute
  '/_staff/ids/_layout/_placeholders/group-id': typeof StaffIdsLayoutPlaceholdersGroupIdRoute
  '/_staff/ids/_layout/_placeholders/operation-activity': typeof StaffIdsLayoutPlaceholdersOperationActivityRoute
  '/_staff/ids/_layout/_placeholders/overview': typeof StaffIdsLayoutPlaceholdersOverviewRoute
  '/_staff/ids/_layout/_placeholders/rule-and-policy': typeof StaffIdsLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/ids/_layout/_placeholders/settings': typeof StaffIdsLayoutPlaceholdersSettingsRoute
  '/_staff/ids/group-id/$id': typeof StaffIdsGroupIdIdRouteWithChildren
  '/_staff/ids/group-id/$id/_$id': typeof StaffIdsGroupIdIdIdRouteWithChildren
  '/_staff/it-operation-core/_root/packages/$packageId': typeof StaffItOperationCoreRootPackagesPackageIdRoute
  '/_staff/labor-core/settings/profile/$profileId': typeof StaffLaborCoreSettingsProfileProfileIdRoute
  '/_staff/licenses/add/$allocationType/completed': typeof StaffLicensesAddAllocationTypeCompletedRoute
  '/_staff/marketplace/sent-orders/$orderId': typeof StaffMarketplaceSentOrdersOrderIdRouteWithChildren
  '/_staff/marketplace/sent-orders/$orderId/_layout': typeof StaffMarketplaceSentOrdersOrderIdLayoutRouteWithChildren
  '/_staff/networks/_layout/_placeholders/alerts': typeof StaffNetworksLayoutPlaceholdersAlertsRoute
  '/_staff/networks/_layout/_placeholders/contract-and-cost': typeof StaffNetworksLayoutPlaceholdersContractAndCostRoute
  '/_staff/networks/_layout/_placeholders/operation-activity': typeof StaffNetworksLayoutPlaceholdersOperationActivityRoute
  '/_staff/networks/_layout/_placeholders/overview': typeof StaffNetworksLayoutPlaceholdersOverviewRoute
  '/_staff/networks/_layout/_placeholders/rule-and-policy': typeof StaffNetworksLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/networks/_layout/_placeholders/settings': typeof StaffNetworksLayoutPlaceholdersSettingsRoute
  '/_staff/person/add-person-certification/$certificationKind/completed': typeof StaffPersonAddPersonCertificationCertificationKindCompletedRoute
  '/_staff/person/add/$workerType/completed': typeof StaffPersonAddWorkerTypeCompletedRoute
  '/_staff/person/alumni/$id': typeof StaffPersonAlumniIdRouteWithChildren
  '/_staff/person/alumni/$id/_profile': typeof StaffPersonAlumniIdProfileRouteWithChildren
  '/_staff/places/_layout/_placeholders/alerts': typeof StaffPlacesLayoutPlaceholdersAlertsRoute
  '/_staff/places/_layout/_placeholders/contract-and-cost': typeof StaffPlacesLayoutPlaceholdersContractAndCostRoute
  '/_staff/places/_layout/_placeholders/operation-activity': typeof StaffPlacesLayoutPlaceholdersOperationActivityRoute
  '/_staff/places/_layout/_placeholders/overview': typeof StaffPlacesLayoutPlaceholdersOverviewRoute
  '/_staff/places/_layout/_placeholders/people': typeof StaffPlacesLayoutPlaceholdersPeopleRoute
  '/_staff/places/_layout/_placeholders/rule-and-policy': typeof StaffPlacesLayoutPlaceholdersRuleAndPolicyRoute
  '/_staff/places/_layout/_placeholders/store': typeof StaffPlacesLayoutPlaceholdersStoreRoute
  '/_staff/profile/device/$id': typeof StaffProfileDeviceIdRouteWithChildren
  '/_staff/profile/device/$id/_profile': typeof StaffProfileDeviceIdProfileRouteWithChildren
  '/_staff/settings/persons/_list/_account': typeof StaffSettingsPersonsListAccountRouteWithChildren
  '/_staff/software/_layout/alerts': typeof StaffSoftwareLayoutAlertsRouteWithChildren
  '/_staff/software/_layout/alerts/_alerts': typeof StaffSoftwareLayoutAlertsAlertsRouteWithChildren
  '/_staff/starlinks/_layout/_placeholders/billing-and-cost': typeof StaffStarlinksLayoutPlaceholdersBillingAndCostRoute
  '/_staff/starlinks/_layout/_placeholders/marketplace': typeof StaffStarlinksLayoutPlaceholdersMarketplaceRoute
  '/_staff/starlinks/_layout/_placeholders/operation-activity': typeof StaffStarlinksLayoutPlaceholdersOperationActivityRoute
  '/_staff/time-and-attendance/_layout/_placeholders/attendances': typeof StaffTimeAndAttendanceLayoutPlaceholdersAttendancesRoute
  '/_staff/time-and-attendance/_layout/_placeholders/clocking': typeof StaffTimeAndAttendanceLayoutPlaceholdersClockingRoute
  '/_individual/individual/operation-package/$id/': typeof IndividualIndividualOperationPackageIdIndexRoute
  '/_individual/individual/task/$id/': typeof IndividualIndividualTaskIdIndexRoute
  '/_staff/accesses/_layout/alerts/': typeof StaffAccessesLayoutAlertsIndexRoute
  '/_staff/accesses/_layout/list/': typeof StaffAccessesLayoutListIndexRoute
  '/_staff/app-integrations/$id/_$id/': typeof StaffAppIntegrationsIdIdIndexRoute
  '/_staff/apps/_list/integrations/': typeof StaffAppsListIntegrationsIndexRoute
  '/_staff/apps/_list/marketplace/': typeof StaffAppsListMarketplaceIndexRoute
  '/_staff/apps/_list/people/': typeof StaffAppsListPeopleIndexRoute
  '/_staff/apps/_list/settings/': typeof StaffAppsListSettingsIndexRoute
  '/_staff/apps/custom-app/add/': typeof StaffAppsCustomAppAddIndexRoute
  '/_staff/business-partner/_list/terminated/': typeof StaffBusinessPartnerListTerminatedIndexRoute
  '/_staff/business-partner/add/$businessPartnerType/': typeof StaffBusinessPartnerAddBusinessPartnerTypeIndexRoute
  '/_staff/certification/_list/settings/': typeof StaffCertificationListSettingsIndexRoute
  '/_staff/certification/add/$certificationKind/': typeof StaffCertificationAddCertificationKindIndexRoute
  '/_staff/contract/import-csv/$contractType/': typeof StaffContractImportCsvContractTypeIndexRoute
  '/_staff/contractor-core/_packages/archives/': typeof StaffContractorCorePackagesArchivesIndexRoute
  '/_staff/contractor-core/_packages/configs/': typeof StaffContractorCorePackagesConfigsIndexRoute
  '/_staff/contractor-core/config/$patternId/': typeof StaffContractorCoreConfigPatternIdIndexRoute
  '/_staff/device-catalog/add/$deviceType/': typeof StaffDeviceCatalogAddDeviceTypeIndexRoute
  '/_staff/devices/_list/catalog/': typeof StaffDevicesListCatalogIndexRoute
  '/_staff/devices/_list/inventory/': typeof StaffDevicesListInventoryIndexRoute
  '/_staff/devices/_list/people/': typeof StaffDevicesListPeopleIndexRoute
  '/_staff/devices/_list/settings/': typeof StaffDevicesListSettingsIndexRoute
  '/_staff/devices/add/$deviceType/': typeof StaffDevicesAddDeviceTypeIndexRoute
  '/_staff/equipment/_layout/settings/': typeof StaffEquipmentLayoutSettingsIndexRoute
  '/_staff/fleets/_layout/_list/': typeof StaffFleetsLayoutListIndexRoute
  '/_staff/ga-operation-core/_packages/archives/': typeof StaffGaOperationCorePackagesArchivesIndexRoute
  '/_staff/ga-operation-core/_packages/configs/': typeof StaffGaOperationCorePackagesConfigsIndexRoute
  '/_staff/ga-operation-core/config/$patternId/': typeof StaffGaOperationCoreConfigPatternIdIndexRoute
  '/_staff/ids/_layout/people/': typeof StaffIdsLayoutPeopleIndexRoute
  '/_staff/ids/group-id/add/': typeof StaffIdsGroupIdAddIndexRoute
  '/_staff/it-operation-core/_root/archives/': typeof StaffItOperationCoreRootArchivesIndexRoute
  '/_staff/it-operation-core/_root/config/': typeof StaffItOperationCoreRootConfigIndexRoute
  '/_staff/it-operation-core/_root/packages/': typeof StaffItOperationCoreRootPackagesIndexRoute
  '/_staff/it-operation-core/config/$patternId/': typeof StaffItOperationCoreConfigPatternIdIndexRoute
  '/_staff/labor-core/_packages/archives/': typeof StaffLaborCorePackagesArchivesIndexRoute
  '/_staff/labor-core/_packages/configs/': typeof StaffLaborCorePackagesConfigsIndexRoute
  '/_staff/labor-core/_packages/settings/': typeof StaffLaborCorePackagesSettingsIndexRoute
  '/_staff/labor-core/config/$patternId/': typeof StaffLaborCoreConfigPatternIdIndexRoute
  '/_staff/licenses/_list/alerts/': typeof StaffLicensesListAlertsIndexRoute
  '/_staff/licenses/_list/contract-and-cost/': typeof StaffLicensesListContractAndCostIndexRoute
  '/_staff/licenses/_list/inventory/': typeof StaffLicensesListInventoryIndexRoute
  '/_staff/licenses/_list/operation-activity/': typeof StaffLicensesListOperationActivityIndexRoute
  '/_staff/licenses/_list/people/': typeof StaffLicensesListPeopleIndexRoute
  '/_staff/licenses/_list/rule-and-policy/': typeof StaffLicensesListRuleAndPolicyIndexRoute
  '/_staff/licenses/_list/settings/': typeof StaffLicensesListSettingsIndexRoute
  '/_staff/licenses/add/$allocationType/': typeof StaffLicensesAddAllocationTypeIndexRoute
  '/_staff/marketplace/sales-orders/$orderId/': typeof StaffMarketplaceSalesOrdersOrderIdIndexRoute
  '/_staff/organization/$id/_layout/': typeof StaffOrganizationIdLayoutIndexRoute
  '/_staff/organization/_list/alert/': typeof StaffOrganizationListAlertIndexRoute
  '/_staff/organization/_list/chart/': typeof StaffOrganizationListChartIndexRoute
  '/_staff/organization/_list/cost/': typeof StaffOrganizationListCostIndexRoute
  '/_staff/organization/_list/history/': typeof StaffOrganizationListHistoryIndexRoute
  '/_staff/organization/_list/rule-policy/': typeof StaffOrganizationListRulePolicyIndexRoute
  '/_staff/organization/_list/settings/': typeof StaffOrganizationListSettingsIndexRoute
  '/_staff/organization/plan/$id/': typeof StaffOrganizationPlanIdIndexRoute
  '/_staff/organization/plan/create/': typeof StaffOrganizationPlanCreateIndexRoute
  '/_staff/people/_list/alumni/': typeof StaffPeopleListAlumniIndexRoute
  '/_staff/people/_list/settings/': typeof StaffPeopleListSettingsIndexRoute
  '/_staff/people/_list/workforce/': typeof StaffPeopleListWorkforceIndexRoute
  '/_staff/person/add-person-certification/$certificationKind/': typeof StaffPersonAddPersonCertificationCertificationKindIndexRoute
  '/_staff/person/add/$workerType/': typeof StaffPersonAddWorkerTypeIndexRoute
  '/_staff/places/_layout/settings/': typeof StaffPlacesLayoutSettingsIndexRoute
  '/_staff/public-ids/$id/details/': typeof StaffPublicIdsIdDetailsIndexRoute
  '/_staff/public-ids/$id/files/': typeof StaffPublicIdsIdFilesIndexRoute
  '/_staff/public-ids/_list/alerts/': typeof StaffPublicIdsListAlertsIndexRoute
  '/_staff/public-ids/_list/members/': typeof StaffPublicIdsListMembersIndexRoute
  '/_staff/public-ids/_list/operation-activity/': typeof StaffPublicIdsListOperationActivityIndexRoute
  '/_staff/public-ids/_list/registry/': typeof StaffPublicIdsListRegistryIndexRoute
  '/_staff/public-ids/_list/rules-and-policies/': typeof StaffPublicIdsListRulesAndPoliciesIndexRoute
  '/_staff/public-ids/_list/settings/': typeof StaffPublicIdsListSettingsIndexRoute
  '/_staff/software/$id/_$id/': typeof StaffSoftwareIdIdIndexRoute
  '/_staff/software/_layout/contract-and-cost/': typeof StaffSoftwareLayoutContractAndCostIndexRoute
  '/_staff/software/_layout/marketplace/': typeof StaffSoftwareLayoutMarketplaceIndexRoute
  '/_staff/software/_layout/operation-activity/': typeof StaffSoftwareLayoutOperationActivityIndexRoute
  '/_staff/software/_layout/people/': typeof StaffSoftwareLayoutPeopleIndexRoute
  '/_staff/software/_layout/registry/': typeof StaffSoftwareLayoutRegistryIndexRoute
  '/_staff/software/_layout/rule-and-policy/': typeof StaffSoftwareLayoutRuleAndPolicyIndexRoute
  '/_staff/software/_layout/settings/': typeof StaffSoftwareLayoutSettingsIndexRoute
  '/_staff/software/add/$type/': typeof StaffSoftwareAddTypeIndexRoute
  '/_staff/starlinks/_layout/alerts/': typeof StaffStarlinksLayoutAlertsIndexRoute
  '/_staff/starlinks/_layout/user-terminals/': typeof StaffStarlinksLayoutUserTerminalsIndexRoute
  '/_staff/storage-files/_list/files/': typeof StaffStorageFilesListFilesIndexRoute
  '/_staff/storage-files/_list/folders/': typeof StaffStorageFilesListFoldersIndexRoute
  '/_staff/time-and-attendance/_layout/attendance-links/': typeof StaffTimeAndAttendanceLayoutAttendanceLinksIndexRoute
  '/_staff/licenses/$id/_profile/': typeof StaffLicensesIdProfileIndexLazyRoute
  '/_staff/person/alumni/$id/_profile/': typeof StaffPersonAlumniIdProfileIndexRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/approval-info': typeof StaffContractIdLayoutPlaceholdersApprovalInfoRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/history': typeof StaffContractIdLayoutPlaceholdersHistoryRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/operation-activity': typeof StaffContractIdLayoutPlaceholdersOperationActivityRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/risk-provisions': typeof StaffContractIdLayoutPlaceholdersRiskProvisionsRouteRoute
  '/_staff/contract/$id/_layout/_placeholders/rule-and-policy': typeof StaffContractIdLayoutPlaceholdersRuleAndPolicyRouteRoute
  '/_staff/profile/device/$id/_profile/files': typeof StaffProfileDeviceIdProfileFilesRouteRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdRouteWithChildren
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutRouteWithChildren
  '/_staff/licenses/$id/service-plans/$licenseServiceId': typeof StaffLicensesIdServicePlansLicenseServiceIdRouteWithChildren
  '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailRouteWithChildren
  '/_staff/marketplace/sent-orders/$orderId/_layout/activities': typeof StaffMarketplaceSentOrdersOrderIdLayoutActivitiesRoute
  '/_staff/profile/device/$id/_profile/configuration': typeof StaffProfileDeviceIdProfileConfigurationRoute
  '/_staff/profile/device/$id/_profile/monitoring': typeof StaffProfileDeviceIdProfileMonitoringRoute
  '/_staff/profile/device/$id/_profile/': typeof StaffProfileDeviceIdProfileIndexRouteLazyRoute
  '/_staff/profile/device/$id/_profile/control': typeof StaffProfileDeviceIdProfileControlRouteLazyRoute
  '/_staff/profile/device/$id/_profile/mdm': typeof StaffProfileDeviceIdProfileMdmRouteLazyRoute
  '/_staff/profile/device/$id/_profile/status': typeof StaffProfileDeviceIdProfileStatusRouteLazyRoute
  '/_individual/individual/task/$id/approval/': typeof IndividualIndividualTaskIdApprovalIndexRoute
  '/_staff/app-integrations/$id/_$id/architecture/': typeof StaffAppIntegrationsIdIdArchitectureIndexRoute
  '/_staff/app-integrations/$id/_$id/detail/': typeof StaffAppIntegrationsIdIdDetailIndexRoute
  '/_staff/app-integrations/$id/_$id/rule-and-policy/': typeof StaffAppIntegrationsIdIdRuleAndPolicyIndexRoute
  '/_staff/app-integrations/$id/_$id/settings/': typeof StaffAppIntegrationsIdIdSettingsIndexRoute
  '/_staff/app-integrations/$id/_$id/users/': typeof StaffAppIntegrationsIdIdUsersIndexRoute
  '/_staff/apps/_list/alerts/_alerts/': typeof StaffAppsListAlertsAlertsIndexRoute
  '/_staff/apps/custom-app/add/$customAppType/': typeof StaffAppsCustomAppAddCustomAppTypeIndexRoute
  '/_staff/business-partner/$id/_layout/_index/': typeof StaffBusinessPartnerIdLayoutIndexIndexRoute
  '/_staff/business-partner/$id/_layout/address-and-contact/': typeof StaffBusinessPartnerIdLayoutAddressAndContactIndexRoute
  '/_staff/certification/$id/_layout/_index/': typeof StaffCertificationIdLayoutIndexIndexRoute
  '/_staff/certification/$id/_layout/certification-holders/': typeof StaffCertificationIdLayoutCertificationHoldersIndexRoute
  '/_staff/certification/$id/_layout/handling-certifications/': typeof StaffCertificationIdLayoutHandlingCertificationsIndexRoute
  '/_staff/certification/$id/_layout/specialty-certifications/': typeof StaffCertificationIdLayoutSpecialtyCertificationsIndexRoute
  '/_staff/certification/_list/settings/issuing-organization/': typeof StaffCertificationListSettingsIssuingOrganizationIndexRoute
  '/_staff/certification/_list/settings/specialty-category-level/': typeof StaffCertificationListSettingsSpecialtyCategoryLevelIndexRoute
  '/_staff/certification/_list/settings/specialty-category/': typeof StaffCertificationListSettingsSpecialtyCategoryIndexRoute
  '/_staff/devices/external-it-saas/$appIntegrationId/preview/': typeof StaffDevicesExternalItSaasAppIntegrationIdPreviewIndexRoute
  '/_staff/equipment/_layout/settings/equipment-items/': typeof StaffEquipmentLayoutSettingsEquipmentItemsIndexRoute
  '/_staff/equipment/_layout/settings/equipment-types/': typeof StaffEquipmentLayoutSettingsEquipmentTypesIndexRoute
  '/_staff/ids/group-id/$id/_$id/': typeof StaffIdsGroupIdIdIdIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdIndexRoute
  '/_staff/licenses/$id/_profile/assignments/': typeof StaffLicensesIdProfileAssignmentsIndexRoute
  '/_staff/licenses/$id/_profile/people/': typeof StaffLicensesIdProfilePeopleIndexRoute
  '/_staff/licenses/$id/_profile/service-plans/': typeof StaffLicensesIdProfileServicePlansIndexRoute
  '/_staff/marketplace/_store/store/devices/': typeof StaffMarketplaceStoreStoreDevicesIndexRoute
  '/_staff/marketplace/_store/store/sales-orders/': typeof StaffMarketplaceStoreStoreSalesOrdersIndexRoute
  '/_staff/marketplace/_store/store/sent-orders/': typeof StaffMarketplaceStoreStoreSentOrdersIndexRoute
  '/_staff/marketplace/_store/store/starlinks/': typeof StaffMarketplaceStoreStoreStarlinksIndexRoute
  '/_staff/marketplace/sent-orders/$orderId/_layout/': typeof StaffMarketplaceSentOrdersOrderIdLayoutIndexRoute
  '/_staff/organization/$id/_layout/history/': typeof StaffOrganizationIdLayoutHistoryIndexRoute
  '/_staff/organization/plan/$id/add/': typeof StaffOrganizationPlanIdAddIndexRoute
  '/_staff/people/_list/settings/board-member-types/': typeof StaffPeopleListSettingsBoardMemberTypesIndexRoute
  '/_staff/people/_list/settings/collaborator-types/': typeof StaffPeopleListSettingsCollaboratorTypesIndexRoute
  '/_staff/people/_list/settings/contract-end-reasons/': typeof StaffPeopleListSettingsContractEndReasonsIndexRoute
  '/_staff/people/_list/settings/contractor-types/': typeof StaffPeopleListSettingsContractorTypesIndexRoute
  '/_staff/people/_list/settings/employee-sub-id-names/': typeof StaffPeopleListSettingsEmployeeSubIdNamesIndexRoute
  '/_staff/people/_list/settings/employment-types/': typeof StaffPeopleListSettingsEmploymentTypesIndexRoute
  '/_staff/people/_list/settings/grades/': typeof StaffPeopleListSettingsGradesIndexRoute
  '/_staff/people/_list/settings/health-insurance-associations/': typeof StaffPeopleListSettingsHealthInsuranceAssociationsIndexRoute
  '/_staff/people/_list/settings/job-competencies/': typeof StaffPeopleListSettingsJobCompetenciesIndexRoute
  '/_staff/people/_list/settings/job-functions/': typeof StaffPeopleListSettingsJobFunctionsIndexRoute
  '/_staff/people/_list/settings/job-grades/': typeof StaffPeopleListSettingsJobGradesIndexRoute
  '/_staff/people/_list/settings/job-levels/': typeof StaffPeopleListSettingsJobLevelsIndexRoute
  '/_staff/people/_list/settings/job-titles/': typeof StaffPeopleListSettingsJobTitlesIndexRoute
  '/_staff/people/_list/settings/job-types/': typeof StaffPeopleListSettingsJobTypesIndexRoute
  '/_staff/people/_list/settings/place-social-insurances/': typeof StaffPeopleListSettingsPlaceSocialInsurancesIndexRoute
  '/_staff/people/_list/settings/positions/': typeof StaffPeopleListSettingsPositionsIndexRoute
  '/_staff/people/_list/settings/retirement-reasons/': typeof StaffPeopleListSettingsRetirementReasonsIndexRoute
  '/_staff/people/_list/settings/work-mode/': typeof StaffPeopleListSettingsWorkModeIndexRoute
  '/_staff/person/$id/_profile/activity/': typeof StaffPersonIdProfileActivityIndexRoute
  '/_staff/person/$id/_profile/apps/': typeof StaffPersonIdProfileAppsIndexRoute
  '/_staff/person/$id/_profile/devices/': typeof StaffPersonIdProfileDevicesIndexRoute
  '/_staff/person/$id/_profile/education-and-qualification/': typeof StaffPersonIdProfileEducationAndQualificationIndexRoute
  '/_staff/person/$id/_profile/employee-information/': typeof StaffPersonIdProfileEmployeeInformationIndexRoute
  '/_staff/person/$id/_profile/equipment/': typeof StaffPersonIdProfileEquipmentIndexRoute
  '/_staff/person/$id/_profile/history/': typeof StaffPersonIdProfileHistoryIndexRoute
  '/_staff/person/$id/_profile/personal-information/': typeof StaffPersonIdProfilePersonalInformationIndexRoute
  '/_staff/person/$id/_profile/public-id/': typeof StaffPersonIdProfilePublicIdIndexRoute
  '/_staff/person/external-hr-saas/$appIntegrationId/preview/': typeof StaffPersonExternalHrSaasAppIntegrationIdPreviewIndexRoute
  '/_staff/places/$id/_layout/administrators/': typeof StaffPlacesIdLayoutAdministratorsIndexRoute
  '/_staff/places/$id/_layout/labor-core/': typeof StaffPlacesIdLayoutLaborCoreIndexRoute
  '/_staff/places/_layout/settings/place-sub-codes/': typeof StaffPlacesLayoutSettingsPlaceSubCodesIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/board-member/': typeof StaffSettingsContractingCorporationProfileLayoutBoardMemberIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/contact-points/': typeof StaffSettingsContractingCorporationProfileLayoutContactPointsIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/': typeof StaffSettingsContractingCorporationProfileLayoutCorporateOverviewIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/group-companies/': typeof StaffSettingsContractingCorporationProfileLayoutGroupCompaniesIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/history/': typeof StaffSettingsContractingCorporationProfileLayoutHistoryIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/registration/': typeof StaffSettingsContractingCorporationProfileLayoutRegistrationIndexRoute
  '/_staff/settings/contracting-corporation-profile/_layout/shareholders/': typeof StaffSettingsContractingCorporationProfileLayoutShareholdersIndexRoute
  '/_staff/settings/permission-and-roles/_list/people-groups/': typeof StaffSettingsPermissionAndRolesListPeopleGroupsIndexRoute
  '/_staff/settings/permission-and-roles/_list/product-permissions/': typeof StaffSettingsPermissionAndRolesListProductPermissionsIndexRoute
  '/_staff/settings/permission-and-roles/_list/roles/': typeof StaffSettingsPermissionAndRolesListRolesIndexRoute
  '/_staff/settings/persons/_list/settings/': typeof StaffSettingsPersonsListSettingsIndexRoute
  '/_staff/software/$id/_$id/activity-monitoring/': typeof StaffSoftwareIdIdActivityMonitoringIndexRoute
  '/_staff/software/$id/_$id/architecture/': typeof StaffSoftwareIdIdArchitectureIndexRoute
  '/_staff/software/$id/_$id/contracts-cost/': typeof StaffSoftwareIdIdContractsCostIndexRoute
  '/_staff/software/$id/_$id/detail/': typeof StaffSoftwareIdIdDetailIndexRoute
  '/_staff/software/$id/_$id/rule-and-policy/': typeof StaffSoftwareIdIdRuleAndPolicyIndexRoute
  '/_staff/software/$id/_$id/settings/': typeof StaffSoftwareIdIdSettingsIndexRoute
  '/_staff/software/$id/_$id/users/': typeof StaffSoftwareIdIdUsersIndexRoute
  '/_staff/software/_layout/alerts/_alerts/': typeof StaffSoftwareLayoutAlertsAlertsIndexRoute
  '/_staff/software/custom-saas/add/$customSaasType/': typeof StaffSoftwareCustomSaasAddCustomSaasTypeIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/': typeof StaffTimeAndAttendanceLayoutListSummaryIndexRoute
  '/_staff/time-and-attendance/_layout/attendance-links/$placeId/': typeof StaffTimeAndAttendanceLayoutAttendanceLinksPlaceIdIndexRoute
  '/_staff/contract/$id/_layout/_index/': typeof StaffContractIdLayoutIndexIndexLazyRoute
  '/_staff/contract/$id/_layout/structure/': typeof StaffContractIdLayoutStructureIndexLazyRoute
  '/_staff/equipment/$id/_layout/_profile/': typeof StaffEquipmentIdLayoutProfileIndexLazyRoute
  '/_staff/fleets/$id/_layout/_profile/': typeof StaffFleetsIdLayoutProfileIndexLazyRoute
  '/_staff/networks/$id/_layout/_profile/': typeof StaffNetworksIdLayoutProfileIndexLazyRoute
  '/_staff/places/$id/_layout/_profile/': typeof StaffPlacesIdLayoutProfileIndexLazyRoute
  '/_staff/starlinks/$id/_layout/_overview/': typeof StaffStarlinksIdLayoutOverviewIndexLazyRoute
  '/_staff/starlinks/$id/_layout/detail/': typeof StaffStarlinksIdLayoutDetailIndexLazyRoute
  '/_staff/apps/_list/alerts/_alerts/shadow-it': typeof StaffAppsListAlertsAlertsShadowItRouteWithChildren
  '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it': typeof StaffAppsListAlertsAlertsShadowItShadowItRouteWithChildren
  '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdRouteWithChildren
  '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdRouteWithChildren
  '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdRouteWithChildren
  '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutRouteWithChildren
  '/_individual/individual/operation-package/$id/pattern/$patternId/': typeof IndividualIndividualOperationPackageIdPatternPatternIdIndexRoute
  '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/': typeof StaffAccessesLayoutAlertsDetailShadowItAppIdIndexRoute
  '/_staff/apps/_list/alerts/_alerts/inactive-user/': typeof StaffAppsListAlertsAlertsInactiveUserIndexRoute
  '/_staff/apps/_list/alerts/_alerts/no-user/': typeof StaffAppsListAlertsAlertsNoUserIndexRoute
  '/_staff/apps/_list/alerts/_alerts/no-worker/': typeof StaffAppsListAlertsAlertsNoWorkerIndexRoute
  '/_staff/apps/_list/alerts/_alerts/violated-assignment/': typeof StaffAppsListAlertsAlertsViolatedAssignmentIndexRoute
  '/_staff/apps/_list/alerts/_alerts/violated-role/': typeof StaffAppsListAlertsAlertsViolatedRoleIndexRoute
  '/_staff/certification/handling-certification/$id/_layout/_index/': typeof StaffCertificationHandlingCertificationIdLayoutIndexIndexRoute
  '/_staff/certification/handling-certification/$id/_layout/certification-holders/': typeof StaffCertificationHandlingCertificationIdLayoutCertificationHoldersIndexRoute
  '/_staff/certification/specialty-certification/$id/_layout/_index/': typeof StaffCertificationSpecialtyCertificationIdLayoutIndexIndexRoute
  '/_staff/certification/specialty-certification/$id/_layout/certification-holders/': typeof StaffCertificationSpecialtyCertificationIdLayoutCertificationHoldersIndexRoute
  '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/': typeof StaffCertificationSpecialtyCertificationIdLayoutHandlingCertificationsIndexRoute
  '/_staff/device-catalog/active/$id/_layout/profile/': typeof StaffDeviceCatalogActiveIdLayoutProfileIndexRoute
  '/_staff/device-catalog/draft/$id/_layout/profile/': typeof StaffDeviceCatalogDraftIdLayoutProfileIndexRoute
  '/_staff/ids/group-id/$id/_$id/members/': typeof StaffIdsGroupIdIdIdMembersIndexRoute
  '/_staff/ids/group-id/$id/_$id/rule-and-policy/': typeof StaffIdsGroupIdIdIdRuleAndPolicyIndexRoute
  '/_staff/ids/group-id/$id/_$id/settings/': typeof StaffIdsGroupIdIdIdSettingsIndexRoute
  '/_staff/marketplace/_store/store/devices/$productId/': typeof StaffMarketplaceStoreStoreDevicesProductIdIndexRoute
  '/_staff/marketplace/_store/store/starlinks/$productId/': typeof StaffMarketplaceStoreStoreStarlinksProductIdIndexRoute
  '/_staff/organization/plan/$id/edit/$unitId/': typeof StaffOrganizationPlanIdEditUnitIdIndexRoute
  '/_staff/person/$id/_profile/family/$familyPersonId/': typeof StaffPersonIdProfileFamilyFamilyPersonIdIndexRoute
  '/_staff/person/alumni/$id/_profile/activity/': typeof StaffPersonAlumniIdProfileActivityIndexRoute
  '/_staff/person/alumni/$id/_profile/apps/': typeof StaffPersonAlumniIdProfileAppsIndexRoute
  '/_staff/person/alumni/$id/_profile/devices/': typeof StaffPersonAlumniIdProfileDevicesIndexRoute
  '/_staff/person/alumni/$id/_profile/education-and-qualification/': typeof StaffPersonAlumniIdProfileEducationAndQualificationIndexRoute
  '/_staff/person/alumni/$id/_profile/employee-information/': typeof StaffPersonAlumniIdProfileEmployeeInformationIndexRoute
  '/_staff/person/alumni/$id/_profile/equipment/': typeof StaffPersonAlumniIdProfileEquipmentIndexRoute
  '/_staff/person/alumni/$id/_profile/history/': typeof StaffPersonAlumniIdProfileHistoryIndexRoute
  '/_staff/person/alumni/$id/_profile/personal-information/': typeof StaffPersonAlumniIdProfilePersonalInformationIndexRoute
  '/_staff/person/alumni/$id/_profile/public-id/': typeof StaffPersonAlumniIdProfilePublicIdIndexRoute
  '/_staff/profile/device/$id/_profile/history/': typeof StaffProfileDeviceIdProfileHistoryIndexRoute
  '/_staff/profile/device/$id/_profile/lifecycle/': typeof StaffProfileDeviceIdProfileLifecycleIndexRoute
  '/_staff/settings/permission-and-roles/_detail/people-groups/$id/': typeof StaffSettingsPermissionAndRolesDetailPeopleGroupsIdIndexRoute
  '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/': typeof StaffSettingsPermissionAndRolesDetailProductPermissionsIdIndexRoute
  '/_staff/settings/permission-and-roles/_detail/roles/$id/': typeof StaffSettingsPermissionAndRolesDetailRolesIdIndexRoute
  '/_staff/settings/permission-and-roles/_form/people-groups/new/': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsNewIndexRoute
  '/_staff/settings/permission-and-roles/_form/product-permissions/new/': typeof StaffSettingsPermissionAndRolesFormProductPermissionsNewIndexRoute
  '/_staff/settings/permission-and-roles/_form/roles/new/': typeof StaffSettingsPermissionAndRolesFormRolesNewIndexRoute
  '/_staff/settings/persons/_list/_account/individual/': typeof StaffSettingsPersonsListAccountIndividualIndexRoute
  '/_staff/settings/persons/_list/_account/staff/': typeof StaffSettingsPersonsListAccountStaffIndexRoute
  '/_staff/software/_layout/alerts/_alerts/alumni/': typeof StaffSoftwareLayoutAlertsAlertsAlumniIndexRoute
  '/_staff/software/_layout/alerts/_alerts/inactive-user/': typeof StaffSoftwareLayoutAlertsAlertsInactiveUserIndexRoute
  '/_staff/software/_layout/alerts/_alerts/no-user/': typeof StaffSoftwareLayoutAlertsAlertsNoUserIndexRoute
  '/_staff/software/_layout/alerts/_alerts/no-worker/': typeof StaffSoftwareLayoutAlertsAlertsNoWorkerIndexRoute
  '/_staff/software/_layout/alerts/_alerts/violated-assignment/': typeof StaffSoftwareLayoutAlertsAlertsViolatedAssignmentIndexRoute
  '/_staff/software/_layout/alerts/_alerts/violated-role/': typeof StaffSoftwareLayoutAlertsAlertsViolatedRoleIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/daily-place/': typeof StaffTimeAndAttendanceLayoutListSummaryDailyPlaceIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPersonIndexRoute
  '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/': typeof StaffTimeAndAttendanceLayoutListSummaryMonthlyPlaceIndexRoute
  '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/': typeof StaffAppsListAlertsAlertsShadowItShadowItIndexRoute
  '/_staff/apps/_list/marketplace/$id/install/finish/': typeof StaffAppsListMarketplaceIdInstallFinishIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDataIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutDetailIndexRoute
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/': typeof StaffItOperationCoreDetailOperationInstancesInstanceIdLayoutOperationActivityIndexRoute
  '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/': typeof StaffLicensesIdServicePlansLicenseServiceIdDetailAccountsIndexRoute
  '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/': typeof StaffSettingsPermissionAndRolesFormPeopleGroupsIdEditIndexRoute
  '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/': typeof StaffSettingsPermissionAndRolesFormProductPermissionsIdEditIndexRoute
  '/_staff/settings/permission-and-roles/_form/roles/$id/edit/': typeof StaffSettingsPermissionAndRolesFormRolesIdEditIndexRoute
  '/_staff/software/_layout/marketplace/$id/install/finish/': typeof StaffSoftwareLayoutMarketplaceIdInstallFinishIndexRoute
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdRouteWithChildren
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileRouteWithChildren
  '/_individual/individual/task/$id/_operation-package/_common/form/$formId/': typeof IndividualIndividualTaskIdOperationPackageCommonFormFormIdIndexRoute
  '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/': typeof StaffAppsListAlertsAlertsShadowItShadowItAppsIndexRoute
  '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/': typeof StaffAppsListAlertsAlertsShadowItShadowItVisitHistoriesIndexRoute
  '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/': typeof StaffPersonIdCertificationsBaseCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/': typeof StaffPersonIdCertificationsHandlingCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/': typeof StaffPersonIdCertificationsSpecialtyCertificationsPersonCertificationInformationIdLayoutIndexIndexRoute
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileIndexRoute
  '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': typeof StaffContractorCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': typeof StaffGaOperationCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
  '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/': typeof StaffLaborCoreOperationPackagesIdPatternsPatternIdInstancesInstanceIdProfileDataIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/apps'
    | '/id-managements'
    | '/it-operation-core/device-inventory'
    | '/places/import-csv'
    | '/accesses'
    | '/apps/$'
    | '/business-operation-events'
    | '/business-partner'
    | '/certification'
    | '/contract'
    | '/contractor-core'
    | '/devices'
    | '/equipment'
    | '/fleets'
    | '/ga-operation-core'
    | '/id-managements/$'
    | '/ids'
    | '/it-operation-core'
    | '/labor-core'
    | '/labor-core/anchor-date'
    | '/labor-core/person-targets'
    | '/licenses'
    | '/marketplace'
    | '/networks'
    | '/organization'
    | '/people'
    | '/places'
    | '/public-ids/$id'
    | '/public-ids'
    | '/software'
    | '/starlinks'
    | '/storage-files'
    | '/time-and-attendance'
    | '/individual'
    | '/cockpit'
    | '/it-operation-core/'
    | '/organization/'
    | '/settings'
    | '/auth/sign-in'
    | '/auth/password-reset'
    | '/licenses/'
    | '/app-integrations/import-csv/$id'
    | '/devices/import-csv/$deviceType'
    | '/it-operation-core/packages'
    | '/person/import-csv/$workerType'
    | '/places/settings'
    | '/public-ids/import-csv/$publicIdType'
    | '/software/$id/import-csv'
    | '/software/people'
    | '/app-integrations/$id'
    | '/apps/contract-and-cost'
    | '/apps/operation-activity'
    | '/apps/rule-and-policy'
    | '/business-operation-events/archive'
    | '/business-operation-events/config'
    | '/business-operation-events/operation-activity'
    | '/business-operation-events/overview'
    | '/business-operation-events/rule-and-policy'
    | '/business-operation-events/settings'
    | '/business-partner/$id'
    | '/certification/$id'
    | '/contract/$id'
    | '/devices/alerts'
    | '/devices/contract-and-cost'
    | '/devices/operation-activity'
    | '/devices/rule-and-policy'
    | '/equipment/$id'
    | '/fleets/$id'
    | '/fleets/alerts'
    | '/fleets/overview'
    | '/fleets/rule-and-policy'
    | '/fleets/settings'
    | '/it-operation-core/device-inventory/data'
    | '/it-operation-core/device-inventory/detail'
    | '/labor-core/settings'
    | '/labor-core/settings/egov-callback'
    | '/licenses/$id'
    | '/networks/$id'
    | '/organization/$id'
    | '/people/alerts'
    | '/people/community'
    | '/people/operation-activity'
    | '/people/people-graph'
    | '/people/rule-and-policy'
    | '/people/salary-and-payment'
    | '/person/$id'
    | '/places/$id'
    | '/settings/contracting-corporation-profile'
    | '/settings/permission-and-roles'
    | '/settings/persons'
    | '/software/$id'
    | '/software/integrations'
    | '/starlinks/$id'
    | '/apps/'
    | '/devices/'
    | '/people/'
    | '/software/'
    | '/certification/settings'
    | '/equipment/settings'
    | '/people/settings'
    | '/accesses/'
    | '/business-operation-events/$eventInstanceId'
    | '/business-operation-events/'
    | '/business-partner/'
    | '/business-partner/add'
    | '/certification/'
    | '/certification/add'
    | '/cockpit/$id'
    | '/contract/'
    | '/contract/add'
    | '/contractor-core/'
    | '/device-catalog/add'
    | '/devices/add'
    | '/devices/external-it-saas'
    | '/equipment/'
    | '/equipment/add-select'
    | '/equipment/add'
    | '/equipment/import-csv'
    | '/fleets/add-select'
    | '/fleets/add'
    | '/ga-operation-core/'
    | '/ids/'
    | '/labor-core/'
    | '/licenses/add'
    | '/marketplace/cart'
    | '/marketplace/unavailable'
    | '/networks/'
    | '/networks/add'
    | '/organization/plan'
    | '/person/add-person-certification'
    | '/person/add'
    | '/person/external-hr-saas'
    | '/places/'
    | '/places/add-select'
    | '/places/add'
    | '/public-ids/$id/'
    | '/public-ids/'
    | '/public-ids/add'
    | '/settings/contracting-corporation-profile/'
    | '/settings/permission-and-roles/'
    | '/settings/persons/'
    | '/software/add'
    | '/starlinks/'
    | '/time-and-attendance/'
    | '/auth/invitation/$invitationCode'
    | '/person/$id/'
    | '/apps/marketplace/$id'
    | '/business-partner/alerts'
    | '/business-partner/contract-and-cost'
    | '/business-partner/operation-activity'
    | '/business-partner/rule-and-policy'
    | '/business-partner/settings'
    | '/certification/alerts'
    | '/certification/operation-activity'
    | '/certification/overview'
    | '/certification/rule-and-policy'
    | '/contract/alerts'
    | '/contract/contract-and-cost'
    | '/contract/operation-activity'
    | '/contract/overview'
    | '/contract/people'
    | '/software/marketplace/$id'
    | '/individual/task/$id/approval-dialog'
    | '/accesses/contract-and-cost'
    | '/accesses/overview'
    | '/accesses/settings'
    | '/accesses/software'
    | '/app-integrations/$id/groups'
    | '/apps/alerts'
    | '/business-partner/add/$businessPartnerType/completed'
    | '/certification/add/$certificationKind/completed'
    | '/certification/handling-certification/$id'
    | '/certification/specialty-certification/$id'
    | '/device-catalog/active/$id'
    | '/device-catalog/add/$deviceType/completed'
    | '/device-catalog/draft/$id'
    | '/devices/settings/catalog'
    | '/devices/add/$deviceType/completed'
    | '/equipment/alerts'
    | '/equipment/overview'
    | '/equipment/rule-and-policy'
    | '/ids/alerts'
    | '/ids/group-id'
    | '/ids/operation-activity'
    | '/ids/overview'
    | '/ids/rule-and-policy'
    | '/ids/settings'
    | '/ids/group-id/$id'
    | '/it-operation-core/packages/$packageId'
    | '/labor-core/settings/profile/$profileId'
    | '/licenses/add/$allocationType/completed'
    | '/marketplace/sent-orders/$orderId'
    | '/networks/alerts'
    | '/networks/contract-and-cost'
    | '/networks/operation-activity'
    | '/networks/overview'
    | '/networks/rule-and-policy'
    | '/networks/settings'
    | '/person/add-person-certification/$certificationKind/completed'
    | '/person/add/$workerType/completed'
    | '/person/alumni/$id'
    | '/places/alerts'
    | '/places/contract-and-cost'
    | '/places/operation-activity'
    | '/places/overview'
    | '/places/people'
    | '/places/rule-and-policy'
    | '/places/store'
    | '/profile/device/$id'
    | '/software/alerts'
    | '/starlinks/billing-and-cost'
    | '/starlinks/marketplace'
    | '/starlinks/operation-activity'
    | '/time-and-attendance/attendances'
    | '/time-and-attendance/clocking'
    | '/individual/operation-package/$id'
    | '/individual/task/$id'
    | '/accesses/alerts'
    | '/accesses/list'
    | '/app-integrations/$id/'
    | '/apps/integrations'
    | '/apps/marketplace'
    | '/apps/people'
    | '/apps/settings'
    | '/apps/custom-app/add'
    | '/business-partner/terminated'
    | '/business-partner/add/$businessPartnerType'
    | '/certification/settings/'
    | '/certification/add/$certificationKind'
    | '/contract/import-csv/$contractType'
    | '/contractor-core/archives'
    | '/contractor-core/configs'
    | '/contractor-core/config/$patternId'
    | '/device-catalog/add/$deviceType'
    | '/devices/catalog'
    | '/devices/inventory'
    | '/devices/people'
    | '/devices/settings'
    | '/devices/add/$deviceType'
    | '/equipment/settings/'
    | '/fleets/'
    | '/ga-operation-core/archives'
    | '/ga-operation-core/configs'
    | '/ga-operation-core/config/$patternId'
    | '/ids/people'
    | '/ids/group-id/add'
    | '/it-operation-core/archives'
    | '/it-operation-core/config'
    | '/it-operation-core/packages/'
    | '/it-operation-core/config/$patternId'
    | '/labor-core/archives'
    | '/labor-core/configs'
    | '/labor-core/settings/'
    | '/labor-core/config/$patternId'
    | '/licenses/alerts'
    | '/licenses/contract-and-cost'
    | '/licenses/inventory'
    | '/licenses/operation-activity'
    | '/licenses/people'
    | '/licenses/rule-and-policy'
    | '/licenses/settings'
    | '/licenses/add/$allocationType'
    | '/marketplace/sales-orders/$orderId'
    | '/organization/$id/'
    | '/organization/alert'
    | '/organization/chart'
    | '/organization/cost'
    | '/organization/history'
    | '/organization/rule-policy'
    | '/organization/settings'
    | '/organization/plan/$id'
    | '/organization/plan/create'
    | '/people/alumni'
    | '/people/settings/'
    | '/people/workforce'
    | '/person/add-person-certification/$certificationKind'
    | '/person/add/$workerType'
    | '/places/settings/'
    | '/public-ids/$id/details'
    | '/public-ids/$id/files'
    | '/public-ids/alerts'
    | '/public-ids/members'
    | '/public-ids/operation-activity'
    | '/public-ids/registry'
    | '/public-ids/rules-and-policies'
    | '/public-ids/settings'
    | '/software/$id/'
    | '/software/contract-and-cost'
    | '/software/marketplace'
    | '/software/operation-activity'
    | '/software/people/'
    | '/software/registry'
    | '/software/rule-and-policy'
    | '/software/settings'
    | '/software/add/$type'
    | '/starlinks/alerts'
    | '/starlinks/user-terminals'
    | '/storage-files/files'
    | '/storage-files/folders'
    | '/time-and-attendance/attendance-links'
    | '/licenses/$id/'
    | '/person/alumni/$id/'
    | '/contract/$id/approval-info'
    | '/contract/$id/history'
    | '/contract/$id/operation-activity'
    | '/contract/$id/risk-provisions'
    | '/contract/$id/rule-and-policy'
    | '/profile/device/$id/files'
    | '/it-operation-core/operation-instances/$instanceId'
    | '/licenses/$id/service-plans/$licenseServiceId'
    | '/marketplace/sent-orders/$orderId/activities'
    | '/profile/device/$id/configuration'
    | '/profile/device/$id/monitoring'
    | '/profile/device/$id/'
    | '/profile/device/$id/control'
    | '/profile/device/$id/mdm'
    | '/profile/device/$id/status'
    | '/individual/task/$id/approval'
    | '/app-integrations/$id/architecture'
    | '/app-integrations/$id/detail'
    | '/app-integrations/$id/rule-and-policy'
    | '/app-integrations/$id/settings'
    | '/app-integrations/$id/users'
    | '/apps/alerts/'
    | '/apps/custom-app/add/$customAppType'
    | '/business-partner/$id/'
    | '/business-partner/$id/address-and-contact'
    | '/certification/$id/'
    | '/certification/$id/certification-holders'
    | '/certification/$id/handling-certifications'
    | '/certification/$id/specialty-certifications'
    | '/certification/settings/issuing-organization'
    | '/certification/settings/specialty-category-level'
    | '/certification/settings/specialty-category'
    | '/devices/external-it-saas/$appIntegrationId/preview'
    | '/equipment/settings/equipment-items'
    | '/equipment/settings/equipment-types'
    | '/ids/group-id/$id/'
    | '/it-operation-core/operation-instances/$instanceId/'
    | '/licenses/$id/assignments'
    | '/licenses/$id/people'
    | '/licenses/$id/service-plans'
    | '/marketplace/store/devices'
    | '/marketplace/store/sales-orders'
    | '/marketplace/store/sent-orders'
    | '/marketplace/store/starlinks'
    | '/marketplace/sent-orders/$orderId/'
    | '/organization/$id/history'
    | '/organization/plan/$id/add'
    | '/people/settings/board-member-types'
    | '/people/settings/collaborator-types'
    | '/people/settings/contract-end-reasons'
    | '/people/settings/contractor-types'
    | '/people/settings/employee-sub-id-names'
    | '/people/settings/employment-types'
    | '/people/settings/grades'
    | '/people/settings/health-insurance-associations'
    | '/people/settings/job-competencies'
    | '/people/settings/job-functions'
    | '/people/settings/job-grades'
    | '/people/settings/job-levels'
    | '/people/settings/job-titles'
    | '/people/settings/job-types'
    | '/people/settings/place-social-insurances'
    | '/people/settings/positions'
    | '/people/settings/retirement-reasons'
    | '/people/settings/work-mode'
    | '/person/$id/activity'
    | '/person/$id/apps'
    | '/person/$id/devices'
    | '/person/$id/education-and-qualification'
    | '/person/$id/employee-information'
    | '/person/$id/equipment'
    | '/person/$id/history'
    | '/person/$id/personal-information'
    | '/person/$id/public-id'
    | '/person/external-hr-saas/$appIntegrationId/preview'
    | '/places/$id/administrators'
    | '/places/$id/labor-core'
    | '/places/settings/place-sub-codes'
    | '/settings/contracting-corporation-profile/board-member'
    | '/settings/contracting-corporation-profile/contact-points'
    | '/settings/contracting-corporation-profile/corporate-overview'
    | '/settings/contracting-corporation-profile/group-companies'
    | '/settings/contracting-corporation-profile/history'
    | '/settings/contracting-corporation-profile/registration'
    | '/settings/contracting-corporation-profile/shareholders'
    | '/settings/permission-and-roles/people-groups'
    | '/settings/permission-and-roles/product-permissions'
    | '/settings/permission-and-roles/roles'
    | '/settings/persons/settings'
    | '/software/$id/activity-monitoring'
    | '/software/$id/architecture'
    | '/software/$id/contracts-cost'
    | '/software/$id/detail'
    | '/software/$id/rule-and-policy'
    | '/software/$id/settings'
    | '/software/$id/users'
    | '/software/alerts/'
    | '/software/custom-saas/add/$customSaasType'
    | '/time-and-attendance/summary'
    | '/time-and-attendance/attendance-links/$placeId'
    | '/contract/$id/'
    | '/contract/$id/structure'
    | '/equipment/$id/'
    | '/fleets/$id/'
    | '/networks/$id/'
    | '/places/$id/'
    | '/starlinks/$id/'
    | '/starlinks/$id/detail'
    | '/apps/alerts/shadow-it'
    | '/person/$id/certifications/base-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
    | '/individual/operation-package/$id/pattern/$patternId'
    | '/accesses/alerts/detail/$shadowItAppId'
    | '/apps/alerts/inactive-user'
    | '/apps/alerts/no-user'
    | '/apps/alerts/no-worker'
    | '/apps/alerts/violated-assignment'
    | '/apps/alerts/violated-role'
    | '/certification/handling-certification/$id/'
    | '/certification/handling-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/'
    | '/certification/specialty-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/handling-certifications'
    | '/device-catalog/active/$id/profile'
    | '/device-catalog/draft/$id/profile'
    | '/ids/group-id/$id/members'
    | '/ids/group-id/$id/rule-and-policy'
    | '/ids/group-id/$id/settings'
    | '/marketplace/store/devices/$productId'
    | '/marketplace/store/starlinks/$productId'
    | '/organization/plan/$id/edit/$unitId'
    | '/person/$id/family/$familyPersonId'
    | '/person/alumni/$id/activity'
    | '/person/alumni/$id/apps'
    | '/person/alumni/$id/devices'
    | '/person/alumni/$id/education-and-qualification'
    | '/person/alumni/$id/employee-information'
    | '/person/alumni/$id/equipment'
    | '/person/alumni/$id/history'
    | '/person/alumni/$id/personal-information'
    | '/person/alumni/$id/public-id'
    | '/profile/device/$id/history'
    | '/profile/device/$id/lifecycle'
    | '/settings/permission-and-roles/people-groups/$id'
    | '/settings/permission-and-roles/product-permissions/$id'
    | '/settings/permission-and-roles/roles/$id'
    | '/settings/permission-and-roles/people-groups/new'
    | '/settings/permission-and-roles/product-permissions/new'
    | '/settings/permission-and-roles/roles/new'
    | '/settings/persons/individual'
    | '/settings/persons/staff'
    | '/software/alerts/alumni'
    | '/software/alerts/inactive-user'
    | '/software/alerts/no-user'
    | '/software/alerts/no-worker'
    | '/software/alerts/violated-assignment'
    | '/software/alerts/violated-role'
    | '/time-and-attendance/summary/daily-place'
    | '/time-and-attendance/summary/monthly-person'
    | '/time-and-attendance/summary/monthly-place'
    | '/apps/alerts/shadow-it/'
    | '/apps/marketplace/$id/install/finish'
    | '/it-operation-core/operation-instances/$instanceId/data'
    | '/it-operation-core/operation-instances/$instanceId/detail'
    | '/it-operation-core/operation-instances/$instanceId/operation-activity'
    | '/licenses/$id/service-plans/$licenseServiceId/accounts'
    | '/settings/permission-and-roles/people-groups/$id/edit'
    | '/settings/permission-and-roles/product-permissions/$id/edit'
    | '/settings/permission-and-roles/roles/$id/edit'
    | '/software/marketplace/$id/install/finish'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/individual/task/$id/form/$formId'
    | '/apps/alerts/shadow-it/apps'
    | '/apps/alerts/shadow-it/visit-histories'
    | '/person/$id/certifications/base-certifications/$personCertificationInformationId/'
    | '/person/$id/certifications/handling-certifications/$personCertificationInformationId/'
    | '/person/$id/certifications/specialty-certifications/$personCertificationInformationId/'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/apps'
    | '/id-managements'
    | '/it-operation-core/device-inventory'
    | '/places/import-csv'
    | '/accesses'
    | '/apps/$'
    | '/business-operation-events'
    | '/business-partner'
    | '/certification'
    | '/contract'
    | '/contractor-core'
    | '/devices'
    | '/equipment'
    | '/fleets'
    | '/ga-operation-core'
    | '/id-managements/$'
    | '/ids'
    | '/it-operation-core'
    | '/labor-core'
    | '/labor-core/anchor-date'
    | '/labor-core/person-targets'
    | '/licenses'
    | '/marketplace'
    | '/networks'
    | '/organization'
    | '/people'
    | '/places'
    | '/public-ids'
    | '/software'
    | '/starlinks'
    | '/storage-files'
    | '/time-and-attendance'
    | '/individual'
    | '/cockpit'
    | '/settings'
    | '/auth/sign-in'
    | '/auth/password-reset'
    | '/app-integrations/import-csv/$id'
    | '/devices/import-csv/$deviceType'
    | '/person/import-csv/$workerType'
    | '/public-ids/import-csv/$publicIdType'
    | '/software/$id/import-csv'
    | '/app-integrations/$id'
    | '/apps/contract-and-cost'
    | '/apps/operation-activity'
    | '/apps/rule-and-policy'
    | '/business-operation-events/archive'
    | '/business-operation-events/config'
    | '/business-operation-events/operation-activity'
    | '/business-operation-events/overview'
    | '/business-operation-events/rule-and-policy'
    | '/business-operation-events/settings'
    | '/business-partner/$id'
    | '/certification/$id'
    | '/contract/$id'
    | '/devices/alerts'
    | '/devices/contract-and-cost'
    | '/devices/operation-activity'
    | '/devices/rule-and-policy'
    | '/equipment/$id'
    | '/fleets/$id'
    | '/fleets/alerts'
    | '/fleets/overview'
    | '/fleets/rule-and-policy'
    | '/fleets/settings'
    | '/it-operation-core/device-inventory/data'
    | '/it-operation-core/device-inventory/detail'
    | '/labor-core/settings/egov-callback'
    | '/licenses/$id'
    | '/networks/$id'
    | '/organization/$id'
    | '/people/alerts'
    | '/people/community'
    | '/people/operation-activity'
    | '/people/people-graph'
    | '/people/rule-and-policy'
    | '/people/salary-and-payment'
    | '/person/$id'
    | '/places/$id'
    | '/settings/contracting-corporation-profile'
    | '/settings/permission-and-roles'
    | '/settings/persons'
    | '/software/$id'
    | '/software/integrations'
    | '/starlinks/$id'
    | '/business-operation-events/$eventInstanceId'
    | '/business-partner/add'
    | '/certification/add'
    | '/cockpit/$id'
    | '/contract/add'
    | '/device-catalog/add'
    | '/devices/add'
    | '/devices/external-it-saas'
    | '/equipment/add-select'
    | '/equipment/add'
    | '/equipment/import-csv'
    | '/fleets/add-select'
    | '/fleets/add'
    | '/licenses/add'
    | '/marketplace/cart'
    | '/marketplace/unavailable'
    | '/networks/add'
    | '/organization/plan'
    | '/person/add-person-certification'
    | '/person/add'
    | '/person/external-hr-saas'
    | '/places/add-select'
    | '/places/add'
    | '/public-ids/$id'
    | '/public-ids/add'
    | '/software/add'
    | '/auth/invitation/$invitationCode'
    | '/apps/marketplace/$id'
    | '/business-partner/alerts'
    | '/business-partner/contract-and-cost'
    | '/business-partner/operation-activity'
    | '/business-partner/rule-and-policy'
    | '/business-partner/settings'
    | '/certification/alerts'
    | '/certification/operation-activity'
    | '/certification/overview'
    | '/certification/rule-and-policy'
    | '/contract/alerts'
    | '/contract/contract-and-cost'
    | '/contract/operation-activity'
    | '/contract/overview'
    | '/contract/people'
    | '/software/marketplace/$id'
    | '/individual/task/$id/approval-dialog'
    | '/accesses/contract-and-cost'
    | '/accesses/overview'
    | '/accesses/settings'
    | '/accesses/software'
    | '/app-integrations/$id/groups'
    | '/apps/alerts'
    | '/business-partner/add/$businessPartnerType/completed'
    | '/certification/add/$certificationKind/completed'
    | '/certification/handling-certification/$id'
    | '/certification/specialty-certification/$id'
    | '/device-catalog/active/$id'
    | '/device-catalog/add/$deviceType/completed'
    | '/device-catalog/draft/$id'
    | '/devices/settings/catalog'
    | '/devices/add/$deviceType/completed'
    | '/equipment/alerts'
    | '/equipment/overview'
    | '/equipment/rule-and-policy'
    | '/equipment/settings'
    | '/ids/alerts'
    | '/ids/group-id'
    | '/ids/operation-activity'
    | '/ids/overview'
    | '/ids/rule-and-policy'
    | '/ids/settings'
    | '/ids/group-id/$id'
    | '/it-operation-core/packages/$packageId'
    | '/labor-core/settings/profile/$profileId'
    | '/licenses/add/$allocationType/completed'
    | '/marketplace/sent-orders/$orderId'
    | '/networks/alerts'
    | '/networks/contract-and-cost'
    | '/networks/operation-activity'
    | '/networks/overview'
    | '/networks/rule-and-policy'
    | '/networks/settings'
    | '/person/add-person-certification/$certificationKind/completed'
    | '/person/add/$workerType/completed'
    | '/person/alumni/$id'
    | '/places/alerts'
    | '/places/contract-and-cost'
    | '/places/operation-activity'
    | '/places/overview'
    | '/places/people'
    | '/places/rule-and-policy'
    | '/places/store'
    | '/profile/device/$id'
    | '/software/alerts'
    | '/starlinks/billing-and-cost'
    | '/starlinks/marketplace'
    | '/starlinks/operation-activity'
    | '/time-and-attendance/attendances'
    | '/time-and-attendance/clocking'
    | '/individual/operation-package/$id'
    | '/individual/task/$id'
    | '/accesses/alerts'
    | '/accesses/list'
    | '/apps/integrations'
    | '/apps/marketplace'
    | '/apps/people'
    | '/apps/settings'
    | '/apps/custom-app/add'
    | '/business-partner/terminated'
    | '/business-partner/add/$businessPartnerType'
    | '/certification/settings'
    | '/certification/add/$certificationKind'
    | '/contract/import-csv/$contractType'
    | '/contractor-core/archives'
    | '/contractor-core/configs'
    | '/contractor-core/config/$patternId'
    | '/device-catalog/add/$deviceType'
    | '/devices/catalog'
    | '/devices/inventory'
    | '/devices/people'
    | '/devices/settings'
    | '/devices/add/$deviceType'
    | '/ga-operation-core/archives'
    | '/ga-operation-core/configs'
    | '/ga-operation-core/config/$patternId'
    | '/ids/people'
    | '/ids/group-id/add'
    | '/it-operation-core/archives'
    | '/it-operation-core/config'
    | '/it-operation-core/packages'
    | '/it-operation-core/config/$patternId'
    | '/labor-core/archives'
    | '/labor-core/configs'
    | '/labor-core/settings'
    | '/labor-core/config/$patternId'
    | '/licenses/alerts'
    | '/licenses/contract-and-cost'
    | '/licenses/inventory'
    | '/licenses/operation-activity'
    | '/licenses/people'
    | '/licenses/rule-and-policy'
    | '/licenses/settings'
    | '/licenses/add/$allocationType'
    | '/marketplace/sales-orders/$orderId'
    | '/organization/alert'
    | '/organization/chart'
    | '/organization/cost'
    | '/organization/history'
    | '/organization/rule-policy'
    | '/organization/settings'
    | '/organization/plan/$id'
    | '/organization/plan/create'
    | '/people/alumni'
    | '/people/settings'
    | '/people/workforce'
    | '/person/add-person-certification/$certificationKind'
    | '/person/add/$workerType'
    | '/places/settings'
    | '/public-ids/$id/details'
    | '/public-ids/$id/files'
    | '/public-ids/alerts'
    | '/public-ids/members'
    | '/public-ids/operation-activity'
    | '/public-ids/registry'
    | '/public-ids/rules-and-policies'
    | '/public-ids/settings'
    | '/software/contract-and-cost'
    | '/software/marketplace'
    | '/software/operation-activity'
    | '/software/people'
    | '/software/registry'
    | '/software/rule-and-policy'
    | '/software/settings'
    | '/software/add/$type'
    | '/starlinks/alerts'
    | '/starlinks/user-terminals'
    | '/storage-files/files'
    | '/storage-files/folders'
    | '/time-and-attendance/attendance-links'
    | '/contract/$id/approval-info'
    | '/contract/$id/history'
    | '/contract/$id/operation-activity'
    | '/contract/$id/risk-provisions'
    | '/contract/$id/rule-and-policy'
    | '/profile/device/$id/files'
    | '/it-operation-core/operation-instances/$instanceId'
    | '/licenses/$id/service-plans/$licenseServiceId'
    | '/marketplace/sent-orders/$orderId/activities'
    | '/profile/device/$id/configuration'
    | '/profile/device/$id/monitoring'
    | '/profile/device/$id/control'
    | '/profile/device/$id/mdm'
    | '/profile/device/$id/status'
    | '/individual/task/$id/approval'
    | '/app-integrations/$id/architecture'
    | '/app-integrations/$id/detail'
    | '/app-integrations/$id/rule-and-policy'
    | '/app-integrations/$id/settings'
    | '/app-integrations/$id/users'
    | '/apps/custom-app/add/$customAppType'
    | '/business-partner/$id/address-and-contact'
    | '/certification/$id/certification-holders'
    | '/certification/$id/handling-certifications'
    | '/certification/$id/specialty-certifications'
    | '/certification/settings/issuing-organization'
    | '/certification/settings/specialty-category-level'
    | '/certification/settings/specialty-category'
    | '/devices/external-it-saas/$appIntegrationId/preview'
    | '/equipment/settings/equipment-items'
    | '/equipment/settings/equipment-types'
    | '/licenses/$id/assignments'
    | '/licenses/$id/people'
    | '/licenses/$id/service-plans'
    | '/marketplace/store/devices'
    | '/marketplace/store/sales-orders'
    | '/marketplace/store/sent-orders'
    | '/marketplace/store/starlinks'
    | '/organization/$id/history'
    | '/organization/plan/$id/add'
    | '/people/settings/board-member-types'
    | '/people/settings/collaborator-types'
    | '/people/settings/contract-end-reasons'
    | '/people/settings/contractor-types'
    | '/people/settings/employee-sub-id-names'
    | '/people/settings/employment-types'
    | '/people/settings/grades'
    | '/people/settings/health-insurance-associations'
    | '/people/settings/job-competencies'
    | '/people/settings/job-functions'
    | '/people/settings/job-grades'
    | '/people/settings/job-levels'
    | '/people/settings/job-titles'
    | '/people/settings/job-types'
    | '/people/settings/place-social-insurances'
    | '/people/settings/positions'
    | '/people/settings/retirement-reasons'
    | '/people/settings/work-mode'
    | '/person/$id/activity'
    | '/person/$id/apps'
    | '/person/$id/devices'
    | '/person/$id/education-and-qualification'
    | '/person/$id/employee-information'
    | '/person/$id/equipment'
    | '/person/$id/history'
    | '/person/$id/personal-information'
    | '/person/$id/public-id'
    | '/person/external-hr-saas/$appIntegrationId/preview'
    | '/places/$id/administrators'
    | '/places/$id/labor-core'
    | '/places/settings/place-sub-codes'
    | '/settings/contracting-corporation-profile/board-member'
    | '/settings/contracting-corporation-profile/contact-points'
    | '/settings/contracting-corporation-profile/corporate-overview'
    | '/settings/contracting-corporation-profile/group-companies'
    | '/settings/contracting-corporation-profile/history'
    | '/settings/contracting-corporation-profile/registration'
    | '/settings/contracting-corporation-profile/shareholders'
    | '/settings/permission-and-roles/people-groups'
    | '/settings/permission-and-roles/product-permissions'
    | '/settings/permission-and-roles/roles'
    | '/settings/persons/settings'
    | '/software/$id/activity-monitoring'
    | '/software/$id/architecture'
    | '/software/$id/contracts-cost'
    | '/software/$id/detail'
    | '/software/$id/rule-and-policy'
    | '/software/$id/settings'
    | '/software/$id/users'
    | '/software/custom-saas/add/$customSaasType'
    | '/time-and-attendance/summary'
    | '/time-and-attendance/attendance-links/$placeId'
    | '/contract/$id/structure'
    | '/starlinks/$id/detail'
    | '/apps/alerts/shadow-it'
    | '/person/$id/certifications/base-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/handling-certifications/$personCertificationInformationId'
    | '/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
    | '/individual/operation-package/$id/pattern/$patternId'
    | '/accesses/alerts/detail/$shadowItAppId'
    | '/apps/alerts/inactive-user'
    | '/apps/alerts/no-user'
    | '/apps/alerts/no-worker'
    | '/apps/alerts/violated-assignment'
    | '/apps/alerts/violated-role'
    | '/certification/handling-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/certification-holders'
    | '/certification/specialty-certification/$id/handling-certifications'
    | '/device-catalog/active/$id/profile'
    | '/device-catalog/draft/$id/profile'
    | '/ids/group-id/$id/members'
    | '/ids/group-id/$id/rule-and-policy'
    | '/ids/group-id/$id/settings'
    | '/marketplace/store/devices/$productId'
    | '/marketplace/store/starlinks/$productId'
    | '/organization/plan/$id/edit/$unitId'
    | '/person/$id/family/$familyPersonId'
    | '/person/alumni/$id/activity'
    | '/person/alumni/$id/apps'
    | '/person/alumni/$id/devices'
    | '/person/alumni/$id/education-and-qualification'
    | '/person/alumni/$id/employee-information'
    | '/person/alumni/$id/equipment'
    | '/person/alumni/$id/history'
    | '/person/alumni/$id/personal-information'
    | '/person/alumni/$id/public-id'
    | '/profile/device/$id/history'
    | '/profile/device/$id/lifecycle'
    | '/settings/permission-and-roles/people-groups/$id'
    | '/settings/permission-and-roles/product-permissions/$id'
    | '/settings/permission-and-roles/roles/$id'
    | '/settings/permission-and-roles/people-groups/new'
    | '/settings/permission-and-roles/product-permissions/new'
    | '/settings/permission-and-roles/roles/new'
    | '/settings/persons/individual'
    | '/settings/persons/staff'
    | '/software/alerts/alumni'
    | '/software/alerts/inactive-user'
    | '/software/alerts/no-user'
    | '/software/alerts/no-worker'
    | '/software/alerts/violated-assignment'
    | '/software/alerts/violated-role'
    | '/time-and-attendance/summary/daily-place'
    | '/time-and-attendance/summary/monthly-person'
    | '/time-and-attendance/summary/monthly-place'
    | '/apps/marketplace/$id/install/finish'
    | '/it-operation-core/operation-instances/$instanceId/data'
    | '/it-operation-core/operation-instances/$instanceId/detail'
    | '/it-operation-core/operation-instances/$instanceId/operation-activity'
    | '/licenses/$id/service-plans/$licenseServiceId/accounts'
    | '/settings/permission-and-roles/people-groups/$id/edit'
    | '/settings/permission-and-roles/product-permissions/$id/edit'
    | '/settings/permission-and-roles/roles/$id/edit'
    | '/software/marketplace/$id/install/finish'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/individual/task/$id/form/$formId'
    | '/apps/alerts/shadow-it/apps'
    | '/apps/alerts/shadow-it/visit-histories'
    | '/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
    | '/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/data'
  id:
    | '__root__'
    | '/'
    | '/_individual'
    | '/_staff'
    | '/_staff/apps'
    | '/_staff/id-managements'
    | '/_staff/it-operation-core/device-inventory'
    | '/_staff/places/import-csv'
    | '/_staff/accesses'
    | '/_staff/accesses/_layout'
    | '/_staff/apps/$'
    | '/_staff/apps/_list'
    | '/_staff/business-operation-events'
    | '/_staff/business-operation-events/_list'
    | '/_staff/business-partner'
    | '/_staff/business-partner/_list'
    | '/_staff/certification'
    | '/_staff/certification/_list'
    | '/_staff/contract'
    | '/_staff/contract/_list'
    | '/_staff/contractor-core'
    | '/_staff/contractor-core/_packages'
    | '/_staff/devices'
    | '/_staff/devices/_list'
    | '/_staff/equipment'
    | '/_staff/equipment/_layout'
    | '/_staff/fleets'
    | '/_staff/fleets/_layout'
    | '/_staff/ga-operation-core'
    | '/_staff/ga-operation-core/_packages'
    | '/_staff/id-managements/$'
    | '/_staff/ids'
    | '/_staff/ids/_layout'
    | '/_staff/it-operation-core'
    | '/_staff/it-operation-core/_detail'
    | '/_staff/it-operation-core/_root'
    | '/_staff/labor-core'
    | '/_staff/labor-core/_packages'
    | '/_staff/labor-core/anchor-date'
    | '/_staff/labor-core/person-targets'
    | '/_staff/licenses'
    | '/_staff/licenses/_list'
    | '/_staff/marketplace'
    | '/_staff/marketplace/_store'
    | '/_staff/networks'
    | '/_staff/networks/_layout'
    | '/_staff/organization'
    | '/_staff/organization/_list'
    | '/_staff/people'
    | '/_staff/people/_list'
    | '/_staff/places'
    | '/_staff/places/_layout'
    | '/_staff/public-ids/$id'
    | '/_staff/public-ids'
    | '/_staff/public-ids/_list'
    | '/_staff/software'
    | '/_staff/software/_layout'
    | '/_staff/starlinks'
    | '/_staff/starlinks/_layout'
    | '/_staff/storage-files'
    | '/_staff/storage-files/_list'
    | '/_staff/time-and-attendance'
    | '/_staff/time-and-attendance/_layout'
    | '/_individual/individual/'
    | '/_staff/cockpit/'
    | '/_staff/it-operation-core/'
    | '/_staff/organization/'
    | '/_staff/settings/'
    | '/auth/sign-in/'
    | '/auth/password-reset/'
    | '/_staff/licenses/_list/'
    | '/_staff/app-integrations/import-csv/$id'
    | '/_staff/devices/import-csv/$deviceType'
    | '/_staff/it-operation-core/_root/packages'
    | '/_staff/person/import-csv/$workerType'
    | '/_staff/places/_layout/settings'
    | '/_staff/public-ids/import-csv/$publicIdType'
    | '/_staff/software/$id/import-csv'
    | '/_staff/software/_layout/people'
    | '/_staff/app-integrations/$id'
    | '/_staff/app-integrations/$id/_$id'
    | '/_staff/apps/_list/contract-and-cost'
    | '/_staff/apps/_list/operation-activity'
    | '/_staff/apps/_list/rule-and-policy'
    | '/_staff/business-operation-events/_list/archive'
    | '/_staff/business-operation-events/_list/config'
    | '/_staff/business-operation-events/_list/operation-activity'
    | '/_staff/business-operation-events/_list/overview'
    | '/_staff/business-operation-events/_list/rule-and-policy'
    | '/_staff/business-operation-events/_list/settings'
    | '/_staff/business-partner/$id'
    | '/_staff/business-partner/$id/_layout'
    | '/_staff/certification/$id'
    | '/_staff/certification/$id/_layout'
    | '/_staff/contract/$id'
    | '/_staff/contract/$id/_layout'
    | '/_staff/devices/_list/alerts'
    | '/_staff/devices/_list/contract-and-cost'
    | '/_staff/devices/_list/operation-activity'
    | '/_staff/devices/_list/rule-and-policy'
    | '/_staff/equipment/$id'
    | '/_staff/equipment/$id/_layout'
    | '/_staff/fleets/$id'
    | '/_staff/fleets/$id/_layout'
    | '/_staff/fleets/_layout/alerts'
    | '/_staff/fleets/_layout/overview'
    | '/_staff/fleets/_layout/rule-and-policy'
    | '/_staff/fleets/_layout/settings'
    | '/_staff/it-operation-core/device-inventory/data'
    | '/_staff/it-operation-core/device-inventory/detail'
    | '/_staff/labor-core/_packages/settings'
    | '/_staff/labor-core/settings/egov-callback'
    | '/_staff/licenses/$id'
    | '/_staff/licenses/$id/_profile'
    | '/_staff/networks/$id'
    | '/_staff/networks/$id/_layout'
    | '/_staff/organization/$id'
    | '/_staff/organization/$id/_layout'
    | '/_staff/people/_list/alerts'
    | '/_staff/people/_list/community'
    | '/_staff/people/_list/operation-activity'
    | '/_staff/people/_list/people-graph'
    | '/_staff/people/_list/rule-and-policy'
    | '/_staff/people/_list/salary-and-payment'
    | '/_staff/person/$id'
    | '/_staff/person/$id/_profile'
    | '/_staff/places/$id'
    | '/_staff/places/$id/_layout'
    | '/_staff/settings/contracting-corporation-profile'
    | '/_staff/settings/contracting-corporation-profile/_layout'
    | '/_staff/settings/permission-and-roles'
    | '/_staff/settings/permission-and-roles/_detail'
    | '/_staff/settings/permission-and-roles/_form'
    | '/_staff/settings/permission-and-roles/_list'
    | '/_staff/settings/persons'
    | '/_staff/settings/persons/_list'
    | '/_staff/software/$id'
    | '/_staff/software/$id/_$id'
    | '/_staff/software/_layout/integrations'
    | '/_staff/starlinks/$id'
    | '/_staff/starlinks/$id/_layout'
    | '/_staff/apps/_list/'
    | '/_staff/devices/_list/'
    | '/_staff/people/_list/'
    | '/_staff/software/_layout/'
    | '/_staff/certification/_list/settings'
    | '/_staff/equipment/_layout/settings'
    | '/_staff/people/_list/settings'
    | '/_staff/accesses/_layout/'
    | '/_staff/business-operation-events/$eventInstanceId/'
    | '/_staff/business-operation-events/_list/'
    | '/_staff/business-partner/_list/'
    | '/_staff/business-partner/add/'
    | '/_staff/certification/_list/'
    | '/_staff/certification/add/'
    | '/_staff/cockpit/$id/'
    | '/_staff/contract/_list/'
    | '/_staff/contract/add/'
    | '/_staff/contractor-core/_packages/'
    | '/_staff/device-catalog/add/'
    | '/_staff/devices/add/'
    | '/_staff/devices/external-it-saas/'
    | '/_staff/equipment/_layout/'
    | '/_staff/equipment/add-select/'
    | '/_staff/equipment/add/'
    | '/_staff/equipment/import-csv/'
    | '/_staff/fleets/add-select/'
    | '/_staff/fleets/add/'
    | '/_staff/ga-operation-core/_packages/'
    | '/_staff/ids/_layout/'
    | '/_staff/labor-core/_packages/'
    | '/_staff/licenses/add/'
    | '/_staff/marketplace/cart/'
    | '/_staff/marketplace/unavailable/'
    | '/_staff/networks/_layout/'
    | '/_staff/networks/add/'
    | '/_staff/organization/plan/'
    | '/_staff/person/add-person-certification/'
    | '/_staff/person/add/'
    | '/_staff/person/external-hr-saas/'
    | '/_staff/places/_layout/'
    | '/_staff/places/add-select/'
    | '/_staff/places/add/'
    | '/_staff/public-ids/$id/'
    | '/_staff/public-ids/_list/'
    | '/_staff/public-ids/add/'
    | '/_staff/settings/contracting-corporation-profile/'
    | '/_staff/settings/permission-and-roles/'
    | '/_staff/settings/persons/'
    | '/_staff/software/add/'
    | '/_staff/starlinks/_layout/'
    | '/_staff/time-and-attendance/_layout/'
    | '/auth/invitation/$invitationCode/'
    | '/_staff/person/$id/_profile/'
    | '/_staff/apps/_list/marketplace/$id'
    | '/_staff/business-partner/_list/_placeholders/alerts'
    | '/_staff/business-partner/_list/_placeholders/contract-and-cost'
    | '/_staff/business-partner/_list/_placeholders/operation-activity'
    | '/_staff/business-partner/_list/_placeholders/rule-and-policy'
    | '/_staff/business-partner/_list/_placeholders/settings'
    | '/_staff/certification/_list/_placeholders/alerts'
    | '/_staff/certification/_list/_placeholders/operation-activity'
    | '/_staff/certification/_list/_placeholders/overview'
    | '/_staff/certification/_list/_placeholders/rule-and-policy'
    | '/_staff/contract/_list/_placeholders/alerts'
    | '/_staff/contract/_list/_placeholders/contract-and-cost'
    | '/_staff/contract/_list/_placeholders/operation-activity'
    | '/_staff/contract/_list/_placeholders/overview'
    | '/_staff/contract/_list/_placeholders/people'
    | '/_staff/software/_layout/marketplace/$id'
    | '/_individual/individual/task/$id/approval-dialog'
    | '/_staff/accesses/_layout/_placeholders/contract-and-cost'
    | '/_staff/accesses/_layout/_placeholders/overview'
    | '/_staff/accesses/_layout/_placeholders/settings'
    | '/_staff/accesses/_layout/_placeholders/software'
    | '/_staff/app-integrations/$id/_$id/groups'
    | '/_staff/apps/_list/alerts'
    | '/_staff/apps/_list/alerts/_alerts'
    | '/_staff/business-partner/add/$businessPartnerType/completed'
    | '/_staff/certification/add/$certificationKind/completed'
    | '/_staff/certification/handling-certification/$id'
    | '/_staff/certification/handling-certification/$id/_layout'
    | '/_staff/certification/specialty-certification/$id'
    | '/_staff/certification/specialty-certification/$id/_layout'
    | '/_staff/device-catalog/active/$id'
    | '/_staff/device-catalog/active/$id/_layout'
    | '/_staff/device-catalog/add/$deviceType/completed'
    | '/_staff/device-catalog/draft/$id'
    | '/_staff/device-catalog/draft/$id/_layout'
    | '/_staff/devices/_list/settings/catalog'
    | '/_staff/devices/add/$deviceType/completed'
    | '/_staff/equipment/_layout/_placeholders/alerts'
    | '/_staff/equipment/_layout/_placeholders/overview'
    | '/_staff/equipment/_layout/_placeholders/rule-and-policy'
    | '/_staff/equipment/_layout/_placeholders/settings'
    | '/_staff/ids/_layout/_placeholders/alerts'
    | '/_staff/ids/_layout/_placeholders/group-id'
    | '/_staff/ids/_layout/_placeholders/operation-activity'
    | '/_staff/ids/_layout/_placeholders/overview'
    | '/_staff/ids/_layout/_placeholders/rule-and-policy'
    | '/_staff/ids/_layout/_placeholders/settings'
    | '/_staff/ids/group-id/$id'
    | '/_staff/ids/group-id/$id/_$id'
    | '/_staff/it-operation-core/_root/packages/$packageId'
    | '/_staff/labor-core/settings/profile/$profileId'
    | '/_staff/licenses/add/$allocationType/completed'
    | '/_staff/marketplace/sent-orders/$orderId'
    | '/_staff/marketplace/sent-orders/$orderId/_layout'
    | '/_staff/networks/_layout/_placeholders/alerts'
    | '/_staff/networks/_layout/_placeholders/contract-and-cost'
    | '/_staff/networks/_layout/_placeholders/operation-activity'
    | '/_staff/networks/_layout/_placeholders/overview'
    | '/_staff/networks/_layout/_placeholders/rule-and-policy'
    | '/_staff/networks/_layout/_placeholders/settings'
    | '/_staff/person/add-person-certification/$certificationKind/completed'
    | '/_staff/person/add/$workerType/completed'
    | '/_staff/person/alumni/$id'
    | '/_staff/person/alumni/$id/_profile'
    | '/_staff/places/_layout/_placeholders/alerts'
    | '/_staff/places/_layout/_placeholders/contract-and-cost'
    | '/_staff/places/_layout/_placeholders/operation-activity'
    | '/_staff/places/_layout/_placeholders/overview'
    | '/_staff/places/_layout/_placeholders/people'
    | '/_staff/places/_layout/_placeholders/rule-and-policy'
    | '/_staff/places/_layout/_placeholders/store'
    | '/_staff/profile/device/$id'
    | '/_staff/profile/device/$id/_profile'
    | '/_staff/settings/persons/_list/_account'
    | '/_staff/software/_layout/alerts'
    | '/_staff/software/_layout/alerts/_alerts'
    | '/_staff/starlinks/_layout/_placeholders/billing-and-cost'
    | '/_staff/starlinks/_layout/_placeholders/marketplace'
    | '/_staff/starlinks/_layout/_placeholders/operation-activity'
    | '/_staff/time-and-attendance/_layout/_placeholders/attendances'
    | '/_staff/time-and-attendance/_layout/_placeholders/clocking'
    | '/_individual/individual/operation-package/$id/'
    | '/_individual/individual/task/$id/'
    | '/_staff/accesses/_layout/alerts/'
    | '/_staff/accesses/_layout/list/'
    | '/_staff/app-integrations/$id/_$id/'
    | '/_staff/apps/_list/integrations/'
    | '/_staff/apps/_list/marketplace/'
    | '/_staff/apps/_list/people/'
    | '/_staff/apps/_list/settings/'
    | '/_staff/apps/custom-app/add/'
    | '/_staff/business-partner/_list/terminated/'
    | '/_staff/business-partner/add/$businessPartnerType/'
    | '/_staff/certification/_list/settings/'
    | '/_staff/certification/add/$certificationKind/'
    | '/_staff/contract/import-csv/$contractType/'
    | '/_staff/contractor-core/_packages/archives/'
    | '/_staff/contractor-core/_packages/configs/'
    | '/_staff/contractor-core/config/$patternId/'
    | '/_staff/device-catalog/add/$deviceType/'
    | '/_staff/devices/_list/catalog/'
    | '/_staff/devices/_list/inventory/'
    | '/_staff/devices/_list/people/'
    | '/_staff/devices/_list/settings/'
    | '/_staff/devices/add/$deviceType/'
    | '/_staff/equipment/_layout/settings/'
    | '/_staff/fleets/_layout/_list/'
    | '/_staff/ga-operation-core/_packages/archives/'
    | '/_staff/ga-operation-core/_packages/configs/'
    | '/_staff/ga-operation-core/config/$patternId/'
    | '/_staff/ids/_layout/people/'
    | '/_staff/ids/group-id/add/'
    | '/_staff/it-operation-core/_root/archives/'
    | '/_staff/it-operation-core/_root/config/'
    | '/_staff/it-operation-core/_root/packages/'
    | '/_staff/it-operation-core/config/$patternId/'
    | '/_staff/labor-core/_packages/archives/'
    | '/_staff/labor-core/_packages/configs/'
    | '/_staff/labor-core/_packages/settings/'
    | '/_staff/labor-core/config/$patternId/'
    | '/_staff/licenses/_list/alerts/'
    | '/_staff/licenses/_list/contract-and-cost/'
    | '/_staff/licenses/_list/inventory/'
    | '/_staff/licenses/_list/operation-activity/'
    | '/_staff/licenses/_list/people/'
    | '/_staff/licenses/_list/rule-and-policy/'
    | '/_staff/licenses/_list/settings/'
    | '/_staff/licenses/add/$allocationType/'
    | '/_staff/marketplace/sales-orders/$orderId/'
    | '/_staff/organization/$id/_layout/'
    | '/_staff/organization/_list/alert/'
    | '/_staff/organization/_list/chart/'
    | '/_staff/organization/_list/cost/'
    | '/_staff/organization/_list/history/'
    | '/_staff/organization/_list/rule-policy/'
    | '/_staff/organization/_list/settings/'
    | '/_staff/organization/plan/$id/'
    | '/_staff/organization/plan/create/'
    | '/_staff/people/_list/alumni/'
    | '/_staff/people/_list/settings/'
    | '/_staff/people/_list/workforce/'
    | '/_staff/person/add-person-certification/$certificationKind/'
    | '/_staff/person/add/$workerType/'
    | '/_staff/places/_layout/settings/'
    | '/_staff/public-ids/$id/details/'
    | '/_staff/public-ids/$id/files/'
    | '/_staff/public-ids/_list/alerts/'
    | '/_staff/public-ids/_list/members/'
    | '/_staff/public-ids/_list/operation-activity/'
    | '/_staff/public-ids/_list/registry/'
    | '/_staff/public-ids/_list/rules-and-policies/'
    | '/_staff/public-ids/_list/settings/'
    | '/_staff/software/$id/_$id/'
    | '/_staff/software/_layout/contract-and-cost/'
    | '/_staff/software/_layout/marketplace/'
    | '/_staff/software/_layout/operation-activity/'
    | '/_staff/software/_layout/people/'
    | '/_staff/software/_layout/registry/'
    | '/_staff/software/_layout/rule-and-policy/'
    | '/_staff/software/_layout/settings/'
    | '/_staff/software/add/$type/'
    | '/_staff/starlinks/_layout/alerts/'
    | '/_staff/starlinks/_layout/user-terminals/'
    | '/_staff/storage-files/_list/files/'
    | '/_staff/storage-files/_list/folders/'
    | '/_staff/time-and-attendance/_layout/attendance-links/'
    | '/_staff/licenses/$id/_profile/'
    | '/_staff/person/alumni/$id/_profile/'
    | '/_staff/contract/$id/_layout/_placeholders/approval-info'
    | '/_staff/contract/$id/_layout/_placeholders/history'
    | '/_staff/contract/$id/_layout/_placeholders/operation-activity'
    | '/_staff/contract/$id/_layout/_placeholders/risk-provisions'
    | '/_staff/contract/$id/_layout/_placeholders/rule-and-policy'
    | '/_staff/profile/device/$id/_profile/files'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout'
    | '/_staff/licenses/$id/service-plans/$licenseServiceId'
    | '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail'
    | '/_staff/marketplace/sent-orders/$orderId/_layout/activities'
    | '/_staff/profile/device/$id/_profile/configuration'
    | '/_staff/profile/device/$id/_profile/monitoring'
    | '/_staff/profile/device/$id/_profile/'
    | '/_staff/profile/device/$id/_profile/control'
    | '/_staff/profile/device/$id/_profile/mdm'
    | '/_staff/profile/device/$id/_profile/status'
    | '/_individual/individual/task/$id/approval/'
    | '/_staff/app-integrations/$id/_$id/architecture/'
    | '/_staff/app-integrations/$id/_$id/detail/'
    | '/_staff/app-integrations/$id/_$id/rule-and-policy/'
    | '/_staff/app-integrations/$id/_$id/settings/'
    | '/_staff/app-integrations/$id/_$id/users/'
    | '/_staff/apps/_list/alerts/_alerts/'
    | '/_staff/apps/custom-app/add/$customAppType/'
    | '/_staff/business-partner/$id/_layout/_index/'
    | '/_staff/business-partner/$id/_layout/address-and-contact/'
    | '/_staff/certification/$id/_layout/_index/'
    | '/_staff/certification/$id/_layout/certification-holders/'
    | '/_staff/certification/$id/_layout/handling-certifications/'
    | '/_staff/certification/$id/_layout/specialty-certifications/'
    | '/_staff/certification/_list/settings/issuing-organization/'
    | '/_staff/certification/_list/settings/specialty-category-level/'
    | '/_staff/certification/_list/settings/specialty-category/'
    | '/_staff/devices/external-it-saas/$appIntegrationId/preview/'
    | '/_staff/equipment/_layout/settings/equipment-items/'
    | '/_staff/equipment/_layout/settings/equipment-types/'
    | '/_staff/ids/group-id/$id/_$id/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/'
    | '/_staff/licenses/$id/_profile/assignments/'
    | '/_staff/licenses/$id/_profile/people/'
    | '/_staff/licenses/$id/_profile/service-plans/'
    | '/_staff/marketplace/_store/store/devices/'
    | '/_staff/marketplace/_store/store/sales-orders/'
    | '/_staff/marketplace/_store/store/sent-orders/'
    | '/_staff/marketplace/_store/store/starlinks/'
    | '/_staff/marketplace/sent-orders/$orderId/_layout/'
    | '/_staff/organization/$id/_layout/history/'
    | '/_staff/organization/plan/$id/add/'
    | '/_staff/people/_list/settings/board-member-types/'
    | '/_staff/people/_list/settings/collaborator-types/'
    | '/_staff/people/_list/settings/contract-end-reasons/'
    | '/_staff/people/_list/settings/contractor-types/'
    | '/_staff/people/_list/settings/employee-sub-id-names/'
    | '/_staff/people/_list/settings/employment-types/'
    | '/_staff/people/_list/settings/grades/'
    | '/_staff/people/_list/settings/health-insurance-associations/'
    | '/_staff/people/_list/settings/job-competencies/'
    | '/_staff/people/_list/settings/job-functions/'
    | '/_staff/people/_list/settings/job-grades/'
    | '/_staff/people/_list/settings/job-levels/'
    | '/_staff/people/_list/settings/job-titles/'
    | '/_staff/people/_list/settings/job-types/'
    | '/_staff/people/_list/settings/place-social-insurances/'
    | '/_staff/people/_list/settings/positions/'
    | '/_staff/people/_list/settings/retirement-reasons/'
    | '/_staff/people/_list/settings/work-mode/'
    | '/_staff/person/$id/_profile/activity/'
    | '/_staff/person/$id/_profile/apps/'
    | '/_staff/person/$id/_profile/devices/'
    | '/_staff/person/$id/_profile/education-and-qualification/'
    | '/_staff/person/$id/_profile/employee-information/'
    | '/_staff/person/$id/_profile/equipment/'
    | '/_staff/person/$id/_profile/history/'
    | '/_staff/person/$id/_profile/personal-information/'
    | '/_staff/person/$id/_profile/public-id/'
    | '/_staff/person/external-hr-saas/$appIntegrationId/preview/'
    | '/_staff/places/$id/_layout/administrators/'
    | '/_staff/places/$id/_layout/labor-core/'
    | '/_staff/places/_layout/settings/place-sub-codes/'
    | '/_staff/settings/contracting-corporation-profile/_layout/board-member/'
    | '/_staff/settings/contracting-corporation-profile/_layout/contact-points/'
    | '/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/'
    | '/_staff/settings/contracting-corporation-profile/_layout/group-companies/'
    | '/_staff/settings/contracting-corporation-profile/_layout/history/'
    | '/_staff/settings/contracting-corporation-profile/_layout/registration/'
    | '/_staff/settings/contracting-corporation-profile/_layout/shareholders/'
    | '/_staff/settings/permission-and-roles/_list/people-groups/'
    | '/_staff/settings/permission-and-roles/_list/product-permissions/'
    | '/_staff/settings/permission-and-roles/_list/roles/'
    | '/_staff/settings/persons/_list/settings/'
    | '/_staff/software/$id/_$id/activity-monitoring/'
    | '/_staff/software/$id/_$id/architecture/'
    | '/_staff/software/$id/_$id/contracts-cost/'
    | '/_staff/software/$id/_$id/detail/'
    | '/_staff/software/$id/_$id/rule-and-policy/'
    | '/_staff/software/$id/_$id/settings/'
    | '/_staff/software/$id/_$id/users/'
    | '/_staff/software/_layout/alerts/_alerts/'
    | '/_staff/software/custom-saas/add/$customSaasType/'
    | '/_staff/time-and-attendance/_layout/_list/summary/'
    | '/_staff/time-and-attendance/_layout/attendance-links/$placeId/'
    | '/_staff/contract/$id/_layout/_index/'
    | '/_staff/contract/$id/_layout/structure/'
    | '/_staff/equipment/$id/_layout/_profile/'
    | '/_staff/fleets/$id/_layout/_profile/'
    | '/_staff/networks/$id/_layout/_profile/'
    | '/_staff/places/$id/_layout/_profile/'
    | '/_staff/starlinks/$id/_layout/_overview/'
    | '/_staff/starlinks/$id/_layout/detail/'
    | '/_staff/apps/_list/alerts/_alerts/shadow-it'
    | '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it'
    | '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId'
    | '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout'
    | '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId'
    | '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout'
    | '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId'
    | '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout'
    | '/_individual/individual/operation-package/$id/pattern/$patternId/'
    | '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/'
    | '/_staff/apps/_list/alerts/_alerts/inactive-user/'
    | '/_staff/apps/_list/alerts/_alerts/no-user/'
    | '/_staff/apps/_list/alerts/_alerts/no-worker/'
    | '/_staff/apps/_list/alerts/_alerts/violated-assignment/'
    | '/_staff/apps/_list/alerts/_alerts/violated-role/'
    | '/_staff/certification/handling-certification/$id/_layout/_index/'
    | '/_staff/certification/handling-certification/$id/_layout/certification-holders/'
    | '/_staff/certification/specialty-certification/$id/_layout/_index/'
    | '/_staff/certification/specialty-certification/$id/_layout/certification-holders/'
    | '/_staff/certification/specialty-certification/$id/_layout/handling-certifications/'
    | '/_staff/device-catalog/active/$id/_layout/profile/'
    | '/_staff/device-catalog/draft/$id/_layout/profile/'
    | '/_staff/ids/group-id/$id/_$id/members/'
    | '/_staff/ids/group-id/$id/_$id/rule-and-policy/'
    | '/_staff/ids/group-id/$id/_$id/settings/'
    | '/_staff/marketplace/_store/store/devices/$productId/'
    | '/_staff/marketplace/_store/store/starlinks/$productId/'
    | '/_staff/organization/plan/$id/edit/$unitId/'
    | '/_staff/person/$id/_profile/family/$familyPersonId/'
    | '/_staff/person/alumni/$id/_profile/activity/'
    | '/_staff/person/alumni/$id/_profile/apps/'
    | '/_staff/person/alumni/$id/_profile/devices/'
    | '/_staff/person/alumni/$id/_profile/education-and-qualification/'
    | '/_staff/person/alumni/$id/_profile/employee-information/'
    | '/_staff/person/alumni/$id/_profile/equipment/'
    | '/_staff/person/alumni/$id/_profile/history/'
    | '/_staff/person/alumni/$id/_profile/personal-information/'
    | '/_staff/person/alumni/$id/_profile/public-id/'
    | '/_staff/profile/device/$id/_profile/history/'
    | '/_staff/profile/device/$id/_profile/lifecycle/'
    | '/_staff/settings/permission-and-roles/_detail/people-groups/$id/'
    | '/_staff/settings/permission-and-roles/_detail/product-permissions/$id/'
    | '/_staff/settings/permission-and-roles/_detail/roles/$id/'
    | '/_staff/settings/permission-and-roles/_form/people-groups/new/'
    | '/_staff/settings/permission-and-roles/_form/product-permissions/new/'
    | '/_staff/settings/permission-and-roles/_form/roles/new/'
    | '/_staff/settings/persons/_list/_account/individual/'
    | '/_staff/settings/persons/_list/_account/staff/'
    | '/_staff/software/_layout/alerts/_alerts/alumni/'
    | '/_staff/software/_layout/alerts/_alerts/inactive-user/'
    | '/_staff/software/_layout/alerts/_alerts/no-user/'
    | '/_staff/software/_layout/alerts/_alerts/no-worker/'
    | '/_staff/software/_layout/alerts/_alerts/violated-assignment/'
    | '/_staff/software/_layout/alerts/_alerts/violated-role/'
    | '/_staff/time-and-attendance/_layout/_list/summary/daily-place/'
    | '/_staff/time-and-attendance/_layout/_list/summary/monthly-person/'
    | '/_staff/time-and-attendance/_layout/_list/summary/monthly-place/'
    | '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/'
    | '/_staff/apps/_list/marketplace/$id/install/finish/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/'
    | '/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/'
    | '/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/'
    | '/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/'
    | '/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/'
    | '/_staff/settings/permission-and-roles/_form/roles/$id/edit/'
    | '/_staff/software/_layout/marketplace/$id/install/finish/'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile'
    | '/_individual/individual/task/$id/_operation-package/_common/form/$formId/'
    | '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/'
    | '/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/'
    | '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/'
    | '/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/'
    | '/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/'
    | '/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
    | '/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
    | '/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  IndividualRoute: typeof IndividualRouteWithChildren
  StaffRoute: typeof StaffRouteWithChildren
  AuthSignInIndexRoute: typeof AuthSignInIndexRoute
  AuthPasswordResetIndexLazyRoute: typeof AuthPasswordResetIndexLazyRoute
  AuthInvitationInvitationCodeIndexRoute: typeof AuthInvitationInvitationCodeIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  IndividualRoute: IndividualRouteWithChildren,
  StaffRoute: StaffRouteWithChildren,
  AuthSignInIndexRoute: AuthSignInIndexRoute,
  AuthPasswordResetIndexLazyRoute: AuthPasswordResetIndexLazyRoute,
  AuthInvitationInvitationCodeIndexRoute:
    AuthInvitationInvitationCodeIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_individual",
        "/_staff",
        "/auth/sign-in/",
        "/auth/password-reset/",
        "/auth/invitation/$invitationCode/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_individual": {
      "filePath": "_individual.tsx",
      "children": [
        "/_individual/individual/",
        "/_individual/individual/task/$id/approval-dialog",
        "/_individual/individual/operation-package/$id/",
        "/_individual/individual/task/$id/",
        "/_individual/individual/task/$id/approval/",
        "/_individual/individual/operation-package/$id/pattern/$patternId/",
        "/_individual/individual/task/$id/_operation-package/_common/form/$formId/"
      ]
    },
    "/_staff": {
      "filePath": "_staff.tsx",
      "children": [
        "/_staff/apps",
        "/_staff/id-managements",
        "/_staff/it-operation-core/device-inventory",
        "/_staff/places/import-csv",
        "/_staff/accesses",
        "/_staff/business-operation-events",
        "/_staff/business-partner",
        "/_staff/certification",
        "/_staff/contract",
        "/_staff/contractor-core",
        "/_staff/devices",
        "/_staff/equipment",
        "/_staff/fleets",
        "/_staff/ga-operation-core",
        "/_staff/ids",
        "/_staff/it-operation-core",
        "/_staff/labor-core",
        "/_staff/licenses",
        "/_staff/marketplace",
        "/_staff/networks",
        "/_staff/organization",
        "/_staff/people",
        "/_staff/places",
        "/_staff/public-ids/$id",
        "/_staff/public-ids",
        "/_staff/software",
        "/_staff/starlinks",
        "/_staff/storage-files",
        "/_staff/time-and-attendance",
        "/_staff/cockpit/",
        "/_staff/settings/",
        "/_staff/app-integrations/import-csv/$id",
        "/_staff/person/import-csv/$workerType",
        "/_staff/app-integrations/$id",
        "/_staff/person/$id",
        "/_staff/settings/contracting-corporation-profile",
        "/_staff/settings/permission-and-roles",
        "/_staff/settings/persons",
        "/_staff/cockpit/$id/",
        "/_staff/device-catalog/add/",
        "/_staff/person/add-person-certification/",
        "/_staff/person/add/",
        "/_staff/person/external-hr-saas/",
        "/_staff/device-catalog/active/$id",
        "/_staff/device-catalog/add/$deviceType/completed",
        "/_staff/device-catalog/draft/$id",
        "/_staff/person/add-person-certification/$certificationKind/completed",
        "/_staff/person/add/$workerType/completed",
        "/_staff/person/alumni/$id",
        "/_staff/profile/device/$id",
        "/_staff/device-catalog/add/$deviceType/",
        "/_staff/person/add-person-certification/$certificationKind/",
        "/_staff/person/add/$workerType/",
        "/_staff/person/external-hr-saas/$appIntegrationId/preview/"
      ]
    },
    "/_staff/apps": {
      "filePath": "_staff/apps.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/apps/$",
        "/_staff/apps/_list",
        "/_staff/apps/custom-app/add/",
        "/_staff/apps/custom-app/add/$customAppType/"
      ]
    },
    "/_staff/id-managements": {
      "filePath": "_staff/id-managements.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/id-managements/$"
      ]
    },
    "/_staff/it-operation-core/device-inventory": {
      "filePath": "_staff/it-operation-core/device-inventory/route.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/it-operation-core/device-inventory/data",
        "/_staff/it-operation-core/device-inventory/detail"
      ]
    },
    "/_staff/places/import-csv": {
      "filePath": "_staff/places/import-csv/route.tsx",
      "parent": "/_staff"
    },
    "/_staff/accesses": {
      "filePath": "_staff/accesses",
      "parent": "/_staff",
      "children": [
        "/_staff/accesses/_layout"
      ]
    },
    "/_staff/accesses/_layout": {
      "filePath": "_staff/accesses/_layout.tsx",
      "parent": "/_staff/accesses",
      "children": [
        "/_staff/accesses/_layout/",
        "/_staff/accesses/_layout/_placeholders/contract-and-cost",
        "/_staff/accesses/_layout/_placeholders/overview",
        "/_staff/accesses/_layout/_placeholders/settings",
        "/_staff/accesses/_layout/_placeholders/software",
        "/_staff/accesses/_layout/alerts/",
        "/_staff/accesses/_layout/list/",
        "/_staff/accesses/_layout/alerts/detail/$shadowItAppId/"
      ]
    },
    "/_staff/apps/$": {
      "filePath": "_staff/apps/$.tsx",
      "parent": "/_staff/apps"
    },
    "/_staff/apps/_list": {
      "filePath": "_staff/apps/_list.tsx",
      "parent": "/_staff/apps",
      "children": [
        "/_staff/apps/_list/contract-and-cost",
        "/_staff/apps/_list/operation-activity",
        "/_staff/apps/_list/rule-and-policy",
        "/_staff/apps/_list/",
        "/_staff/apps/_list/marketplace/$id",
        "/_staff/apps/_list/alerts",
        "/_staff/apps/_list/integrations/",
        "/_staff/apps/_list/marketplace/",
        "/_staff/apps/_list/people/",
        "/_staff/apps/_list/settings/"
      ]
    },
    "/_staff/business-operation-events": {
      "filePath": "_staff/business-operation-events",
      "parent": "/_staff",
      "children": [
        "/_staff/business-operation-events/_list",
        "/_staff/business-operation-events/$eventInstanceId/"
      ]
    },
    "/_staff/business-operation-events/_list": {
      "filePath": "_staff/business-operation-events/_list.tsx",
      "parent": "/_staff/business-operation-events",
      "children": [
        "/_staff/business-operation-events/_list/archive",
        "/_staff/business-operation-events/_list/config",
        "/_staff/business-operation-events/_list/operation-activity",
        "/_staff/business-operation-events/_list/overview",
        "/_staff/business-operation-events/_list/rule-and-policy",
        "/_staff/business-operation-events/_list/settings",
        "/_staff/business-operation-events/_list/"
      ]
    },
    "/_staff/business-partner": {
      "filePath": "_staff/business-partner",
      "parent": "/_staff",
      "children": [
        "/_staff/business-partner/_list",
        "/_staff/business-partner/$id",
        "/_staff/business-partner/add/",
        "/_staff/business-partner/add/$businessPartnerType/completed",
        "/_staff/business-partner/add/$businessPartnerType/"
      ]
    },
    "/_staff/business-partner/_list": {
      "filePath": "_staff/business-partner/_list.tsx",
      "parent": "/_staff/business-partner",
      "children": [
        "/_staff/business-partner/_list/",
        "/_staff/business-partner/_list/_placeholders/alerts",
        "/_staff/business-partner/_list/_placeholders/contract-and-cost",
        "/_staff/business-partner/_list/_placeholders/operation-activity",
        "/_staff/business-partner/_list/_placeholders/rule-and-policy",
        "/_staff/business-partner/_list/_placeholders/settings",
        "/_staff/business-partner/_list/terminated/"
      ]
    },
    "/_staff/certification": {
      "filePath": "_staff/certification",
      "parent": "/_staff",
      "children": [
        "/_staff/certification/_list",
        "/_staff/certification/$id",
        "/_staff/certification/add/",
        "/_staff/certification/add/$certificationKind/completed",
        "/_staff/certification/handling-certification/$id",
        "/_staff/certification/specialty-certification/$id",
        "/_staff/certification/add/$certificationKind/"
      ]
    },
    "/_staff/certification/_list": {
      "filePath": "_staff/certification/_list.tsx",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/_list/settings",
        "/_staff/certification/_list/",
        "/_staff/certification/_list/_placeholders/alerts",
        "/_staff/certification/_list/_placeholders/operation-activity",
        "/_staff/certification/_list/_placeholders/overview",
        "/_staff/certification/_list/_placeholders/rule-and-policy"
      ]
    },
    "/_staff/contract": {
      "filePath": "_staff/contract",
      "parent": "/_staff",
      "children": [
        "/_staff/contract/_list",
        "/_staff/contract/$id",
        "/_staff/contract/add/",
        "/_staff/contract/import-csv/$contractType/"
      ]
    },
    "/_staff/contract/_list": {
      "filePath": "_staff/contract/_list.tsx",
      "parent": "/_staff/contract",
      "children": [
        "/_staff/contract/_list/",
        "/_staff/contract/_list/_placeholders/alerts",
        "/_staff/contract/_list/_placeholders/contract-and-cost",
        "/_staff/contract/_list/_placeholders/operation-activity",
        "/_staff/contract/_list/_placeholders/overview",
        "/_staff/contract/_list/_placeholders/people"
      ]
    },
    "/_staff/contractor-core": {
      "filePath": "_staff/contractor-core",
      "parent": "/_staff",
      "children": [
        "/_staff/contractor-core/_packages",
        "/_staff/contractor-core/config/$patternId/",
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId"
      ]
    },
    "/_staff/contractor-core/_packages": {
      "filePath": "_staff/contractor-core/_packages.tsx",
      "parent": "/_staff/contractor-core",
      "children": [
        "/_staff/contractor-core/_packages/",
        "/_staff/contractor-core/_packages/archives/",
        "/_staff/contractor-core/_packages/configs/"
      ]
    },
    "/_staff/devices": {
      "filePath": "_staff/devices",
      "parent": "/_staff",
      "children": [
        "/_staff/devices/_list",
        "/_staff/devices/import-csv/$deviceType",
        "/_staff/devices/add/",
        "/_staff/devices/external-it-saas/",
        "/_staff/devices/add/$deviceType/completed",
        "/_staff/devices/add/$deviceType/",
        "/_staff/devices/external-it-saas/$appIntegrationId/preview/"
      ]
    },
    "/_staff/devices/_list": {
      "filePath": "_staff/devices/_list.tsx",
      "parent": "/_staff/devices",
      "children": [
        "/_staff/devices/_list/alerts",
        "/_staff/devices/_list/contract-and-cost",
        "/_staff/devices/_list/operation-activity",
        "/_staff/devices/_list/rule-and-policy",
        "/_staff/devices/_list/",
        "/_staff/devices/_list/settings/catalog",
        "/_staff/devices/_list/catalog/",
        "/_staff/devices/_list/inventory/",
        "/_staff/devices/_list/people/",
        "/_staff/devices/_list/settings/"
      ]
    },
    "/_staff/equipment": {
      "filePath": "_staff/equipment",
      "parent": "/_staff",
      "children": [
        "/_staff/equipment/_layout",
        "/_staff/equipment/$id",
        "/_staff/equipment/add-select/",
        "/_staff/equipment/add/",
        "/_staff/equipment/import-csv/"
      ]
    },
    "/_staff/equipment/_layout": {
      "filePath": "_staff/equipment/_layout.tsx",
      "parent": "/_staff/equipment",
      "children": [
        "/_staff/equipment/_layout/settings",
        "/_staff/equipment/_layout/",
        "/_staff/equipment/_layout/_placeholders/alerts",
        "/_staff/equipment/_layout/_placeholders/overview",
        "/_staff/equipment/_layout/_placeholders/rule-and-policy",
        "/_staff/equipment/_layout/_placeholders/settings"
      ]
    },
    "/_staff/fleets": {
      "filePath": "_staff/fleets",
      "parent": "/_staff",
      "children": [
        "/_staff/fleets/_layout",
        "/_staff/fleets/$id",
        "/_staff/fleets/add-select/",
        "/_staff/fleets/add/"
      ]
    },
    "/_staff/fleets/_layout": {
      "filePath": "_staff/fleets/_layout.tsx",
      "parent": "/_staff/fleets",
      "children": [
        "/_staff/fleets/_layout/alerts",
        "/_staff/fleets/_layout/overview",
        "/_staff/fleets/_layout/rule-and-policy",
        "/_staff/fleets/_layout/settings",
        "/_staff/fleets/_layout/_list/"
      ]
    },
    "/_staff/ga-operation-core": {
      "filePath": "_staff/ga-operation-core",
      "parent": "/_staff",
      "children": [
        "/_staff/ga-operation-core/_packages",
        "/_staff/ga-operation-core/config/$patternId/",
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId"
      ]
    },
    "/_staff/ga-operation-core/_packages": {
      "filePath": "_staff/ga-operation-core/_packages.tsx",
      "parent": "/_staff/ga-operation-core",
      "children": [
        "/_staff/ga-operation-core/_packages/",
        "/_staff/ga-operation-core/_packages/archives/",
        "/_staff/ga-operation-core/_packages/configs/"
      ]
    },
    "/_staff/id-managements/$": {
      "filePath": "_staff/id-managements/$.tsx",
      "parent": "/_staff/id-managements"
    },
    "/_staff/ids": {
      "filePath": "_staff/ids",
      "parent": "/_staff",
      "children": [
        "/_staff/ids/_layout",
        "/_staff/ids/group-id/$id",
        "/_staff/ids/group-id/add/"
      ]
    },
    "/_staff/ids/_layout": {
      "filePath": "_staff/ids/_layout.tsx",
      "parent": "/_staff/ids",
      "children": [
        "/_staff/ids/_layout/",
        "/_staff/ids/_layout/_placeholders/alerts",
        "/_staff/ids/_layout/_placeholders/group-id",
        "/_staff/ids/_layout/_placeholders/operation-activity",
        "/_staff/ids/_layout/_placeholders/overview",
        "/_staff/ids/_layout/_placeholders/rule-and-policy",
        "/_staff/ids/_layout/_placeholders/settings",
        "/_staff/ids/_layout/people/"
      ]
    },
    "/_staff/it-operation-core": {
      "filePath": "_staff/it-operation-core",
      "parent": "/_staff",
      "children": [
        "/_staff/it-operation-core/_detail",
        "/_staff/it-operation-core/_root",
        "/_staff/it-operation-core/",
        "/_staff/it-operation-core/config/$patternId/"
      ]
    },
    "/_staff/it-operation-core/_detail": {
      "filePath": "_staff/it-operation-core/_detail.tsx",
      "parent": "/_staff/it-operation-core",
      "children": [
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId"
      ]
    },
    "/_staff/it-operation-core/_root": {
      "filePath": "_staff/it-operation-core/_root.tsx",
      "parent": "/_staff/it-operation-core",
      "children": [
        "/_staff/it-operation-core/_root/packages",
        "/_staff/it-operation-core/_root/archives/",
        "/_staff/it-operation-core/_root/config/"
      ]
    },
    "/_staff/labor-core": {
      "filePath": "_staff/labor-core",
      "parent": "/_staff",
      "children": [
        "/_staff/labor-core/_packages",
        "/_staff/labor-core/anchor-date",
        "/_staff/labor-core/person-targets",
        "/_staff/labor-core/settings/egov-callback",
        "/_staff/labor-core/settings/profile/$profileId",
        "/_staff/labor-core/config/$patternId/",
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId"
      ]
    },
    "/_staff/labor-core/_packages": {
      "filePath": "_staff/labor-core/_packages.tsx",
      "parent": "/_staff/labor-core",
      "children": [
        "/_staff/labor-core/_packages/settings",
        "/_staff/labor-core/_packages/",
        "/_staff/labor-core/_packages/archives/",
        "/_staff/labor-core/_packages/configs/"
      ]
    },
    "/_staff/labor-core/anchor-date": {
      "filePath": "_staff/labor-core/anchor-date.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/labor-core/person-targets": {
      "filePath": "_staff/labor-core/person-targets.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses": {
      "filePath": "_staff/licenses",
      "parent": "/_staff",
      "children": [
        "/_staff/licenses/_list",
        "/_staff/licenses/$id",
        "/_staff/licenses/add/",
        "/_staff/licenses/add/$allocationType/completed",
        "/_staff/licenses/add/$allocationType/"
      ]
    },
    "/_staff/licenses/_list": {
      "filePath": "_staff/licenses/_list.tsx",
      "parent": "/_staff/licenses",
      "children": [
        "/_staff/licenses/_list/",
        "/_staff/licenses/_list/alerts/",
        "/_staff/licenses/_list/contract-and-cost/",
        "/_staff/licenses/_list/inventory/",
        "/_staff/licenses/_list/operation-activity/",
        "/_staff/licenses/_list/people/",
        "/_staff/licenses/_list/rule-and-policy/",
        "/_staff/licenses/_list/settings/"
      ]
    },
    "/_staff/marketplace": {
      "filePath": "_staff/marketplace",
      "parent": "/_staff",
      "children": [
        "/_staff/marketplace/_store",
        "/_staff/marketplace/cart/",
        "/_staff/marketplace/unavailable/",
        "/_staff/marketplace/sent-orders/$orderId",
        "/_staff/marketplace/sales-orders/$orderId/"
      ]
    },
    "/_staff/marketplace/_store": {
      "filePath": "_staff/marketplace/_store.tsx",
      "parent": "/_staff/marketplace",
      "children": [
        "/_staff/marketplace/_store/store/devices/",
        "/_staff/marketplace/_store/store/sales-orders/",
        "/_staff/marketplace/_store/store/sent-orders/",
        "/_staff/marketplace/_store/store/starlinks/",
        "/_staff/marketplace/_store/store/devices/$productId/",
        "/_staff/marketplace/_store/store/starlinks/$productId/"
      ]
    },
    "/_staff/networks": {
      "filePath": "_staff/networks",
      "parent": "/_staff",
      "children": [
        "/_staff/networks/_layout",
        "/_staff/networks/$id",
        "/_staff/networks/add/"
      ]
    },
    "/_staff/networks/_layout": {
      "filePath": "_staff/networks/_layout.tsx",
      "parent": "/_staff/networks",
      "children": [
        "/_staff/networks/_layout/",
        "/_staff/networks/_layout/_placeholders/alerts",
        "/_staff/networks/_layout/_placeholders/contract-and-cost",
        "/_staff/networks/_layout/_placeholders/operation-activity",
        "/_staff/networks/_layout/_placeholders/overview",
        "/_staff/networks/_layout/_placeholders/rule-and-policy",
        "/_staff/networks/_layout/_placeholders/settings"
      ]
    },
    "/_staff/organization": {
      "filePath": "_staff/organization",
      "parent": "/_staff",
      "children": [
        "/_staff/organization/_list",
        "/_staff/organization/",
        "/_staff/organization/$id",
        "/_staff/organization/plan/",
        "/_staff/organization/plan/$id/",
        "/_staff/organization/plan/create/",
        "/_staff/organization/plan/$id/add/",
        "/_staff/organization/plan/$id/edit/$unitId/"
      ]
    },
    "/_staff/organization/_list": {
      "filePath": "_staff/organization/_list.tsx",
      "parent": "/_staff/organization",
      "children": [
        "/_staff/organization/_list/alert/",
        "/_staff/organization/_list/chart/",
        "/_staff/organization/_list/cost/",
        "/_staff/organization/_list/history/",
        "/_staff/organization/_list/rule-policy/",
        "/_staff/organization/_list/settings/"
      ]
    },
    "/_staff/people": {
      "filePath": "_staff/people",
      "parent": "/_staff",
      "children": [
        "/_staff/people/_list"
      ]
    },
    "/_staff/people/_list": {
      "filePath": "_staff/people/_list.tsx",
      "parent": "/_staff/people",
      "children": [
        "/_staff/people/_list/alerts",
        "/_staff/people/_list/community",
        "/_staff/people/_list/operation-activity",
        "/_staff/people/_list/people-graph",
        "/_staff/people/_list/rule-and-policy",
        "/_staff/people/_list/salary-and-payment",
        "/_staff/people/_list/",
        "/_staff/people/_list/settings",
        "/_staff/people/_list/alumni/",
        "/_staff/people/_list/workforce/"
      ]
    },
    "/_staff/places": {
      "filePath": "_staff/places",
      "parent": "/_staff",
      "children": [
        "/_staff/places/_layout",
        "/_staff/places/$id",
        "/_staff/places/add-select/",
        "/_staff/places/add/"
      ]
    },
    "/_staff/places/_layout": {
      "filePath": "_staff/places/_layout.tsx",
      "parent": "/_staff/places",
      "children": [
        "/_staff/places/_layout/settings",
        "/_staff/places/_layout/",
        "/_staff/places/_layout/_placeholders/alerts",
        "/_staff/places/_layout/_placeholders/contract-and-cost",
        "/_staff/places/_layout/_placeholders/operation-activity",
        "/_staff/places/_layout/_placeholders/overview",
        "/_staff/places/_layout/_placeholders/people",
        "/_staff/places/_layout/_placeholders/rule-and-policy",
        "/_staff/places/_layout/_placeholders/store"
      ]
    },
    "/_staff/public-ids/$id": {
      "filePath": "_staff/public-ids/$id.tsx",
      "parent": "/_staff",
      "children": [
        "/_staff/public-ids/$id/",
        "/_staff/public-ids/$id/details/",
        "/_staff/public-ids/$id/files/"
      ]
    },
    "/_staff/public-ids": {
      "filePath": "_staff/public-ids",
      "parent": "/_staff",
      "children": [
        "/_staff/public-ids/_list",
        "/_staff/public-ids/import-csv/$publicIdType",
        "/_staff/public-ids/add/"
      ]
    },
    "/_staff/public-ids/_list": {
      "filePath": "_staff/public-ids/_list.tsx",
      "parent": "/_staff/public-ids",
      "children": [
        "/_staff/public-ids/_list/",
        "/_staff/public-ids/_list/alerts/",
        "/_staff/public-ids/_list/members/",
        "/_staff/public-ids/_list/operation-activity/",
        "/_staff/public-ids/_list/registry/",
        "/_staff/public-ids/_list/rules-and-policies/",
        "/_staff/public-ids/_list/settings/"
      ]
    },
    "/_staff/software": {
      "filePath": "_staff/software",
      "parent": "/_staff",
      "children": [
        "/_staff/software/_layout",
        "/_staff/software/$id/import-csv",
        "/_staff/software/$id",
        "/_staff/software/add/",
        "/_staff/software/add/$type/",
        "/_staff/software/custom-saas/add/$customSaasType/"
      ]
    },
    "/_staff/software/_layout": {
      "filePath": "_staff/software/_layout.tsx",
      "parent": "/_staff/software",
      "children": [
        "/_staff/software/_layout/people",
        "/_staff/software/_layout/integrations",
        "/_staff/software/_layout/",
        "/_staff/software/_layout/marketplace/$id",
        "/_staff/software/_layout/alerts",
        "/_staff/software/_layout/contract-and-cost/",
        "/_staff/software/_layout/marketplace/",
        "/_staff/software/_layout/operation-activity/",
        "/_staff/software/_layout/registry/",
        "/_staff/software/_layout/rule-and-policy/",
        "/_staff/software/_layout/settings/"
      ]
    },
    "/_staff/starlinks": {
      "filePath": "_staff/starlinks",
      "parent": "/_staff",
      "children": [
        "/_staff/starlinks/_layout",
        "/_staff/starlinks/$id"
      ]
    },
    "/_staff/starlinks/_layout": {
      "filePath": "_staff/starlinks/_layout.tsx",
      "parent": "/_staff/starlinks",
      "children": [
        "/_staff/starlinks/_layout/",
        "/_staff/starlinks/_layout/_placeholders/billing-and-cost",
        "/_staff/starlinks/_layout/_placeholders/marketplace",
        "/_staff/starlinks/_layout/_placeholders/operation-activity",
        "/_staff/starlinks/_layout/alerts/",
        "/_staff/starlinks/_layout/user-terminals/"
      ]
    },
    "/_staff/storage-files": {
      "filePath": "_staff/storage-files",
      "parent": "/_staff",
      "children": [
        "/_staff/storage-files/_list"
      ]
    },
    "/_staff/storage-files/_list": {
      "filePath": "_staff/storage-files/_list.tsx",
      "parent": "/_staff/storage-files",
      "children": [
        "/_staff/storage-files/_list/files/",
        "/_staff/storage-files/_list/folders/"
      ]
    },
    "/_staff/time-and-attendance": {
      "filePath": "_staff/time-and-attendance",
      "parent": "/_staff",
      "children": [
        "/_staff/time-and-attendance/_layout"
      ]
    },
    "/_staff/time-and-attendance/_layout": {
      "filePath": "_staff/time-and-attendance/_layout.tsx",
      "parent": "/_staff/time-and-attendance",
      "children": [
        "/_staff/time-and-attendance/_layout/",
        "/_staff/time-and-attendance/_layout/_placeholders/attendances",
        "/_staff/time-and-attendance/_layout/_placeholders/clocking",
        "/_staff/time-and-attendance/_layout/attendance-links/",
        "/_staff/time-and-attendance/_layout/_list/summary/",
        "/_staff/time-and-attendance/_layout/attendance-links/$placeId/",
        "/_staff/time-and-attendance/_layout/_list/summary/daily-place/",
        "/_staff/time-and-attendance/_layout/_list/summary/monthly-person/",
        "/_staff/time-and-attendance/_layout/_list/summary/monthly-place/"
      ]
    },
    "/_individual/individual/": {
      "filePath": "_individual/individual/index.tsx",
      "parent": "/_individual"
    },
    "/_staff/cockpit/": {
      "filePath": "_staff/cockpit/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/it-operation-core/": {
      "filePath": "_staff/it-operation-core/index.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/organization/": {
      "filePath": "_staff/organization/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/settings/": {
      "filePath": "_staff/settings/index.tsx",
      "parent": "/_staff"
    },
    "/auth/sign-in/": {
      "filePath": "auth/sign-in/index.tsx"
    },
    "/auth/password-reset/": {
      "filePath": "auth/password-reset/index.lazy.tsx"
    },
    "/_staff/licenses/_list/": {
      "filePath": "_staff/licenses/_list/index/route.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/app-integrations/import-csv/$id": {
      "filePath": "_staff/app-integrations/import-csv/$id/route.tsx",
      "parent": "/_staff"
    },
    "/_staff/devices/import-csv/$deviceType": {
      "filePath": "_staff/devices/import-csv/$deviceType/route.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/it-operation-core/_root/packages": {
      "filePath": "_staff/it-operation-core/_root/packages/route.tsx",
      "parent": "/_staff/it-operation-core/_root",
      "children": [
        "/_staff/it-operation-core/_root/packages/$packageId",
        "/_staff/it-operation-core/_root/packages/"
      ]
    },
    "/_staff/person/import-csv/$workerType": {
      "filePath": "_staff/person/import-csv/$workerType/route.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/_layout/settings": {
      "filePath": "_staff/places/_layout/settings/route.tsx",
      "parent": "/_staff/places/_layout",
      "children": [
        "/_staff/places/_layout/settings/",
        "/_staff/places/_layout/settings/place-sub-codes/"
      ]
    },
    "/_staff/public-ids/import-csv/$publicIdType": {
      "filePath": "_staff/public-ids/import-csv/$publicIdType/route.tsx",
      "parent": "/_staff/public-ids"
    },
    "/_staff/software/$id/import-csv": {
      "filePath": "_staff/software/$id/import-csv/route.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/software/_layout/people": {
      "filePath": "_staff/software/_layout/people/route.tsx",
      "parent": "/_staff/software/_layout",
      "children": [
        "/_staff/software/_layout/people/"
      ]
    },
    "/_staff/app-integrations/$id": {
      "filePath": "_staff/app-integrations/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/app-integrations/$id/_$id"
      ]
    },
    "/_staff/app-integrations/$id/_$id": {
      "filePath": "_staff/app-integrations/$id/_$id.tsx",
      "parent": "/_staff/app-integrations/$id",
      "children": [
        "/_staff/app-integrations/$id/_$id/groups",
        "/_staff/app-integrations/$id/_$id/",
        "/_staff/app-integrations/$id/_$id/architecture/",
        "/_staff/app-integrations/$id/_$id/detail/",
        "/_staff/app-integrations/$id/_$id/rule-and-policy/",
        "/_staff/app-integrations/$id/_$id/settings/",
        "/_staff/app-integrations/$id/_$id/users/"
      ]
    },
    "/_staff/apps/_list/contract-and-cost": {
      "filePath": "_staff/apps/_list/contract-and-cost.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/apps/_list/operation-activity": {
      "filePath": "_staff/apps/_list/operation-activity.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/apps/_list/rule-and-policy": {
      "filePath": "_staff/apps/_list/rule-and-policy.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/business-operation-events/_list/archive": {
      "filePath": "_staff/business-operation-events/_list/archive.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/config": {
      "filePath": "_staff/business-operation-events/_list/config.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/operation-activity": {
      "filePath": "_staff/business-operation-events/_list/operation-activity.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/overview": {
      "filePath": "_staff/business-operation-events/_list/overview.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/rule-and-policy": {
      "filePath": "_staff/business-operation-events/_list/rule-and-policy.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-operation-events/_list/settings": {
      "filePath": "_staff/business-operation-events/_list/settings.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-partner/$id": {
      "filePath": "_staff/business-partner/$id",
      "parent": "/_staff/business-partner",
      "children": [
        "/_staff/business-partner/$id/_layout"
      ]
    },
    "/_staff/business-partner/$id/_layout": {
      "filePath": "_staff/business-partner/$id/_layout.tsx",
      "parent": "/_staff/business-partner/$id",
      "children": [
        "/_staff/business-partner/$id/_layout/_index/",
        "/_staff/business-partner/$id/_layout/address-and-contact/"
      ]
    },
    "/_staff/certification/$id": {
      "filePath": "_staff/certification/$id",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/$id/_layout"
      ]
    },
    "/_staff/certification/$id/_layout": {
      "filePath": "_staff/certification/$id/_layout.tsx",
      "parent": "/_staff/certification/$id",
      "children": [
        "/_staff/certification/$id/_layout/_index/",
        "/_staff/certification/$id/_layout/certification-holders/",
        "/_staff/certification/$id/_layout/handling-certifications/",
        "/_staff/certification/$id/_layout/specialty-certifications/"
      ]
    },
    "/_staff/contract/$id": {
      "filePath": "_staff/contract/$id",
      "parent": "/_staff/contract",
      "children": [
        "/_staff/contract/$id/_layout"
      ]
    },
    "/_staff/contract/$id/_layout": {
      "filePath": "_staff/contract/$id/_layout.tsx",
      "parent": "/_staff/contract/$id",
      "children": [
        "/_staff/contract/$id/_layout/_placeholders/approval-info",
        "/_staff/contract/$id/_layout/_placeholders/history",
        "/_staff/contract/$id/_layout/_placeholders/operation-activity",
        "/_staff/contract/$id/_layout/_placeholders/risk-provisions",
        "/_staff/contract/$id/_layout/_placeholders/rule-and-policy",
        "/_staff/contract/$id/_layout/_index/",
        "/_staff/contract/$id/_layout/structure/"
      ]
    },
    "/_staff/devices/_list/alerts": {
      "filePath": "_staff/devices/_list/alerts.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/contract-and-cost": {
      "filePath": "_staff/devices/_list/contract-and-cost.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/operation-activity": {
      "filePath": "_staff/devices/_list/operation-activity.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/rule-and-policy": {
      "filePath": "_staff/devices/_list/rule-and-policy.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/equipment/$id": {
      "filePath": "_staff/equipment/$id",
      "parent": "/_staff/equipment",
      "children": [
        "/_staff/equipment/$id/_layout"
      ]
    },
    "/_staff/equipment/$id/_layout": {
      "filePath": "_staff/equipment/$id/_layout.tsx",
      "parent": "/_staff/equipment/$id",
      "children": [
        "/_staff/equipment/$id/_layout/_profile/"
      ]
    },
    "/_staff/fleets/$id": {
      "filePath": "_staff/fleets/$id",
      "parent": "/_staff/fleets",
      "children": [
        "/_staff/fleets/$id/_layout"
      ]
    },
    "/_staff/fleets/$id/_layout": {
      "filePath": "_staff/fleets/$id/_layout.tsx",
      "parent": "/_staff/fleets/$id",
      "children": [
        "/_staff/fleets/$id/_layout/_profile/"
      ]
    },
    "/_staff/fleets/_layout/alerts": {
      "filePath": "_staff/fleets/_layout/alerts.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/fleets/_layout/overview": {
      "filePath": "_staff/fleets/_layout/overview.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/fleets/_layout/rule-and-policy": {
      "filePath": "_staff/fleets/_layout/rule-and-policy.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/fleets/_layout/settings": {
      "filePath": "_staff/fleets/_layout/settings.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/it-operation-core/device-inventory/data": {
      "filePath": "_staff/it-operation-core/device-inventory/data.tsx",
      "parent": "/_staff/it-operation-core/device-inventory"
    },
    "/_staff/it-operation-core/device-inventory/detail": {
      "filePath": "_staff/it-operation-core/device-inventory/detail.tsx",
      "parent": "/_staff/it-operation-core/device-inventory"
    },
    "/_staff/labor-core/_packages/settings": {
      "filePath": "_staff/labor-core/_packages/settings.tsx",
      "parent": "/_staff/labor-core/_packages",
      "children": [
        "/_staff/labor-core/_packages/settings/"
      ]
    },
    "/_staff/labor-core/settings/egov-callback": {
      "filePath": "_staff/labor-core/settings/egov-callback.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses/$id": {
      "filePath": "_staff/licenses/$id",
      "parent": "/_staff/licenses",
      "children": [
        "/_staff/licenses/$id/_profile",
        "/_staff/licenses/$id/service-plans/$licenseServiceId"
      ]
    },
    "/_staff/licenses/$id/_profile": {
      "filePath": "_staff/licenses/$id/_profile.tsx",
      "parent": "/_staff/licenses/$id",
      "children": [
        "/_staff/licenses/$id/_profile/",
        "/_staff/licenses/$id/_profile/assignments/",
        "/_staff/licenses/$id/_profile/people/",
        "/_staff/licenses/$id/_profile/service-plans/"
      ]
    },
    "/_staff/networks/$id": {
      "filePath": "_staff/networks/$id",
      "parent": "/_staff/networks",
      "children": [
        "/_staff/networks/$id/_layout"
      ]
    },
    "/_staff/networks/$id/_layout": {
      "filePath": "_staff/networks/$id/_layout.tsx",
      "parent": "/_staff/networks/$id",
      "children": [
        "/_staff/networks/$id/_layout/_profile/"
      ]
    },
    "/_staff/organization/$id": {
      "filePath": "_staff/organization/$id",
      "parent": "/_staff/organization",
      "children": [
        "/_staff/organization/$id/_layout"
      ]
    },
    "/_staff/organization/$id/_layout": {
      "filePath": "_staff/organization/$id/_layout.tsx",
      "parent": "/_staff/organization/$id",
      "children": [
        "/_staff/organization/$id/_layout/",
        "/_staff/organization/$id/_layout/history/"
      ]
    },
    "/_staff/people/_list/alerts": {
      "filePath": "_staff/people/_list/alerts.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/community": {
      "filePath": "_staff/people/_list/community.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/operation-activity": {
      "filePath": "_staff/people/_list/operation-activity.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/people-graph": {
      "filePath": "_staff/people/_list/people-graph.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/rule-and-policy": {
      "filePath": "_staff/people/_list/rule-and-policy.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/salary-and-payment": {
      "filePath": "_staff/people/_list/salary-and-payment.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/person/$id": {
      "filePath": "_staff/person/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/person/$id/_profile",
        "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId",
        "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId",
        "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId"
      ]
    },
    "/_staff/person/$id/_profile": {
      "filePath": "_staff/person/$id/_profile.tsx",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/_profile/",
        "/_staff/person/$id/_profile/activity/",
        "/_staff/person/$id/_profile/apps/",
        "/_staff/person/$id/_profile/devices/",
        "/_staff/person/$id/_profile/education-and-qualification/",
        "/_staff/person/$id/_profile/employee-information/",
        "/_staff/person/$id/_profile/equipment/",
        "/_staff/person/$id/_profile/history/",
        "/_staff/person/$id/_profile/personal-information/",
        "/_staff/person/$id/_profile/public-id/",
        "/_staff/person/$id/_profile/family/$familyPersonId/"
      ]
    },
    "/_staff/places/$id": {
      "filePath": "_staff/places/$id",
      "parent": "/_staff/places",
      "children": [
        "/_staff/places/$id/_layout"
      ]
    },
    "/_staff/places/$id/_layout": {
      "filePath": "_staff/places/$id/_layout.tsx",
      "parent": "/_staff/places/$id",
      "children": [
        "/_staff/places/$id/_layout/administrators/",
        "/_staff/places/$id/_layout/labor-core/",
        "/_staff/places/$id/_layout/_profile/"
      ]
    },
    "/_staff/settings/contracting-corporation-profile": {
      "filePath": "_staff/settings/contracting-corporation-profile",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/contracting-corporation-profile/_layout",
        "/_staff/settings/contracting-corporation-profile/"
      ]
    },
    "/_staff/settings/contracting-corporation-profile/_layout": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile",
      "children": [
        "/_staff/settings/contracting-corporation-profile/_layout/board-member/",
        "/_staff/settings/contracting-corporation-profile/_layout/contact-points/",
        "/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/",
        "/_staff/settings/contracting-corporation-profile/_layout/group-companies/",
        "/_staff/settings/contracting-corporation-profile/_layout/history/",
        "/_staff/settings/contracting-corporation-profile/_layout/registration/",
        "/_staff/settings/contracting-corporation-profile/_layout/shareholders/"
      ]
    },
    "/_staff/settings/permission-and-roles": {
      "filePath": "_staff/settings/permission-and-roles",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/permission-and-roles/_detail",
        "/_staff/settings/permission-and-roles/_form",
        "/_staff/settings/permission-and-roles/_list",
        "/_staff/settings/permission-and-roles/"
      ]
    },
    "/_staff/settings/permission-and-roles/_detail": {
      "filePath": "_staff/settings/permission-and-roles/_detail.tsx",
      "parent": "/_staff/settings/permission-and-roles",
      "children": [
        "/_staff/settings/permission-and-roles/_detail/people-groups/$id/",
        "/_staff/settings/permission-and-roles/_detail/product-permissions/$id/",
        "/_staff/settings/permission-and-roles/_detail/roles/$id/"
      ]
    },
    "/_staff/settings/permission-and-roles/_form": {
      "filePath": "_staff/settings/permission-and-roles/_form.tsx",
      "parent": "/_staff/settings/permission-and-roles",
      "children": [
        "/_staff/settings/permission-and-roles/_form/people-groups/new/",
        "/_staff/settings/permission-and-roles/_form/product-permissions/new/",
        "/_staff/settings/permission-and-roles/_form/roles/new/",
        "/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/",
        "/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/",
        "/_staff/settings/permission-and-roles/_form/roles/$id/edit/"
      ]
    },
    "/_staff/settings/permission-and-roles/_list": {
      "filePath": "_staff/settings/permission-and-roles/_list.tsx",
      "parent": "/_staff/settings/permission-and-roles",
      "children": [
        "/_staff/settings/permission-and-roles/_list/people-groups/",
        "/_staff/settings/permission-and-roles/_list/product-permissions/",
        "/_staff/settings/permission-and-roles/_list/roles/"
      ]
    },
    "/_staff/settings/persons": {
      "filePath": "_staff/settings/persons",
      "parent": "/_staff",
      "children": [
        "/_staff/settings/persons/_list",
        "/_staff/settings/persons/"
      ]
    },
    "/_staff/settings/persons/_list": {
      "filePath": "_staff/settings/persons/_list.tsx",
      "parent": "/_staff/settings/persons",
      "children": [
        "/_staff/settings/persons/_list/_account",
        "/_staff/settings/persons/_list/settings/"
      ]
    },
    "/_staff/software/$id": {
      "filePath": "_staff/software/$id",
      "parent": "/_staff/software",
      "children": [
        "/_staff/software/$id/_$id"
      ]
    },
    "/_staff/software/$id/_$id": {
      "filePath": "_staff/software/$id/_$id.tsx",
      "parent": "/_staff/software/$id",
      "children": [
        "/_staff/software/$id/_$id/",
        "/_staff/software/$id/_$id/activity-monitoring/",
        "/_staff/software/$id/_$id/architecture/",
        "/_staff/software/$id/_$id/contracts-cost/",
        "/_staff/software/$id/_$id/detail/",
        "/_staff/software/$id/_$id/rule-and-policy/",
        "/_staff/software/$id/_$id/settings/",
        "/_staff/software/$id/_$id/users/"
      ]
    },
    "/_staff/software/_layout/integrations": {
      "filePath": "_staff/software/_layout/integrations.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/starlinks/$id": {
      "filePath": "_staff/starlinks/$id",
      "parent": "/_staff/starlinks",
      "children": [
        "/_staff/starlinks/$id/_layout"
      ]
    },
    "/_staff/starlinks/$id/_layout": {
      "filePath": "_staff/starlinks/$id/_layout.tsx",
      "parent": "/_staff/starlinks/$id",
      "children": [
        "/_staff/starlinks/$id/_layout/_overview/",
        "/_staff/starlinks/$id/_layout/detail/"
      ]
    },
    "/_staff/apps/_list/": {
      "filePath": "_staff/apps/_list/index/route.lazy.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/devices/_list/": {
      "filePath": "_staff/devices/_list/index/route.lazy.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/people/_list/": {
      "filePath": "_staff/people/_list/index/route.lazy.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/software/_layout/": {
      "filePath": "_staff/software/_layout/index/route.lazy.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/certification/_list/settings": {
      "filePath": "_staff/certification/_list/settings/route.lazy.tsx",
      "parent": "/_staff/certification/_list",
      "children": [
        "/_staff/certification/_list/settings/",
        "/_staff/certification/_list/settings/issuing-organization/",
        "/_staff/certification/_list/settings/specialty-category-level/",
        "/_staff/certification/_list/settings/specialty-category/"
      ]
    },
    "/_staff/equipment/_layout/settings": {
      "filePath": "_staff/equipment/_layout/settings/route.lazy.tsx",
      "parent": "/_staff/equipment/_layout",
      "children": [
        "/_staff/equipment/_layout/settings/",
        "/_staff/equipment/_layout/settings/equipment-items/",
        "/_staff/equipment/_layout/settings/equipment-types/"
      ]
    },
    "/_staff/people/_list/settings": {
      "filePath": "_staff/people/_list/settings/route.lazy.tsx",
      "parent": "/_staff/people/_list",
      "children": [
        "/_staff/people/_list/settings/",
        "/_staff/people/_list/settings/board-member-types/",
        "/_staff/people/_list/settings/collaborator-types/",
        "/_staff/people/_list/settings/contract-end-reasons/",
        "/_staff/people/_list/settings/contractor-types/",
        "/_staff/people/_list/settings/employee-sub-id-names/",
        "/_staff/people/_list/settings/employment-types/",
        "/_staff/people/_list/settings/grades/",
        "/_staff/people/_list/settings/health-insurance-associations/",
        "/_staff/people/_list/settings/job-competencies/",
        "/_staff/people/_list/settings/job-functions/",
        "/_staff/people/_list/settings/job-grades/",
        "/_staff/people/_list/settings/job-levels/",
        "/_staff/people/_list/settings/job-titles/",
        "/_staff/people/_list/settings/job-types/",
        "/_staff/people/_list/settings/place-social-insurances/",
        "/_staff/people/_list/settings/positions/",
        "/_staff/people/_list/settings/retirement-reasons/",
        "/_staff/people/_list/settings/work-mode/"
      ]
    },
    "/_staff/accesses/_layout/": {
      "filePath": "_staff/accesses/_layout/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/business-operation-events/$eventInstanceId/": {
      "filePath": "_staff/business-operation-events/$eventInstanceId/index.tsx",
      "parent": "/_staff/business-operation-events"
    },
    "/_staff/business-operation-events/_list/": {
      "filePath": "_staff/business-operation-events/_list/index.tsx",
      "parent": "/_staff/business-operation-events/_list"
    },
    "/_staff/business-partner/_list/": {
      "filePath": "_staff/business-partner/_list/index.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/add/": {
      "filePath": "_staff/business-partner/add/index.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/certification/_list/": {
      "filePath": "_staff/certification/_list/index.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/add/": {
      "filePath": "_staff/certification/add/index.tsx",
      "parent": "/_staff/certification"
    },
    "/_staff/cockpit/$id/": {
      "filePath": "_staff/cockpit/$id/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/contract/_list/": {
      "filePath": "_staff/contract/_list/index.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/add/": {
      "filePath": "_staff/contract/add/index.tsx",
      "parent": "/_staff/contract"
    },
    "/_staff/contractor-core/_packages/": {
      "filePath": "_staff/contractor-core/_packages/index.tsx",
      "parent": "/_staff/contractor-core/_packages"
    },
    "/_staff/device-catalog/add/": {
      "filePath": "_staff/device-catalog/add/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/devices/add/": {
      "filePath": "_staff/devices/add/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/devices/external-it-saas/": {
      "filePath": "_staff/devices/external-it-saas/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/": {
      "filePath": "_staff/equipment/_layout/index.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/add-select/": {
      "filePath": "_staff/equipment/add-select/index.tsx",
      "parent": "/_staff/equipment"
    },
    "/_staff/equipment/add/": {
      "filePath": "_staff/equipment/add/index.tsx",
      "parent": "/_staff/equipment"
    },
    "/_staff/equipment/import-csv/": {
      "filePath": "_staff/equipment/import-csv/index.tsx",
      "parent": "/_staff/equipment"
    },
    "/_staff/fleets/add-select/": {
      "filePath": "_staff/fleets/add-select/index.tsx",
      "parent": "/_staff/fleets"
    },
    "/_staff/fleets/add/": {
      "filePath": "_staff/fleets/add/index.tsx",
      "parent": "/_staff/fleets"
    },
    "/_staff/ga-operation-core/_packages/": {
      "filePath": "_staff/ga-operation-core/_packages/index.tsx",
      "parent": "/_staff/ga-operation-core/_packages"
    },
    "/_staff/ids/_layout/": {
      "filePath": "_staff/ids/_layout/index.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/labor-core/_packages/": {
      "filePath": "_staff/labor-core/_packages/index.tsx",
      "parent": "/_staff/labor-core/_packages"
    },
    "/_staff/licenses/add/": {
      "filePath": "_staff/licenses/add/index.tsx",
      "parent": "/_staff/licenses"
    },
    "/_staff/marketplace/cart/": {
      "filePath": "_staff/marketplace/cart/index.tsx",
      "parent": "/_staff/marketplace"
    },
    "/_staff/marketplace/unavailable/": {
      "filePath": "_staff/marketplace/unavailable/index.tsx",
      "parent": "/_staff/marketplace"
    },
    "/_staff/networks/_layout/": {
      "filePath": "_staff/networks/_layout/index.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/add/": {
      "filePath": "_staff/networks/add/index.tsx",
      "parent": "/_staff/networks"
    },
    "/_staff/organization/plan/": {
      "filePath": "_staff/organization/plan/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/person/add-person-certification/": {
      "filePath": "_staff/person/add-person-certification/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/add/": {
      "filePath": "_staff/person/add/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/external-hr-saas/": {
      "filePath": "_staff/person/external-hr-saas/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/_layout/": {
      "filePath": "_staff/places/_layout/index.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/add-select/": {
      "filePath": "_staff/places/add-select/index.tsx",
      "parent": "/_staff/places"
    },
    "/_staff/places/add/": {
      "filePath": "_staff/places/add/index.tsx",
      "parent": "/_staff/places"
    },
    "/_staff/public-ids/$id/": {
      "filePath": "_staff/public-ids/$id/index.tsx",
      "parent": "/_staff/public-ids/$id"
    },
    "/_staff/public-ids/_list/": {
      "filePath": "_staff/public-ids/_list/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/add/": {
      "filePath": "_staff/public-ids/add/index.tsx",
      "parent": "/_staff/public-ids"
    },
    "/_staff/settings/contracting-corporation-profile/": {
      "filePath": "_staff/settings/contracting-corporation-profile/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile"
    },
    "/_staff/settings/permission-and-roles/": {
      "filePath": "_staff/settings/permission-and-roles/index.tsx",
      "parent": "/_staff/settings/permission-and-roles"
    },
    "/_staff/settings/persons/": {
      "filePath": "_staff/settings/persons/index.tsx",
      "parent": "/_staff/settings/persons"
    },
    "/_staff/software/add/": {
      "filePath": "_staff/software/add/index.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/starlinks/_layout/": {
      "filePath": "_staff/starlinks/_layout/index.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/time-and-attendance/_layout/": {
      "filePath": "_staff/time-and-attendance/_layout/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/auth/invitation/$invitationCode/": {
      "filePath": "auth/invitation/$invitationCode/index.tsx"
    },
    "/_staff/person/$id/_profile/": {
      "filePath": "_staff/person/$id/_profile/index/route.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/apps/_list/marketplace/$id": {
      "filePath": "_staff/apps/_list/marketplace/$id/route.tsx",
      "parent": "/_staff/apps/_list",
      "children": [
        "/_staff/apps/_list/marketplace/$id/install/finish/"
      ]
    },
    "/_staff/business-partner/_list/_placeholders/alerts": {
      "filePath": "_staff/business-partner/_list/_placeholders/alerts/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/contract-and-cost": {
      "filePath": "_staff/business-partner/_list/_placeholders/contract-and-cost/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/operation-activity": {
      "filePath": "_staff/business-partner/_list/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/rule-and-policy": {
      "filePath": "_staff/business-partner/_list/_placeholders/rule-and-policy/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/_list/_placeholders/settings": {
      "filePath": "_staff/business-partner/_list/_placeholders/settings/route.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/certification/_list/_placeholders/alerts": {
      "filePath": "_staff/certification/_list/_placeholders/alerts/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/_list/_placeholders/operation-activity": {
      "filePath": "_staff/certification/_list/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/_list/_placeholders/overview": {
      "filePath": "_staff/certification/_list/_placeholders/overview/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/certification/_list/_placeholders/rule-and-policy": {
      "filePath": "_staff/certification/_list/_placeholders/rule-and-policy/route.tsx",
      "parent": "/_staff/certification/_list"
    },
    "/_staff/contract/_list/_placeholders/alerts": {
      "filePath": "_staff/contract/_list/_placeholders/alerts/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/contract-and-cost": {
      "filePath": "_staff/contract/_list/_placeholders/contract-and-cost/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/operation-activity": {
      "filePath": "_staff/contract/_list/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/overview": {
      "filePath": "_staff/contract/_list/_placeholders/overview/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/contract/_list/_placeholders/people": {
      "filePath": "_staff/contract/_list/_placeholders/people/route.tsx",
      "parent": "/_staff/contract/_list"
    },
    "/_staff/software/_layout/marketplace/$id": {
      "filePath": "_staff/software/_layout/marketplace/$id/route.tsx",
      "parent": "/_staff/software/_layout",
      "children": [
        "/_staff/software/_layout/marketplace/$id/install/finish/"
      ]
    },
    "/_individual/individual/task/$id/approval-dialog": {
      "filePath": "_individual/individual/task/$id/approval-dialog.tsx",
      "parent": "/_individual"
    },
    "/_staff/accesses/_layout/_placeholders/contract-and-cost": {
      "filePath": "_staff/accesses/_layout/_placeholders/contract-and-cost.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/_placeholders/overview": {
      "filePath": "_staff/accesses/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/_placeholders/settings": {
      "filePath": "_staff/accesses/_layout/_placeholders/settings.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/_placeholders/software": {
      "filePath": "_staff/accesses/_layout/_placeholders/software.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/app-integrations/$id/_$id/groups": {
      "filePath": "_staff/app-integrations/$id/_$id/groups.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/apps/_list/alerts": {
      "filePath": "_staff/apps/_list/alerts",
      "parent": "/_staff/apps/_list",
      "children": [
        "/_staff/apps/_list/alerts/_alerts"
      ]
    },
    "/_staff/apps/_list/alerts/_alerts": {
      "filePath": "_staff/apps/_list/alerts/_alerts.tsx",
      "parent": "/_staff/apps/_list/alerts",
      "children": [
        "/_staff/apps/_list/alerts/_alerts/",
        "/_staff/apps/_list/alerts/_alerts/shadow-it",
        "/_staff/apps/_list/alerts/_alerts/inactive-user/",
        "/_staff/apps/_list/alerts/_alerts/no-user/",
        "/_staff/apps/_list/alerts/_alerts/no-worker/",
        "/_staff/apps/_list/alerts/_alerts/violated-assignment/",
        "/_staff/apps/_list/alerts/_alerts/violated-role/"
      ]
    },
    "/_staff/business-partner/add/$businessPartnerType/completed": {
      "filePath": "_staff/business-partner/add/$businessPartnerType/completed.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/certification/add/$certificationKind/completed": {
      "filePath": "_staff/certification/add/$certificationKind/completed.tsx",
      "parent": "/_staff/certification"
    },
    "/_staff/certification/handling-certification/$id": {
      "filePath": "_staff/certification/handling-certification/$id",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/handling-certification/$id/_layout"
      ]
    },
    "/_staff/certification/handling-certification/$id/_layout": {
      "filePath": "_staff/certification/handling-certification/$id/_layout.tsx",
      "parent": "/_staff/certification/handling-certification/$id",
      "children": [
        "/_staff/certification/handling-certification/$id/_layout/_index/",
        "/_staff/certification/handling-certification/$id/_layout/certification-holders/"
      ]
    },
    "/_staff/certification/specialty-certification/$id": {
      "filePath": "_staff/certification/specialty-certification/$id",
      "parent": "/_staff/certification",
      "children": [
        "/_staff/certification/specialty-certification/$id/_layout"
      ]
    },
    "/_staff/certification/specialty-certification/$id/_layout": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout.tsx",
      "parent": "/_staff/certification/specialty-certification/$id",
      "children": [
        "/_staff/certification/specialty-certification/$id/_layout/_index/",
        "/_staff/certification/specialty-certification/$id/_layout/certification-holders/",
        "/_staff/certification/specialty-certification/$id/_layout/handling-certifications/"
      ]
    },
    "/_staff/device-catalog/active/$id": {
      "filePath": "_staff/device-catalog/active/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/device-catalog/active/$id/_layout"
      ]
    },
    "/_staff/device-catalog/active/$id/_layout": {
      "filePath": "_staff/device-catalog/active/$id/_layout.tsx",
      "parent": "/_staff/device-catalog/active/$id",
      "children": [
        "/_staff/device-catalog/active/$id/_layout/profile/"
      ]
    },
    "/_staff/device-catalog/add/$deviceType/completed": {
      "filePath": "_staff/device-catalog/add/$deviceType/completed.tsx",
      "parent": "/_staff"
    },
    "/_staff/device-catalog/draft/$id": {
      "filePath": "_staff/device-catalog/draft/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/device-catalog/draft/$id/_layout"
      ]
    },
    "/_staff/device-catalog/draft/$id/_layout": {
      "filePath": "_staff/device-catalog/draft/$id/_layout.tsx",
      "parent": "/_staff/device-catalog/draft/$id",
      "children": [
        "/_staff/device-catalog/draft/$id/_layout/profile/"
      ]
    },
    "/_staff/devices/_list/settings/catalog": {
      "filePath": "_staff/devices/_list/settings/catalog.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/add/$deviceType/completed": {
      "filePath": "_staff/devices/add/$deviceType/completed.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/_placeholders/alerts": {
      "filePath": "_staff/equipment/_layout/_placeholders/alerts.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/_layout/_placeholders/overview": {
      "filePath": "_staff/equipment/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/equipment/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/equipment/_layout/_placeholders/settings": {
      "filePath": "_staff/equipment/_layout/_placeholders/settings.tsx",
      "parent": "/_staff/equipment/_layout"
    },
    "/_staff/ids/_layout/_placeholders/alerts": {
      "filePath": "_staff/ids/_layout/_placeholders/alerts.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/group-id": {
      "filePath": "_staff/ids/_layout/_placeholders/group-id.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/ids/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/overview": {
      "filePath": "_staff/ids/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/ids/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/_layout/_placeholders/settings": {
      "filePath": "_staff/ids/_layout/_placeholders/settings.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/group-id/$id": {
      "filePath": "_staff/ids/group-id/$id",
      "parent": "/_staff/ids",
      "children": [
        "/_staff/ids/group-id/$id/_$id"
      ]
    },
    "/_staff/ids/group-id/$id/_$id": {
      "filePath": "_staff/ids/group-id/$id/_$id.tsx",
      "parent": "/_staff/ids/group-id/$id",
      "children": [
        "/_staff/ids/group-id/$id/_$id/",
        "/_staff/ids/group-id/$id/_$id/members/",
        "/_staff/ids/group-id/$id/_$id/rule-and-policy/",
        "/_staff/ids/group-id/$id/_$id/settings/"
      ]
    },
    "/_staff/it-operation-core/_root/packages/$packageId": {
      "filePath": "_staff/it-operation-core/_root/packages/$packageId.tsx",
      "parent": "/_staff/it-operation-core/_root/packages"
    },
    "/_staff/labor-core/settings/profile/$profileId": {
      "filePath": "_staff/labor-core/settings/profile.$profileId.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses/add/$allocationType/completed": {
      "filePath": "_staff/licenses/add/$allocationType/completed.tsx",
      "parent": "/_staff/licenses"
    },
    "/_staff/marketplace/sent-orders/$orderId": {
      "filePath": "_staff/marketplace/sent-orders/$orderId",
      "parent": "/_staff/marketplace",
      "children": [
        "/_staff/marketplace/sent-orders/$orderId/_layout"
      ]
    },
    "/_staff/marketplace/sent-orders/$orderId/_layout": {
      "filePath": "_staff/marketplace/sent-orders/$orderId/_layout.tsx",
      "parent": "/_staff/marketplace/sent-orders/$orderId",
      "children": [
        "/_staff/marketplace/sent-orders/$orderId/_layout/activities",
        "/_staff/marketplace/sent-orders/$orderId/_layout/"
      ]
    },
    "/_staff/networks/_layout/_placeholders/alerts": {
      "filePath": "_staff/networks/_layout/_placeholders/alerts.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/contract-and-cost": {
      "filePath": "_staff/networks/_layout/_placeholders/contract-and-cost.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/networks/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/overview": {
      "filePath": "_staff/networks/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/networks/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/networks/_layout/_placeholders/settings": {
      "filePath": "_staff/networks/_layout/_placeholders/settings.tsx",
      "parent": "/_staff/networks/_layout"
    },
    "/_staff/person/add-person-certification/$certificationKind/completed": {
      "filePath": "_staff/person/add-person-certification/$certificationKind/completed.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/add/$workerType/completed": {
      "filePath": "_staff/person/add/$workerType/completed.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/alumni/$id": {
      "filePath": "_staff/person/alumni/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/person/alumni/$id/_profile"
      ]
    },
    "/_staff/person/alumni/$id/_profile": {
      "filePath": "_staff/person/alumni/$id/_profile.tsx",
      "parent": "/_staff/person/alumni/$id",
      "children": [
        "/_staff/person/alumni/$id/_profile/",
        "/_staff/person/alumni/$id/_profile/activity/",
        "/_staff/person/alumni/$id/_profile/apps/",
        "/_staff/person/alumni/$id/_profile/devices/",
        "/_staff/person/alumni/$id/_profile/education-and-qualification/",
        "/_staff/person/alumni/$id/_profile/employee-information/",
        "/_staff/person/alumni/$id/_profile/equipment/",
        "/_staff/person/alumni/$id/_profile/history/",
        "/_staff/person/alumni/$id/_profile/personal-information/",
        "/_staff/person/alumni/$id/_profile/public-id/"
      ]
    },
    "/_staff/places/_layout/_placeholders/alerts": {
      "filePath": "_staff/places/_layout/_placeholders/alerts.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/contract-and-cost": {
      "filePath": "_staff/places/_layout/_placeholders/contract-and-cost.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/places/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/overview": {
      "filePath": "_staff/places/_layout/_placeholders/overview.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/people": {
      "filePath": "_staff/places/_layout/_placeholders/people.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/places/_layout/_placeholders/rule-and-policy.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/places/_layout/_placeholders/store": {
      "filePath": "_staff/places/_layout/_placeholders/store.tsx",
      "parent": "/_staff/places/_layout"
    },
    "/_staff/profile/device/$id": {
      "filePath": "_staff/profile/device/$id",
      "parent": "/_staff",
      "children": [
        "/_staff/profile/device/$id/_profile"
      ]
    },
    "/_staff/profile/device/$id/_profile": {
      "filePath": "_staff/profile/device/$id/_profile.tsx",
      "parent": "/_staff/profile/device/$id",
      "children": [
        "/_staff/profile/device/$id/_profile/files",
        "/_staff/profile/device/$id/_profile/configuration",
        "/_staff/profile/device/$id/_profile/monitoring",
        "/_staff/profile/device/$id/_profile/",
        "/_staff/profile/device/$id/_profile/control",
        "/_staff/profile/device/$id/_profile/mdm",
        "/_staff/profile/device/$id/_profile/status",
        "/_staff/profile/device/$id/_profile/history/",
        "/_staff/profile/device/$id/_profile/lifecycle/"
      ]
    },
    "/_staff/settings/persons/_list/_account": {
      "filePath": "_staff/settings/persons/_list/_account.tsx",
      "parent": "/_staff/settings/persons/_list",
      "children": [
        "/_staff/settings/persons/_list/_account/individual/",
        "/_staff/settings/persons/_list/_account/staff/"
      ]
    },
    "/_staff/software/_layout/alerts": {
      "filePath": "_staff/software/_layout/alerts",
      "parent": "/_staff/software/_layout",
      "children": [
        "/_staff/software/_layout/alerts/_alerts"
      ]
    },
    "/_staff/software/_layout/alerts/_alerts": {
      "filePath": "_staff/software/_layout/alerts/_alerts.tsx",
      "parent": "/_staff/software/_layout/alerts",
      "children": [
        "/_staff/software/_layout/alerts/_alerts/",
        "/_staff/software/_layout/alerts/_alerts/alumni/",
        "/_staff/software/_layout/alerts/_alerts/inactive-user/",
        "/_staff/software/_layout/alerts/_alerts/no-user/",
        "/_staff/software/_layout/alerts/_alerts/no-worker/",
        "/_staff/software/_layout/alerts/_alerts/violated-assignment/",
        "/_staff/software/_layout/alerts/_alerts/violated-role/"
      ]
    },
    "/_staff/starlinks/_layout/_placeholders/billing-and-cost": {
      "filePath": "_staff/starlinks/_layout/_placeholders/billing-and-cost.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/starlinks/_layout/_placeholders/marketplace": {
      "filePath": "_staff/starlinks/_layout/_placeholders/marketplace.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/starlinks/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/starlinks/_layout/_placeholders/operation-activity.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/time-and-attendance/_layout/_placeholders/attendances": {
      "filePath": "_staff/time-and-attendance/_layout/_placeholders/attendances.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/time-and-attendance/_layout/_placeholders/clocking": {
      "filePath": "_staff/time-and-attendance/_layout/_placeholders/clocking.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_individual/individual/operation-package/$id/": {
      "filePath": "_individual/individual/operation-package/$id/index.tsx",
      "parent": "/_individual"
    },
    "/_individual/individual/task/$id/": {
      "filePath": "_individual/individual/task/$id/index.tsx",
      "parent": "/_individual"
    },
    "/_staff/accesses/_layout/alerts/": {
      "filePath": "_staff/accesses/_layout/alerts/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/accesses/_layout/list/": {
      "filePath": "_staff/accesses/_layout/list/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/app-integrations/$id/_$id/": {
      "filePath": "_staff/app-integrations/$id/_$id/index.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/apps/_list/integrations/": {
      "filePath": "_staff/apps/_list/integrations/index.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/apps/_list/marketplace/": {
      "filePath": "_staff/apps/_list/marketplace/index.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/apps/_list/people/": {
      "filePath": "_staff/apps/_list/people/index.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/apps/_list/settings/": {
      "filePath": "_staff/apps/_list/settings/index.tsx",
      "parent": "/_staff/apps/_list"
    },
    "/_staff/apps/custom-app/add/": {
      "filePath": "_staff/apps/custom-app/add/index.tsx",
      "parent": "/_staff/apps"
    },
    "/_staff/business-partner/_list/terminated/": {
      "filePath": "_staff/business-partner/_list/terminated/index.tsx",
      "parent": "/_staff/business-partner/_list"
    },
    "/_staff/business-partner/add/$businessPartnerType/": {
      "filePath": "_staff/business-partner/add/$businessPartnerType/index.tsx",
      "parent": "/_staff/business-partner"
    },
    "/_staff/certification/_list/settings/": {
      "filePath": "_staff/certification/_list/settings/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/certification/add/$certificationKind/": {
      "filePath": "_staff/certification/add/$certificationKind/index.tsx",
      "parent": "/_staff/certification"
    },
    "/_staff/contract/import-csv/$contractType/": {
      "filePath": "_staff/contract/import-csv/$contractType/index.tsx",
      "parent": "/_staff/contract"
    },
    "/_staff/contractor-core/_packages/archives/": {
      "filePath": "_staff/contractor-core/_packages/archives/index.tsx",
      "parent": "/_staff/contractor-core/_packages"
    },
    "/_staff/contractor-core/_packages/configs/": {
      "filePath": "_staff/contractor-core/_packages/configs/index.tsx",
      "parent": "/_staff/contractor-core/_packages"
    },
    "/_staff/contractor-core/config/$patternId/": {
      "filePath": "_staff/contractor-core/config/$patternId/index.tsx",
      "parent": "/_staff/contractor-core"
    },
    "/_staff/device-catalog/add/$deviceType/": {
      "filePath": "_staff/device-catalog/add/$deviceType/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/devices/_list/catalog/": {
      "filePath": "_staff/devices/_list/catalog/index.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/inventory/": {
      "filePath": "_staff/devices/_list/inventory/index.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/people/": {
      "filePath": "_staff/devices/_list/people/index.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/_list/settings/": {
      "filePath": "_staff/devices/_list/settings/index.tsx",
      "parent": "/_staff/devices/_list"
    },
    "/_staff/devices/add/$deviceType/": {
      "filePath": "_staff/devices/add/$deviceType/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/settings/": {
      "filePath": "_staff/equipment/_layout/settings/index.tsx",
      "parent": "/_staff/equipment/_layout/settings"
    },
    "/_staff/fleets/_layout/_list/": {
      "filePath": "_staff/fleets/_layout/_list/index.tsx",
      "parent": "/_staff/fleets/_layout"
    },
    "/_staff/ga-operation-core/_packages/archives/": {
      "filePath": "_staff/ga-operation-core/_packages/archives/index.tsx",
      "parent": "/_staff/ga-operation-core/_packages"
    },
    "/_staff/ga-operation-core/_packages/configs/": {
      "filePath": "_staff/ga-operation-core/_packages/configs/index.tsx",
      "parent": "/_staff/ga-operation-core/_packages"
    },
    "/_staff/ga-operation-core/config/$patternId/": {
      "filePath": "_staff/ga-operation-core/config/$patternId/index.tsx",
      "parent": "/_staff/ga-operation-core"
    },
    "/_staff/ids/_layout/people/": {
      "filePath": "_staff/ids/_layout/people/index.tsx",
      "parent": "/_staff/ids/_layout"
    },
    "/_staff/ids/group-id/add/": {
      "filePath": "_staff/ids/group-id/add/index.tsx",
      "parent": "/_staff/ids"
    },
    "/_staff/it-operation-core/_root/archives/": {
      "filePath": "_staff/it-operation-core/_root/archives/index.tsx",
      "parent": "/_staff/it-operation-core/_root"
    },
    "/_staff/it-operation-core/_root/config/": {
      "filePath": "_staff/it-operation-core/_root/config/index.tsx",
      "parent": "/_staff/it-operation-core/_root"
    },
    "/_staff/it-operation-core/_root/packages/": {
      "filePath": "_staff/it-operation-core/_root/packages/index.tsx",
      "parent": "/_staff/it-operation-core/_root/packages"
    },
    "/_staff/it-operation-core/config/$patternId/": {
      "filePath": "_staff/it-operation-core/config/$patternId/index.tsx",
      "parent": "/_staff/it-operation-core"
    },
    "/_staff/labor-core/_packages/archives/": {
      "filePath": "_staff/labor-core/_packages/archives/index.tsx",
      "parent": "/_staff/labor-core/_packages"
    },
    "/_staff/labor-core/_packages/configs/": {
      "filePath": "_staff/labor-core/_packages/configs/index.tsx",
      "parent": "/_staff/labor-core/_packages"
    },
    "/_staff/labor-core/_packages/settings/": {
      "filePath": "_staff/labor-core/_packages/settings/index.tsx",
      "parent": "/_staff/labor-core/_packages/settings"
    },
    "/_staff/labor-core/config/$patternId/": {
      "filePath": "_staff/labor-core/config/$patternId/index.tsx",
      "parent": "/_staff/labor-core"
    },
    "/_staff/licenses/_list/alerts/": {
      "filePath": "_staff/licenses/_list/alerts/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/contract-and-cost/": {
      "filePath": "_staff/licenses/_list/contract-and-cost/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/inventory/": {
      "filePath": "_staff/licenses/_list/inventory/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/operation-activity/": {
      "filePath": "_staff/licenses/_list/operation-activity/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/people/": {
      "filePath": "_staff/licenses/_list/people/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/rule-and-policy/": {
      "filePath": "_staff/licenses/_list/rule-and-policy/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/_list/settings/": {
      "filePath": "_staff/licenses/_list/settings/index.tsx",
      "parent": "/_staff/licenses/_list"
    },
    "/_staff/licenses/add/$allocationType/": {
      "filePath": "_staff/licenses/add/$allocationType/index.tsx",
      "parent": "/_staff/licenses"
    },
    "/_staff/marketplace/sales-orders/$orderId/": {
      "filePath": "_staff/marketplace/sales-orders/$orderId/index.tsx",
      "parent": "/_staff/marketplace"
    },
    "/_staff/organization/$id/_layout/": {
      "filePath": "_staff/organization/$id/_layout/index.tsx",
      "parent": "/_staff/organization/$id/_layout"
    },
    "/_staff/organization/_list/alert/": {
      "filePath": "_staff/organization/_list/alert/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/chart/": {
      "filePath": "_staff/organization/_list/chart/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/cost/": {
      "filePath": "_staff/organization/_list/cost/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/history/": {
      "filePath": "_staff/organization/_list/history/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/rule-policy/": {
      "filePath": "_staff/organization/_list/rule-policy/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/_list/settings/": {
      "filePath": "_staff/organization/_list/settings/index.tsx",
      "parent": "/_staff/organization/_list"
    },
    "/_staff/organization/plan/$id/": {
      "filePath": "_staff/organization/plan/$id/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/organization/plan/create/": {
      "filePath": "_staff/organization/plan/create/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/people/_list/alumni/": {
      "filePath": "_staff/people/_list/alumni/index.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/people/_list/settings/": {
      "filePath": "_staff/people/_list/settings/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/workforce/": {
      "filePath": "_staff/people/_list/workforce/index.tsx",
      "parent": "/_staff/people/_list"
    },
    "/_staff/person/add-person-certification/$certificationKind/": {
      "filePath": "_staff/person/add-person-certification/$certificationKind/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/person/add/$workerType/": {
      "filePath": "_staff/person/add/$workerType/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/_layout/settings/": {
      "filePath": "_staff/places/_layout/settings/index.tsx",
      "parent": "/_staff/places/_layout/settings"
    },
    "/_staff/public-ids/$id/details/": {
      "filePath": "_staff/public-ids/$id/details/index.tsx",
      "parent": "/_staff/public-ids/$id"
    },
    "/_staff/public-ids/$id/files/": {
      "filePath": "_staff/public-ids/$id/files/index.tsx",
      "parent": "/_staff/public-ids/$id"
    },
    "/_staff/public-ids/_list/alerts/": {
      "filePath": "_staff/public-ids/_list/alerts/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/members/": {
      "filePath": "_staff/public-ids/_list/members/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/operation-activity/": {
      "filePath": "_staff/public-ids/_list/operation-activity/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/registry/": {
      "filePath": "_staff/public-ids/_list/registry/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/rules-and-policies/": {
      "filePath": "_staff/public-ids/_list/rules-and-policies/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/public-ids/_list/settings/": {
      "filePath": "_staff/public-ids/_list/settings/index.tsx",
      "parent": "/_staff/public-ids/_list"
    },
    "/_staff/software/$id/_$id/": {
      "filePath": "_staff/software/$id/_$id/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/_layout/contract-and-cost/": {
      "filePath": "_staff/software/_layout/contract-and-cost/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/marketplace/": {
      "filePath": "_staff/software/_layout/marketplace/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/operation-activity/": {
      "filePath": "_staff/software/_layout/operation-activity/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/people/": {
      "filePath": "_staff/software/_layout/people/index.tsx",
      "parent": "/_staff/software/_layout/people"
    },
    "/_staff/software/_layout/registry/": {
      "filePath": "_staff/software/_layout/registry/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/rule-and-policy/": {
      "filePath": "_staff/software/_layout/rule-and-policy/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/_layout/settings/": {
      "filePath": "_staff/software/_layout/settings/index.tsx",
      "parent": "/_staff/software/_layout"
    },
    "/_staff/software/add/$type/": {
      "filePath": "_staff/software/add/$type/index.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/starlinks/_layout/alerts/": {
      "filePath": "_staff/starlinks/_layout/alerts/index.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/starlinks/_layout/user-terminals/": {
      "filePath": "_staff/starlinks/_layout/user-terminals/index.tsx",
      "parent": "/_staff/starlinks/_layout"
    },
    "/_staff/storage-files/_list/files/": {
      "filePath": "_staff/storage-files/_list/files/index.tsx",
      "parent": "/_staff/storage-files/_list"
    },
    "/_staff/storage-files/_list/folders/": {
      "filePath": "_staff/storage-files/_list/folders/index.tsx",
      "parent": "/_staff/storage-files/_list"
    },
    "/_staff/time-and-attendance/_layout/attendance-links/": {
      "filePath": "_staff/time-and-attendance/_layout/attendance-links/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/licenses/$id/_profile/": {
      "filePath": "_staff/licenses/$id/_profile/index.lazy.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/": {
      "filePath": "_staff/person/alumni/$id/_profile/index/route.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/contract/$id/_layout/_placeholders/approval-info": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/approval-info/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/history": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/history/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/operation-activity": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/operation-activity/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/risk-provisions": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/risk-provisions/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/_placeholders/rule-and-policy": {
      "filePath": "_staff/contract/$id/_layout/_placeholders/rule-and-policy/route.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/profile/device/$id/_profile/files": {
      "filePath": "_staff/profile/device/$id/_profile/files/route.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId",
      "parent": "/_staff/it-operation-core/_detail",
      "children": [
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout",
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/"
      ]
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId",
      "children": [
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/",
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/",
        "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/"
      ]
    },
    "/_staff/licenses/$id/service-plans/$licenseServiceId": {
      "filePath": "_staff/licenses/$id/service-plans/$licenseServiceId",
      "parent": "/_staff/licenses/$id",
      "children": [
        "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail"
      ]
    },
    "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail": {
      "filePath": "_staff/licenses/$id/service-plans/$licenseServiceId/_detail.tsx",
      "parent": "/_staff/licenses/$id/service-plans/$licenseServiceId",
      "children": [
        "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/"
      ]
    },
    "/_staff/marketplace/sent-orders/$orderId/_layout/activities": {
      "filePath": "_staff/marketplace/sent-orders/$orderId/_layout/activities.tsx",
      "parent": "/_staff/marketplace/sent-orders/$orderId/_layout"
    },
    "/_staff/profile/device/$id/_profile/configuration": {
      "filePath": "_staff/profile/device/$id/_profile/configuration.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/profile/device/$id/_profile/monitoring": {
      "filePath": "_staff/profile/device/$id/_profile/monitoring.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/profile/device/$id/_profile/": {
      "filePath": "_staff/profile/device/$id/_profile/index/route.lazy.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/profile/device/$id/_profile/control": {
      "filePath": "_staff/profile/device/$id/_profile/control/route.lazy.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/profile/device/$id/_profile/mdm": {
      "filePath": "_staff/profile/device/$id/_profile/mdm/route.lazy.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/profile/device/$id/_profile/status": {
      "filePath": "_staff/profile/device/$id/_profile/status/route.lazy.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_individual/individual/task/$id/approval/": {
      "filePath": "_individual/individual/task/$id/approval/index.tsx",
      "parent": "/_individual"
    },
    "/_staff/app-integrations/$id/_$id/architecture/": {
      "filePath": "_staff/app-integrations/$id/_$id/architecture/index.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/app-integrations/$id/_$id/detail/": {
      "filePath": "_staff/app-integrations/$id/_$id/detail/index.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/app-integrations/$id/_$id/rule-and-policy/": {
      "filePath": "_staff/app-integrations/$id/_$id/rule-and-policy/index.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/app-integrations/$id/_$id/settings/": {
      "filePath": "_staff/app-integrations/$id/_$id/settings/index.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/app-integrations/$id/_$id/users/": {
      "filePath": "_staff/app-integrations/$id/_$id/users/index.tsx",
      "parent": "/_staff/app-integrations/$id/_$id"
    },
    "/_staff/apps/_list/alerts/_alerts/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts"
    },
    "/_staff/apps/custom-app/add/$customAppType/": {
      "filePath": "_staff/apps/custom-app/add/$customAppType/index.tsx",
      "parent": "/_staff/apps"
    },
    "/_staff/business-partner/$id/_layout/_index/": {
      "filePath": "_staff/business-partner/$id/_layout/_index/index.tsx",
      "parent": "/_staff/business-partner/$id/_layout"
    },
    "/_staff/business-partner/$id/_layout/address-and-contact/": {
      "filePath": "_staff/business-partner/$id/_layout/address-and-contact/index.tsx",
      "parent": "/_staff/business-partner/$id/_layout"
    },
    "/_staff/certification/$id/_layout/_index/": {
      "filePath": "_staff/certification/$id/_layout/_index/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/$id/_layout/certification-holders/": {
      "filePath": "_staff/certification/$id/_layout/certification-holders/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/$id/_layout/handling-certifications/": {
      "filePath": "_staff/certification/$id/_layout/handling-certifications/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/$id/_layout/specialty-certifications/": {
      "filePath": "_staff/certification/$id/_layout/specialty-certifications/index.tsx",
      "parent": "/_staff/certification/$id/_layout"
    },
    "/_staff/certification/_list/settings/issuing-organization/": {
      "filePath": "_staff/certification/_list/settings/issuing-organization/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/certification/_list/settings/specialty-category-level/": {
      "filePath": "_staff/certification/_list/settings/specialty-category-level/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/certification/_list/settings/specialty-category/": {
      "filePath": "_staff/certification/_list/settings/specialty-category/index.tsx",
      "parent": "/_staff/certification/_list/settings"
    },
    "/_staff/devices/external-it-saas/$appIntegrationId/preview/": {
      "filePath": "_staff/devices/external-it-saas/$appIntegrationId/preview/index.tsx",
      "parent": "/_staff/devices"
    },
    "/_staff/equipment/_layout/settings/equipment-items/": {
      "filePath": "_staff/equipment/_layout/settings/equipment-items/index.tsx",
      "parent": "/_staff/equipment/_layout/settings"
    },
    "/_staff/equipment/_layout/settings/equipment-types/": {
      "filePath": "_staff/equipment/_layout/settings/equipment-types/index.tsx",
      "parent": "/_staff/equipment/_layout/settings"
    },
    "/_staff/ids/group-id/$id/_$id/": {
      "filePath": "_staff/ids/group-id/$id/_$id/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId"
    },
    "/_staff/licenses/$id/_profile/assignments/": {
      "filePath": "_staff/licenses/$id/_profile/assignments/index.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/licenses/$id/_profile/people/": {
      "filePath": "_staff/licenses/$id/_profile/people/index.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/licenses/$id/_profile/service-plans/": {
      "filePath": "_staff/licenses/$id/_profile/service-plans/index.tsx",
      "parent": "/_staff/licenses/$id/_profile"
    },
    "/_staff/marketplace/_store/store/devices/": {
      "filePath": "_staff/marketplace/_store/store/devices/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/sales-orders/": {
      "filePath": "_staff/marketplace/_store/store/sales-orders/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/sent-orders/": {
      "filePath": "_staff/marketplace/_store/store/sent-orders/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/starlinks/": {
      "filePath": "_staff/marketplace/_store/store/starlinks/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/sent-orders/$orderId/_layout/": {
      "filePath": "_staff/marketplace/sent-orders/$orderId/_layout/index.tsx",
      "parent": "/_staff/marketplace/sent-orders/$orderId/_layout"
    },
    "/_staff/organization/$id/_layout/history/": {
      "filePath": "_staff/organization/$id/_layout/history/index.tsx",
      "parent": "/_staff/organization/$id/_layout"
    },
    "/_staff/organization/plan/$id/add/": {
      "filePath": "_staff/organization/plan/$id/add/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/people/_list/settings/board-member-types/": {
      "filePath": "_staff/people/_list/settings/board-member-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/collaborator-types/": {
      "filePath": "_staff/people/_list/settings/collaborator-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/contract-end-reasons/": {
      "filePath": "_staff/people/_list/settings/contract-end-reasons/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/contractor-types/": {
      "filePath": "_staff/people/_list/settings/contractor-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/employee-sub-id-names/": {
      "filePath": "_staff/people/_list/settings/employee-sub-id-names/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/employment-types/": {
      "filePath": "_staff/people/_list/settings/employment-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/grades/": {
      "filePath": "_staff/people/_list/settings/grades/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/health-insurance-associations/": {
      "filePath": "_staff/people/_list/settings/health-insurance-associations/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-competencies/": {
      "filePath": "_staff/people/_list/settings/job-competencies/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-functions/": {
      "filePath": "_staff/people/_list/settings/job-functions/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-grades/": {
      "filePath": "_staff/people/_list/settings/job-grades/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-levels/": {
      "filePath": "_staff/people/_list/settings/job-levels/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-titles/": {
      "filePath": "_staff/people/_list/settings/job-titles/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/job-types/": {
      "filePath": "_staff/people/_list/settings/job-types/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/place-social-insurances/": {
      "filePath": "_staff/people/_list/settings/place-social-insurances/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/positions/": {
      "filePath": "_staff/people/_list/settings/positions/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/retirement-reasons/": {
      "filePath": "_staff/people/_list/settings/retirement-reasons/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/people/_list/settings/work-mode/": {
      "filePath": "_staff/people/_list/settings/work-mode/index.tsx",
      "parent": "/_staff/people/_list/settings"
    },
    "/_staff/person/$id/_profile/activity/": {
      "filePath": "_staff/person/$id/_profile/activity/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/apps/": {
      "filePath": "_staff/person/$id/_profile/apps/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/devices/": {
      "filePath": "_staff/person/$id/_profile/devices/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/education-and-qualification/": {
      "filePath": "_staff/person/$id/_profile/education-and-qualification/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/employee-information/": {
      "filePath": "_staff/person/$id/_profile/employee-information/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/equipment/": {
      "filePath": "_staff/person/$id/_profile/equipment/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/history/": {
      "filePath": "_staff/person/$id/_profile/history/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/personal-information/": {
      "filePath": "_staff/person/$id/_profile/personal-information/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/$id/_profile/public-id/": {
      "filePath": "_staff/person/$id/_profile/public-id/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/external-hr-saas/$appIntegrationId/preview/": {
      "filePath": "_staff/person/external-hr-saas/$appIntegrationId/preview/index.tsx",
      "parent": "/_staff"
    },
    "/_staff/places/$id/_layout/administrators/": {
      "filePath": "_staff/places/$id/_layout/administrators/index.tsx",
      "parent": "/_staff/places/$id/_layout"
    },
    "/_staff/places/$id/_layout/labor-core/": {
      "filePath": "_staff/places/$id/_layout/labor-core/index.tsx",
      "parent": "/_staff/places/$id/_layout"
    },
    "/_staff/places/_layout/settings/place-sub-codes/": {
      "filePath": "_staff/places/_layout/settings/place-sub-codes/index.tsx",
      "parent": "/_staff/places/_layout/settings"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/board-member/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/board-member/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/contact-points/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/contact-points/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/corporate-overview/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/corporate-overview/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/group-companies/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/group-companies/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/history/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/history/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/registration/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/registration/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/contracting-corporation-profile/_layout/shareholders/": {
      "filePath": "_staff/settings/contracting-corporation-profile/_layout/shareholders/index.tsx",
      "parent": "/_staff/settings/contracting-corporation-profile/_layout"
    },
    "/_staff/settings/permission-and-roles/_list/people-groups/": {
      "filePath": "_staff/settings/permission-and-roles/_list/people-groups/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_list"
    },
    "/_staff/settings/permission-and-roles/_list/product-permissions/": {
      "filePath": "_staff/settings/permission-and-roles/_list/product-permissions/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_list"
    },
    "/_staff/settings/permission-and-roles/_list/roles/": {
      "filePath": "_staff/settings/permission-and-roles/_list/roles/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_list"
    },
    "/_staff/settings/persons/_list/settings/": {
      "filePath": "_staff/settings/persons/_list/settings/index.tsx",
      "parent": "/_staff/settings/persons/_list"
    },
    "/_staff/software/$id/_$id/activity-monitoring/": {
      "filePath": "_staff/software/$id/_$id/activity-monitoring/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/architecture/": {
      "filePath": "_staff/software/$id/_$id/architecture/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/contracts-cost/": {
      "filePath": "_staff/software/$id/_$id/contracts-cost/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/detail/": {
      "filePath": "_staff/software/$id/_$id/detail/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/rule-and-policy/": {
      "filePath": "_staff/software/$id/_$id/rule-and-policy/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/settings/": {
      "filePath": "_staff/software/$id/_$id/settings/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/$id/_$id/users/": {
      "filePath": "_staff/software/$id/_$id/users/index.tsx",
      "parent": "/_staff/software/$id/_$id"
    },
    "/_staff/software/_layout/alerts/_alerts/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/custom-saas/add/$customSaasType/": {
      "filePath": "_staff/software/custom-saas/add/$customSaasType/index.tsx",
      "parent": "/_staff/software"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/time-and-attendance/_layout/attendance-links/$placeId/": {
      "filePath": "_staff/time-and-attendance/_layout/attendance-links/$placeId/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/contract/$id/_layout/_index/": {
      "filePath": "_staff/contract/$id/_layout/_index/index.lazy.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/contract/$id/_layout/structure/": {
      "filePath": "_staff/contract/$id/_layout/structure/index.lazy.tsx",
      "parent": "/_staff/contract/$id/_layout"
    },
    "/_staff/equipment/$id/_layout/_profile/": {
      "filePath": "_staff/equipment/$id/_layout/_profile/index.lazy.tsx",
      "parent": "/_staff/equipment/$id/_layout"
    },
    "/_staff/fleets/$id/_layout/_profile/": {
      "filePath": "_staff/fleets/$id/_layout/_profile/index.lazy.tsx",
      "parent": "/_staff/fleets/$id/_layout"
    },
    "/_staff/networks/$id/_layout/_profile/": {
      "filePath": "_staff/networks/$id/_layout/_profile/index.lazy.tsx",
      "parent": "/_staff/networks/$id/_layout"
    },
    "/_staff/places/$id/_layout/_profile/": {
      "filePath": "_staff/places/$id/_layout/_profile/index.lazy.tsx",
      "parent": "/_staff/places/$id/_layout"
    },
    "/_staff/starlinks/$id/_layout/_overview/": {
      "filePath": "_staff/starlinks/$id/_layout/_overview/index.lazy.tsx",
      "parent": "/_staff/starlinks/$id/_layout"
    },
    "/_staff/starlinks/$id/_layout/detail/": {
      "filePath": "_staff/starlinks/$id/_layout/detail/index.lazy.tsx",
      "parent": "/_staff/starlinks/$id/_layout"
    },
    "/_staff/apps/_list/alerts/_alerts/shadow-it": {
      "filePath": "_staff/apps/_list/alerts/_alerts/shadow-it",
      "parent": "/_staff/apps/_list/alerts/_alerts",
      "children": [
        "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it"
      ]
    },
    "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it": {
      "filePath": "_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts/shadow-it",
      "children": [
        "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/",
        "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/",
        "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/"
      ]
    },
    "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId": {
      "filePath": "_staff/person/$id/certifications/base-certifications/$personCertificationInformationId",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout"
      ]
    },
    "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout": {
      "filePath": "_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout.tsx",
      "parent": "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId",
      "children": [
        "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/"
      ]
    },
    "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId": {
      "filePath": "_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout"
      ]
    },
    "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout": {
      "filePath": "_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout.tsx",
      "parent": "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId",
      "children": [
        "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/"
      ]
    },
    "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId": {
      "filePath": "_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId",
      "parent": "/_staff/person/$id",
      "children": [
        "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout"
      ]
    },
    "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout": {
      "filePath": "_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout.tsx",
      "parent": "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId",
      "children": [
        "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/"
      ]
    },
    "/_individual/individual/operation-package/$id/pattern/$patternId/": {
      "filePath": "_individual/individual/operation-package/$id/pattern/$patternId/index.tsx",
      "parent": "/_individual"
    },
    "/_staff/accesses/_layout/alerts/detail/$shadowItAppId/": {
      "filePath": "_staff/accesses/_layout/alerts/detail/$shadowItAppId/index.tsx",
      "parent": "/_staff/accesses/_layout"
    },
    "/_staff/apps/_list/alerts/_alerts/inactive-user/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/inactive-user/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts"
    },
    "/_staff/apps/_list/alerts/_alerts/no-user/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/no-user/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts"
    },
    "/_staff/apps/_list/alerts/_alerts/no-worker/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/no-worker/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts"
    },
    "/_staff/apps/_list/alerts/_alerts/violated-assignment/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/violated-assignment/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts"
    },
    "/_staff/apps/_list/alerts/_alerts/violated-role/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/violated-role/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts"
    },
    "/_staff/certification/handling-certification/$id/_layout/_index/": {
      "filePath": "_staff/certification/handling-certification/$id/_layout/_index/index.tsx",
      "parent": "/_staff/certification/handling-certification/$id/_layout"
    },
    "/_staff/certification/handling-certification/$id/_layout/certification-holders/": {
      "filePath": "_staff/certification/handling-certification/$id/_layout/certification-holders/index.tsx",
      "parent": "/_staff/certification/handling-certification/$id/_layout"
    },
    "/_staff/certification/specialty-certification/$id/_layout/_index/": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout/_index/index.tsx",
      "parent": "/_staff/certification/specialty-certification/$id/_layout"
    },
    "/_staff/certification/specialty-certification/$id/_layout/certification-holders/": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout/certification-holders/index.tsx",
      "parent": "/_staff/certification/specialty-certification/$id/_layout"
    },
    "/_staff/certification/specialty-certification/$id/_layout/handling-certifications/": {
      "filePath": "_staff/certification/specialty-certification/$id/_layout/handling-certifications/index.tsx",
      "parent": "/_staff/certification/specialty-certification/$id/_layout"
    },
    "/_staff/device-catalog/active/$id/_layout/profile/": {
      "filePath": "_staff/device-catalog/active/$id/_layout/profile/index.tsx",
      "parent": "/_staff/device-catalog/active/$id/_layout"
    },
    "/_staff/device-catalog/draft/$id/_layout/profile/": {
      "filePath": "_staff/device-catalog/draft/$id/_layout/profile/index.tsx",
      "parent": "/_staff/device-catalog/draft/$id/_layout"
    },
    "/_staff/ids/group-id/$id/_$id/members/": {
      "filePath": "_staff/ids/group-id/$id/_$id/members/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/$id/_$id/rule-and-policy/": {
      "filePath": "_staff/ids/group-id/$id/_$id/rule-and-policy/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/ids/group-id/$id/_$id/settings/": {
      "filePath": "_staff/ids/group-id/$id/_$id/settings/index.tsx",
      "parent": "/_staff/ids/group-id/$id/_$id"
    },
    "/_staff/marketplace/_store/store/devices/$productId/": {
      "filePath": "_staff/marketplace/_store/store/devices/$productId/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/marketplace/_store/store/starlinks/$productId/": {
      "filePath": "_staff/marketplace/_store/store/starlinks/$productId/index.tsx",
      "parent": "/_staff/marketplace/_store"
    },
    "/_staff/organization/plan/$id/edit/$unitId/": {
      "filePath": "_staff/organization/plan/$id/edit/$unitId/index.tsx",
      "parent": "/_staff/organization"
    },
    "/_staff/person/$id/_profile/family/$familyPersonId/": {
      "filePath": "_staff/person/$id/_profile/family/$familyPersonId/index.tsx",
      "parent": "/_staff/person/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/activity/": {
      "filePath": "_staff/person/alumni/$id/_profile/activity/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/apps/": {
      "filePath": "_staff/person/alumni/$id/_profile/apps/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/devices/": {
      "filePath": "_staff/person/alumni/$id/_profile/devices/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/education-and-qualification/": {
      "filePath": "_staff/person/alumni/$id/_profile/education-and-qualification/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/employee-information/": {
      "filePath": "_staff/person/alumni/$id/_profile/employee-information/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/equipment/": {
      "filePath": "_staff/person/alumni/$id/_profile/equipment/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/history/": {
      "filePath": "_staff/person/alumni/$id/_profile/history/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/personal-information/": {
      "filePath": "_staff/person/alumni/$id/_profile/personal-information/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/person/alumni/$id/_profile/public-id/": {
      "filePath": "_staff/person/alumni/$id/_profile/public-id/index.tsx",
      "parent": "/_staff/person/alumni/$id/_profile"
    },
    "/_staff/profile/device/$id/_profile/history/": {
      "filePath": "_staff/profile/device/$id/_profile/history/index.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/profile/device/$id/_profile/lifecycle/": {
      "filePath": "_staff/profile/device/$id/_profile/lifecycle/index.tsx",
      "parent": "/_staff/profile/device/$id/_profile"
    },
    "/_staff/settings/permission-and-roles/_detail/people-groups/$id/": {
      "filePath": "_staff/settings/permission-and-roles/_detail/people-groups/$id/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_detail"
    },
    "/_staff/settings/permission-and-roles/_detail/product-permissions/$id/": {
      "filePath": "_staff/settings/permission-and-roles/_detail/product-permissions/$id/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_detail"
    },
    "/_staff/settings/permission-and-roles/_detail/roles/$id/": {
      "filePath": "_staff/settings/permission-and-roles/_detail/roles/$id/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_detail"
    },
    "/_staff/settings/permission-and-roles/_form/people-groups/new/": {
      "filePath": "_staff/settings/permission-and-roles/_form/people-groups/new/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/product-permissions/new/": {
      "filePath": "_staff/settings/permission-and-roles/_form/product-permissions/new/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/roles/new/": {
      "filePath": "_staff/settings/permission-and-roles/_form/roles/new/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/persons/_list/_account/individual/": {
      "filePath": "_staff/settings/persons/_list/_account/individual/index.tsx",
      "parent": "/_staff/settings/persons/_list/_account"
    },
    "/_staff/settings/persons/_list/_account/staff/": {
      "filePath": "_staff/settings/persons/_list/_account/staff/index.tsx",
      "parent": "/_staff/settings/persons/_list/_account"
    },
    "/_staff/software/_layout/alerts/_alerts/alumni/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/alumni/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/inactive-user/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/inactive-user/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/no-user/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/no-user/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/no-worker/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/no-worker/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/violated-assignment/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/violated-assignment/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/software/_layout/alerts/_alerts/violated-role/": {
      "filePath": "_staff/software/_layout/alerts/_alerts/violated-role/index.tsx",
      "parent": "/_staff/software/_layout/alerts/_alerts"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/daily-place/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/daily-place/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/monthly-person/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/monthly-person/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/time-and-attendance/_layout/_list/summary/monthly-place/": {
      "filePath": "_staff/time-and-attendance/_layout/_list/summary/monthly-place/index.tsx",
      "parent": "/_staff/time-and-attendance/_layout"
    },
    "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it"
    },
    "/_staff/apps/_list/marketplace/$id/install/finish/": {
      "filePath": "_staff/apps/_list/marketplace/$id/install.finish/index.tsx",
      "parent": "/_staff/apps/_list/marketplace/$id"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/data/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/detail/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout"
    },
    "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/": {
      "filePath": "_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout/operation-activity/index.tsx",
      "parent": "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout"
    },
    "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/": {
      "filePath": "_staff/licenses/$id/service-plans/$licenseServiceId/_detail/accounts/index.tsx",
      "parent": "/_staff/licenses/$id/service-plans/$licenseServiceId/_detail"
    },
    "/_staff/settings/permission-and-roles/_form/people-groups/$id/edit/": {
      "filePath": "_staff/settings/permission-and-roles/_form/people-groups/$id/edit/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/": {
      "filePath": "_staff/settings/permission-and-roles/_form/product-permissions/$id/edit/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/settings/permission-and-roles/_form/roles/$id/edit/": {
      "filePath": "_staff/settings/permission-and-roles/_form/roles/$id/edit/index.tsx",
      "parent": "/_staff/settings/permission-and-roles/_form"
    },
    "/_staff/software/_layout/marketplace/$id/install/finish/": {
      "filePath": "_staff/software/_layout/marketplace/$id/install.finish/index.tsx",
      "parent": "/_staff/software/_layout/marketplace/$id"
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "parent": "/_staff/contractor-core",
      "children": [
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
      ]
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile.tsx",
      "parent": "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "children": [
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/",
        "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/"
      ]
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "parent": "/_staff/ga-operation-core",
      "children": [
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
      ]
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile.tsx",
      "parent": "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "children": [
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/",
        "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/"
      ]
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "parent": "/_staff/labor-core",
      "children": [
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
      ]
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile.tsx",
      "parent": "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId",
      "children": [
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/",
        "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/"
      ]
    },
    "/_individual/individual/task/$id/_operation-package/_common/form/$formId/": {
      "filePath": "_individual/individual/task/$id/_operation-package/_common/form/$formId/index.tsx",
      "parent": "/_individual"
    },
    "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/apps/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it"
    },
    "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/": {
      "filePath": "_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it/visit-histories/index.tsx",
      "parent": "/_staff/apps/_list/alerts/_alerts/shadow-it/_shadow-it"
    },
    "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/": {
      "filePath": "_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout/_index/index.tsx",
      "parent": "/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout"
    },
    "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/": {
      "filePath": "_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout/_index/index.tsx",
      "parent": "/_staff/person/$id/certifications/handling-certifications/$personCertificationInformationId/_layout"
    },
    "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/": {
      "filePath": "_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/index.tsx",
      "parent": "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout"
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index.tsx",
      "parent": "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index.tsx",
      "parent": "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/index.tsx",
      "parent": "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/": {
      "filePath": "_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index.tsx",
      "parent": "/_staff/contractor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/": {
      "filePath": "_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index.tsx",
      "parent": "/_staff/ga-operation-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    },
    "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/": {
      "filePath": "_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile/data/index.tsx",
      "parent": "/_staff/labor-core/operation-packages/$id/patterns/$patternId/instances/$instanceId/_profile"
    }
  }
}
ROUTE_MANIFEST_END */
